import { Fragment as e, computed as t, createBlock as n, createCommentVNode as r, createElementBlock as i, createElementVNode as a, createSlots as o, createTextVNode as s, createVNode as c, defineComponent as l, mergeModels as u, normalizeClass as d, openBlock as f, reactive as p, ref as m, renderList as h, renderSlot as g, resolveDynamicComponent as _, toDisplayString as v, toValue as ee, unref as y, useAttrs as te, useModel as ne, useTemplateRef as re, watch as b, withCtx as x } from "vue";
import { Notification as ie, useNotification as ae } from "@myparcel-frontend/notifications";
import { ActionButton as oe, ActionButtonWrapper as se, Badge as ce, Button as le, ButtonWithSpinner as ue, CarrierLogo as de, CarrierTruck48 as fe, ClipboardText as pe, Date as me, EcommercePlatformLogo as he, Edit as ge, ExternalLinkAnchor as _e, FormRow as ve, Heading as ye, IconBase as be, IconSize as xe, LoadMoreSection as Se, Modal as Ce, MyParcelShopLogo as we, Notification as Te, PackageTypeIcon as Ee, PopOver as De, RadioGroup as Oe, SidePanel as ke, Spinner as Ae, TabLink as je, TrackAndTraceTimeline as Me, Trash as Ne } from "@myparcel-frontend/ui";
import { useAsyncState as Pe } from "@vueuse/core";
import { useI18n as Fe } from "vue-i18n";
import * as S from "zod";
import Ie from "zod";
import { useSdk as Le } from "@myparcel-frontend/sdk";
import { isValidPostalCode as Re } from "@myparcel-frontend/address-service";
import { Form as ze, TextInputField as Be, utils as Ve } from "@myparcel-frontend/forms";
import { useForm as He } from "vee-validate";
import { IconBase as Ue, IconSize as We } from "@myparcel-frontend/icons";
import { useTrackAndTrace as Ge } from "@myparcel-frontend/composables";
//#region ../../libs/types/dist/index.js
var C = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18,
	Spring: 19,
	ViaTim: 20,
	DhlFreight: 21
}, w = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	Spring: "spring",
	SPRING: "SPRING",
	ViaTim: "viatim",
	VIA_TIM: "VIA_TIM",
	DhlFreight: "dhlfreight",
	DHL_FREIGHT: "DHL_FREIGHT"
};
C.Dhl, C.Instabox, C.PostNl, w.PostNl, C.Bpost, w.Bpost, C.CheapCargo, w.CheapCargo, C.Dpd, w.Dpd, C.Instabox, w.Instabox, C.Dhl, w.Dhl, C.Bol, w.Bol, C.Ups, w.Ups, C.DhlForYou, w.DhlForYou, C.DhlParcelConnect, w.DhlParcelConnect, C.DhlEuroPlus, w.DhlEuroPlus, C.UpsStandard, w.UpsStandard, C.UpsExpressSaver, w.UpsExpressSaver, C.Gls, w.Gls, C.Brt, w.Brt, C.Trunkrs, w.Trunkrs, C.InPost, w.InPost, C.PosteItaliane, w.PosteItaliane, C.Spring, w.Spring, C.ViaTim, w.ViaTim, C.DhlFreight, w.DhlFreight;
var Ke = {
	[C.PostNl]: w.POSTNL,
	[C.Bpost]: w.BPOST,
	[C.CheapCargo]: w.CHEAP_CARGO,
	[C.Dpd]: w.DPD,
	[C.Instabox]: w.INSTABOX,
	[C.Dhl]: w.DHL,
	[C.Bol]: w.BOL,
	[C.Ups]: w.UPS,
	[C.DhlForYou]: w.DHL_FOR_YOU,
	[C.DhlParcelConnect]: w.DHL_PARCEL_CONNECT,
	[C.DhlEuroPlus]: w.DHL_EUROPLUS,
	[C.UpsStandard]: w.UPS_STANDARD,
	[C.UpsExpressSaver]: w.UPS_EXPRESS_SAVER,
	[C.Gls]: w.GLS,
	[C.Brt]: w.BRT,
	[C.Trunkrs]: w.TRUNKRS,
	[C.InPost]: w.INPOST,
	[C.PosteItaliane]: w.POSTE_ITALIANE,
	[C.Spring]: w.SPRING,
	[C.ViaTim]: w.VIA_TIM,
	[C.DhlFreight]: w.DHL_FREIGHT
}, qe = (e) => Ke[e];
w.POSTNL, C.PostNl, w.BPOST, C.Bpost, w.CHEAP_CARGO, C.CheapCargo, w.DPD, C.Dpd, w.INSTABOX, C.Instabox, w.DHL, C.Dhl, w.BOL, C.Bol, w.UPS, C.Ups, w.DHL_FOR_YOU, C.DhlForYou, w.DHL_PARCEL_CONNECT, C.DhlParcelConnect, w.DHL_EUROPLUS, C.DhlEuroPlus, w.UPS_STANDARD, C.UpsStandard, w.UPS_EXPRESS_SAVER, C.UpsExpressSaver, w.GLS, C.Gls, w.BRT, C.Brt, w.TRUNKRS, C.Trunkrs, w.INPOST, C.InPost, w.POSTE_ITALIANE, C.PosteItaliane, w.SPRING, C.Spring, w.VIA_TIM, C.ViaTim, w.DHL_FREIGHT, C.DhlFreight;
var Je = {
	[w.PostNl]: C.PostNl,
	[w.POSTNL]: C.PostNl,
	[w.Bpost]: C.Bpost,
	[w.BPOST]: C.Bpost,
	[w.CheapCargo]: C.CheapCargo,
	[w.CHEAP_CARGO]: C.CheapCargo,
	[w.Dpd]: C.Dpd,
	[w.DPD]: C.Dpd,
	[w.Instabox]: C.Instabox,
	[w.Dhl]: C.Dhl,
	[w.BolCom]: C.Bol,
	[w.Bol]: C.Bol,
	[w.BOL]: C.Bol,
	[w.Ups]: C.Ups,
	[w.DhlForYou]: C.DhlForYou,
	[w.DHL_FOR_YOU]: C.DhlForYou,
	[w.DhlParcelConnect]: C.DhlParcelConnect,
	[w.DHL_PARCEL_CONNECT]: C.DhlParcelConnect,
	[w.DhlEuroPlus]: C.DhlEuroPlus,
	[w.DHL_EUROPLUS]: C.DhlEuroPlus,
	[w.UpsStandard]: C.UpsStandard,
	[w.UPS_STANDARD]: C.UpsStandard,
	[w.UpsExpressSaver]: C.UpsExpressSaver,
	[w.UPS_EXPRESS_SAVER]: C.UpsExpressSaver,
	[w.Gls]: C.Gls,
	[w.GLS]: C.Gls,
	[w.Brt]: C.Brt,
	[w.BRT]: C.Brt,
	[w.Trunkrs]: C.Trunkrs,
	[w.TRUNKRS]: C.Trunkrs,
	[w.InPost]: C.InPost,
	[w.INPOST]: C.InPost,
	[w.PosteItaliane]: C.PosteItaliane,
	[w.POSTE_ITALIANE]: C.PosteItaliane,
	[w.Spring]: C.Spring,
	[w.SPRING]: C.Spring,
	[w.ViaTim]: C.ViaTim,
	[w.VIA_TIM]: C.ViaTim,
	[w.DhlFreight]: C.DhlFreight,
	[w.DHL_FREIGHT]: C.DhlFreight
}, Ye = (e) => Je[e];
C.PostNl, C.Bpost, C.CheapCargo, C.Dpd, C.Instabox, C.Dhl, C.Bol, C.Ups, C.DhlForYou, C.DhlParcelConnect, C.DhlEuroPlus, C.UpsStandard, C.UpsExpressSaver, C.Gls, C.Brt, C.Trunkrs, C.InPost, C.PosteItaliane, C.Spring, C.ViaTim, C.DhlFreight;
var T = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
}, Xe = [
	T.Austria,
	T.Belgium,
	T.Bulgaria,
	T.Croatia,
	T.Cyprus,
	T.CzechRepublic,
	T.Denmark,
	T.Estonia,
	T.Finland,
	T.France,
	T.Germany,
	T.Greece,
	T.Hungary,
	T.Ireland,
	T.Italy,
	T.Latvia,
	T.Lithuania,
	T.Luxembourg,
	T.Malta,
	T.Netherlands,
	T.Poland,
	T.Portugal,
	T.Romania,
	T.Slovakia,
	T.Slovenia,
	T.Spain,
	T.Sweden
];
Object.values(T), T.Angola, T.AntiguaAndBarbuda, T.Aruba, T.Bahamas, T.Belize, T.Benin, T.Bermuda, T.BonaireSintEustatiusAndSaba, T.Botswana, T.BurkinaFaso, T.Burundi, T.Cameroon, T.CanaryIslands, T.CentralAfricanRepublic, T.Comoros, T.CongoBrazzaville, T.CongoKinshasa, T.CoteDIvoire, T.Curacao, T.Djibouti, T.Dominica, T.DutchAntilles, T.EquatorialGuinea, T.Eritrea, T.Fiji, T.Gabon, T.Gambia, T.Ghana, T.Grenada, T.Guyana, T.HongKong, T.Kiribati, T.KoreaPeoplesDemocraticRepublic, T.Macao, T.Malawi, T.Mali, T.Mauritania, T.Nauru, T.Qatar, T.Rwanda, T.SaintKittsAndNevis, T.SaoTomeAndPrincipe, T.Seychelles, T.SierraLeone, T.SintMaarten, T.Suriname, T.SyrianArabRepublic, T.TimorLeste, T.Togo, T.Tonga, T.Tuvalu, T.Uganda, T.UnitedArabEmirates, T.Vanuatu, T.Yemen, T.Zimbabwe, T.Austria, T.Belgium, T.Bulgaria, T.Croatia, T.CzechRepublic, T.Estonia, T.Finland, T.France, T.Germany, T.Greece, T.Hungary, T.Ireland, T.Italy, T.Latvia, T.Lithuania, T.Luxembourg, T.Malta, T.Netherlands, T.Portugal, T.Romania, T.Slovakia, T.Slovenia, T.Spain, T.UnitedKingdom;
var Ze = [
	T.Denmark,
	T.Germany,
	T.Sweden
], Qe = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, $e = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, et = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
};
Qe.EarlyMorning, $e.EarlyMorning, Qe.Morning, $e.Morning, Qe.Standard, $e.Standard, Qe.Evening, $e.Evening, Qe.Pickup, $e.Pickup, Qe.PickupExpress, $e.PickupExpress, Qe.SameDayDelivery, $e.SameDayDelivery, Qe.Express, $e.Express;
var tt = {
	[$e.EarlyMorning]: Qe.EarlyMorning,
	[$e.Morning]: Qe.Morning,
	[$e.Standard]: Qe.Standard,
	[$e.Evening]: Qe.Evening,
	[$e.Pickup]: Qe.Pickup,
	[$e.PickupExpress]: Qe.PickupExpress,
	[$e.SameDayDelivery]: Qe.SameDayDelivery,
	[$e.Express]: Qe.Express
};
Qe.EarlyMorning, et.EarlyMorning, Qe.Morning, et.Morning, Qe.Standard, et.Standard, Qe.Evening, et.Evening, Qe.Pickup, et.Pickup, Qe.PickupExpress, et.PickupExpress, Qe.SameDayDelivery, et.SameDayDelivery, Qe.Express, et.Express;
var nt = {
	[et.EarlyMorning]: $e.EarlyMorning,
	[et.Morning]: $e.Morning,
	[et.Standard]: $e.Standard,
	[et.Evening]: $e.Evening,
	[et.Pickup]: $e.Pickup,
	[et.PickupExpress]: $e.PickupExpress,
	[et.SameDayDelivery]: $e.SameDayDelivery,
	[et.Express]: $e.Express
}, rt = {
	[Qe.EarlyMorning]: "earlyMorning",
	[Qe.Morning]: "morning",
	[Qe.Standard]: "standard",
	[Qe.Evening]: "evening",
	[Qe.Pickup]: "pickup",
	[Qe.PickupExpress]: "pickupExpress",
	[Qe.SameDayDelivery]: "sameDay",
	[Qe.Express]: "express"
}, it = (e) => {
	if (e == null || e === "") return "";
	let t;
	if (typeof e == "number") t = e;
	else if (t = tt[e], t == null) {
		let n = nt[e];
		t = n == null ? void 0 : tt[n];
	}
	return t != null && rt[t] || String(e);
};
({ Vasco: 1 }).Vasco, { Vasco: "vasco" }.Vasco;
var at = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, ot = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
};
ot.Sunday, at.Sunday, ot.Monday, at.Monday, ot.Tuesday, at.Tuesday, ot.Wednesday, at.Wednesday, ot.Thursday, at.Thursday, ot.Friday, at.Friday, ot.Saturday, at.Saturday, at.Sunday, ot.Sunday, at.Monday, ot.Monday, at.Tuesday, ot.Tuesday, at.Wednesday, ot.Wednesday, at.Thursday, ot.Thursday, at.Friday, ot.Friday, at.Saturday, ot.Saturday;
var st = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
};
st.Bytes, st.Kilobytes, st.Megabytes, st.Gigabytes, st.Terabytes;
var ct = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, lt = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
};
ct.Bol, lt.Bol, ct.Exact, lt.Exact, ct.Amazon, lt.Amazon, ct.Wix, lt.Wix, ct.ExactDe, lt.ExactDe, ct.Etsy, lt.Etsy, lt.Bol, ct.Bol, lt.Exact, ct.Exact, lt.Amazon, ct.Amazon, lt.Wix, ct.Wix, lt.ExactDe, ct.ExactDe, lt.Etsy, ct.Etsy;
var ut = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, dt = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
};
ut.Unpaid, dt.Unpaid, ut.Due, dt.Due, ut.DuePrepayment, dt.DuePrepayment, ut.Reminder1, dt.Reminder1, ut.Reminder2, dt.Reminder2, ut.Dun, dt.Dun, ut.Collection, dt.Collection, ut.Instalments, dt.Instalments, ut.PaymentArrangement, dt.PaymentArrangement, ut.Dispute, dt.Dispute, ut.LegalProcedure, dt.LegalProcedure, ut.Insolvency, dt.Insolvency, ut.WriteOff, dt.WriteOff, ut.Pending, dt.Pending, ut.Cancelled, dt.Cancelled, ut.Paid, dt.Paid, ut.PaidOnline, dt.PaidOnline, ut.PaidAutomatic, dt.PaidAutomatic, ut.PaidCredit, dt.PaidCredit, ut.PaidZeroItems, dt.PaidZeroItems, ut.InvoiceWith0InvoiceItemsPaidZeroBalance, dt.PaidZeroBalance, ut.Due, ut.Reminder1, ut.Reminder2, ut.Dun, ut.Collection, ut.Instalments, ut.PaymentArrangement, ut.Dispute, ut.Paid, ut.PaidOnline, ut.PaidAutomatic, ut.PaidCredit, ut.PaidZeroItems;
var ft = {
	Gram: "g",
	Kilogram: "kg"
};
ft.Gram, ft.Kilogram;
var pt = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
};
pt.Millimeter, pt.Centimeter, pt.Meter;
var mt = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, ht = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnRouteHandedToCarrier: 3,
	EnRouteSorting: 4,
	EnRouteDistribution: 5,
	EnRouteCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedLetter: 12,
	InactiveCredited: 13,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnRouteHandedToCarrier: 32,
	InactiveEnRouteSorting: 33,
	InactiveEnRouteDistribution: 34,
	InactiveEnRouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38
};
ht.PendingConcept, ht.PendingRegistered, ht.EnRouteHandedToCarrier, ht.EnRouteSorting, ht.EnRouteDistribution, ht.EnRouteCustoms, ht.DeliveredReadyForPickup, ht.DeliveredAtRecipient, ht.DeliveredPackagePickedUp;
var gt = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, _t = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
};
_t.Light, gt.Light, _t.Start, gt.Start, _t.Plus, gt.Plus, _t.Premium, gt.Premium, _t.Max, gt.Max, gt.Light, _t.Light, gt.Start, _t.Start, gt.Plus, _t.Plus, gt.Premium, _t.Premium, gt.Max, _t.Max;
var vt = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, yt = {
	Start: gt.Start,
	Plus: gt.Plus,
	Premium: gt.Premium,
	Max: gt.Max
};
vt.Start, yt.Start, vt.Plus, yt.Plus, vt.Premium, yt.Premium, vt.Max, yt.Max, yt.Start, vt.Start, yt.Plus, vt.Plus, yt.Premium, vt.Premium, yt.Max, vt.Max;
var bt = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, xt = {
	Start: gt.Start,
	Plus: gt.Plus,
	Premium: gt.Premium,
	Max: gt.Max
};
bt.Start, xt.Start, bt.Plus, xt.Plus, bt.Premium, xt.Premium, bt.Max, xt.Max, xt.Start, bt.Start, xt.Plus, bt.Plus, xt.Premium, bt.Premium, xt.Max, bt.Max;
var St = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, Ct = {
	Light: gt.Light,
	Start: gt.Start,
	Plus: gt.Plus,
	Premium: gt.Premium,
	Max: gt.Max
};
St.Light, Ct.Light, St.Start, Ct.Start, St.Plus, Ct.Plus, St.Premium, Ct.Premium, St.Max, Ct.Max, Ct.Light, St.Light, Ct.Start, St.Start, Ct.Plus, St.Plus, Ct.Premium, St.Premium, Ct.Max, St.Max;
var wt = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, Tt = {
	Start: gt.Start,
	Plus: gt.Plus,
	Premium: gt.Premium,
	Max: gt.Max
};
wt.Start, Tt.Start, wt.Plus, Tt.Plus, wt.Premium, Tt.Premium, wt.Max, Tt.Max, Tt.Start, wt.Start, Tt.Plus, wt.Plus, Tt.Premium, wt.Premium, Tt.Max, wt.Max;
var Et = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, Dt = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, Ot = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
};
Et.MyParcel, Dt.MyParcel, Et.Flespakket, Dt.Flespakket, Et.SendMyParcel, Dt.SendMyParcel, Et.MyParcelIt, Dt.MyParcelIt, Et.DeliverDutch, Dt.DeliverDutch, Et.PostNlPlugin, Dt.PostNlPlugin, Et.MyParcel, Ot.MyParcelNl, Et.Flespakket, Ot.MyParcelNl, Et.SendMyParcel, Ot.MyParcelBe, Et.MyParcelIt, Ot.MyParcelIt, Et.DeliverDutch, Ot.DeliverDutch, Et.PostNlPlugin, Ot.PostNlPlugin, Ot.MyParcelNl, Et.MyParcel, Ot.MyParcelBe, Et.SendMyParcel, Ot.MyParcelIt, Et.MyParcelIt, Ot.MyParcelNl, mt.HomeCountry, T.Netherlands, mt.Eu, mt.Row, T.Belgium, Ot.MyParcelBe, mt.HomeCountry, T.Belgium, T.Netherlands, mt.Eu, mt.Row, Ot.MyParcelBe, mt.HomeCountry, T.Belgium, mt.Eu, mt.Row, Ot.MyParcelNl, mt.HomeCountry, T.Netherlands, mt.Eu, mt.Row, Ot.MyParcelNl, mt.HomeCountry, T.Netherlands, T.Belgium, T.Luxembourg, C.Bpost, C.PostNl, C.DhlForYou, C.DhlParcelConnect, C.DhlEuroPlus, C.Ups, C.UpsStandard, C.UpsExpressSaver;
var kt = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, At = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
};
kt.Package, At.Package, kt.Mailbox, At.Mailbox, kt.Letter, At.Letter, kt.DigitalStamp, At.DigitalStamp, kt.Pallet, At.Pallet, kt.PackageSmall, At.PackageSmall, kt.Envelope, At.Envelope, At.Package, kt.Package, At.Mailbox, kt.Mailbox, At.Letter, kt.Letter, At.DigitalStamp, kt.DigitalStamp, At.Pallet, kt.Pallet, At.PackageSmall, kt.PackageSmall, At.Envelope, kt.Envelope;
var jt = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
};
kt.Package, jt.PACKAGE, kt.Mailbox, jt.MAILBOX, kt.Letter, jt.UNFRANKED, kt.DigitalStamp, jt.DIGITAL_STAMP, kt.Pallet, jt.PALLET, kt.PackageSmall, jt.SMALL_PACKAGE, kt.Envelope, jt.ENVELOPE, jt.PACKAGE, kt.Package, jt.MAILBOX, kt.Mailbox, jt.UNFRANKED, kt.Letter, jt.DIGITAL_STAMP, kt.DigitalStamp, jt.PALLET, kt.Pallet, jt.SMALL_PACKAGE, kt.PackageSmall, jt.ENVELOPE, kt.Envelope, kt.Package, kt.Mailbox, kt.Letter, kt.DigitalStamp, kt.Pallet, kt.PackageSmall, kt.Envelope;
var Mt = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
};
Mt.PendingConcept, Mt.PendingRegistered, Mt.EnrouteHandedToCarrier, Mt.EnrouteSorting, Mt.EnrouteDistribution, Mt.DeliveredAtCustoms, Mt.DeliveredAtRecipient, Mt.DeliveredPackagePickedUp, Mt.DeliveredReturnShipmentPackagePickedUp, Mt.DeliveredAtAgreedLocation, Mt.PrintedLetter, Mt.PrintedDigitalStamp, Mt.InactiveConcept, Mt.InactiveRegistered, Mt.InactiveEnrouteHandedToCarrier, Mt.InactiveEnrouteSorting, Mt.InactiveEnrouteDistribution, Mt.InactiveEnrouteCustoms, Mt.InactiveDeliveredAtRecipient, Mt.InactiveDeliveredReadyForPickup, Mt.InactiveDeliveredPackagePickedUp;
//#endregion
//#region ../../libs/utils/dist/index.js
var Nt = Object.create, Pt = Object.defineProperty, Ft = Object.getOwnPropertyDescriptor, It = Object.getOwnPropertyNames, Lt = Object.getPrototypeOf, Rt = Object.prototype.hasOwnProperty, zt = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), Bt = (e, t) => {
	let n = {};
	for (var r in e) Pt(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || Pt(n, Symbol.toStringTag, { value: "Module" }), n;
}, Vt = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = It(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !Rt.call(e, s) && s !== n && Pt(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = Ft(t, s)) || r.enumerable
	});
	return e;
}, Ht = (e, t, n) => (n = e == null ? {} : Nt(Lt(e)), Vt(t || !e || !e.__esModule || !Rt.call(e, "default") ? Pt(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), E = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18,
	Spring: 19,
	ViaTim: 20,
	DhlFreight: 21
}, D = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	Spring: "spring",
	SPRING: "SPRING",
	ViaTim: "viatim",
	VIA_TIM: "VIA_TIM",
	DhlFreight: "dhlfreight",
	DHL_FREIGHT: "DHL_FREIGHT"
};
E.Dhl, E.Instabox, E.PostNl, D.PostNl, E.Bpost, D.Bpost, E.CheapCargo, D.CheapCargo, E.Dpd, D.Dpd, E.Instabox, D.Instabox, E.Dhl, D.Dhl, E.Bol, D.Bol, E.Ups, D.Ups, E.DhlForYou, D.DhlForYou, E.DhlParcelConnect, D.DhlParcelConnect, E.DhlEuroPlus, D.DhlEuroPlus, E.UpsStandard, D.UpsStandard, E.UpsExpressSaver, D.UpsExpressSaver, E.Gls, D.Gls, E.Brt, D.Brt, E.Trunkrs, D.Trunkrs, E.InPost, D.InPost, E.PosteItaliane, D.PosteItaliane, E.Spring, D.Spring, E.ViaTim, D.ViaTim, E.DhlFreight, D.DhlFreight, E.PostNl, D.POSTNL, E.Bpost, D.BPOST, E.CheapCargo, D.CHEAP_CARGO, E.Dpd, D.DPD, E.Instabox, D.INSTABOX, E.Dhl, D.DHL, E.Bol, D.BOL, E.Ups, D.UPS, E.DhlForYou, D.DHL_FOR_YOU, E.DhlParcelConnect, D.DHL_PARCEL_CONNECT, E.DhlEuroPlus, D.DHL_EUROPLUS, E.UpsStandard, D.UPS_STANDARD, E.UpsExpressSaver, D.UPS_EXPRESS_SAVER, E.Gls, D.GLS, E.Brt, D.BRT, E.Trunkrs, D.TRUNKRS, E.InPost, D.INPOST, E.PosteItaliane, D.POSTE_ITALIANE, E.Spring, D.SPRING, E.ViaTim, D.VIA_TIM, E.DhlFreight, D.DHL_FREIGHT, D.POSTNL, E.PostNl, D.BPOST, E.Bpost, D.CHEAP_CARGO, E.CheapCargo, D.DPD, E.Dpd, D.INSTABOX, E.Instabox, D.DHL, E.Dhl, D.BOL, E.Bol, D.UPS, E.Ups, D.DHL_FOR_YOU, E.DhlForYou, D.DHL_PARCEL_CONNECT, E.DhlParcelConnect, D.DHL_EUROPLUS, E.DhlEuroPlus, D.UPS_STANDARD, E.UpsStandard, D.UPS_EXPRESS_SAVER, E.UpsExpressSaver, D.GLS, E.Gls, D.BRT, E.Brt, D.TRUNKRS, E.Trunkrs, D.INPOST, E.InPost, D.POSTE_ITALIANE, E.PosteItaliane, D.SPRING, E.Spring, D.VIA_TIM, E.ViaTim, D.DHL_FREIGHT, E.DhlFreight;
var Ut = {
	[D.PostNl]: E.PostNl,
	[D.POSTNL]: E.PostNl,
	[D.Bpost]: E.Bpost,
	[D.BPOST]: E.Bpost,
	[D.CheapCargo]: E.CheapCargo,
	[D.CHEAP_CARGO]: E.CheapCargo,
	[D.Dpd]: E.Dpd,
	[D.DPD]: E.Dpd,
	[D.Instabox]: E.Instabox,
	[D.Dhl]: E.Dhl,
	[D.BolCom]: E.Bol,
	[D.Bol]: E.Bol,
	[D.BOL]: E.Bol,
	[D.Ups]: E.Ups,
	[D.DhlForYou]: E.DhlForYou,
	[D.DHL_FOR_YOU]: E.DhlForYou,
	[D.DhlParcelConnect]: E.DhlParcelConnect,
	[D.DHL_PARCEL_CONNECT]: E.DhlParcelConnect,
	[D.DhlEuroPlus]: E.DhlEuroPlus,
	[D.DHL_EUROPLUS]: E.DhlEuroPlus,
	[D.UpsStandard]: E.UpsStandard,
	[D.UPS_STANDARD]: E.UpsStandard,
	[D.UpsExpressSaver]: E.UpsExpressSaver,
	[D.UPS_EXPRESS_SAVER]: E.UpsExpressSaver,
	[D.Gls]: E.Gls,
	[D.GLS]: E.Gls,
	[D.Brt]: E.Brt,
	[D.BRT]: E.Brt,
	[D.Trunkrs]: E.Trunkrs,
	[D.TRUNKRS]: E.Trunkrs,
	[D.InPost]: E.InPost,
	[D.INPOST]: E.InPost,
	[D.PosteItaliane]: E.PosteItaliane,
	[D.POSTE_ITALIANE]: E.PosteItaliane,
	[D.Spring]: E.Spring,
	[D.SPRING]: E.Spring,
	[D.ViaTim]: E.ViaTim,
	[D.VIA_TIM]: E.ViaTim,
	[D.DhlFreight]: E.DhlFreight,
	[D.DHL_FREIGHT]: E.DhlFreight
}, Wt = {
	[E.PostNl]: "postnl",
	[E.Bpost]: "bpost",
	[E.CheapCargo]: "cheapCargo",
	[E.Dpd]: "dpd",
	[E.Instabox]: "instabox",
	[E.Dhl]: "dhl",
	[E.Bol]: "bol",
	[E.Ups]: "ups",
	[E.DhlForYou]: "dhlForYou",
	[E.DhlParcelConnect]: "dhlParcelConnect",
	[E.DhlEuroPlus]: "dhlEuroplus",
	[E.UpsStandard]: "upsStandard",
	[E.UpsExpressSaver]: "upsExpressSaver",
	[E.Gls]: "gls",
	[E.Brt]: "brt",
	[E.Trunkrs]: "trunkrs",
	[E.InPost]: "inPost",
	[E.PosteItaliane]: "posteItaliane",
	[E.Spring]: "spring",
	[E.ViaTim]: "viaTim",
	[E.DhlFreight]: "dhlFreight"
}, O = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
};
O.Austria, O.Belgium, O.Bulgaria, O.Croatia, O.Cyprus, O.CzechRepublic, O.Denmark, O.Estonia, O.Finland, O.France, O.Germany, O.Greece, O.Hungary, O.Ireland, O.Italy, O.Latvia, O.Lithuania, O.Luxembourg, O.Malta, O.Netherlands, O.Poland, O.Portugal, O.Romania, O.Slovakia, O.Slovenia, O.Spain, O.Sweden, Object.values(O), O.Angola, O.AntiguaAndBarbuda, O.Aruba, O.Bahamas, O.Belize, O.Benin, O.Bermuda, O.BonaireSintEustatiusAndSaba, O.Botswana, O.BurkinaFaso, O.Burundi, O.Cameroon, O.CanaryIslands, O.CentralAfricanRepublic, O.Comoros, O.CongoBrazzaville, O.CongoKinshasa, O.CoteDIvoire, O.Curacao, O.Djibouti, O.Dominica, O.DutchAntilles, O.EquatorialGuinea, O.Eritrea, O.Fiji, O.Gabon, O.Gambia, O.Ghana, O.Grenada, O.Guyana, O.HongKong, O.Kiribati, O.KoreaPeoplesDemocraticRepublic, O.Macao, O.Malawi, O.Mali, O.Mauritania, O.Nauru, O.Qatar, O.Rwanda, O.SaintKittsAndNevis, O.SaoTomeAndPrincipe, O.Seychelles, O.SierraLeone, O.SintMaarten, O.Suriname, O.SyrianArabRepublic, O.TimorLeste, O.Togo, O.Tonga, O.Tuvalu, O.Uganda, O.UnitedArabEmirates, O.Vanuatu, O.Yemen, O.Zimbabwe, O.Austria, O.Belgium, O.Bulgaria, O.Croatia, O.CzechRepublic, O.Estonia, O.Finland, O.France, O.Germany, O.Greece, O.Hungary, O.Ireland, O.Italy, O.Latvia, O.Lithuania, O.Luxembourg, O.Malta, O.Netherlands, O.Portugal, O.Romania, O.Slovakia, O.Slovenia, O.Spain, O.UnitedKingdom, O.Denmark, O.Germany, O.Sweden;
var Gt = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, Kt = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, qt = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
};
Gt.EarlyMorning, Kt.EarlyMorning, Gt.Morning, Kt.Morning, Gt.Standard, Kt.Standard, Gt.Evening, Kt.Evening, Gt.Pickup, Kt.Pickup, Gt.PickupExpress, Kt.PickupExpress, Gt.SameDayDelivery, Kt.SameDayDelivery, Gt.Express, Kt.Express, Kt.EarlyMorning, Gt.EarlyMorning, Kt.Morning, Gt.Morning, Kt.Standard, Gt.Standard, Kt.Evening, Gt.Evening, Kt.Pickup, Gt.Pickup, Kt.PickupExpress, Gt.PickupExpress, Kt.SameDayDelivery, Gt.SameDayDelivery, Kt.Express, Gt.Express, Gt.EarlyMorning, qt.EarlyMorning, Gt.Morning, qt.Morning, Gt.Standard, qt.Standard, Gt.Evening, qt.Evening, Gt.Pickup, qt.Pickup, Gt.PickupExpress, qt.PickupExpress, Gt.SameDayDelivery, qt.SameDayDelivery, Gt.Express, qt.Express, qt.EarlyMorning, Kt.EarlyMorning, qt.Morning, Kt.Morning, qt.Standard, Kt.Standard, qt.Evening, Kt.Evening, qt.Pickup, Kt.Pickup, qt.PickupExpress, Kt.PickupExpress, qt.SameDayDelivery, Kt.SameDayDelivery, qt.Express, Kt.Express, Gt.EarlyMorning, Gt.Morning, Gt.Standard, Gt.Evening, Gt.Pickup, Gt.PickupExpress, Gt.SameDayDelivery, Gt.Express, { Vasco: 1 }.Vasco, { Vasco: "vasco" }.Vasco;
var Jt = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, Yt = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
};
Yt.Sunday, Jt.Sunday, Yt.Monday, Jt.Monday, Yt.Tuesday, Jt.Tuesday, Yt.Wednesday, Jt.Wednesday, Yt.Thursday, Jt.Thursday, Yt.Friday, Jt.Friday, Yt.Saturday, Jt.Saturday, Jt.Sunday, Yt.Sunday, Jt.Monday, Yt.Monday, Jt.Tuesday, Yt.Tuesday, Jt.Wednesday, Yt.Wednesday, Jt.Thursday, Yt.Thursday, Jt.Friday, Yt.Friday, Jt.Saturday, Yt.Saturday;
var Xt = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
};
Xt.Bytes, Xt.Kilobytes, Xt.Megabytes, Xt.Gigabytes, Xt.Terabytes;
var Zt = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, Qt = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
};
Zt.Bol, Qt.Bol, Zt.Exact, Qt.Exact, Zt.Amazon, Qt.Amazon, Zt.Wix, Qt.Wix, Zt.ExactDe, Qt.ExactDe, Zt.Etsy, Qt.Etsy, Qt.Bol, Zt.Bol, Qt.Exact, Zt.Exact, Qt.Amazon, Zt.Amazon, Qt.Wix, Zt.Wix, Qt.ExactDe, Zt.ExactDe, Qt.Etsy, Zt.Etsy;
var $t = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, en = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
};
$t.Unpaid, en.Unpaid, $t.Due, en.Due, $t.DuePrepayment, en.DuePrepayment, $t.Reminder1, en.Reminder1, $t.Reminder2, en.Reminder2, $t.Dun, en.Dun, $t.Collection, en.Collection, $t.Instalments, en.Instalments, $t.PaymentArrangement, en.PaymentArrangement, $t.Dispute, en.Dispute, $t.LegalProcedure, en.LegalProcedure, $t.Insolvency, en.Insolvency, $t.WriteOff, en.WriteOff, $t.Pending, en.Pending, $t.Cancelled, en.Cancelled, $t.Paid, en.Paid, $t.PaidOnline, en.PaidOnline, $t.PaidAutomatic, en.PaidAutomatic, $t.PaidCredit, en.PaidCredit, $t.PaidZeroItems, en.PaidZeroItems, $t.InvoiceWith0InvoiceItemsPaidZeroBalance, en.PaidZeroBalance, $t.Due, $t.Reminder1, $t.Reminder2, $t.Dun, $t.Collection, $t.Instalments, $t.PaymentArrangement, $t.Dispute, $t.Paid, $t.PaidOnline, $t.PaidAutomatic, $t.PaidCredit, $t.PaidZeroItems;
var tn = {
	Gram: "gram",
	Kilogram: "kilogram"
}, nn = {
	Gram: "g",
	Kilogram: "kg"
}, rn = {
	[nn.Gram]: 1,
	[nn.Kilogram]: 1e3
}, an = {
	Millimeter: "millimeter",
	Centimeter: "centimeter",
	Meter: "meter"
}, on = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
}, sn = {
	[on.Millimeter]: .1,
	[on.Centimeter]: 1,
	[on.Meter]: 100
}, cn = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, ln = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnRouteHandedToCarrier: 3,
	EnRouteSorting: 4,
	EnRouteDistribution: 5,
	EnRouteCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedLetter: 12,
	InactiveCredited: 13,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnRouteHandedToCarrier: 32,
	InactiveEnRouteSorting: 33,
	InactiveEnRouteDistribution: 34,
	InactiveEnRouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38
};
ln.PendingConcept, ln.PendingRegistered, ln.EnRouteHandedToCarrier, ln.EnRouteSorting, ln.EnRouteDistribution, ln.EnRouteCustoms, ln.DeliveredReadyForPickup, ln.DeliveredAtRecipient, ln.DeliveredPackagePickedUp;
var un = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, dn = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
};
dn.Light, un.Light, dn.Start, un.Start, dn.Plus, un.Plus, dn.Premium, un.Premium, dn.Max, un.Max, un.Light, dn.Light, un.Start, dn.Start, un.Plus, dn.Plus, un.Premium, dn.Premium, un.Max, dn.Max;
var fn = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, pn = {
	Start: un.Start,
	Plus: un.Plus,
	Premium: un.Premium,
	Max: un.Max
};
fn.Start, pn.Start, fn.Plus, pn.Plus, fn.Premium, pn.Premium, fn.Max, pn.Max, pn.Start, fn.Start, pn.Plus, fn.Plus, pn.Premium, fn.Premium, pn.Max, fn.Max;
var mn = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, hn = {
	Start: un.Start,
	Plus: un.Plus,
	Premium: un.Premium,
	Max: un.Max
};
mn.Start, hn.Start, mn.Plus, hn.Plus, mn.Premium, hn.Premium, mn.Max, hn.Max, hn.Start, mn.Start, hn.Plus, mn.Plus, hn.Premium, mn.Premium, hn.Max, mn.Max;
var gn = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, _n = {
	Light: un.Light,
	Start: un.Start,
	Plus: un.Plus,
	Premium: un.Premium,
	Max: un.Max
};
gn.Light, _n.Light, gn.Start, _n.Start, gn.Plus, _n.Plus, gn.Premium, _n.Premium, gn.Max, _n.Max, _n.Light, gn.Light, _n.Start, gn.Start, _n.Plus, gn.Plus, _n.Premium, gn.Premium, _n.Max, gn.Max;
var vn = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, yn = {
	Start: un.Start,
	Plus: un.Plus,
	Premium: un.Premium,
	Max: un.Max
};
vn.Start, yn.Start, vn.Plus, yn.Plus, vn.Premium, yn.Premium, vn.Max, yn.Max, yn.Start, vn.Start, yn.Plus, vn.Plus, yn.Premium, vn.Premium, yn.Max, vn.Max;
var bn = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, xn = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, Sn = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
};
bn.MyParcel, xn.MyParcel, bn.Flespakket, xn.Flespakket, bn.SendMyParcel, xn.SendMyParcel, bn.MyParcelIt, xn.MyParcelIt, bn.DeliverDutch, xn.DeliverDutch, bn.PostNlPlugin, xn.PostNlPlugin, bn.MyParcel, Sn.MyParcelNl, bn.Flespakket, Sn.MyParcelNl, bn.SendMyParcel, Sn.MyParcelBe, bn.MyParcelIt, Sn.MyParcelIt, bn.DeliverDutch, Sn.DeliverDutch, bn.PostNlPlugin, Sn.PostNlPlugin, Sn.MyParcelNl, bn.MyParcel, Sn.MyParcelBe, bn.SendMyParcel, Sn.MyParcelIt, bn.MyParcelIt, Sn.MyParcelNl, cn.HomeCountry, O.Netherlands, cn.Eu, cn.Row, O.Belgium, Sn.MyParcelBe, cn.HomeCountry, O.Belgium, O.Netherlands, cn.Eu, cn.Row, Sn.MyParcelBe, cn.HomeCountry, O.Belgium, cn.Eu, cn.Row, Sn.MyParcelNl, cn.HomeCountry, O.Netherlands, cn.Eu, cn.Row, Sn.MyParcelNl, cn.HomeCountry, O.Netherlands, O.Belgium, O.Luxembourg, E.Bpost, E.PostNl, E.DhlForYou, E.DhlParcelConnect, E.DhlEuroPlus, E.Ups, E.UpsStandard, E.UpsExpressSaver;
var Cn = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, wn = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
};
Cn.Package, wn.Package, Cn.Mailbox, wn.Mailbox, Cn.Letter, wn.Letter, Cn.DigitalStamp, wn.DigitalStamp, Cn.Pallet, wn.Pallet, Cn.PackageSmall, wn.PackageSmall, Cn.Envelope, wn.Envelope, wn.Package, Cn.Package, wn.Mailbox, Cn.Mailbox, wn.Letter, Cn.Letter, wn.DigitalStamp, Cn.DigitalStamp, wn.Pallet, Cn.Pallet, wn.PackageSmall, Cn.PackageSmall, wn.Envelope, Cn.Envelope;
var Tn = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
};
Cn.Package, Tn.PACKAGE, Cn.Mailbox, Tn.MAILBOX, Cn.Letter, Tn.UNFRANKED, Cn.DigitalStamp, Tn.DIGITAL_STAMP, Cn.Pallet, Tn.PALLET, Cn.PackageSmall, Tn.SMALL_PACKAGE, Cn.Envelope, Tn.ENVELOPE, Tn.PACKAGE, Cn.Package, Tn.MAILBOX, Cn.Mailbox, Tn.UNFRANKED, Cn.Letter, Tn.DIGITAL_STAMP, Cn.DigitalStamp, Tn.PALLET, Cn.Pallet, Tn.SMALL_PACKAGE, Cn.PackageSmall, Tn.ENVELOPE, Cn.Envelope, Cn.Package, Cn.Mailbox, Cn.Letter, Cn.DigitalStamp, Cn.Pallet, Cn.PackageSmall, Cn.Envelope;
var En = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
};
En.PendingConcept, En.PendingRegistered, En.EnrouteHandedToCarrier, En.EnrouteSorting, En.EnrouteDistribution, En.DeliveredAtCustoms, En.DeliveredAtRecipient, En.DeliveredPackagePickedUp, En.DeliveredReturnShipmentPackagePickedUp, En.DeliveredAtAgreedLocation, En.PrintedLetter, En.PrintedDigitalStamp, En.InactiveConcept, En.InactiveRegistered, En.InactiveEnrouteHandedToCarrier, En.InactiveEnrouteSorting, En.InactiveEnrouteDistribution, En.InactiveEnrouteCustoms, En.InactiveDeliveredAtRecipient, En.InactiveDeliveredReadyForPickup, En.InactiveDeliveredPackagePickedUp;
var Dn = {
	MILLIMETER: "mm",
	CENTIMETER: "cm",
	DECIMETER: "dm",
	METER: "m",
	KILOMETER: "km"
}, On = {
	GRAM: "g",
	KILOGRAM: "kg"
}, kn = (e) => {
	if (!e) return;
	let t = (e) => Ut[e];
	return t(e) ?? t(e.toLowerCase()) ?? t(e.toUpperCase());
}, An = (e) => {
	if (e == null || e === "") return "";
	let t = typeof e == "number" ? e : kn(e);
	return t != null && Wt[t] || String(e);
};
function jn(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") {
		if (Array.isArray(e)) {
			var i = e.length;
			for (t = 0; t < i; t++) e[t] && (n = jn(e[t])) && (r && (r += " "), r += n);
		} else for (n in e) e[n] && (r && (r += " "), r += n);
	}
	return r;
}
function Mn() {
	for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = jn(e)) && (r && (r += " "), r += t);
	return r;
}
var Nn = "-";
function Pn(e) {
	let t = Rn(e), { conflictingClassGroups: n, conflictingClassGroupModifiers: r } = e;
	function i(e) {
		let n = e.split(Nn);
		return n[0] === "" && n.length !== 1 && n.shift(), Fn(n, t) || Ln(e);
	}
	function a(e, t) {
		let i = n[e] || [];
		return t && r[e] ? [...i, ...r[e]] : i;
	}
	return {
		getClassGroupId: i,
		getConflictingClassGroupIds: a
	};
}
function Fn(e, t) {
	if (e.length === 0) return t.classGroupId;
	let n = e[0], r = t.nextPart.get(n), i = r ? Fn(e.slice(1), r) : void 0;
	if (i) return i;
	if (t.validators.length === 0) return;
	let a = e.join(Nn);
	return t.validators.find(({ validator: e }) => e(a))?.classGroupId;
}
var In = /^\[(.+)\]$/;
function Ln(e) {
	if (In.test(e)) {
		let t = In.exec(e)[1], n = t?.substring(0, t.indexOf(":"));
		if (n) return "arbitrary.." + n;
	}
}
function Rn(e) {
	let { theme: t, prefix: n } = e, r = {
		nextPart: /* @__PURE__ */ new Map(),
		validators: []
	};
	return Hn(Object.entries(e.classGroups), n).forEach(([e, n]) => {
		zn(n, r, e, t);
	}), r;
}
function zn(e, t, n, r) {
	e.forEach((e) => {
		if (typeof e == "string") {
			let r = e === "" ? t : Bn(t, e);
			r.classGroupId = n;
			return;
		}
		if (typeof e == "function") {
			if (Vn(e)) {
				zn(e(r), t, n, r);
				return;
			}
			t.validators.push({
				validator: e,
				classGroupId: n
			});
			return;
		}
		Object.entries(e).forEach(([e, i]) => {
			zn(i, Bn(t, e), n, r);
		});
	});
}
function Bn(e, t) {
	let n = e;
	return t.split(Nn).forEach((e) => {
		n.nextPart.has(e) || n.nextPart.set(e, {
			nextPart: /* @__PURE__ */ new Map(),
			validators: []
		}), n = n.nextPart.get(e);
	}), n;
}
function Vn(e) {
	return e.isThemeGetter;
}
function Hn(e, t) {
	return t ? e.map(([e, n]) => [e, n.map((e) => typeof e == "string" ? t + e : typeof e == "object" ? Object.fromEntries(Object.entries(e).map(([e, n]) => [t + e, n])) : e)]) : e;
}
function Un(e) {
	if (e < 1) return {
		get: () => void 0,
		set: () => {}
	};
	let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
	function i(i, a) {
		n.set(i, a), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
	}
	return {
		get(e) {
			let t = n.get(e);
			if (t !== void 0) return t;
			if ((t = r.get(e)) !== void 0) return i(e, t), t;
		},
		set(e, t) {
			n.has(e) ? n.set(e, t) : i(e, t);
		}
	};
}
var Wn = "!";
function Gn(e) {
	let t = e.separator, n = t.length === 1, r = t[0], i = t.length;
	return function(e) {
		let a = [], o = 0, s = 0, c;
		for (let l = 0; l < e.length; l++) {
			let u = e[l];
			if (o === 0) {
				if (u === r && (n || e.slice(l, l + i) === t)) {
					a.push(e.slice(s, l)), s = l + i;
					continue;
				}
				if (u === "/") {
					c = l;
					continue;
				}
			}
			u === "[" ? o++ : u === "]" && o--;
		}
		let l = a.length === 0 ? e : e.substring(s), u = l.startsWith(Wn);
		return {
			modifiers: a,
			hasImportantModifier: u,
			baseClassName: u ? l.substring(1) : l,
			maybePostfixModifierPosition: c && c > s ? c - s : void 0
		};
	};
}
function Kn(e) {
	if (e.length <= 1) return e;
	let t = [], n = [];
	return e.forEach((e) => {
		e[0] === "[" ? (t.push(...n.sort(), e), n = []) : n.push(e);
	}), t.push(...n.sort()), t;
}
function qn(e) {
	return {
		cache: Un(e.cacheSize),
		splitModifiers: Gn(e),
		...Pn(e)
	};
}
var Jn = /\s+/;
function Yn(e, t) {
	let { splitModifiers: n, getClassGroupId: r, getConflictingClassGroupIds: i } = t, a = /* @__PURE__ */ new Set();
	return e.trim().split(Jn).map((e) => {
		let { modifiers: t, hasImportantModifier: i, baseClassName: a, maybePostfixModifierPosition: o } = n(e), s = r(o ? a.substring(0, o) : a), c = !!o;
		if (!s) {
			if (!o || (s = r(a), !s)) return {
				isTailwindClass: !1,
				originalClassName: e
			};
			c = !1;
		}
		let l = Kn(t).join(":");
		return {
			isTailwindClass: !0,
			modifierId: i ? l + Wn : l,
			classGroupId: s,
			originalClassName: e,
			hasPostfixModifier: c
		};
	}).reverse().filter((e) => {
		if (!e.isTailwindClass) return !0;
		let { modifierId: t, classGroupId: n, hasPostfixModifier: r } = e, o = t + n;
		return !a.has(o) && (a.add(o), i(n, r).forEach((e) => a.add(t + e)), !0);
	}).reverse().map((e) => e.originalClassName).join(" ");
}
function Xn() {
	let e = 0, t, n, r = "";
	for (; e < arguments.length;) (t = arguments[e++]) && (n = Zn(t)) && (r && (r += " "), r += n);
	return r;
}
function Zn(e) {
	if (typeof e == "string") return e;
	let t, n = "";
	for (let r = 0; r < e.length; r++) e[r] && (t = Zn(e[r])) && (n && (n += " "), n += t);
	return n;
}
function Qn(e, ...t) {
	let n, r, i, a = o;
	function o(o) {
		return n = qn(t.reduce((e, t) => t(e), e())), r = n.cache.get, i = n.cache.set, a = s, s(o);
	}
	function s(e) {
		let t = r(e);
		if (t) return t;
		let a = Yn(e, n);
		return i(e, a), a;
	}
	return function() {
		return a(Xn.apply(null, arguments));
	};
}
function $n(e) {
	let t = (t) => t[e] || [];
	return t.isThemeGetter = !0, t;
}
var er = /^\[(?:([a-z-]+):)?(.+)\]$/i, tr = /^\d+\/\d+$/, nr = /*#__PURE__*/ new Set([
	"px",
	"full",
	"screen"
]), rr = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, ir = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, ar = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, or = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, sr = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function cr(e) {
	return ur(e) || nr.has(e) || tr.test(e);
}
function lr(e) {
	return Cr(e, "length", wr);
}
function ur(e) {
	return !!e && !Number.isNaN(Number(e));
}
function dr(e) {
	return Cr(e, "number", ur);
}
function fr(e) {
	return !!e && Number.isInteger(Number(e));
}
function pr(e) {
	return e.endsWith("%") && ur(e.slice(0, -1));
}
function mr(e) {
	return er.test(e);
}
function hr(e) {
	return rr.test(e);
}
var gr = /*#__PURE__*/ new Set([
	"length",
	"size",
	"percentage"
]);
function _r(e) {
	return Cr(e, gr, Tr);
}
function vr(e) {
	return Cr(e, "position", Tr);
}
var yr = /*#__PURE__*/ new Set(["image", "url"]);
function br(e) {
	return Cr(e, yr, Dr);
}
function xr(e) {
	return Cr(e, "", Er);
}
function Sr() {
	return !0;
}
function Cr(e, t, n) {
	let r = er.exec(e);
	return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}
function wr(e) {
	return ir.test(e) && !ar.test(e);
}
function Tr() {
	return !1;
}
function Er(e) {
	return or.test(e);
}
function Dr(e) {
	return sr.test(e);
}
function Or() {
	let e = $n("colors"), t = $n("spacing"), n = $n("blur"), r = $n("brightness"), i = $n("borderColor"), a = $n("borderRadius"), o = $n("borderSpacing"), s = $n("borderWidth"), c = $n("contrast"), l = $n("grayscale"), u = $n("hueRotate"), d = $n("invert"), f = $n("gap"), p = $n("gradientColorStops"), m = $n("gradientColorStopPositions"), h = $n("inset"), g = $n("margin"), _ = $n("opacity"), v = $n("padding"), ee = $n("saturate"), y = $n("scale"), te = $n("sepia"), ne = $n("skew"), re = $n("space"), b = $n("translate"), x = () => [
		"auto",
		"contain",
		"none"
	], ie = () => [
		"auto",
		"hidden",
		"clip",
		"visible",
		"scroll"
	], ae = () => [
		"auto",
		mr,
		t
	], oe = () => [mr, t], se = () => [
		"",
		cr,
		lr
	], ce = () => [
		"auto",
		ur,
		mr
	], le = () => [
		"bottom",
		"center",
		"left",
		"left-bottom",
		"left-top",
		"right",
		"right-bottom",
		"right-top",
		"top"
	], ue = () => [
		"solid",
		"dashed",
		"dotted",
		"double",
		"none"
	], de = () => [
		"normal",
		"multiply",
		"screen",
		"overlay",
		"darken",
		"lighten",
		"color-dodge",
		"color-burn",
		"hard-light",
		"soft-light",
		"difference",
		"exclusion",
		"hue",
		"saturation",
		"color",
		"luminosity"
	], fe = () => [
		"start",
		"end",
		"center",
		"between",
		"around",
		"evenly",
		"stretch"
	], pe = () => [
		"",
		"0",
		mr
	], me = () => [
		"auto",
		"avoid",
		"all",
		"avoid-page",
		"page",
		"left",
		"right",
		"column"
	], he = () => [ur, dr], ge = () => [ur, mr];
	return {
		cacheSize: 500,
		separator: ":",
		theme: {
			colors: [Sr],
			spacing: [cr, lr],
			blur: [
				"none",
				"",
				hr,
				mr
			],
			brightness: he(),
			borderColor: [e],
			borderRadius: [
				"none",
				"",
				"full",
				hr,
				mr
			],
			borderSpacing: oe(),
			borderWidth: se(),
			contrast: he(),
			grayscale: pe(),
			hueRotate: ge(),
			invert: pe(),
			gap: oe(),
			gradientColorStops: [e],
			gradientColorStopPositions: [pr, lr],
			inset: ae(),
			margin: ae(),
			opacity: he(),
			padding: oe(),
			saturate: he(),
			scale: he(),
			sepia: pe(),
			skew: ge(),
			space: oe(),
			translate: oe()
		},
		classGroups: {
			aspect: [{ aspect: [
				"auto",
				"square",
				"video",
				mr
			] }],
			container: ["container"],
			columns: [{ columns: [hr] }],
			"break-after": [{ "break-after": me() }],
			"break-before": [{ "break-before": me() }],
			"break-inside": [{ "break-inside": [
				"auto",
				"avoid",
				"avoid-page",
				"avoid-column"
			] }],
			"box-decoration": [{ "box-decoration": ["slice", "clone"] }],
			box: [{ box: ["border", "content"] }],
			display: [
				"block",
				"inline-block",
				"inline",
				"flex",
				"inline-flex",
				"table",
				"inline-table",
				"table-caption",
				"table-cell",
				"table-column",
				"table-column-group",
				"table-footer-group",
				"table-header-group",
				"table-row-group",
				"table-row",
				"flow-root",
				"grid",
				"inline-grid",
				"contents",
				"list-item",
				"hidden"
			],
			float: [{ float: [
				"right",
				"left",
				"none",
				"start",
				"end"
			] }],
			clear: [{ clear: [
				"left",
				"right",
				"both",
				"none",
				"start",
				"end"
			] }],
			isolation: ["isolate", "isolation-auto"],
			"object-fit": [{ object: [
				"contain",
				"cover",
				"fill",
				"none",
				"scale-down"
			] }],
			"object-position": [{ object: [...le(), mr] }],
			overflow: [{ overflow: ie() }],
			"overflow-x": [{ "overflow-x": ie() }],
			"overflow-y": [{ "overflow-y": ie() }],
			overscroll: [{ overscroll: x() }],
			"overscroll-x": [{ "overscroll-x": x() }],
			"overscroll-y": [{ "overscroll-y": x() }],
			position: [
				"static",
				"fixed",
				"absolute",
				"relative",
				"sticky"
			],
			inset: [{ inset: [h] }],
			"inset-x": [{ "inset-x": [h] }],
			"inset-y": [{ "inset-y": [h] }],
			start: [{ start: [h] }],
			end: [{ end: [h] }],
			top: [{ top: [h] }],
			right: [{ right: [h] }],
			bottom: [{ bottom: [h] }],
			left: [{ left: [h] }],
			visibility: [
				"visible",
				"invisible",
				"collapse"
			],
			z: [{ z: [
				"auto",
				fr,
				mr
			] }],
			basis: [{ basis: ae() }],
			"flex-direction": [{ flex: [
				"row",
				"row-reverse",
				"col",
				"col-reverse"
			] }],
			"flex-wrap": [{ flex: [
				"wrap",
				"wrap-reverse",
				"nowrap"
			] }],
			flex: [{ flex: [
				"1",
				"auto",
				"initial",
				"none",
				mr
			] }],
			grow: [{ grow: pe() }],
			shrink: [{ shrink: pe() }],
			order: [{ order: [
				"first",
				"last",
				"none",
				fr,
				mr
			] }],
			"grid-cols": [{ "grid-cols": [Sr] }],
			"col-start-end": [{ col: [
				"auto",
				{ span: [
					"full",
					fr,
					mr
				] },
				mr
			] }],
			"col-start": [{ "col-start": ce() }],
			"col-end": [{ "col-end": ce() }],
			"grid-rows": [{ "grid-rows": [Sr] }],
			"row-start-end": [{ row: [
				"auto",
				{ span: [fr, mr] },
				mr
			] }],
			"row-start": [{ "row-start": ce() }],
			"row-end": [{ "row-end": ce() }],
			"grid-flow": [{ "grid-flow": [
				"row",
				"col",
				"dense",
				"row-dense",
				"col-dense"
			] }],
			"auto-cols": [{ "auto-cols": [
				"auto",
				"min",
				"max",
				"fr",
				mr
			] }],
			"auto-rows": [{ "auto-rows": [
				"auto",
				"min",
				"max",
				"fr",
				mr
			] }],
			gap: [{ gap: [f] }],
			"gap-x": [{ "gap-x": [f] }],
			"gap-y": [{ "gap-y": [f] }],
			"justify-content": [{ justify: ["normal", ...fe()] }],
			"justify-items": [{ "justify-items": [
				"start",
				"end",
				"center",
				"stretch"
			] }],
			"justify-self": [{ "justify-self": [
				"auto",
				"start",
				"end",
				"center",
				"stretch"
			] }],
			"align-content": [{ content: [
				"normal",
				...fe(),
				"baseline"
			] }],
			"align-items": [{ items: [
				"start",
				"end",
				"center",
				"baseline",
				"stretch"
			] }],
			"align-self": [{ self: [
				"auto",
				"start",
				"end",
				"center",
				"stretch",
				"baseline"
			] }],
			"place-content": [{ "place-content": [...fe(), "baseline"] }],
			"place-items": [{ "place-items": [
				"start",
				"end",
				"center",
				"baseline",
				"stretch"
			] }],
			"place-self": [{ "place-self": [
				"auto",
				"start",
				"end",
				"center",
				"stretch"
			] }],
			p: [{ p: [v] }],
			px: [{ px: [v] }],
			py: [{ py: [v] }],
			ps: [{ ps: [v] }],
			pe: [{ pe: [v] }],
			pt: [{ pt: [v] }],
			pr: [{ pr: [v] }],
			pb: [{ pb: [v] }],
			pl: [{ pl: [v] }],
			m: [{ m: [g] }],
			mx: [{ mx: [g] }],
			my: [{ my: [g] }],
			ms: [{ ms: [g] }],
			me: [{ me: [g] }],
			mt: [{ mt: [g] }],
			mr: [{ mr: [g] }],
			mb: [{ mb: [g] }],
			ml: [{ ml: [g] }],
			"space-x": [{ "space-x": [re] }],
			"space-x-reverse": ["space-x-reverse"],
			"space-y": [{ "space-y": [re] }],
			"space-y-reverse": ["space-y-reverse"],
			w: [{ w: [
				"auto",
				"min",
				"max",
				"fit",
				"svw",
				"lvw",
				"dvw",
				mr,
				t
			] }],
			"min-w": [{ "min-w": [
				mr,
				t,
				"min",
				"max",
				"fit"
			] }],
			"max-w": [{ "max-w": [
				mr,
				t,
				"none",
				"full",
				"min",
				"max",
				"fit",
				"prose",
				{ screen: [hr] },
				hr
			] }],
			h: [{ h: [
				mr,
				t,
				"auto",
				"min",
				"max",
				"fit",
				"svh",
				"lvh",
				"dvh"
			] }],
			"min-h": [{ "min-h": [
				mr,
				t,
				"min",
				"max",
				"fit",
				"svh",
				"lvh",
				"dvh"
			] }],
			"max-h": [{ "max-h": [
				mr,
				t,
				"min",
				"max",
				"fit",
				"svh",
				"lvh",
				"dvh"
			] }],
			size: [{ size: [
				mr,
				t,
				"auto",
				"min",
				"max",
				"fit"
			] }],
			"font-size": [{ text: [
				"base",
				hr,
				lr
			] }],
			"font-smoothing": ["antialiased", "subpixel-antialiased"],
			"font-style": ["italic", "not-italic"],
			"font-weight": [{ font: [
				"thin",
				"extralight",
				"light",
				"normal",
				"medium",
				"semibold",
				"bold",
				"extrabold",
				"black",
				dr
			] }],
			"font-family": [{ font: [Sr] }],
			"fvn-normal": ["normal-nums"],
			"fvn-ordinal": ["ordinal"],
			"fvn-slashed-zero": ["slashed-zero"],
			"fvn-figure": ["lining-nums", "oldstyle-nums"],
			"fvn-spacing": ["proportional-nums", "tabular-nums"],
			"fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
			tracking: [{ tracking: [
				"tighter",
				"tight",
				"normal",
				"wide",
				"wider",
				"widest",
				mr
			] }],
			"line-clamp": [{ "line-clamp": [
				"none",
				ur,
				dr
			] }],
			leading: [{ leading: [
				"none",
				"tight",
				"snug",
				"normal",
				"relaxed",
				"loose",
				cr,
				mr
			] }],
			"list-image": [{ "list-image": ["none", mr] }],
			"list-style-type": [{ list: [
				"none",
				"disc",
				"decimal",
				mr
			] }],
			"list-style-position": [{ list: ["inside", "outside"] }],
			"placeholder-color": [{ placeholder: [e] }],
			"placeholder-opacity": [{ "placeholder-opacity": [_] }],
			"text-alignment": [{ text: [
				"left",
				"center",
				"right",
				"justify",
				"start",
				"end"
			] }],
			"text-color": [{ text: [e] }],
			"text-opacity": [{ "text-opacity": [_] }],
			"text-decoration": [
				"underline",
				"overline",
				"line-through",
				"no-underline"
			],
			"text-decoration-style": [{ decoration: [...ue(), "wavy"] }],
			"text-decoration-thickness": [{ decoration: [
				"auto",
				"from-font",
				cr,
				lr
			] }],
			"underline-offset": [{ "underline-offset": [
				"auto",
				cr,
				mr
			] }],
			"text-decoration-color": [{ decoration: [e] }],
			"text-transform": [
				"uppercase",
				"lowercase",
				"capitalize",
				"normal-case"
			],
			"text-overflow": [
				"truncate",
				"text-ellipsis",
				"text-clip"
			],
			"text-wrap": [{ text: [
				"wrap",
				"nowrap",
				"balance",
				"pretty"
			] }],
			indent: [{ indent: oe() }],
			"vertical-align": [{ align: [
				"baseline",
				"top",
				"middle",
				"bottom",
				"text-top",
				"text-bottom",
				"sub",
				"super",
				mr
			] }],
			whitespace: [{ whitespace: [
				"normal",
				"nowrap",
				"pre",
				"pre-line",
				"pre-wrap",
				"break-spaces"
			] }],
			break: [{ break: [
				"normal",
				"words",
				"all",
				"keep"
			] }],
			hyphens: [{ hyphens: [
				"none",
				"manual",
				"auto"
			] }],
			content: [{ content: ["none", mr] }],
			"bg-attachment": [{ bg: [
				"fixed",
				"local",
				"scroll"
			] }],
			"bg-clip": [{ "bg-clip": [
				"border",
				"padding",
				"content",
				"text"
			] }],
			"bg-opacity": [{ "bg-opacity": [_] }],
			"bg-origin": [{ "bg-origin": [
				"border",
				"padding",
				"content"
			] }],
			"bg-position": [{ bg: [...le(), vr] }],
			"bg-repeat": [{ bg: ["no-repeat", { repeat: [
				"",
				"x",
				"y",
				"round",
				"space"
			] }] }],
			"bg-size": [{ bg: [
				"auto",
				"cover",
				"contain",
				_r
			] }],
			"bg-image": [{ bg: [
				"none",
				{ "gradient-to": [
					"t",
					"tr",
					"r",
					"br",
					"b",
					"bl",
					"l",
					"tl"
				] },
				br
			] }],
			"bg-color": [{ bg: [e] }],
			"gradient-from-pos": [{ from: [m] }],
			"gradient-via-pos": [{ via: [m] }],
			"gradient-to-pos": [{ to: [m] }],
			"gradient-from": [{ from: [p] }],
			"gradient-via": [{ via: [p] }],
			"gradient-to": [{ to: [p] }],
			rounded: [{ rounded: [a] }],
			"rounded-s": [{ "rounded-s": [a] }],
			"rounded-e": [{ "rounded-e": [a] }],
			"rounded-t": [{ "rounded-t": [a] }],
			"rounded-r": [{ "rounded-r": [a] }],
			"rounded-b": [{ "rounded-b": [a] }],
			"rounded-l": [{ "rounded-l": [a] }],
			"rounded-ss": [{ "rounded-ss": [a] }],
			"rounded-se": [{ "rounded-se": [a] }],
			"rounded-ee": [{ "rounded-ee": [a] }],
			"rounded-es": [{ "rounded-es": [a] }],
			"rounded-tl": [{ "rounded-tl": [a] }],
			"rounded-tr": [{ "rounded-tr": [a] }],
			"rounded-br": [{ "rounded-br": [a] }],
			"rounded-bl": [{ "rounded-bl": [a] }],
			"border-w": [{ border: [s] }],
			"border-w-x": [{ "border-x": [s] }],
			"border-w-y": [{ "border-y": [s] }],
			"border-w-s": [{ "border-s": [s] }],
			"border-w-e": [{ "border-e": [s] }],
			"border-w-t": [{ "border-t": [s] }],
			"border-w-r": [{ "border-r": [s] }],
			"border-w-b": [{ "border-b": [s] }],
			"border-w-l": [{ "border-l": [s] }],
			"border-opacity": [{ "border-opacity": [_] }],
			"border-style": [{ border: [...ue(), "hidden"] }],
			"divide-x": [{ "divide-x": [s] }],
			"divide-x-reverse": ["divide-x-reverse"],
			"divide-y": [{ "divide-y": [s] }],
			"divide-y-reverse": ["divide-y-reverse"],
			"divide-opacity": [{ "divide-opacity": [_] }],
			"divide-style": [{ divide: ue() }],
			"border-color": [{ border: [i] }],
			"border-color-x": [{ "border-x": [i] }],
			"border-color-y": [{ "border-y": [i] }],
			"border-color-t": [{ "border-t": [i] }],
			"border-color-r": [{ "border-r": [i] }],
			"border-color-b": [{ "border-b": [i] }],
			"border-color-l": [{ "border-l": [i] }],
			"divide-color": [{ divide: [i] }],
			"outline-style": [{ outline: ["", ...ue()] }],
			"outline-offset": [{ "outline-offset": [cr, mr] }],
			"outline-w": [{ outline: [cr, lr] }],
			"outline-color": [{ outline: [e] }],
			"ring-w": [{ ring: se() }],
			"ring-w-inset": ["ring-inset"],
			"ring-color": [{ ring: [e] }],
			"ring-opacity": [{ "ring-opacity": [_] }],
			"ring-offset-w": [{ "ring-offset": [cr, lr] }],
			"ring-offset-color": [{ "ring-offset": [e] }],
			shadow: [{ shadow: [
				"",
				"inner",
				"none",
				hr,
				xr
			] }],
			"shadow-color": [{ shadow: [Sr] }],
			opacity: [{ opacity: [_] }],
			"mix-blend": [{ "mix-blend": [
				...de(),
				"plus-lighter",
				"plus-darker"
			] }],
			"bg-blend": [{ "bg-blend": de() }],
			filter: [{ filter: ["", "none"] }],
			blur: [{ blur: [n] }],
			brightness: [{ brightness: [r] }],
			contrast: [{ contrast: [c] }],
			"drop-shadow": [{ "drop-shadow": [
				"",
				"none",
				hr,
				mr
			] }],
			grayscale: [{ grayscale: [l] }],
			"hue-rotate": [{ "hue-rotate": [u] }],
			invert: [{ invert: [d] }],
			saturate: [{ saturate: [ee] }],
			sepia: [{ sepia: [te] }],
			"backdrop-filter": [{ "backdrop-filter": ["", "none"] }],
			"backdrop-blur": [{ "backdrop-blur": [n] }],
			"backdrop-brightness": [{ "backdrop-brightness": [r] }],
			"backdrop-contrast": [{ "backdrop-contrast": [c] }],
			"backdrop-grayscale": [{ "backdrop-grayscale": [l] }],
			"backdrop-hue-rotate": [{ "backdrop-hue-rotate": [u] }],
			"backdrop-invert": [{ "backdrop-invert": [d] }],
			"backdrop-opacity": [{ "backdrop-opacity": [_] }],
			"backdrop-saturate": [{ "backdrop-saturate": [ee] }],
			"backdrop-sepia": [{ "backdrop-sepia": [te] }],
			"border-collapse": [{ border: ["collapse", "separate"] }],
			"border-spacing": [{ "border-spacing": [o] }],
			"border-spacing-x": [{ "border-spacing-x": [o] }],
			"border-spacing-y": [{ "border-spacing-y": [o] }],
			"table-layout": [{ table: ["auto", "fixed"] }],
			caption: [{ caption: ["top", "bottom"] }],
			transition: [{ transition: [
				"none",
				"all",
				"",
				"colors",
				"opacity",
				"shadow",
				"transform",
				mr
			] }],
			duration: [{ duration: ge() }],
			ease: [{ ease: [
				"linear",
				"in",
				"out",
				"in-out",
				mr
			] }],
			delay: [{ delay: ge() }],
			animate: [{ animate: [
				"none",
				"spin",
				"ping",
				"pulse",
				"bounce",
				mr
			] }],
			transform: [{ transform: [
				"",
				"gpu",
				"none"
			] }],
			scale: [{ scale: [y] }],
			"scale-x": [{ "scale-x": [y] }],
			"scale-y": [{ "scale-y": [y] }],
			rotate: [{ rotate: [fr, mr] }],
			"translate-x": [{ "translate-x": [b] }],
			"translate-y": [{ "translate-y": [b] }],
			"skew-x": [{ "skew-x": [ne] }],
			"skew-y": [{ "skew-y": [ne] }],
			"transform-origin": [{ origin: [
				"center",
				"top",
				"top-right",
				"right",
				"bottom-right",
				"bottom",
				"bottom-left",
				"left",
				"top-left",
				mr
			] }],
			accent: [{ accent: ["auto", e] }],
			appearance: [{ appearance: ["none", "auto"] }],
			cursor: [{ cursor: [
				"auto",
				"default",
				"pointer",
				"wait",
				"text",
				"move",
				"help",
				"not-allowed",
				"none",
				"context-menu",
				"progress",
				"cell",
				"crosshair",
				"vertical-text",
				"alias",
				"copy",
				"no-drop",
				"grab",
				"grabbing",
				"all-scroll",
				"col-resize",
				"row-resize",
				"n-resize",
				"e-resize",
				"s-resize",
				"w-resize",
				"ne-resize",
				"nw-resize",
				"se-resize",
				"sw-resize",
				"ew-resize",
				"ns-resize",
				"nesw-resize",
				"nwse-resize",
				"zoom-in",
				"zoom-out",
				mr
			] }],
			"caret-color": [{ caret: [e] }],
			"pointer-events": [{ "pointer-events": ["none", "auto"] }],
			resize: [{ resize: [
				"none",
				"y",
				"x",
				""
			] }],
			"scroll-behavior": [{ scroll: ["auto", "smooth"] }],
			"scroll-m": [{ "scroll-m": oe() }],
			"scroll-mx": [{ "scroll-mx": oe() }],
			"scroll-my": [{ "scroll-my": oe() }],
			"scroll-ms": [{ "scroll-ms": oe() }],
			"scroll-me": [{ "scroll-me": oe() }],
			"scroll-mt": [{ "scroll-mt": oe() }],
			"scroll-mr": [{ "scroll-mr": oe() }],
			"scroll-mb": [{ "scroll-mb": oe() }],
			"scroll-ml": [{ "scroll-ml": oe() }],
			"scroll-p": [{ "scroll-p": oe() }],
			"scroll-px": [{ "scroll-px": oe() }],
			"scroll-py": [{ "scroll-py": oe() }],
			"scroll-ps": [{ "scroll-ps": oe() }],
			"scroll-pe": [{ "scroll-pe": oe() }],
			"scroll-pt": [{ "scroll-pt": oe() }],
			"scroll-pr": [{ "scroll-pr": oe() }],
			"scroll-pb": [{ "scroll-pb": oe() }],
			"scroll-pl": [{ "scroll-pl": oe() }],
			"snap-align": [{ snap: [
				"start",
				"end",
				"center",
				"align-none"
			] }],
			"snap-stop": [{ snap: ["normal", "always"] }],
			"snap-type": [{ snap: [
				"none",
				"x",
				"y",
				"both"
			] }],
			"snap-strictness": [{ snap: ["mandatory", "proximity"] }],
			touch: [{ touch: [
				"auto",
				"none",
				"manipulation"
			] }],
			"touch-x": [{ "touch-pan": [
				"x",
				"left",
				"right"
			] }],
			"touch-y": [{ "touch-pan": [
				"y",
				"up",
				"down"
			] }],
			"touch-pz": ["touch-pinch-zoom"],
			select: [{ select: [
				"none",
				"text",
				"all",
				"auto"
			] }],
			"will-change": [{ "will-change": [
				"auto",
				"scroll",
				"contents",
				"transform",
				mr
			] }],
			fill: [{ fill: [e, "none"] }],
			"stroke-w": [{ stroke: [
				cr,
				lr,
				dr
			] }],
			stroke: [{ stroke: [e, "none"] }],
			sr: ["sr-only", "not-sr-only"],
			"forced-color-adjust": [{ "forced-color-adjust": ["auto", "none"] }]
		},
		conflictingClassGroups: {
			overflow: ["overflow-x", "overflow-y"],
			overscroll: ["overscroll-x", "overscroll-y"],
			inset: [
				"inset-x",
				"inset-y",
				"start",
				"end",
				"top",
				"right",
				"bottom",
				"left"
			],
			"inset-x": ["right", "left"],
			"inset-y": ["top", "bottom"],
			flex: [
				"basis",
				"grow",
				"shrink"
			],
			gap: ["gap-x", "gap-y"],
			p: [
				"px",
				"py",
				"ps",
				"pe",
				"pt",
				"pr",
				"pb",
				"pl"
			],
			px: ["pr", "pl"],
			py: ["pt", "pb"],
			m: [
				"mx",
				"my",
				"ms",
				"me",
				"mt",
				"mr",
				"mb",
				"ml"
			],
			mx: ["mr", "ml"],
			my: ["mt", "mb"],
			size: ["w", "h"],
			"font-size": ["leading"],
			"fvn-normal": [
				"fvn-ordinal",
				"fvn-slashed-zero",
				"fvn-figure",
				"fvn-spacing",
				"fvn-fraction"
			],
			"fvn-ordinal": ["fvn-normal"],
			"fvn-slashed-zero": ["fvn-normal"],
			"fvn-figure": ["fvn-normal"],
			"fvn-spacing": ["fvn-normal"],
			"fvn-fraction": ["fvn-normal"],
			"line-clamp": ["display", "overflow"],
			rounded: [
				"rounded-s",
				"rounded-e",
				"rounded-t",
				"rounded-r",
				"rounded-b",
				"rounded-l",
				"rounded-ss",
				"rounded-se",
				"rounded-ee",
				"rounded-es",
				"rounded-tl",
				"rounded-tr",
				"rounded-br",
				"rounded-bl"
			],
			"rounded-s": ["rounded-ss", "rounded-es"],
			"rounded-e": ["rounded-se", "rounded-ee"],
			"rounded-t": ["rounded-tl", "rounded-tr"],
			"rounded-r": ["rounded-tr", "rounded-br"],
			"rounded-b": ["rounded-br", "rounded-bl"],
			"rounded-l": ["rounded-tl", "rounded-bl"],
			"border-spacing": ["border-spacing-x", "border-spacing-y"],
			"border-w": [
				"border-w-s",
				"border-w-e",
				"border-w-t",
				"border-w-r",
				"border-w-b",
				"border-w-l"
			],
			"border-w-x": ["border-w-r", "border-w-l"],
			"border-w-y": ["border-w-t", "border-w-b"],
			"border-color": [
				"border-color-t",
				"border-color-r",
				"border-color-b",
				"border-color-l"
			],
			"border-color-x": ["border-color-r", "border-color-l"],
			"border-color-y": ["border-color-t", "border-color-b"],
			"scroll-m": [
				"scroll-mx",
				"scroll-my",
				"scroll-ms",
				"scroll-me",
				"scroll-mt",
				"scroll-mr",
				"scroll-mb",
				"scroll-ml"
			],
			"scroll-mx": ["scroll-mr", "scroll-ml"],
			"scroll-my": ["scroll-mt", "scroll-mb"],
			"scroll-p": [
				"scroll-px",
				"scroll-py",
				"scroll-ps",
				"scroll-pe",
				"scroll-pt",
				"scroll-pr",
				"scroll-pb",
				"scroll-pl"
			],
			"scroll-px": ["scroll-pr", "scroll-pl"],
			"scroll-py": ["scroll-pt", "scroll-pb"],
			touch: [
				"touch-x",
				"touch-y",
				"touch-pz"
			],
			"touch-x": ["touch"],
			"touch-y": ["touch"],
			"touch-pz": ["touch"]
		},
		conflictingClassGroupModifiers: { "font-size": ["leading"] }
	};
}
var kr = /*#__PURE__*/ Qn(Or);
function Ar(...e) {
	return kr(Mn(e));
}
var jr = (e) => e === O.UnitedKingdom, Mr = (e) => e === O.Netherlands, Nr = (e) => e === O.Belgium, Pr = (e) => e === O.Germany, Fr = (e) => e === O.France, Ir = (e) => e === O.Ireland, Lr = (e) => e === O.UnitedStatesOfAmerica, Rr = (e) => e === O.PuertoRico, zr = { countryCode: /* @__PURE__ */ Bt({
	isBelgium: () => Nr,
	isFrance: () => Fr,
	isGermany: () => Pr,
	isIreland: () => Ir,
	isNetherlands: () => Mr,
	isPuertoRico: () => Rr,
	isUnitedKingdom: () => jr,
	isUnitedStatesOfAmerica: () => Lr
}) }, Br = /* @__PURE__ */ zt(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs = r();
	})(e, (function() {
		var e = 1e3, t = 6e4, n = 36e5, r = "millisecond", i = "second", a = "minute", o = "hour", s = "day", c = "week", l = "month", u = "quarter", d = "year", f = "date", p = "Invalid Date", m = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, h = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, g = {
			name: "en",
			weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
			months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
			ordinal: function(e) {
				var t = [
					"th",
					"st",
					"nd",
					"rd"
				], n = e % 100;
				return "[" + e + (t[(n - 20) % 10] || t[n] || t[0]) + "]";
			}
		}, _ = function(e, t, n) {
			var r = String(e);
			return !r || r.length >= t ? e : "" + Array(t + 1 - r.length).join(n) + e;
		}, v = {
			s: _,
			z: function(e) {
				var t = -e.utcOffset(), n = Math.abs(t), r = Math.floor(n / 60), i = n % 60;
				return (t <= 0 ? "+" : "-") + _(r, 2, "0") + ":" + _(i, 2, "0");
			},
			m: function e(t, n) {
				if (t.date() < n.date()) return -e(n, t);
				var r = 12 * (n.year() - t.year()) + (n.month() - t.month()), i = t.clone().add(r, l), a = n - i < 0, o = t.clone().add(r + (a ? -1 : 1), l);
				return +(-(r + (n - i) / (a ? i - o : o - i)) || 0);
			},
			a: function(e) {
				return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
			},
			p: function(e) {
				return {
					M: l,
					y: d,
					w: c,
					d: s,
					D: f,
					h: o,
					m: a,
					s: i,
					ms: r,
					Q: u
				}[e] || String(e || "").toLowerCase().replace(/s$/, "");
			},
			u: function(e) {
				return e === void 0;
			}
		}, ee = "en", y = {};
		y[ee] = g;
		var te = "$isDayjsObject", ne = function(e) {
			return e instanceof ie || !(!e || !e[te]);
		}, re = function e(t, n, r) {
			var i;
			if (!t) return ee;
			if (typeof t == "string") {
				var a = t.toLowerCase();
				y[a] && (i = a), n && (y[a] = n, i = a);
				var o = t.split("-");
				if (!i && o.length > 1) return e(o[0]);
			} else {
				var s = t.name;
				y[s] = t, i = s;
			}
			return !r && i && (ee = i), i || !r && ee;
		}, b = function(e, t) {
			if (ne(e)) return e.clone();
			var n = typeof t == "object" ? t : {};
			return n.date = e, n.args = arguments, new ie(n);
		}, x = v;
		x.l = re, x.i = ne, x.w = function(e, t) {
			return b(e, {
				locale: t.$L,
				utc: t.$u,
				x: t.$x,
				$offset: t.$offset
			});
		};
		var ie = function() {
			function g(e) {
				this.$L = re(e.locale, null, !0), this.parse(e), this.$x = this.$x || e.x || {}, this[te] = !0;
			}
			var _ = g.prototype;
			return _.parse = function(e) {
				this.$d = function(e) {
					var t = e.date, n = e.utc;
					if (t === null) return /* @__PURE__ */ new Date(NaN);
					if (x.u(t)) return /* @__PURE__ */ new Date();
					if (t instanceof Date) return new Date(t);
					if (typeof t == "string" && !/Z$/i.test(t)) {
						var r = t.match(m);
						if (r) {
							var i = r[2] - 1 || 0, a = (r[7] || "0").substring(0, 3);
							return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a);
						}
					}
					return new Date(t);
				}(e), this.init();
			}, _.init = function() {
				var e = this.$d;
				this.$y = e.getFullYear(), this.$M = e.getMonth(), this.$D = e.getDate(), this.$W = e.getDay(), this.$H = e.getHours(), this.$m = e.getMinutes(), this.$s = e.getSeconds(), this.$ms = e.getMilliseconds();
			}, _.$utils = function() {
				return x;
			}, _.isValid = function() {
				return this.$d.toString() !== p;
			}, _.isSame = function(e, t) {
				var n = b(e);
				return this.startOf(t) <= n && n <= this.endOf(t);
			}, _.isAfter = function(e, t) {
				return b(e) < this.startOf(t);
			}, _.isBefore = function(e, t) {
				return this.endOf(t) < b(e);
			}, _.$g = function(e, t, n) {
				return x.u(e) ? this[t] : this.set(n, e);
			}, _.unix = function() {
				return Math.floor(this.valueOf() / 1e3);
			}, _.valueOf = function() {
				return this.$d.getTime();
			}, _.startOf = function(e, t) {
				var n = this, r = !!x.u(t) || t, u = x.p(e), p = function(e, t) {
					var i = x.w(n.$u ? Date.UTC(n.$y, t, e) : new Date(n.$y, t, e), n);
					return r ? i : i.endOf(s);
				}, m = function(e, t) {
					return x.w(n.toDate()[e].apply(n.toDate("s"), (r ? [
						0,
						0,
						0,
						0
					] : [
						23,
						59,
						59,
						999
					]).slice(t)), n);
				}, h = this.$W, g = this.$M, _ = this.$D, v = "set" + (this.$u ? "UTC" : "");
				switch (u) {
					case d: return r ? p(1, 0) : p(31, 11);
					case l: return r ? p(1, g) : p(0, g + 1);
					case c:
						var ee = this.$locale().weekStart || 0, y = (h < ee ? h + 7 : h) - ee;
						return p(r ? _ - y : _ + (6 - y), g);
					case s:
					case f: return m(v + "Hours", 0);
					case o: return m(v + "Minutes", 1);
					case a: return m(v + "Seconds", 2);
					case i: return m(v + "Milliseconds", 3);
					default: return this.clone();
				}
			}, _.endOf = function(e) {
				return this.startOf(e, !1);
			}, _.$set = function(e, t) {
				var n, c = x.p(e), u = "set" + (this.$u ? "UTC" : ""), p = (n = {}, n[s] = u + "Date", n[f] = u + "Date", n[l] = u + "Month", n[d] = u + "FullYear", n[o] = u + "Hours", n[a] = u + "Minutes", n[i] = u + "Seconds", n[r] = u + "Milliseconds", n)[c], m = c === s ? this.$D + (t - this.$W) : t;
				if (c === l || c === d) {
					var h = this.clone().set(f, 1);
					h.$d[p](m), h.init(), this.$d = h.set(f, Math.min(this.$D, h.daysInMonth())).$d;
				} else p && this.$d[p](m);
				return this.init(), this;
			}, _.set = function(e, t) {
				return this.clone().$set(e, t);
			}, _.get = function(e) {
				return this[x.p(e)]();
			}, _.add = function(r, u) {
				var f, p = this;
				r = Number(r);
				var m = x.p(u), h = function(e) {
					var t = b(p);
					return x.w(t.date(t.date() + Math.round(e * r)), p);
				};
				if (m === l) return this.set(l, this.$M + r);
				if (m === d) return this.set(d, this.$y + r);
				if (m === s) return h(1);
				if (m === c) return h(7);
				var g = (f = {}, f[a] = t, f[o] = n, f[i] = e, f)[m] || 1, _ = this.$d.getTime() + r * g;
				return x.w(_, this);
			}, _.subtract = function(e, t) {
				return this.add(-1 * e, t);
			}, _.format = function(e) {
				var t = this, n = this.$locale();
				if (!this.isValid()) return n.invalidDate || p;
				var r = e || "YYYY-MM-DDTHH:mm:ssZ", i = x.z(this), a = this.$H, o = this.$m, s = this.$M, c = n.weekdays, l = n.months, u = n.meridiem, d = function(e, n, i, a) {
					return e && (e[n] || e(t, r)) || i[n].slice(0, a);
				}, f = function(e) {
					return x.s(a % 12 || 12, e, "0");
				}, m = u || function(e, t, n) {
					var r = e < 12 ? "AM" : "PM";
					return n ? r.toLowerCase() : r;
				};
				return r.replace(h, (function(e, r) {
					return r || function(e) {
						switch (e) {
							case "YY": return String(t.$y).slice(-2);
							case "YYYY": return x.s(t.$y, 4, "0");
							case "M": return s + 1;
							case "MM": return x.s(s + 1, 2, "0");
							case "MMM": return d(n.monthsShort, s, l, 3);
							case "MMMM": return d(l, s);
							case "D": return t.$D;
							case "DD": return x.s(t.$D, 2, "0");
							case "d": return String(t.$W);
							case "dd": return d(n.weekdaysMin, t.$W, c, 2);
							case "ddd": return d(n.weekdaysShort, t.$W, c, 3);
							case "dddd": return c[t.$W];
							case "H": return String(a);
							case "HH": return x.s(a, 2, "0");
							case "h": return f(1);
							case "hh": return f(2);
							case "a": return m(a, o, !0);
							case "A": return m(a, o, !1);
							case "m": return String(o);
							case "mm": return x.s(o, 2, "0");
							case "s": return String(t.$s);
							case "ss": return x.s(t.$s, 2, "0");
							case "SSS": return x.s(t.$ms, 3, "0");
							case "Z": return i;
						}
						return null;
					}(e) || i.replace(":", "");
				}));
			}, _.utcOffset = function() {
				return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
			}, _.diff = function(r, f, p) {
				var m, h = this, g = x.p(f), _ = b(r), v = (_.utcOffset() - this.utcOffset()) * t, ee = this - _, y = function() {
					return x.m(h, _);
				};
				switch (g) {
					case d:
						m = y() / 12;
						break;
					case l:
						m = y();
						break;
					case u:
						m = y() / 3;
						break;
					case c:
						m = (ee - v) / 6048e5;
						break;
					case s:
						m = (ee - v) / 864e5;
						break;
					case o:
						m = ee / n;
						break;
					case a:
						m = ee / t;
						break;
					case i:
						m = ee / e;
						break;
					default: m = ee;
				}
				return p ? m : x.a(m);
			}, _.daysInMonth = function() {
				return this.endOf(l).$D;
			}, _.$locale = function() {
				return y[this.$L];
			}, _.locale = function(e, t) {
				if (!e) return this.$L;
				var n = this.clone(), r = re(e, t, !0);
				return r && (n.$L = r), n;
			}, _.clone = function() {
				return x.w(this.$d, this);
			}, _.toDate = function() {
				return new Date(this.valueOf());
			}, _.toJSON = function() {
				return this.isValid() ? this.toISOString() : null;
			}, _.toISOString = function() {
				return this.$d.toISOString();
			}, _.toString = function() {
				return this.$d.toUTCString();
			}, g;
		}(), ae = ie.prototype;
		return b.prototype = ae, [
			["$ms", r],
			["$s", i],
			["$m", a],
			["$H", o],
			["$W", s],
			["$M", l],
			["$y", d],
			["$D", f]
		].forEach((function(e) {
			ae[e[1]] = function(t) {
				return this.$g(t, e[0], e[1]);
			};
		})), b.extend = function(e, t) {
			return e.$i ||= (e(t, ie, b), !0), b;
		}, b.locale = re, b.isDayjs = ne, b.unix = function(e) {
			return b(1e3 * e);
		}, b.en = y[ee], b.Ls = y, b.p = {}, b;
	}));
})), Vr = /* @__PURE__ */ zt(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(Br()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_nl = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "nl",
			weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
			weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
			weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
			months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
			monthsShort: "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
			ordinal: function(e) {
				return "[" + e + (e === 1 || e === 8 || e >= 20 ? "ste" : "de") + "]";
			},
			weekStart: 1,
			yearStart: 4,
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD-MM-YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "over %s",
				past: "%s geleden",
				s: "een paar seconden",
				m: "een minuut",
				mm: "%d minuten",
				h: "een uur",
				hh: "%d uur",
				d: "een dag",
				dd: "%d dagen",
				M: "een maand",
				MM: "%d maanden",
				y: "een jaar",
				yy: "%d jaar"
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), Hr = /* @__PURE__ */ zt(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(Br()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_it = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "it",
			weekdays: "domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"),
			weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
			weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
			months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),
			weekStart: 1,
			monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD/MM/YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "tra %s",
				past: "%s fa",
				s: "qualche secondo",
				m: "un minuto",
				mm: "%d minuti",
				h: "un' ora",
				hh: "%d ore",
				d: "un giorno",
				dd: "%d giorni",
				M: "un mese",
				MM: "%d mesi",
				y: "un anno",
				yy: "%d anni"
			},
			ordinal: function(e) {
				return e + "º";
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), Ur = /* @__PURE__ */ zt(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(Br()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_fr = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "fr",
			weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
			weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
			weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
			months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
			monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
			weekStart: 1,
			yearStart: 4,
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD/MM/YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "dans %s",
				past: "il y a %s",
				s: "quelques secondes",
				m: "une minute",
				mm: "%d minutes",
				h: "une heure",
				hh: "%d heures",
				d: "un jour",
				dd: "%d jours",
				M: "un mois",
				MM: "%d mois",
				y: "un an",
				yy: "%d ans"
			},
			ordinal: function(e) {
				return "" + e + (e === 1 ? "er" : "");
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), Wr = /* @__PURE__ */ zt(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_calendar = r();
	})(e, (function() {
		return function(e, t, n) {
			var r = "h:mm A", i = {
				lastDay: "[Yesterday at] " + r,
				sameDay: "[Today at] " + r,
				nextDay: "[Tomorrow at] " + r,
				nextWeek: "dddd [at] " + r,
				lastWeek: "[Last] dddd [at] " + r,
				sameElse: "MM/DD/YYYY"
			};
			t.prototype.calendar = function(e, t) {
				var r = t || this.$locale().calendar || i, a = n(e || void 0).startOf("d"), o = this.diff(a, "d", !0), s = "sameElse", c = o < -6 ? s : o < -1 ? "lastWeek" : o < 0 ? "lastDay" : o < 1 ? "sameDay" : o < 2 ? "nextDay" : o < 7 ? "nextWeek" : s, l = r[c] || i[c];
				return typeof l == "function" ? l.call(this, n()) : this.format(l);
			};
		};
	}));
})), Gr = /* @__PURE__ */ zt(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_customParseFormat = r();
	})(e, (function() {
		var e = {
			LTS: "h:mm:ss A",
			LT: "h:mm A",
			L: "MM/DD/YYYY",
			LL: "MMMM D, YYYY",
			LLL: "MMMM D, YYYY h:mm A",
			LLLL: "dddd, MMMM D, YYYY h:mm A"
		}, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d\d/, r = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, a = {}, o = function(e) {
			return (e = +e) + (e > 68 ? 1900 : 2e3);
		}, s = function(e) {
			return function(t) {
				this[e] = +t;
			};
		}, c = [/[+-]\d\d:?(\d\d)?|Z/, function(e) {
			(this.zone ||= {}).offset = function(e) {
				if (!e || e === "Z") return 0;
				var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
				return n === 0 ? 0 : t[0] === "+" ? -n : n;
			}(e);
		}], l = function(e) {
			var t = a[e];
			return t && (t.indexOf ? t : t.s.concat(t.f));
		}, u = function(e, t) {
			var n, r = a.meridiem;
			if (r) {
				for (var i = 1; i <= 24; i += 1) if (e.indexOf(r(i, 0, t)) > -1) {
					n = i > 12;
					break;
				}
			} else n = e === (t ? "pm" : "PM");
			return n;
		}, d = {
			A: [i, function(e) {
				this.afternoon = u(e, !1);
			}],
			a: [i, function(e) {
				this.afternoon = u(e, !0);
			}],
			S: [/\d/, function(e) {
				this.milliseconds = 100 * e;
			}],
			SS: [n, function(e) {
				this.milliseconds = 10 * e;
			}],
			SSS: [/\d{3}/, function(e) {
				this.milliseconds = +e;
			}],
			s: [r, s("seconds")],
			ss: [r, s("seconds")],
			m: [r, s("minutes")],
			mm: [r, s("minutes")],
			H: [r, s("hours")],
			h: [r, s("hours")],
			HH: [r, s("hours")],
			hh: [r, s("hours")],
			D: [r, s("day")],
			DD: [n, s("day")],
			Do: [i, function(e) {
				var t = a.ordinal, n = e.match(/\d+/);
				if (this.day = n[0], t) for (var r = 1; r <= 31; r += 1) t(r).replace(/\[|\]/g, "") === e && (this.day = r);
			}],
			M: [r, s("month")],
			MM: [n, s("month")],
			MMM: [i, function(e) {
				var t = l("months"), n = (l("monthsShort") || t.map((function(e) {
					return e.slice(0, 3);
				}))).indexOf(e) + 1;
				if (n < 1) throw Error();
				this.month = n % 12 || n;
			}],
			MMMM: [i, function(e) {
				var t = l("months").indexOf(e) + 1;
				if (t < 1) throw Error();
				this.month = t % 12 || t;
			}],
			Y: [/[+-]?\d+/, s("year")],
			YY: [n, function(e) {
				this.year = o(e);
			}],
			YYYY: [/\d{4}/, s("year")],
			Z: c,
			ZZ: c
		};
		function f(n) {
			for (var r = n, i = a && a.formats, o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (function(t, n, r) {
				var a = r && r.toUpperCase();
				return n || i[r] || e[r] || i[a].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (function(e, t, n) {
					return t || n.slice(1);
				}));
			}))).match(t), s = o.length, c = 0; c < s; c += 1) {
				var l = o[c], u = d[l], f = u && u[0], p = u && u[1];
				o[c] = p ? {
					regex: f,
					parser: p
				} : l.replace(/^\[|\]$/g, "");
			}
			return function(e) {
				for (var t = {}, n = 0, r = 0; n < s; n += 1) {
					var i = o[n];
					if (typeof i == "string") r += i.length;
					else {
						var a = i.regex, c = i.parser, l = e.slice(r), u = a.exec(l)[0];
						c.call(t, u), e = e.replace(u, "");
					}
				}
				return function(e) {
					var t = e.afternoon;
					if (t !== void 0) {
						var n = e.hours;
						t ? n < 12 && (e.hours += 12) : n === 12 && (e.hours = 0), delete e.afternoon;
					}
				}(t), t;
			};
		}
		return function(e, t, n) {
			n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (o = e.parseTwoDigitYear);
			var r = t.prototype, i = r.parse;
			r.parse = function(e) {
				var t = e.date, r = e.utc, o = e.args;
				this.$u = r;
				var s = o[1];
				if (typeof s == "string") {
					var c = !0 === o[2], l = !0 === o[3], u = c || l, d = o[2];
					l && (d = o[2]), a = this.$locale(), !c && d && (a = n.Ls[d]), this.$d = function(e, t, n) {
						try {
							if (["x", "X"].indexOf(t) > -1) return /* @__PURE__ */ new Date((t === "X" ? 1e3 : 1) * e);
							var r = f(t)(e), i = r.year, a = r.month, o = r.day, s = r.hours, c = r.minutes, l = r.seconds, u = r.milliseconds, d = r.zone, p = /* @__PURE__ */ new Date(), m = o || (i || a ? 1 : p.getDate()), h = i || p.getFullYear(), g = 0;
							i && !a || (g = a > 0 ? a - 1 : p.getMonth());
							var _ = s || 0, v = c || 0, ee = l || 0, y = u || 0;
							return d ? new Date(Date.UTC(h, g, m, _, v, ee, y + 60 * d.offset * 1e3)) : n ? new Date(Date.UTC(h, g, m, _, v, ee, y)) : new Date(h, g, m, _, v, ee, y);
						} catch {
							return /* @__PURE__ */ new Date("");
						}
					}(t, s, r), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(s) && (this.$d = /* @__PURE__ */ new Date("")), a = {};
				} else if (s instanceof Array) for (var p = s.length, m = 1; m <= p; m += 1) {
					o[1] = s[m - 1];
					var h = n.apply(this, o);
					if (h.isValid()) {
						this.$d = h.$d, this.$L = h.$L, this.init();
						break;
					}
					m === p && (this.$d = /* @__PURE__ */ new Date(""));
				}
				else i.call(this, e);
			};
		};
	}));
})), Kr = /* @__PURE__ */ zt(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isBetween = r();
	})(e, (function() {
		return function(e, t, n) {
			t.prototype.isBetween = function(e, t, r, i) {
				var a = n(e), o = n(t), s = (i ||= "()")[0] === "(", c = i[1] === ")";
				return (s ? this.isAfter(a, r) : !this.isBefore(a, r)) && (c ? this.isBefore(o, r) : !this.isAfter(o, r)) || (s ? this.isBefore(a, r) : !this.isAfter(a, r)) && (c ? this.isAfter(o, r) : !this.isBefore(o, r));
			};
		};
	}));
})), qr = /* @__PURE__ */ zt(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isLeapYear = r();
	})(e, (function() {
		return function(e, t) {
			t.prototype.isLeapYear = function() {
				return this.$y % 4 == 0 && this.$y % 100 != 0 || this.$y % 400 == 0;
			};
		};
	}));
})), Jr = /* @__PURE__ */ zt(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isToday = r();
	})(e, (function() {
		return function(e, t, n) {
			t.prototype.isToday = function() {
				var e = "YYYY-MM-DD", t = n();
				return this.format(e) === t.format(e);
			};
		};
	}));
})), Yr = /* @__PURE__ */ zt(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isYesterday = r();
	})(e, (function() {
		return function(e, t, n) {
			t.prototype.isYesterday = function() {
				var e = "YYYY-MM-DD", t = n().subtract(1, "day");
				return this.format(e) === t.format(e);
			};
		};
	}));
})), Xr = /* @__PURE__ */ zt(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_timezone = r();
	})(e, (function() {
		var e = {
			year: 0,
			month: 1,
			day: 2,
			hour: 3,
			minute: 4,
			second: 5
		}, t = {};
		return function(n, r, i) {
			var a, o = function(e, n, r) {
				r === void 0 && (r = {});
				var i = new Date(e);
				return function(e, n) {
					n === void 0 && (n = {});
					var r = n.timeZoneName || "short", i = e + "|" + r, a = t[i];
					return a || (a = new Intl.DateTimeFormat("en-US", {
						hour12: !1,
						timeZone: e,
						year: "numeric",
						month: "2-digit",
						day: "2-digit",
						hour: "2-digit",
						minute: "2-digit",
						second: "2-digit",
						timeZoneName: r
					}), t[i] = a), a;
				}(n, r).formatToParts(i);
			}, s = function(t, n) {
				for (var r = o(t, n), a = [], s = 0; s < r.length; s += 1) {
					var c = r[s], l = c.type, u = c.value, d = e[l];
					d >= 0 && (a[d] = parseInt(u, 10));
				}
				var f = a[3], p = f === 24 ? 0 : f, m = a[0] + "-" + a[1] + "-" + a[2] + " " + p + ":" + a[4] + ":" + a[5] + ":000", h = +t;
				return (i.utc(m).valueOf() - (h -= h % 1e3)) / 6e4;
			}, c = r.prototype;
			c.tz = function(e, t) {
				e === void 0 && (e = a);
				var n = this.utcOffset(), r = this.toDate(), o = r.toLocaleString("en-US", { timeZone: e }), s = Math.round((r - new Date(o)) / 1e3 / 60), c = i(o, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(r.getTimezoneOffset() / 15) - s, !0);
				if (t) {
					var l = c.utcOffset();
					c = c.add(n - l, "minute");
				}
				return c.$x.$timezone = e, c;
			}, c.offsetName = function(e) {
				var t = this.$x.$timezone || i.tz.guess(), n = o(this.valueOf(), t, { timeZoneName: e }).find((function(e) {
					return e.type.toLowerCase() === "timezonename";
				}));
				return n && n.value;
			};
			var l = c.startOf;
			c.startOf = function(e, t) {
				if (!this.$x || !this.$x.$timezone) return l.call(this, e, t);
				var n = i(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
				return l.call(n, e, t).tz(this.$x.$timezone, !0);
			}, i.tz = function(e, t, n) {
				var r = n && t, o = n || t || a, c = s(+i(), o);
				if (typeof e != "string") return i(e).tz(o);
				var l = function(e, t, n) {
					var r = e - 60 * t * 1e3, i = s(r, n);
					if (t === i) return [r, t];
					var a = s(r -= 60 * (i - t) * 1e3, n);
					return i === a ? [r, i] : [e - 60 * Math.min(i, a) * 1e3, Math.max(i, a)];
				}(i.utc(e, r).valueOf(), c, o), u = l[0], d = l[1], f = i(u).utcOffset(d);
				return f.$x.$timezone = o, f;
			}, i.tz.guess = function() {
				return Intl.DateTimeFormat().resolvedOptions().timeZone;
			}, i.tz.setDefault = function(e) {
				a = e;
			};
		};
	}));
})), Zr = /* @__PURE__ */ zt(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_utc = r();
	})(e, (function() {
		var e = "minute", t = /[+-]\d\d(?::?\d\d)?/g, n = /([+-]|\d\d)/g;
		return function(r, i, a) {
			var o = i.prototype;
			a.utc = function(e) {
				return new i({
					date: e,
					utc: !0,
					args: arguments
				});
			}, o.utc = function(t) {
				var n = a(this.toDate(), {
					locale: this.$L,
					utc: !0
				});
				return t ? n.add(this.utcOffset(), e) : n;
			}, o.local = function() {
				return a(this.toDate(), {
					locale: this.$L,
					utc: !1
				});
			};
			var s = o.parse;
			o.parse = function(e) {
				e.utc && (this.$u = !0), this.$utils().u(e.$offset) || (this.$offset = e.$offset), s.call(this, e);
			};
			var c = o.init;
			o.init = function() {
				if (this.$u) {
					var e = this.$d;
					this.$y = e.getUTCFullYear(), this.$M = e.getUTCMonth(), this.$D = e.getUTCDate(), this.$W = e.getUTCDay(), this.$H = e.getUTCHours(), this.$m = e.getUTCMinutes(), this.$s = e.getUTCSeconds(), this.$ms = e.getUTCMilliseconds();
				} else c.call(this);
			};
			var l = o.utcOffset;
			o.utcOffset = function(r, i) {
				var a = this.$utils().u;
				if (a(r)) return this.$u ? 0 : a(this.$offset) ? l.call(this) : this.$offset;
				if (typeof r == "string" && (r = function(e) {
					e === void 0 && (e = "");
					var r = e.match(t);
					if (!r) return null;
					var i = ("" + r[0]).match(n) || [
						"-",
						0,
						0
					], a = i[0], o = 60 * i[1] + +i[2];
					return o === 0 ? 0 : a === "+" ? o : -o;
				}(r), r === null)) return this;
				var o = Math.abs(r) <= 16 ? 60 * r : r, s = this;
				if (i) return s.$offset = o, s.$u = r === 0, s;
				if (r !== 0) {
					var c = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
					(s = this.local().add(o + c, e)).$offset = o, s.$x.$localOffset = c;
				} else s = this.utc();
				return s;
			};
			var u = o.format;
			o.format = function(e) {
				var t = e || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
				return u.call(this, t);
			}, o.valueOf = function() {
				var e = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
				return this.$d.valueOf() - 6e4 * e;
			}, o.isUTC = function() {
				return !!this.$u;
			}, o.toISOString = function() {
				return this.toDate().toISOString();
			}, o.toString = function() {
				return this.toDate().toUTCString();
			};
			var d = o.toDate;
			o.toDate = function(e) {
				return e === "s" && this.$offset ? a(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : d.call(this);
			};
			var f = o.diff;
			o.diff = function(e, t, n) {
				if (e && this.$u === e.$u) return f.call(this, e, t, n);
				var r = this.local(), i = a(e).local();
				return f.call(r, i, t, n);
			};
		};
	}));
}));
Vr(), Hr(), Ur();
var Qr = /* @__PURE__ */ Ht(Br(), 1), $r = /* @__PURE__ */ Ht(Wr(), 1), ei = /* @__PURE__ */ Ht(Gr(), 1), ti = /* @__PURE__ */ Ht(Kr(), 1), ni = /* @__PURE__ */ Ht(qr(), 1), ri = /* @__PURE__ */ Ht(Jr(), 1), ii = /* @__PURE__ */ Ht(Yr(), 1), ai = /* @__PURE__ */ Ht(Xr(), 1), oi = /* @__PURE__ */ Ht(Zr(), 1);
Qr.default.extend(ei.default), Qr.default.extend(ni.default), Qr.default.extend($r.default), Qr.default.extend(oi.default), Qr.default.extend(ti.default), Qr.default.extend(ri.default), Qr.default.extend(ii.default), Qr.default.extend(ai.default), Qr.default.locale("nl"), Qr.default.tz.setDefault("Europe/Amsterdam");
var si = Qr.default, ci = (e) => e === Kt.Morning, li = (e) => e === Kt.Evening, ui = (e) => [Kt.Pickup, Kt.PickupExpress].includes(e), di = (e) => [
	Kt.EarlyMorning,
	Kt.Morning,
	Kt.Standard,
	Kt.Evening,
	Kt.SameDayDelivery,
	Kt.Express
].includes(e), fi = (e, { locale: t = "nl-NL", currency: n = "EUR", ...r } = {}) => new Intl.NumberFormat(t, {
	style: "currency",
	currency: n,
	...r
}).format(e / 100), pi = {
	format: fi,
	fromMoney: (e) => e ? typeof e.micros == "number" ? e.micros / 1e4 : (e.integral ?? 0) * 100 + (e.fractional ?? 0) : 0,
	rounded: (e) => `${fi(e, {
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	})},-`,
	toCents: (e) => Math.round(e * 100),
	toMoney: (e, t) => {
		let n = Math.round(e * 1e4), r = Math.floor(n / 1e4);
		return {
			currency: t ?? "EUR",
			integral: Math.floor(r / 100),
			fractional: r % 100,
			micros: n
		};
	},
	toNumberFromSegments: (e) => {
		if (!e) return 0;
		let t = e?.integral ?? 0, n = e?.fractional ?? 0;
		return t * 100 + n;
	},
	toNumberFromString: (e) => {
		let t = e?.trim() ?? "", n = Math.max(t.lastIndexOf("."), t.lastIndexOf(","));
		if (n >= 0) {
			let e = t.substring(0, n), r = t.substring(n + 1);
			return e = e.replace(/[.,]/g, ""), r.length < 2 ? r = r.padEnd(2, "0") : r.length > 2 && (r = r.substring(0, 2)), parseInt(e + r, 10);
		}
		return parseInt(t.replace(/[.,]/g, ""), 10);
	},
	toSegments: (e) => ({
		integral: Math.floor(e / 100),
		fractional: e % 100
	})
}, mi = { toCentimeters: (e, t) => {
	switch (t) {
		case on.Millimeter:
		case an.Millimeter: return e * sn[on.Millimeter];
		case on.Centimeter:
		case an.Centimeter: return e;
		case on.Meter:
		case an.Meter: return e * sn[on.Meter];
		default: throw Error(`Unknown unit ${t}`);
	}
} }, hi = { toBytes: (e) => {
	if (!e) return "0 b";
	let t = 1024, n = [
		"b",
		"kb",
		"mb",
		"gb"
	], r = Math.floor(Math.log(e) / Math.log(t));
	return `${Math.round(e / t ** r * 100) / 100} ${n[r]}`.replace(".", ",");
} }, gi = {
	toCeiledDecimal: (e, t = 1) => {
		let n = 10 ** t;
		return Math.ceil(e * n) / n;
	},
	toRoundedDecimal: (e, t = 1) => {
		let n = 10 ** t;
		return Math.round(e * n) / n;
	},
	formatCompactNumber: (e) => {
		if (e < 1e3) return String(e);
		let t = e / 1e3;
		return t % 1 == 0 ? `${t}k` : `${t.toFixed(1).replace(/\.0$/, "")}k`;
	}
}, _i = { toTime: (e, t) => si(e, "HH:mm:ss").format(t) }, vi = { parseUrlFromDoubleSlashes: (e) => e.replace(/([^:]\/)\/+/g, "$1") }, yi = (e, t) => {
	switch (t) {
		case nn.Gram:
		case tn.Gram: return e;
		case nn.Kilogram:
		case tn.Kilogram: return e * rn[nn.Kilogram];
		default: throw Error(`Unknown unit ${t}`);
	}
}, bi = (e, t) => {
	switch (t) {
		case tn.Gram:
		case nn.Gram: return e / rn[nn.Kilogram];
		case nn.Kilogram:
		case tn.Kilogram: return e;
		default: throw Error(`Unknown unit ${t}`);
	}
}, xi = (e, t, n = { round: !0 }) => {
	if (t === tn.Gram) return `${e}g`;
	if (t === tn.Kilogram) return `${n.round ? Math.round(e) : e}kg`;
	throw Error(`Unknown unit ${t}`);
}, Si = {
	currency: pi,
	dimensions: mi,
	weight: {
		toGrams: yi,
		toKilograms: bi,
		toString: xi,
		toMinMaxString: (e, t, n) => (n === tn.Kilogram && (e = bi(e, tn.Gram), t = bi(t, tn.Gram)), `${xi(e, n)} - ${xi(t, n)}`)
	},
	time: _i,
	url: vi,
	fileSize: hi,
	number: gi
}, Ci = {
	[Dn.MILLIMETER]: "unit.millimeter.short",
	[Dn.CENTIMETER]: "unit.centimeter.short",
	[Dn.DECIMETER]: "unit.decimeter.short",
	[Dn.METER]: "unit.meter.short",
	[Dn.KILOMETER]: "unit.kilometer.short",
	[On.GRAM]: "unit.gram.short",
	[On.KILOGRAM]: "unit.kilogram.short"
}, wi = (e) => Ci[e], Ti = (e) => {
	switch (e) {
		case "g":
		case nn.Gram:
		case tn.Gram: return rn[nn.Gram];
		case nn.Kilogram:
		case tn.Kilogram: return rn[nn.Kilogram];
		default: throw Error(`Unknown weight unit: ${e}`);
	}
}, Ei = {
	[Dn.MILLIMETER]: 1,
	[Dn.CENTIMETER]: 10,
	[Dn.DECIMETER]: 100,
	[Dn.METER]: 1e3,
	[Dn.KILOMETER]: 1e6
}, Di = ({ value: e, unit: t }, n) => {
	let r = Ei[t], i = Ei[n];
	return !r || !i ? e : e * r / i;
}, Oi = (e) => Object.hasOwn(Ei, e), ki = ({ value: e, unit: t }) => Oi(t) ? Di({
	value: e,
	unit: t
}, Dn.CENTIMETER) : void 0, Ai = ({ value: e, unit: t }) => Oi(t) ? Di({
	value: e,
	unit: t
}, Dn.METER) : void 0, ji = ({ value: e, unit: t }) => Oi(t) ? Di({
	value: e,
	unit: t
}, Dn.MILLIMETER) : void 0, Mi = ({ value: e, unit: t }) => Oi(t) ? Di({
	value: e,
	unit: t
}, Dn.KILOMETER) : void 0, Ni = {
	[On.GRAM]: 1,
	[On.KILOGRAM]: 1e3
}, Pi = ({ value: e, unit: t }, n) => {
	let r = Ni[t], i = Ni[n];
	return !r || !i ? e : e * r / i;
}, Fi = (e) => Object.hasOwn(Ni, e), Ii = {
	convertLengthUnit: Di,
	convertMassUnit: Pi,
	getUnitTranslationKey: wi,
	getWeightFactor: Ti,
	isLengthUnit: Oi,
	isMassUnit: Fi,
	toCentimetres: ki,
	toGrams: ({ value: e, unit: t }) => Fi(t) ? Pi({
		value: e,
		unit: t
	}, On.GRAM) : void 0,
	toKilograms: ({ value: e, unit: t }) => Fi(t) ? Pi({
		value: e,
		unit: t
	}, On.KILOGRAM) : void 0,
	toKilometres: Mi,
	toMetres: Ai,
	toMillimetres: ji,
	transformMetersToKilometers: (e) => {
		let t = e / 1e3;
		return t % 1 == 0 ? t : parseFloat(t.toFixed(1));
	}
}, Li = { bodySerializer: (e) => JSON.stringify(e, (e, t) => typeof t == "bigint" ? t.toString() : t) };
Object.entries({
	$body_: "body",
	$headers_: "headers",
	$path_: "path",
	$query_: "query"
});
var Ri = ({ onRequest: e, onSseError: t, onSseEvent: n, responseTransformer: r, responseValidator: i, sseDefaultRetryDelay: a, sseMaxRetryAttempts: o, sseMaxRetryDelay: s, sseSleepFn: c, url: l, ...u }) => {
	let d, f = c ?? ((e) => new Promise((t) => setTimeout(t, e)));
	return { stream: async function* () {
		let c = a ?? 3e3, p = 0, m = u.signal ?? new AbortController().signal;
		for (; !m.aborted;) {
			p++;
			let a = u.headers instanceof Headers ? u.headers : new Headers(u.headers);
			d !== void 0 && a.set("Last-Event-ID", d);
			try {
				let t = {
					redirect: "follow",
					...u,
					body: u.serializedBody,
					headers: a,
					signal: m
				}, o = new Request(l, t);
				e && (o = await e(l, t));
				let s = await (u.fetch ?? globalThis.fetch)(o);
				if (!s.ok) throw Error(`SSE failed: ${s.status} ${s.statusText}`);
				if (!s.body) throw Error("No body in SSE response");
				let f = s.body.pipeThrough(new TextDecoderStream()).getReader(), p = "", h = () => {
					try {
						f.cancel();
					} catch {}
				};
				m.addEventListener("abort", h);
				try {
					for (;;) {
						let { done: e, value: t } = await f.read();
						if (e) break;
						p += t, p = p.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
						let a = p.split("\n\n");
						p = a.pop() ?? "";
						for (let e of a) {
							let t = e.split("\n"), a = [], o;
							for (let e of t) if (e.startsWith("data:")) a.push(e.replace(/^data:\s*/, ""));
							else if (e.startsWith("event:")) o = e.replace(/^event:\s*/, "");
							else if (e.startsWith("id:")) d = e.replace(/^id:\s*/, "");
							else if (e.startsWith("retry:")) {
								let t = Number.parseInt(e.replace(/^retry:\s*/, ""), 10);
								Number.isNaN(t) || (c = t);
							}
							let s, l = !1;
							if (a.length) {
								let e = a.join("\n");
								try {
									s = JSON.parse(e), l = !0;
								} catch {
									s = e;
								}
							}
							l && (i && await i(s), r && (s = await r(s))), n?.({
								data: s,
								event: o,
								id: d,
								retry: c
							}), a.length && (yield s);
						}
					}
				} finally {
					m.removeEventListener("abort", h), f.releaseLock();
				}
				break;
			} catch (e) {
				if (t?.(e), o !== void 0 && p >= o) break;
				let n = Math.min(c * 2 ** (p - 1), s ?? 3e4);
				await f(n);
			}
		}
	}() };
}, zi = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, Bi = (e) => {
	switch (e) {
		case "form": return ",";
		case "pipeDelimited": return "|";
		case "spaceDelimited": return "%20";
		default: return ",";
	}
}, Vi = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, Hi = ({ allowReserved: e, explode: t, name: n, style: r, value: i }) => {
	if (!t) {
		let t = (e ? i : i.map((e) => encodeURIComponent(e))).join(Bi(r));
		switch (r) {
			case "label": return `.${t}`;
			case "matrix": return `;${n}=${t}`;
			case "simple": return t;
			default: return `${n}=${t}`;
		}
	}
	let a = zi(r), o = i.map((t) => r === "label" || r === "simple" ? e ? t : encodeURIComponent(t) : Ui({
		allowReserved: e,
		name: n,
		value: t
	})).join(a);
	return r === "label" || r === "matrix" ? a + o : o;
}, Ui = ({ allowReserved: e, name: t, value: n }) => {
	if (n == null) return "";
	if (typeof n == "object") throw Error("Deeply-nested arrays/objects aren’t supported. Provide your own `querySerializer()` to handle these.");
	return `${t}=${e ? n : encodeURIComponent(n)}`;
}, Wi = ({ allowReserved: e, explode: t, name: n, style: r, value: i, valueOnly: a }) => {
	if (i instanceof Date) return a ? i.toISOString() : `${n}=${i.toISOString()}`;
	if (r !== "deepObject" && !t) {
		let t = [];
		Object.entries(i).forEach(([n, r]) => {
			t = [
				...t,
				n,
				e ? r : encodeURIComponent(r)
			];
		});
		let a = t.join(",");
		switch (r) {
			case "form": return `${n}=${a}`;
			case "label": return `.${a}`;
			case "matrix": return `;${n}=${a}`;
			default: return a;
		}
	}
	let o = Vi(r), s = Object.entries(i).map(([t, i]) => Ui({
		allowReserved: e,
		name: r === "deepObject" ? `${n}[${t}]` : t,
		value: i
	})).join(o);
	return r === "label" || r === "matrix" ? o + s : s;
}, Gi = /\{[^{}]+\}/g, Ki = ({ path: e, url: t }) => {
	let n = t, r = t.match(Gi);
	if (r) for (let t of r) {
		let r = !1, i = t.substring(1, t.length - 1), a = "simple";
		i.endsWith("*") && (r = !0, i = i.substring(0, i.length - 1)), i.startsWith(".") ? (i = i.substring(1), a = "label") : i.startsWith(";") && (i = i.substring(1), a = "matrix");
		let o = e[i];
		if (o == null) continue;
		if (Array.isArray(o)) {
			n = n.replace(t, Hi({
				explode: r,
				name: i,
				style: a,
				value: o
			}));
			continue;
		}
		if (typeof o == "object") {
			n = n.replace(t, Wi({
				explode: r,
				name: i,
				style: a,
				value: o,
				valueOnly: !0
			}));
			continue;
		}
		if (a === "matrix") {
			n = n.replace(t, `;${Ui({
				name: i,
				value: o
			})}`);
			continue;
		}
		let s = encodeURIComponent(a === "label" ? `.${o}` : o);
		n = n.replace(t, s);
	}
	return n;
}, qi = ({ baseUrl: e, path: t, query: n, querySerializer: r, url: i }) => {
	let a = i.startsWith("/") ? i : `/${i}`, o = (e ?? "") + a;
	t && (o = Ki({
		path: t,
		url: o
	}));
	let s = n ? r(n) : "";
	return s.startsWith("?") && (s = s.substring(1)), s && (o += `?${s}`), o;
};
function Ji(e) {
	let t = e.body !== void 0;
	if (t && e.bodySerializer) return "serializedBody" in e ? e.serializedBody !== void 0 && e.serializedBody !== "" ? e.serializedBody : null : e.body === "" ? null : e.body;
	if (t) return e.body;
}
var Yi = async (e, t) => {
	let n = typeof t == "function" ? await t(e) : t;
	if (n) return e.scheme === "bearer" ? `Bearer ${n}` : e.scheme === "basic" ? `Basic ${btoa(n)}` : n;
}, Xi = ({ parameters: e = {}, ...t } = {}) => (n) => {
	let r = [];
	if (n && typeof n == "object") for (let i in n) {
		let a = n[i];
		if (a == null) continue;
		let o = e[i] || t;
		if (Array.isArray(a)) {
			let e = Hi({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "form",
				value: a,
				...o.array
			});
			e && r.push(e);
		} else if (typeof a == "object") {
			let e = Wi({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "deepObject",
				value: a,
				...o.object
			});
			e && r.push(e);
		} else {
			let e = Ui({
				allowReserved: o.allowReserved,
				name: i,
				value: a
			});
			e && r.push(e);
		}
	}
	return r.join("&");
}, Zi = (e) => {
	if (!e) return "stream";
	let t = e.split(";")[0]?.trim();
	if (t) {
		if (t.startsWith("application/json") || t.endsWith("+json")) return "json";
		if (t === "multipart/form-data") return "formData";
		if ([
			"application/",
			"audio/",
			"image/",
			"video/"
		].some((e) => t.startsWith(e))) return "blob";
		if (t.startsWith("text/")) return "text";
	}
}, Qi = (e, t) => t ? !!(e.headers.has(t) || e.query?.[t] || e.headers.get("Cookie")?.includes(`${t}=`)) : !1, $i = async ({ security: e, ...t }) => {
	for (let n of e) {
		if (Qi(t, n.name)) continue;
		let e = await Yi(n, t.auth);
		if (!e) continue;
		let r = n.name ?? "Authorization";
		switch (n.in) {
			case "query":
				t.query ||= {}, t.query[r] = e;
				break;
			case "cookie":
				t.headers.append("Cookie", `${r}=${e}`);
				break;
			default: t.headers.set(r, e);
		}
	}
}, ea = (e) => qi({
	baseUrl: e.baseUrl,
	path: e.path,
	query: e.query,
	querySerializer: typeof e.querySerializer == "function" ? e.querySerializer : Xi(e.querySerializer),
	url: e.url
}), ta = (e, t) => {
	let n = {
		...e,
		...t
	};
	return n.baseUrl?.endsWith("/") && (n.baseUrl = n.baseUrl.substring(0, n.baseUrl.length - 1)), n.headers = ra(e.headers, t.headers), n;
}, na = (e) => {
	let t = [];
	return e.forEach((e, n) => {
		t.push([n, e]);
	}), t;
}, ra = (...e) => {
	let t = new Headers();
	for (let n of e) {
		if (!n) continue;
		let e = n instanceof Headers ? na(n) : Object.entries(n);
		for (let [n, r] of e) if (r === null) t.delete(n);
		else if (Array.isArray(r)) for (let e of r) t.append(n, e);
		else r !== void 0 && t.set(n, typeof r == "object" ? JSON.stringify(r) : r);
	}
	return t;
}, ia = class {
	fns = [];
	clear() {
		this.fns = [];
	}
	eject(e) {
		let t = this.getInterceptorIndex(e);
		this.fns[t] && (this.fns[t] = null);
	}
	exists(e) {
		let t = this.getInterceptorIndex(e);
		return !!this.fns[t];
	}
	getInterceptorIndex(e) {
		return typeof e == "number" ? this.fns[e] ? e : -1 : this.fns.indexOf(e);
	}
	update(e, t) {
		let n = this.getInterceptorIndex(e);
		return this.fns[n] ? (this.fns[n] = t, e) : !1;
	}
	use(e) {
		return this.fns.push(e), this.fns.length - 1;
	}
}, aa = () => ({
	error: new ia(),
	request: new ia(),
	response: new ia()
}), oa = Xi({
	allowReserved: !1,
	array: {
		explode: !0,
		style: "form"
	},
	object: {
		explode: !0,
		style: "deepObject"
	}
}), sa = { "Content-Type": "application/json" }, ca = (e = {}) => ({
	...Li,
	headers: sa,
	parseAs: "auto",
	querySerializer: oa,
	...e
});
((e = {}) => {
	let t = ta(ca(), e), n = () => ({ ...t }), r = (e) => (t = ta(t, e), n()), i = aa(), a = async (e) => {
		let n = {
			...t,
			...e,
			fetch: e.fetch ?? t.fetch ?? globalThis.fetch,
			headers: ra(t.headers, e.headers),
			serializedBody: void 0
		};
		return n.security && await $i({
			...n,
			security: n.security
		}), n.requestValidator && await n.requestValidator(n), n.body !== void 0 && n.bodySerializer && (n.serializedBody = n.bodySerializer(n.body)), (n.body === void 0 || n.serializedBody === "") && n.headers.delete("Content-Type"), {
			opts: n,
			url: ea(n)
		};
	}, o = async (e) => {
		let { opts: t, url: n } = await a(e), r = {
			redirect: "follow",
			...t,
			body: Ji(t)
		}, o = new Request(n, r);
		for (let e of i.request.fns) e && (o = await e(o, t));
		let s = t.fetch, c;
		try {
			c = await s(o);
		} catch (e) {
			let n = e;
			for (let r of i.error.fns) r && (n = await r(e, void 0, o, t));
			if (n ||= {}, t.throwOnError) throw n;
			return t.responseStyle === "data" ? void 0 : {
				error: n,
				request: o,
				response: void 0
			};
		}
		for (let e of i.response.fns) e && (c = await e(c, o, t));
		let l = {
			request: o,
			response: c
		};
		if (c.ok) {
			let e = (t.parseAs === "auto" ? Zi(c.headers.get("Content-Type")) : t.parseAs) ?? "json";
			if (c.status === 204 || c.headers.get("Content-Length") === "0") {
				let n;
				switch (e) {
					case "arrayBuffer":
					case "blob":
					case "text":
						n = await c[e]();
						break;
					case "formData":
						n = new FormData();
						break;
					case "stream":
						n = c.body;
						break;
					default: n = {};
				}
				return t.responseStyle === "data" ? n : {
					data: n,
					...l
				};
			}
			let n;
			switch (e) {
				case "arrayBuffer":
				case "blob":
				case "formData":
				case "text":
					n = await c[e]();
					break;
				case "json": {
					let e = await c.text();
					n = e ? JSON.parse(e) : {};
					break;
				}
				case "stream": return t.responseStyle === "data" ? c.body : {
					data: c.body,
					...l
				};
			}
			return e === "json" && (t.responseValidator && await t.responseValidator(n), t.responseTransformer && (n = await t.responseTransformer(n))), t.responseStyle === "data" ? n : {
				data: n,
				...l
			};
		}
		let u = await c.text(), d;
		try {
			d = JSON.parse(u);
		} catch {}
		let f = d ?? u, p = f;
		for (let e of i.error.fns) e && (p = await e(f, c, o, t));
		if (p ||= {}, t.throwOnError) throw p;
		return t.responseStyle === "data" ? void 0 : {
			error: p,
			...l
		};
	}, s = (e) => (t) => o({
		...t,
		method: e
	}), c = (e) => async (t) => {
		let { opts: n, url: r } = await a(t);
		return Ri({
			...n,
			body: n.body,
			headers: n.headers,
			method: e,
			onRequest: async (e, t) => {
				let r = new Request(e, t);
				for (let e of i.request.fns) e && (r = await e(r, n));
				return r;
			},
			serializedBody: Ji(n),
			url: r
		});
	};
	return {
		buildUrl: (e) => ea({
			...t,
			...e
		}),
		connect: s("CONNECT"),
		delete: s("DELETE"),
		get: s("GET"),
		getConfig: n,
		head: s("HEAD"),
		interceptors: i,
		options: s("OPTIONS"),
		patch: s("PATCH"),
		post: s("POST"),
		put: s("PUT"),
		request: o,
		setConfig: r,
		sse: {
			connect: c("CONNECT"),
			delete: c("DELETE"),
			get: c("GET"),
			head: c("HEAD"),
			options: c("OPTIONS"),
			patch: c("PATCH"),
			post: c("POST"),
			put: c("PUT"),
			trace: c("TRACE")
		},
		trace: s("TRACE")
	};
})(ca({
	baseUrl: "https://order.api.myparcel.nl",
	throwOnError: !0
}));
var la = S.string().length(2).regex(/[A-Z]{2}/).register(S.globalRegistry, { description: "ISO 3166-1 alpha-2 country code." }), ua = S.object({
	city: S.string().min(1).max(100).register(S.globalRegistry, { description: "The city of the address." }),
	countryCode: la,
	street: S.string().min(1).max(100).register(S.globalRegistry, { description: "The street of the address." }),
	additionalInformation: S.string().min(1).max(100).register(S.globalRegistry, { description: "Additional information about the address." }).optional(),
	boxNumber: S.string().min(1).max(20).register(S.globalRegistry, { description: "The box number of the address, only applicable for specific country codes." }).optional(),
	houseNumber: S.string().min(1).max(25).register(S.globalRegistry, { description: "The house number of the address." }).optional(),
	houseNumberSuffix: S.string().min(1).max(25).register(S.globalRegistry, { description: "The house number suffix of the address." }).optional(),
	postalCode: S.string().min(1).max(15).register(S.globalRegistry, { description: "The postal code of the address." }).optional(),
	region: S.string().min(1).max(100).register(S.globalRegistry, { description: "The region of the address." }).optional(),
	state: S.string().min(1).max(100).register(S.globalRegistry, { description: "The state of the address." }).optional()
}).register(S.globalRegistry, { description: "A physical address." }), da = S.enum([
	"BPOST",
	"BRT",
	"CHEAP_CARGO",
	"DHL_EUROPLUS",
	"DHL_FOR_YOU",
	"DHL_FREIGHT",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"GLS",
	"INPOST",
	"POSTNL",
	"POSTE_ITALIANE",
	"SPRING",
	"TRUNKRS",
	"UPS_EXPRESS_SAVER",
	"UPS_STANDARD",
	"VIA_TIM",
	"BOL"
]).register(S.globalRegistry, { description: "The carrier of the package." }), fa = S.enum([
	"BPOST",
	"BRT",
	"CHEAP_CARGO",
	"DHL_EUROPLUS",
	"DHL_FOR_YOU",
	"DHL_FREIGHT",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"GLS",
	"INPOST",
	"POSTNL",
	"POSTE_ITALIANE",
	"SPRING",
	"TRUNKRS",
	"UPS_EXPRESS_SAVER",
	"UPS_STANDARD",
	"VIA_TIM"
]).register(S.globalRegistry, { description: "The carrier to select to ship a package with." }), pa = S.object({
	groups: S.array(S.object({
		description: S.string().min(1).max(50).register(S.globalRegistry, { description: "A clear and detailed description of the goods within this group." }),
		hsCode: S.string().min(6).max(12).register(S.globalRegistry, { description: "The Harmonized System (HS) code for the goods in this group, a globally recognized classification for traded products." }),
		numberOfItems: S.int().gte(1).lte(99999).register(S.globalRegistry, { description: "The total quantity of individual items within this specific group." }),
		totalValue: S.object({
			currency: S.string().length(3).register(S.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
			micros: S.int().gte(0).lte(9007199254740991).register(S.globalRegistry, { description: "The amount of money in integer micros." })
		}).register(S.globalRegistry, { description: "The total declared value of all items within this group." }),
		totalWeight: S.object({
			unit: S.enum(["g", "kg"]).register(S.globalRegistry, { description: "The unit of weight." }),
			value: S.int().gte(1).lte(999999999)
		}).register(S.globalRegistry, { description: "The total weight of all items within this specific group." }),
		countryCodeOfOrigin: la.and(S.unknown().register(S.globalRegistry, { description: "The ISO 3166-1 alpha-2 country code indicating where the goods in this group originated." })).optional()
	}).register(S.globalRegistry, { description: "A consolidated group of items within a customs declaration that share common customs attributes." })).min(1).max(100).register(S.globalRegistry, { description: "The list of item groups." }),
	purpose: S.enum([
		"COMMERCIAL_GOODS",
		"COMMERCIAL_SAMPLE",
		"DOCUMENTS",
		"GIFT",
		"RETURNED_GOODS"
	]).register(S.globalRegistry, { description: "The primary reason or purpose for the international shipment." }),
	totalWeight: S.object({
		unit: S.enum(["g", "kg"]).register(S.globalRegistry, { description: "The unit of weight." }),
		value: S.int().gte(1).lte(999999999)
	}).register(S.globalRegistry, { description: "The total weight of all items declared within this customs declaration." }),
	invoiceNumber: S.string().min(1).max(150).register(S.globalRegistry, { description: "The identifying number of the commercial invoice associated with this shipment." }).optional()
}).register(S.globalRegistry, { description: "The official declaration of goods for customs clearance purposes during international shipment." }), ma = S.object({
	groups: S.array(S.object({
		description: S.string().min(1).max(100).register(S.globalRegistry, { description: "A clear and detailed description of the goods within this group." }),
		hsCode: S.string().min(6).max(12).register(S.globalRegistry, { description: "The Harmonized System (HS) code for the goods in this group, a globally recognized classification for traded products." }),
		numberOfItems: S.int().gte(1).lte(99999).register(S.globalRegistry, { description: "The total quantity of individual items within this specific group." }),
		totalValue: S.object({
			currency: S.string().length(3).register(S.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
			micros: S.int().gte(0).lte(9007199254740991).register(S.globalRegistry, { description: "The amount of money in integer micros." })
		}).register(S.globalRegistry, { description: "The total declared value of all items within this group." }),
		totalWeight: S.object({
			unit: S.enum(["g", "kg"]).register(S.globalRegistry, { description: "The total weight of all items within this specific group." }),
			value: S.int().gte(1).lte(999999999)
		}).register(S.globalRegistry, { description: "The total weight of all items within this specific group." }),
		countryCodeOfOrigin: la.and(S.unknown().register(S.globalRegistry, { description: "The ISO 3166-1 alpha-2 country code indicating where the goods in this group originated." })).optional()
	}).register(S.globalRegistry, { description: "A consolidated group of items within a customs declaration that share common customs attributes." })).min(1).max(100).register(S.globalRegistry, { description: "The list of item groups." }),
	purpose: S.enum([
		"COMMERCIAL_GOODS",
		"COMMERCIAL_SAMPLE",
		"DOCUMENTS",
		"GIFT",
		"RETURNED_GOODS"
	]).register(S.globalRegistry, { description: "The primary reason or purpose for the international shipment." }),
	totalWeight: S.object({
		unit: S.enum(["g", "kg"]).register(S.globalRegistry, { description: "The total weight of all items declared within this customs declaration." }),
		value: S.int().gte(1).lte(999999999)
	}).register(S.globalRegistry, { description: "The total weight of all items declared within this customs declaration." }),
	invoiceNumber: S.string().min(1).max(150).register(S.globalRegistry, { description: "The identifying number of the commercial invoice associated with this shipment." }).optional()
}).register(S.globalRegistry, { description: "The official declaration of goods for customs clearance purposes during international shipment." }), ha = S.string().min(1).max(100).register(S.globalRegistry, { description: "The customer reference of the order." }), ga = S.enum([
	"EARLY_MORNING_DELIVERY",
	"EVENING_DELIVERY",
	"EXPRESS_DELIVERY",
	"MORNING_DELIVERY",
	"PICKUP_EXPRESS_DELIVERY",
	"PICKUP_DELIVERY",
	"SAME_DAY_DELIVERY",
	"STANDARD_DELIVERY"
]).register(S.globalRegistry, { description: "The delivery type of the shipment." }), _a = S.object({
	notifyOnDelivery: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Notify sender upon package delivery." }).optional(),
	preferredDate: S.object({ date: S.iso.date().register(S.globalRegistry, { description: "Recipient specified preferred delivery date." }) }).register(S.globalRegistry, { description: "This option allows you to set a preferred date for delivery, so a drop off date can be calculated." }).optional()
}).register(S.globalRegistry, { description: "Options regarding delivery timing and notifications." }), va = S.object({
	options: _a.optional(),
	type: ga.optional()
}).register(S.globalRegistry, { description: "The delivery details of the shipment." }), ya = S.object({ date: S.iso.date().register(S.globalRegistry, { description: "The date at which to drop off the package." }).optional() }).register(S.globalRegistry, { description: "The drop-off details." }), ba = S.object({
	currency: S.string().length(3).register(S.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
	micros: S.int().gte(0).lte(9007199254740991).register(S.globalRegistry, { description: "The amount of money in integer micros." })
}).register(S.globalRegistry, { description: "A monetary value represented by split integral and fractional parts to avoid floating point errors." }), xa = S.enum(["EU", "NON_EU"]).register(S.globalRegistry, { description: "A geographic area code that represents a specific list of countries." }), Sa = S.enum([
	"CANCELED",
	"COMPLETED",
	"DISCOVERED",
	"IMPORT_REQUESTED",
	"OPEN",
	"PROCESSING",
	"RETURNING"
]).register(S.globalRegistry, { description: "The status of the order." }), Ca = S.enum([
	"DIGITAL_STAMP",
	"ENVELOPE",
	"MAILBOX",
	"PACKAGE",
	"PALLET",
	"SMALL_PACKAGE",
	"UNFRANKED"
]).register(S.globalRegistry, { description: "The type of the package." }), wa = S.union([
	S.object({
		group: S.enum(["PICKING_AND_PACKING"]),
		name: S.enum(["PACKED"])
	}),
	S.object({
		group: S.enum(["DISPATCHING"]),
		name: S.enum(["READY_TO_SHIP"])
	}),
	S.object({
		group: S.enum(["DISPATCHING"]),
		name: S.enum(["LABELED"])
	}),
	S.object({
		group: S.enum(["DISPATCHING"]),
		name: S.enum(["HANDED_OVER"])
	}),
	S.object({
		group: S.enum(["UNTRACEABLE"]),
		name: S.enum(["LABELED"])
	}),
	S.object({
		group: S.enum(["SORTING"]),
		name: S.enum(["IN_SORTING_PROCESS"])
	}),
	S.object({
		group: S.enum(["DISTRIBUTING"]),
		name: S.enum(["OUT_FOR_DELIVERY"])
	}),
	S.object({
		group: S.enum(["DISTRIBUTING"]),
		name: S.enum(["AT_CUSTOMS"])
	}),
	S.object({
		group: S.enum(["DISTRIBUTING"]),
		name: S.enum(["AT_PICKUP_POINT"])
	}),
	S.object({
		group: S.enum(["DELIVERED"]),
		name: S.enum(["AT_AGREED_LOCATION"])
	}),
	S.object({
		group: S.enum(["DELIVERED"]),
		name: S.enum(["AT_RECIPIENT"])
	}),
	S.object({
		group: S.enum(["DELIVERED"]),
		name: S.enum(["AT_SENDER"])
	}),
	S.object({
		group: S.enum(["DELIVERED"]),
		name: S.enum(["MARKED_AS"])
	}),
	S.object({
		group: S.enum(["DELIVERED"]),
		name: S.enum(["PICKED_UP"])
	})
]), Ta = S.enum([
	"PAID",
	"PENDING",
	"UNPAID"
]).register(S.globalRegistry, { description: "The current payment status." }), Ea = S.object({
	height: S.object({
		unit: S.enum([
			"mm",
			"cm",
			"m"
		]).register(S.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: S.int().gte(1).lte(1e6).register(S.globalRegistry, { description: "The dimension value." })
	}).register(S.globalRegistry, { description: "The height." }).optional(),
	length: S.object({
		unit: S.enum([
			"mm",
			"cm",
			"m"
		]).register(S.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: S.int().gte(1).lte(1e6).register(S.globalRegistry, { description: "The dimension value." })
	}).register(S.globalRegistry, { description: "The length." }).optional(),
	weight: S.object({
		unit: S.enum(["g", "kg"]).register(S.globalRegistry, { description: "The unit of weight." }),
		value: S.int().gte(1).lte(999999999)
	}).register(S.globalRegistry, { description: "The weight." }).optional(),
	width: S.object({
		unit: S.enum([
			"mm",
			"cm",
			"m"
		]).register(S.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: S.int().gte(1).lte(1e6).register(S.globalRegistry, { description: "The dimension value." })
	}).register(S.globalRegistry, { description: "The width." }).optional()
}), Da = S.object({
	height: S.object({
		unit: S.enum([
			"mm",
			"cm",
			"m"
		]).register(S.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: S.int().gte(1).lte(1e6).register(S.globalRegistry, { description: "The dimension value." })
	}).register(S.globalRegistry, { description: "The height." }).optional(),
	length: S.object({
		unit: S.enum([
			"mm",
			"cm",
			"m"
		]).register(S.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: S.int().gte(1).lte(1e6).register(S.globalRegistry, { description: "The dimension value." })
	}).register(S.globalRegistry, { description: "The length." }).optional(),
	weight: S.object({
		unit: S.enum(["g", "kg"]).register(S.globalRegistry, { description: "The unit of weight." }),
		value: S.int().gte(1).lte(999999999)
	}).register(S.globalRegistry, { description: "The physical weight." }),
	width: S.object({
		unit: S.enum([
			"mm",
			"cm",
			"m"
		]).register(S.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: S.int().gte(1).lte(1e6).register(S.globalRegistry, { description: "The dimension value." })
	}).register(S.globalRegistry, { description: "The width." }).optional()
}).register(S.globalRegistry, { description: "The physical dimensions." }), Oa = S.union([la, xa]), ka = S.enum(["OUTBOUND", "INBOUND"]).register(S.globalRegistry, { description: "The direction of the shipment. OUTBOUND is from sender to recipient, INBOUND is from recipient to sender." }), Aa = S.object({
	additionalInsurance: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Provides enhanced insurance coverage beyond the standard amount." }).optional(),
	deliverAtPostalPoint: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Indicates that the parcel will be delivered to a designated postal service point rather than the recipient's address, requiring the recipient to collect it from that location." }).optional(),
	freshFood: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Designates the shipment as containing perishable, non-frozen food items, ensuring appropriate handling procedures are applied to maintain freshness and prevent spoilage during transit." }).optional(),
	frozen: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Specifies that the shipment contains items that must remain frozen, necessitating strict, continuous temperature-controlled environments throughout the transit process to prevent thawing." }).optional(),
	hideSender: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Omits the sender's information from the shipping label, maintaining sender anonymity in the delivery process." }).optional(),
	insurance: S.object({ amount: S.object({
		currency: S.string().length(3).register(S.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
		micros: S.int().gte(0).lte(9007199254740991).register(S.globalRegistry, { description: "The amount of money in integer micros." })
	}).register(S.globalRegistry, { description: "The amount to insure." }) }).register(S.globalRegistry, { description: "Provides standard insurance coverage up to the specified monetary amount." }).optional(),
	noTracking: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Disables all tracking and tracing capabilities for the shipment." }).optional(),
	oversizedPackage: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Designates the shipment as exceeding standard size limitations, requiring special handling procedures and potentially incurring additional fees." }).optional(),
	printReturnLabelAtDropOff: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Provides the recipient with a digital identifier that can be presented at a drop-off location to print the return label on-site. This option is only applicable for inbound shipments." }).optional(),
	priorityDelivery: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Designates the shipment for expedited processing and transport through the delivery network, often resulting in a faster transit time compared to standard services." }).optional(),
	recipientOnlyDelivery: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Restricts delivery exclusively to the named recipient, requiring verification of recipient identity and prohibiting delivery to anyone else at the same address." }).optional(),
	requiresAgeVerification: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Requires the recipient to provide valid identification to verify they meet the minimum age requirement before the package can be released, typically used for age-restricted items." }).optional(),
	requiresCashOnDelivery: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Mandates that the carrier collect the full order amount in cash from the recipient upon delivery, ensuring payment is secured before the goods are handed over." }).optional(),
	requiresReceiptCode: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Requires the recipient to provide a specific verification code at the time of delivery, adding an extra layer of security and confirmation for sensitive shipments." }).optional(),
	requiresSignature: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Mandates that the recipient or authorized representative must provide a signature upon delivery, creating proof of receipt and transfer of responsibility." }).optional(),
	returnContributionFee: S.object({ amount: S.object({
		currency: S.string().length(3).register(S.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
		micros: S.int().gte(0).lte(9007199254740991).register(S.globalRegistry, { description: "The amount of money in integer micros." })
	}).register(S.globalRegistry, { description: "The amount of the contribution." }) }).register(S.globalRegistry, { description: "Specifies that the recipient must pay the designated contribution amount toward the cost of returning the item. This option is only applicable for inbound shipments." }).optional(),
	returnOnFirstFailedDelivery: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Instructs the carrier to return the package to the sender immediately after the first unsuccessful delivery attempt, bypassing the standard redelivery procedures or holding period." }).optional(),
	sameDayDelivery: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Expedited delivery within the same calendar day that the shipping label is created." }).optional(),
	saturdayDelivery: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Enables delivery on Saturday, which is typically outside standard delivery days, ensuring the package arrives before the start of the following work week." }).optional(),
	scheduledCollection: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Arranges for the carrier to pick up the package from the sender's location, eliminating the need for the sender to drop off the package." }).optional()
}).register(S.globalRegistry, { description: "Options applicable to shipments." }), ja = S.object({ customLabelText: S.object({ text: S.string().min(1).max(45).register(S.globalRegistry, { description: "Allows adding personalized text to be printed on the shipping label, which can include special handling instructions or reference information." }) }).register(S.globalRegistry, { description: "Defines a custom text to be printed on the shipping label." }).optional() }).register(S.globalRegistry, { description: "Options applicable to individual packages of a shipment." }), Ma = Aa.and(ja), Na = S.enum(["ASC", "DESC"]).register(S.globalRegistry, { description: "Specifies the ordering of results: ascending (ASC) or descending (DESC)." }), Pa = S.object({
	emailAddress: S.string().min(1).max(320).register(S.globalRegistry, { description: "An email address." }).optional(),
	locale: S.union([S.string().length(5).register(S.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), S.string().length(2).register(S.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: S.string().min(1).max(50).register(S.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: S.enum(["BUSINESS"]).register(S.globalRegistry, { description: "Discriminator for business contacts." }),
	company: S.string().min(1).max(100).register(S.globalRegistry, { description: "The name of the company." }),
	attention: S.string().min(1).max(100).register(S.globalRegistry, { description: "The name of the contact person." }).optional(),
	vatNumbersByCountry: S.record(S.string(), S.string().min(1).max(20).register(S.globalRegistry, { description: "The VAT registration number for the given country." })).register(S.globalRegistry, { description: "A collection of VAT registration numbers of the company, indexed by ISO country code." }).optional(),
	voecNumber: S.string().min(1).max(20).register(S.globalRegistry, { description: "The VOEC number of the company." }).optional(),
	eoriNumber: S.string().min(1).max(20).register(S.globalRegistry, { description: "The EORI number of the company." }).optional()
}), Fa = S.object({
	emailAddress: S.string().min(1).max(320).register(S.globalRegistry, { description: "An email address." }).optional(),
	locale: S.union([S.string().length(5).register(S.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), S.string().length(2).register(S.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: S.string().min(1).max(50).register(S.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: S.enum(["PRIVATE"]).register(S.globalRegistry, { description: "Discriminator for private contacts." }),
	name: S.string().min(1).max(200).register(S.globalRegistry, { description: "The name of the contact person." })
}), Ia = S.union([S.object({ type: S.literal("BUSINESS") }).and(Pa), S.object({ type: S.literal("PRIVATE") }).and(Fa)]), La = S.object({
	locale: S.union([S.string().length(5).register(S.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), S.string().length(2).register(S.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: S.string().min(1).max(50).register(S.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: S.enum(["BUSINESS"]).register(S.globalRegistry, { description: "Discriminator for business contacts." }),
	company: S.string().min(1).max(100).register(S.globalRegistry, { description: "The name of the company." }),
	attention: S.string().min(1).max(100).register(S.globalRegistry, { description: "The name of the contact person." }).optional(),
	vatNumbersByCountry: S.record(S.string(), S.string().min(1).max(20).register(S.globalRegistry, { description: "The VAT registration number for the given country." })).register(S.globalRegistry, { description: "A collection of VAT registration numbers of the company, indexed by ISO country code." }).optional(),
	voecNumber: S.string().min(1).max(20).register(S.globalRegistry, { description: "The VOEC number of the company." }).optional(),
	eoriNumber: S.string().min(1).max(20).register(S.globalRegistry, { description: "The EORI number of the company." }).optional(),
	emailAddresses: S.array(S.string().min(1).max(320).register(S.globalRegistry, { description: "An email address." })).min(1).max(5).register(S.globalRegistry, { description: "The email addresses of the contact. The first email address will be used as the primary email address. The remaining will be used as extra email addresses if the right permissions are present." }).optional()
}).register(S.globalRegistry, { description: "A business contact that supports multiple email addresses." }), Ra = S.object({
	locale: S.union([S.string().length(5).register(S.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), S.string().length(2).register(S.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: S.string().min(1).max(50).register(S.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: S.enum(["PRIVATE"]).register(S.globalRegistry, { description: "Discriminator for private contacts." }),
	name: S.string().min(1).max(200).register(S.globalRegistry, { description: "The name of the contact person." }),
	emailAddresses: S.array(S.string().min(1).max(320).register(S.globalRegistry, { description: "An email address." })).min(1).max(5).register(S.globalRegistry, { description: "The email addresses of the contact. The first email address will be used as the primary email address. The remaining will be used as extra email addresses if the right permissions are present." }).optional()
}).register(S.globalRegistry, { description: "A private contact that supports multiple email addresses." }), za = S.union([S.object({ type: S.literal("BUSINESS") }).and(La), S.object({ type: S.literal("PRIVATE") }).and(Ra)]), Ba = S.object({
	address: ua.optional(),
	contact: Ia.optional()
}).register(S.globalRegistry, { description: "The billing details of an order." }), Va = S.object({
	name: S.enum([
		"BOL",
		"CSCART",
		"GENERIC",
		"LIGHTSPEED",
		"MAGENTO",
		"PRESTA",
		"SHOPIFY",
		"WOOCOMMERCE"
	]).register(S.globalRegistry, { description: "The identifier of the external e-commerce platform." }),
	sourceId: S.string().min(1).max(50).register(S.globalRegistry, { description: "The order ID as defined in the source system." })
}).register(S.globalRegistry, { description: "The external reference of the ecommerce platform." }), Ha = S.object({
	id: S.string().min(1).max(50).register(S.globalRegistry, { description: "The unique identifier of the sales channel." }),
	name: S.string().min(3).max(50).register(S.globalRegistry, { description: "The name of the sales channel at the time of import." })
}).register(S.globalRegistry, { description: "The external reference of the sales channel." }), Ua = S.object({
	source: S.enum(["SALES_CHANNEL"]),
	salesChannel: Ha,
	ecommercePlatform: Va
}), Wa = S.object({ source: S.enum(["MYPARCEL_SHOP"]) }).register(S.globalRegistry, { description: "This external reference is set when the order originates from an \"etiketten\" shipment. The only actions allowed on this type of order is cancel" }), Ga = S.object({
	source: S.enum(["IMPORT"]),
	sourceId: S.string().min(1).max(50).register(S.globalRegistry, { description: "The order ID as defined in the source system." })
}).register(S.globalRegistry, { description: "This external reference is set when the order originates from a generic ecommerce order import" }), Ka = S.union([
	S.object({ source: S.literal("SALES_CHANNEL") }).and(Ua),
	S.object({ source: S.literal("MYPARCEL_SHOP") }).and(Wa),
	S.object({ source: S.literal("IMPORT") }).and(Ga)
]), qa = S.object({ sourceId: S.string().min(1).max(50).register(S.globalRegistry, { description: "The order line ID as defined in the source system." }) }).register(S.globalRegistry, { description: "The external reference of the order line." }), Ja = S.object({
	credited: S.boolean().register(S.globalRegistry, { description: "Whether the label is credited by us." }),
	createdBy: S.union([S.string().regex(/^shop\/.{1,250}$/).register(S.globalRegistry, { description: "A shop principal identifier." }), S.string().regex(/^user\/.{1,250}$/).register(S.globalRegistry, { description: "A user principal identifier." })]).optional(),
	paymentStatus: Ta.optional(),
	barcode: S.string().min(1).max(50).register(S.globalRegistry, { description: "The barcode of the label." }),
	delayed: S.boolean().register(S.globalRegistry, { description: "Whether the shipment is delayed." }),
	partnerBarcodes: S.array(S.string().min(1).max(50).register(S.globalRegistry, { description: "The barcode identifier associated with the shipment label." })).min(1).max(5).register(S.globalRegistry, { description: "The partner barcodes when the parcel is taken over by a partner carrier." }).optional()
}), Ya = S.object({
	credited: S.boolean().register(S.globalRegistry, { description: "Whether the label is credited by us." }),
	createdBy: S.union([S.string().regex(/^shop\/.{1,250}$/).register(S.globalRegistry, { description: "A shop principal identifier." }), S.string().regex(/^user\/.{1,250}$/).register(S.globalRegistry, { description: "A user principal identifier." })]).optional(),
	paymentStatus: Ta.optional()
}), Xa = S.object({
	type: S.enum(["IMPORTED"]),
	id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of a note of an order." }),
	notedAt: S.union([S.string(), S.iso.datetime().register(S.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	origin: S.enum(["SALES_CHANNEL"]).register(S.globalRegistry, { description: "The origin of the note." }),
	text: S.string().min(1).max(2500).register(S.globalRegistry, { description: "The text of the note." }),
	author: S.string().min(1).max(200).register(S.globalRegistry, { description: "The author of the note." }).optional(),
	locale: S.union([S.string().length(5).register(S.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), S.string().length(2).register(S.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	updatedAt: S.union([S.string(), S.iso.datetime().register(S.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]).optional()
}), Za = S.object({
	type: S.enum(["PRINCIPAL"]),
	id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of a note of an order." }),
	notedAt: S.union([S.string(), S.iso.datetime().register(S.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	principal: S.string().min(1).max(100).register(S.globalRegistry, { description: "The principal who crated the note." }),
	text: S.string().min(1).max(2500).register(S.globalRegistry, { description: "The text of the note." }),
	locale: S.union([S.string().length(5).register(S.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), S.string().length(2).register(S.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	updatedAt: S.union([S.string(), S.iso.datetime().register(S.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]).optional()
}), Qa = S.union([S.object({ type: S.literal("IMPORTED") }).and(Xa), S.object({ type: S.literal("PRINCIPAL") }).and(Za)]), $a = S.union([
	S.object({
		address: ua,
		location: S.object({
			name: S.string().min(1).max(200).register(S.globalRegistry, { description: "The name of the pickup location." }),
			code: S.string().min(1).max(64).register(S.globalRegistry, { description: "The location code of the pickup location." }).optional(),
			type: S.enum([
				"CLICK_COLLECT",
				"PARCEL_LOCKER",
				"PARCEL_POINT",
				"POST_OFFICE",
				"POST_POINT"
			]).register(S.globalRegistry, { description: "The bpost pickup location type." })
		}).register(S.globalRegistry, { description: "The pickup location details." })
	}).register(S.globalRegistry, { description: "The bpost pickup details." }),
	S.object({
		address: ua,
		location: S.object({
			name: S.string().min(1).max(200).register(S.globalRegistry, { description: "The name of the pickup location." }),
			code: S.string().min(1).max(64).register(S.globalRegistry, { description: "The location code of the pickup location." }).optional()
		}).register(S.globalRegistry, { description: "The pickup location details." }),
		retailNetworkId: S.enum(["PNPNL-01", "PNPBE-01"]).register(S.globalRegistry, { description: "PostNL Retail network ID." })
	}).register(S.globalRegistry, { description: "The PostNL pickup details." }),
	S.object({
		address: ua,
		location: S.object({
			name: S.string().min(1).max(200).register(S.globalRegistry, { description: "The name of the pickup location." }),
			code: S.string().min(1).max(64).register(S.globalRegistry, { description: "The location code of the pickup location." }).optional()
		}).register(S.globalRegistry, { description: "The pickup location details." })
	}).register(S.globalRegistry, { description: "The general pickup details." })
]), eo = S.object({
	carrier: da,
	direction: ka,
	disableAutoDetectPickup: S.boolean().register(S.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }),
	packageType: Ca,
	recipient: S.object({
		address: ua,
		contact: za
	}).register(S.globalRegistry, { description: "The recipient of the shipment." }),
	customContractId: S.string().min(1).max(50).register(S.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
	delivery: va.optional(),
	options: Aa.optional(),
	pickup: $a.optional(),
	sender: S.object({
		address: ua,
		contact: Ia
	}).register(S.globalRegistry, { description: "The sender of the shipment." }).optional(),
	saveRecipientAddress: S.boolean().register(S.globalRegistry, { description: "When set to true, the recipient address is saved to the user's address book." }).optional()
}), to = S.object({
	id: S.string().min(1).register(S.globalRegistry, { description: "The unique identifier of the shipment." }),
	carrier: da,
	createdAt: S.union([S.string(), S.iso.datetime().register(S.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	direction: ka,
	hidden: S.boolean().register(S.globalRegistry, { description: "Whether the shipment is hidden." }),
	packageType: Ca,
	recipient: S.object({
		address: ua.optional(),
		contact: za.optional()
	}).register(S.globalRegistry, { description: "The recipient of the shipment." }),
	customContractId: S.string().min(1).max(50).register(S.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
	customsDeclaration: ma.optional(),
	delivery: va.optional(),
	dropOff: ya.optional(),
	label: S.union([Ja, Ya]).optional(),
	multicollo: S.object({
		id: S.uuid().register(S.globalRegistry, { description: "The unique identifier for a multicollo shipment group." }),
		totalPackages: S.int().gte(2).lte(20).register(S.globalRegistry, { description: "The total number of individual packages included within this specific multicollo shipment group." })
	}).register(S.globalRegistry, { description: "Details if this package is part of a multi-package (multicollo) shipment. A multicollo shipment is a group of packages belonging to the same shipment that are consolidated for combined labeling and potential cost reduction. This object will only be present if the package is part of such a group." }).optional(),
	options: Ma.optional(),
	pickup: $a.optional(),
	price: ba.optional(),
	sender: S.object({
		address: ua,
		contact: Ia
	}).register(S.globalRegistry, { description: "The sender of the shipment." }).optional()
}).register(S.globalRegistry, { description: "The shipment properties of a package." }), no = S.object({
	id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of a line of an order." }),
	product: S.object({
		name: S.string().min(1).max(250).register(S.globalRegistry, { description: "The name of the product." }),
		ean: S.string().min(1).max(13).register(S.globalRegistry, { description: "The EAN of the product." }).optional(),
		sku: S.string().min(1).max(200).register(S.globalRegistry, { description: "The SKU of the product." }).optional(),
		id: S.uuid().register(S.globalRegistry, { description: "Identifier of the product. This is always undefined when the `status` is `DISCOVERED` or `IMPORT_REQUESTED`, otherwise it is always defined." }).optional()
	}).register(S.globalRegistry, { description: "The product of an order line." }),
	quantity: S.int().gte(1).register(S.globalRegistry, { description: "The quantity of the product of the order line." }),
	externalReference: qa.optional(),
	price: ba.and(S.unknown().register(S.globalRegistry, { description: "The price of the product of the order line." })).optional()
}).register(S.globalRegistry, { description: "The line of the order" }), ro = S.object({
	customsDeclaration: pa.optional(),
	options: ja.optional(),
	physicalProperties: Da.optional()
}), io = S.object({
	lines: S.array(S.object({
		id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of a line of an order." }),
		quantity: S.int().gte(1).register(S.globalRegistry, { description: "The quantity of the product of the order line." })
	})).min(1).max(100).optional(),
	physicalProperties: Da.optional()
}), ao = S.object({
	id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the package." }),
	status: wa,
	physicalProperties: Ea.optional(),
	lines: S.array(S.object({
		id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of a line of an order." }),
		quantity: S.int().gte(1).register(S.globalRegistry, { description: "The quantity that the package contains" })
	})).min(1).max(100).register(S.globalRegistry, { description: "The order lines related to the package." }).optional(),
	shipment: to.optional()
}), oo = S.object({
	customsDeclaration: pa.optional(),
	options: ja.optional(),
	physicalProperties: Da.optional(),
	shipment: S.object({
		carrier: fa,
		direction: ka,
		disableAutoDetectPickup: S.boolean().register(S.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }),
		packageType: Ca,
		recipient: S.object({
			address: ua,
			contact: za
		}).register(S.globalRegistry, { description: "The recipient of the shipment." }),
		customContractId: S.string().min(1).max(50).register(S.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
		delivery: va.optional(),
		options: Aa.optional(),
		pickup: $a.optional(),
		sender: S.object({
			address: ua,
			contact: Ia
		}).register(S.globalRegistry, { description: "The sender of the shipment." }).optional(),
		saveRecipientAddress: S.boolean().register(S.globalRegistry, { description: "When set to true, the recipient address is saved to the user's address book." }).optional()
	})
}), so = S.object({
	carrier: da.optional(),
	customContractId: S.string().min(1).max(50).register(S.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
	customsDeclaration: ma.optional(),
	delivery: va.optional(),
	direction: ka.optional(),
	disableAutoDetectPickup: S.boolean().register(S.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }).optional(),
	numberOfLabels: S.int().gte(1).lte(20).optional(),
	options: Ma.optional(),
	packageType: Ca.optional(),
	pickup: $a.optional(),
	recipient: S.object({
		address: ua.optional(),
		contact: za.optional()
	}).register(S.globalRegistry, { description: "The recipient of the shipment." }).optional()
}).register(S.globalRegistry, { description: "The shipping preferences of the order. This should be used as default information when preparing packages for shipment." }), co = S.union([S.object({
	shopId: S.string().min(1).max(50).register(S.globalRegistry, { description: "The unique identifier of the shop." }),
	customerReference: ha.optional(),
	package: oo
}), S.object({
	shopId: S.string().min(1).max(50).register(S.globalRegistry, { description: "The unique identifier of the shop." }),
	customerReference: ha.optional(),
	multicollo: S.object({
		packages: S.array(ro).min(2).max(20),
		shipment: S.object({
			carrier: fa,
			direction: ka,
			disableAutoDetectPickup: S.boolean().register(S.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }),
			packageType: Ca,
			recipient: S.object({
				address: ua,
				contact: za
			}).register(S.globalRegistry, { description: "The recipient of the shipment." }),
			customContractId: S.string().min(1).max(50).register(S.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
			delivery: va.optional(),
			options: Aa.optional(),
			pickup: $a.optional(),
			sender: S.object({
				address: ua,
				contact: Ia
			}).register(S.globalRegistry, { description: "The sender of the shipment." }).optional(),
			saveRecipientAddress: S.boolean().register(S.globalRegistry, { description: "When set to true, the recipient address is saved to the user's address book." }).optional()
		})
	})
})]), lo = S.object({
	id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." }),
	packages: S.array(io).min(1).max(25)
}), uo = S.object({
	id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the package." }),
	customsDeclaration: pa.optional(),
	options: ja.optional(),
	physicalProperties: Da.optional()
}), fo = S.union([S.object({
	id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." }),
	shipment: eo,
	packages: S.array(uo).min(1).max(25)
}), S.object({
	id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." }),
	shipment: eo,
	multicollo: S.array(uo).min(2).max(25)
})]), po = S.object({
	id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." }),
	orderedAt: S.union([S.string(), S.iso.datetime().register(S.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	price: ba,
	shopId: S.string().min(1).max(50).register(S.globalRegistry, { description: "The unique identifier of the shop." }),
	shortId: S.string().length(9).register(S.globalRegistry, { description: "The short ID of the order." }),
	status: Sa,
	assignedUserId: S.string().min(1).max(50).register(S.globalRegistry, { description: "The user ID assigned to the order." }).optional(),
	billingDetails: Ba.optional(),
	customerReference: ha.optional(),
	externalReferences: Ka.and(S.unknown().register(S.globalRegistry, { description: "The external references of the order. These are read-only and automatically populated by the system based on the source." })).optional(),
	lines: S.array(no).min(1).max(100).register(S.globalRegistry, { description: "The lines of the order" }).optional(),
	notes: S.array(Qa).min(1).max(100).register(S.globalRegistry, { description: "The notes of the order." }).optional(),
	packages: S.array(ao).min(1).max(25).register(S.globalRegistry, { description: "The packages of the order." }).optional(),
	rules: S.object({ setShippingPreferences: S.object({
		path: S.array(S.union([S.object({
			id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the rule." }),
			name: S.string().register(S.globalRegistry, { description: "The name of the rule." })
		}), S.object({
			id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the rule group." }),
			condition: S.union([S.object({ countryCode: la }), S.object({ geoAreaCode: xa })])
		})])).min(1).register(S.globalRegistry, { description: "The path of the rule." }),
		appliedAt: S.union([S.string(), S.iso.datetime().register(S.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
		result: S.enum(["PRESERVE", "REPLACE"]).register(S.globalRegistry, { description: "How the rule was applied." })
	}).optional() }).register(S.globalRegistry, { description: "The rules that have been applied to the order." }).optional(),
	shipping: so.optional()
}), mo = S.object({
	type: S.enum([
		"about:blank",
		"urn:problem:client",
		"urn:problem:invalid-request-syntax",
		"urn:problem:not-found",
		"urn:problem:server",
		"urn:problem:unauthorized",
		"urn:problem:unsupported-media-type"
	]).register(S.globalRegistry, { description: "A URI reference that identifies the problem type." }),
	status: S.union([
		S.literal(400),
		S.literal(401),
		S.literal(404),
		S.literal(415),
		S.literal(500)
	]).register(S.globalRegistry, { description: "The HTTP status code generated by the origin server." }),
	title: S.string().min(1).max(100).register(S.globalRegistry, { description: "A short human-readable summary of the problem type." }),
	detail: S.string().min(1).max(5e3).register(S.globalRegistry, { description: "A human-readable explanation specific to this occurrence of the problem." }),
	instance: S.url().register(S.globalRegistry, { description: "A URI reference that identifies the specific occurrence of the problem." }),
	cause: S.unknown().register(S.globalRegistry, { description: "The cause of this problem when debug mode is enabled." }).optional()
}), ho = mo.and(S.object({
	type: S.enum(["urn:problem:client"]).register(S.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: S.literal(400).register(S.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: S.array(S.object({
		detail: S.string().min(1).max(5e3),
		pointer: S.string().min(1).max(200).register(S.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).min(1).register(S.globalRegistry, { description: "Detailed information regarding the violations." })
})), go = mo.and(S.object({
	type: S.enum(["urn:problem:server"]).register(S.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: S.literal(500).register(S.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional()
}));
mo.and(S.object({
	type: S.enum(["urn:problem:invalid-request-syntax"]).register(S.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: S.literal(400).register(S.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: S.array(S.object({
		detail: S.string().min(1).max(5e3),
		pointer: S.string().min(1).max(200).register(S.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).min(1).register(S.globalRegistry, { description: "Detailed information regarding the syntactic violations." })
})), S.object({
	body: S.array(S.object({
		id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." }),
		text: S.string().min(1).max(2500).register(S.globalRegistry, { description: "The text of the note." }),
		locale: S.union([S.string().length(5).register(S.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), S.string().length(2).register(S.globalRegistry, { description: "ISO 639-1 language code." })]).optional()
	})).min(1).max(50).register(S.globalRegistry, { description: "Body for adding an order note." }),
	path: S.never().optional(),
	query: S.never().optional()
}), S.array(S.union([
	S.object({
		status: S.literal(200),
		ids: S.array(S.uuid()).min(1)
	}),
	ho,
	go
])).min(1).max(50).register(S.globalRegistry, { description: "The result per ID." }), S.object({
	body: S.array(S.object({
		id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." }),
		userId: S.string().min(1).max(50).register(S.globalRegistry, { description: "User to assign to these orders." })
	})).min(1).max(50).register(S.globalRegistry, { description: "Body for assigning orders to an user." }),
	path: S.never().optional(),
	query: S.never().optional()
}), S.array(S.union([
	S.object({ status: S.literal(200) }),
	ho,
	go
])).min(1).max(50).register(S.globalRegistry, { description: "The result per ID." }), S.object({
	body: S.array(S.object({ id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." }) })).min(1).max(50).register(S.globalRegistry, { description: "Body for canceling orders." }),
	path: S.never().optional(),
	query: S.never().optional()
}), S.array(S.union([
	S.object({ status: S.literal(200) }),
	ho,
	go
])).min(1).max(50).register(S.globalRegistry, { description: "The result per ID." }), S.object({
	body: S.array(co).min(1).max(50).register(S.globalRegistry, { description: "Body for creating an order with shippable packages." }),
	path: S.never().optional(),
	query: S.never().optional()
}), S.array(S.union([
	S.object({
		status: S.literal(201),
		id: S.uuid()
	}),
	ho,
	go
])).min(1).max(50).register(S.globalRegistry, { description: "The result per item." }), S.object({
	body: S.array(lo).min(1).max(50).register(S.globalRegistry, { description: "Body adding packages to orders" }),
	path: S.never().optional(),
	query: S.never().optional()
}), S.array(S.union([
	S.object({
		status: S.literal(200),
		ids: S.array(S.uuid()).min(1)
	}),
	ho,
	go
])).min(1).max(50).register(S.globalRegistry, { description: "The result per ID." }), S.object({
	body: S.array(fo).min(1).max(50).register(S.globalRegistry, { description: "Body preparing packages for shipment" }),
	path: S.never().optional(),
	query: S.never().optional()
}), S.array(S.union([
	S.object({ status: S.literal(200) }),
	ho,
	go
])).min(1).max(50).register(S.globalRegistry, { description: "The result per ID." }), S.object({
	body: S.array(S.object({
		id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." }),
		packageIds: S.array(S.uuid().register(S.globalRegistry, { description: "The unique identifier of the package." })).min(1).max(25)
	})).min(1).max(50).register(S.globalRegistry, { description: "Body for unpreparing packages for shipment" }),
	path: S.never().optional(),
	query: S.never().optional()
}), S.array(S.union([
	S.object({ status: S.literal(200) }),
	ho,
	go
])).min(1).max(50).register(S.globalRegistry, { description: "The result per ID." }), S.object({
	body: S.array(S.object({
		id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." }),
		noteId: S.uuid().register(S.globalRegistry, { description: "The unique identifier of a note of an order." }),
		text: S.string().min(1).max(2500).register(S.globalRegistry, { description: "The text of the note." })
	})).min(1).max(50).register(S.globalRegistry, { description: "Body for editing an order note." }),
	path: S.never().optional(),
	query: S.never().optional()
}), S.array(S.union([
	S.object({ status: S.literal(200) }),
	ho,
	go
])).min(1).max(50).register(S.globalRegistry, { description: "The result per ID." }), S.object({
	body: S.array(S.object({ id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." }) })).min(1).max(50).register(S.globalRegistry, { description: "Body for importing an order." }),
	path: S.never().optional(),
	query: S.never().optional()
}), S.array(S.union([
	S.object({ status: S.literal(200) }),
	ho,
	go
])).min(1).max(50).register(S.globalRegistry, { description: "The result per ID." }), S.object({
	body: S.never().optional(),
	path: S.never().optional(),
	query: S.object({
		aggregations: S.array(Sa).min(1).max(7).register(S.globalRegistry, { description: "The statuses to retrieve counts for." }).optional(),
		filter: S.object({
			assignedUserId: S.array(S.string().min(1).max(50).register(S.globalRegistry, { description: "The unique identifier of the user." })).min(1).max(100).optional(),
			carrier: S.array(da).min(1).max(18).optional(),
			hasAssignedUser: S.enum(["true", "false"]).register(S.globalRegistry, { description: "Whether the order has an assigned user or not." }).optional(),
			hasNotes: S.enum(["true", "false"]).register(S.globalRegistry, { description: "Whether the order has notes or not." }).optional(),
			orderId: S.array(S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." })).min(1).max(100).optional(),
			orderedAt: S.array(S.string().regex(/^(?<inequalitySymbol>gt|gte|lt|lte)\s(?<datetime>((\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\d|3[01])|(0[469]|11)-(0[1-9]|[12]\d|30)|(02)-(0[1-9]|1\d|2[0-8])))T([01]\d|2[0-3]):[0-5]\d(:[0-5]\d(\.\d+)?)?(Z|([+-]\d{2}:?\d{2})))$/).register(S.globalRegistry, { description: "Inequality symbol 'gt', 'gte', 'lt', 'lte' with a datetime in ISO 8601 format." })).min(1).max(2).optional(),
			packageStatusGroup: S.array(S.enum([
				"PICKING_AND_PACKING",
				"DISPATCHING",
				"UNTRACEABLE",
				"SORTING",
				"DISTRIBUTING",
				"DELIVERED"
			])).min(1).max(6).optional(),
			packageType: S.array(Ca).min(1).max(7).optional(),
			price: S.array(S.string().regex(/^(?<inequalitySymbol>gt|gte|lt|lte)\s(?<number>\d{1,15}(?:.\d{0,2})?)$/).register(S.globalRegistry, { description: "Inequality symbol 'gt', 'gte', 'lt', 'lte' with a number with a maximum precision of 2." })).min(1).max(2).optional(),
			regionCode: S.array(Oa).min(1).max(100).optional(),
			salesChannelId: S.array(S.string().min(1).max(50).register(S.globalRegistry, { description: "The unique identifier of the sales channel." })).min(1).max(100).optional(),
			shipmentDelayed: S.enum(["true", "false"]).register(S.globalRegistry, { description: "Whether the order has a package with a delayed shipment or not." }).optional(),
			shipmentDirection: S.array(ka).min(1).max(2).optional(),
			shipmentPaymentStatus: S.array(Ta).min(1).max(3).optional(),
			shopId: S.array(S.string().min(1).max(50).register(S.globalRegistry, { description: "The unique identifier of the shop." })).min(1).max(100).optional(),
			status: S.array(Sa).min(1).max(7).optional()
		}).optional(),
		limit: S.int().gte(0).lte(50).nullish().default(50),
		pageToken: S.string().min(4).max(500).register(S.globalRegistry, { description: "The page token to retrieve the next page of orders." }).optional(),
		query: S.string().min(1).max(500).register(S.globalRegistry, { description: "The following operators are supported:\n'+ signifies AND operation'\n'| signifies OR operation'\n'- negates a single token'\n'\" wraps a number of tokens to signify a phrase for searching'\n'* at the end of a term signifies a prefix query'\n'( and ) signify precedence'\n'~N after a word signifies edit distance (fuzziness)'\n'~N after a phrase signifies slop amount'\nTo use one of these characters literally, escape it with a preceding backslash (\\)." }).optional(),
		sort: S.object({
			customerReference: Na.optional(),
			orderedAt: Na.optional(),
			price: Na.optional(),
			sourceId: Na.optional()
		}).register(S.globalRegistry, { description: "When no `query` is provided the default sort is by `orderedAt` descending. When a `query` is provided the default sort is by relevance." }).optional()
	}).optional()
}), S.object({
	results: S.array(po).min(0).max(50).register(S.globalRegistry, { description: "The list of orders." }),
	total: S.object({
		relation: S.enum(["eq", "gte"]).register(S.globalRegistry, { description: "The relation of the total number of orders." }),
		value: S.int().gte(0).register(S.globalRegistry, { description: "The total number of orders." })
	}),
	aggregations: S.object({ status: S.array(S.object({
		key: Sa,
		count: S.int().gte(0)
	})).optional() }).register(S.globalRegistry, { description: "Count of orders per status, scoped to the active search query and all active filters except the status filter." }).optional(),
	nextPageToken: S.string().min(1).max(500).register(S.globalRegistry, { description: "The next page token to retrieve the next page of orders." }).optional()
}).register(S.globalRegistry, { description: "The found orders." }), S.object({
	body: S.never().optional(),
	path: S.never().optional(),
	query: S.object({
		shipmentLabelsLayout: S.enum(["INTERLEAVED"]).register(S.globalRegistry, { description: "How shipment labels are included alongside the packing slips in the resulting PDF. `INTERLEAVED` outputs each packing slip immediately followed by its shipment label. When the parameter is omitted, no shipment labels are included and only packing slips are rendered." }).optional(),
		orderId: S.array(S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." })).min(1).max(50).register(S.globalRegistry, { description: "The orderId of the order to include in the packing slips. A maximum of 50 orders can be included in the request. When packageId is provided, exactly one orderId is allowed." }),
		packageId: S.array(S.uuid().register(S.globalRegistry, { description: "The unique identifier of the package." })).min(1).max(20).register(S.globalRegistry, { description: "The packageId of the package to include in the packing slips. The packageIds must belong to the single orderId in the request and a maximum of 20 packageIds can be included." }).optional()
	}),
	headers: S.object({ Accept: S.enum(["application/pdf", "application/pdf+print"]).register(S.globalRegistry, { description: "Use `application/pdf` to download the packing slip. Use `application/pdf+print; printer-group-id=<uuid>` to send the packing slip directly to a printer group." }) })
}), S.union([S.string().register(S.globalRegistry, { description: "Packing slips PDF. Returned when `Accept: application/pdf`." }), S.void().register(S.globalRegistry, { description: "The packing slip has been sent to the printer. Returned when `Accept: application/pdf+print; printer-group-id=<uuid>`." })]), S.object({
	body: S.never().optional(),
	path: S.never().optional(),
	query: S.object({ orderId: S.array(S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." })).min(1).max(50).register(S.globalRegistry, { description: "The orderId of the order to include in the picklist. A maximum of 50 orders can be included in the request." }) }),
	headers: S.object({ Accept: S.enum(["application/pdf", "application/pdf+print"]).register(S.globalRegistry, { description: "Use `application/pdf` to download the picklist. Use `application/pdf+print; printer-group-id=<uuid>` to send the picklist directly to a printer group." }) })
}), S.union([S.string().register(S.globalRegistry, { description: "Picklist PDF. Returned when `Accept: application/pdf`." }), S.void().register(S.globalRegistry, { description: "The picklist has been sent to the printer. Returned when `Accept: application/pdf+print; printer-group-id=<uuid>`." })]), S.object({
	body: S.array(S.object({
		id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." }),
		noteIds: S.array(S.uuid().register(S.globalRegistry, { description: "The unique identifier of a note of an order." })).min(1).max(150).register(S.globalRegistry, { description: "Note IDs to remove from the order." })
	})).min(1).max(50).register(S.globalRegistry, { description: "Body for removing order notes." }),
	path: S.never().optional(),
	query: S.never().optional()
}), S.array(S.union([
	S.object({ status: S.literal(200) }),
	ho,
	go
])).min(1).max(50).register(S.globalRegistry, { description: "The result per ID." }), S.object({
	body: S.array(S.object({ id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." }) })).min(1).max(50).register(S.globalRegistry, { description: "Body for unassigning orders from an user." }),
	path: S.never().optional(),
	query: S.never().optional()
}), S.array(S.union([
	S.object({ status: S.literal(200) }),
	ho,
	go
])).min(1).max(50).register(S.globalRegistry, { description: "The result per ID." }), S.object({
	body: S.array(S.object({ id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." }) })).min(1).max(50).register(S.globalRegistry, { description: "Body for evaluating order rules." }),
	path: S.never().optional(),
	query: S.never().optional()
}), S.array(S.union([
	S.object({ status: S.literal(200) }),
	ho,
	go
])).min(1).max(50).register(S.globalRegistry, { description: "The result per ID." });
var _o = S.string().register(S.globalRegistry, { description: "ISO 3166-1 alpha-2 country code." }), vo = S.object({
	city: S.string().register(S.globalRegistry, { description: "The city of the address." }),
	countryCode: _o,
	street: S.string().register(S.globalRegistry, { description: "The street of the address." }),
	additionalInformation: S.string().register(S.globalRegistry, { description: "Additional information about the address." }).optional(),
	boxNumber: S.string().register(S.globalRegistry, { description: "The box number of the address, only applicable for specific country codes." }).optional(),
	houseNumber: S.string().register(S.globalRegistry, { description: "The house number of the address." }).optional(),
	houseNumberSuffix: S.string().register(S.globalRegistry, { description: "The house number suffix of the address." }).optional(),
	postalCode: S.string().register(S.globalRegistry, { description: "The postal code of the address." }).optional(),
	region: S.string().register(S.globalRegistry, { description: "The region of the address." }).optional(),
	state: S.string().register(S.globalRegistry, { description: "The state of the address." }).optional()
}).register(S.globalRegistry, { description: "A physical address." }), yo = S.union([S.enum([
	"BPOST",
	"BRT",
	"CHEAP_CARGO",
	"DHL_EUROPLUS",
	"DHL_FOR_YOU",
	"DHL_FREIGHT",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"GLS",
	"INPOST",
	"POSTNL",
	"POSTE_ITALIANE",
	"SPRING",
	"TRUNKRS",
	"UPS_EXPRESS_SAVER",
	"UPS_STANDARD",
	"VIA_TIM",
	"BOL"
]), S.string()]).register(S.globalRegistry, { description: "The carrier of the package." }), bo = S.union([S.enum([
	"BPOST",
	"BRT",
	"CHEAP_CARGO",
	"DHL_EUROPLUS",
	"DHL_FOR_YOU",
	"DHL_FREIGHT",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"GLS",
	"INPOST",
	"POSTNL",
	"POSTE_ITALIANE",
	"SPRING",
	"TRUNKRS",
	"UPS_EXPRESS_SAVER",
	"UPS_STANDARD",
	"VIA_TIM"
]), S.string()]).register(S.globalRegistry, { description: "The carrier to select to ship a package with." }), xo = S.object({
	groups: S.array(S.object({
		description: S.string().register(S.globalRegistry, { description: "A clear and detailed description of the goods within this group." }),
		hsCode: S.string().register(S.globalRegistry, { description: "The Harmonized System (HS) code for the goods in this group, a globally recognized classification for traded products." }),
		numberOfItems: S.int().gte(1).lte(99999).register(S.globalRegistry, { description: "The total quantity of individual items within this specific group." }),
		totalValue: S.object({
			currency: S.string().register(S.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
			micros: S.int().gte(0).lte(9007199254740991).register(S.globalRegistry, { description: "The amount of money in integer micros." })
		}).register(S.globalRegistry, { description: "The total declared value of all items within this group." }),
		totalWeight: S.object({
			unit: S.union([S.enum(["g", "kg"]), S.string()]).register(S.globalRegistry, { description: "The unit of weight." }),
			value: S.int().gte(1).lte(999999999)
		}).register(S.globalRegistry, { description: "The total weight of all items within this specific group." }),
		countryCodeOfOrigin: _o.and(S.unknown().register(S.globalRegistry, { description: "The ISO 3166-1 alpha-2 country code indicating where the goods in this group originated." })).optional()
	}).register(S.globalRegistry, { description: "A consolidated group of items within a customs declaration that share common customs attributes." })).register(S.globalRegistry, { description: "The list of item groups." }),
	purpose: S.union([S.enum([
		"COMMERCIAL_GOODS",
		"COMMERCIAL_SAMPLE",
		"DOCUMENTS",
		"GIFT",
		"RETURNED_GOODS"
	]), S.string()]).register(S.globalRegistry, { description: "The primary reason or purpose for the international shipment." }),
	totalWeight: S.object({
		unit: S.union([S.enum(["g", "kg"]), S.string()]).register(S.globalRegistry, { description: "The unit of weight." }),
		value: S.int().gte(1).lte(999999999)
	}).register(S.globalRegistry, { description: "The total weight of all items declared within this customs declaration." }),
	invoiceNumber: S.string().register(S.globalRegistry, { description: "The identifying number of the commercial invoice associated with this shipment." }).optional()
}).register(S.globalRegistry, { description: "The official declaration of goods for customs clearance purposes during international shipment." }), So = S.object({
	groups: S.array(S.object({
		description: S.string().register(S.globalRegistry, { description: "A clear and detailed description of the goods within this group." }),
		hsCode: S.string().register(S.globalRegistry, { description: "The Harmonized System (HS) code for the goods in this group, a globally recognized classification for traded products." }),
		numberOfItems: S.int().gte(1).lte(99999).register(S.globalRegistry, { description: "The total quantity of individual items within this specific group." }),
		totalValue: S.object({
			currency: S.string().register(S.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
			micros: S.int().gte(0).lte(9007199254740991).register(S.globalRegistry, { description: "The amount of money in integer micros." })
		}).register(S.globalRegistry, { description: "The total declared value of all items within this group." }),
		totalWeight: S.object({
			unit: S.union([S.enum(["g", "kg"]), S.string()]).register(S.globalRegistry, { description: "The total weight of all items within this specific group." }),
			value: S.int().gte(1).lte(999999999)
		}).register(S.globalRegistry, { description: "The total weight of all items within this specific group." }),
		countryCodeOfOrigin: _o.and(S.unknown().register(S.globalRegistry, { description: "The ISO 3166-1 alpha-2 country code indicating where the goods in this group originated." })).optional()
	}).register(S.globalRegistry, { description: "A consolidated group of items within a customs declaration that share common customs attributes." })).register(S.globalRegistry, { description: "The list of item groups." }),
	purpose: S.union([S.enum([
		"COMMERCIAL_GOODS",
		"COMMERCIAL_SAMPLE",
		"DOCUMENTS",
		"GIFT",
		"RETURNED_GOODS"
	]), S.string()]).register(S.globalRegistry, { description: "The primary reason or purpose for the international shipment." }),
	totalWeight: S.object({
		unit: S.union([S.enum(["g", "kg"]), S.string()]).register(S.globalRegistry, { description: "The total weight of all items declared within this customs declaration." }),
		value: S.int().gte(1).lte(999999999)
	}).register(S.globalRegistry, { description: "The total weight of all items declared within this customs declaration." }),
	invoiceNumber: S.string().register(S.globalRegistry, { description: "The identifying number of the commercial invoice associated with this shipment." }).optional()
}).register(S.globalRegistry, { description: "The official declaration of goods for customs clearance purposes during international shipment." }), Co = S.string().register(S.globalRegistry, { description: "The customer reference of the order." }), wo = S.union([S.enum([
	"EARLY_MORNING_DELIVERY",
	"EVENING_DELIVERY",
	"EXPRESS_DELIVERY",
	"MORNING_DELIVERY",
	"PICKUP_EXPRESS_DELIVERY",
	"PICKUP_DELIVERY",
	"SAME_DAY_DELIVERY",
	"STANDARD_DELIVERY"
]), S.string()]).register(S.globalRegistry, { description: "The delivery type of the shipment." }), To = S.object({
	notifyOnDelivery: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Notify sender upon package delivery." }).optional(),
	preferredDate: S.object({ date: S.iso.date().register(S.globalRegistry, { description: "Recipient specified preferred delivery date." }) }).register(S.globalRegistry, { description: "This option allows you to set a preferred date for delivery, so a drop off date can be calculated." }).optional()
}).register(S.globalRegistry, { description: "Options regarding delivery timing and notifications." }), Eo = S.object({
	options: To.optional(),
	type: wo.optional()
}).register(S.globalRegistry, { description: "The delivery details of the shipment." }), Do = S.object({ date: S.iso.date().register(S.globalRegistry, { description: "The date at which to drop off the package." }).optional() }).register(S.globalRegistry, { description: "The drop-off details." }), Oo = S.object({
	currency: S.string().register(S.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
	micros: S.int().gte(0).lte(9007199254740991).register(S.globalRegistry, { description: "The amount of money in integer micros." })
}).register(S.globalRegistry, { description: "A monetary value represented by split integral and fractional parts to avoid floating point errors." }), ko = S.union([S.enum(["EU", "NON_EU"]), S.string()]).register(S.globalRegistry, { description: "A geographic area code that represents a specific list of countries." }), Ao = S.union([S.enum([
	"CANCELED",
	"COMPLETED",
	"DISCOVERED",
	"IMPORT_REQUESTED",
	"OPEN",
	"PROCESSING",
	"RETURNING"
]), S.string()]).register(S.globalRegistry, { description: "The status of the order." }), jo = S.union([S.enum([
	"DIGITAL_STAMP",
	"ENVELOPE",
	"MAILBOX",
	"PACKAGE",
	"PALLET",
	"SMALL_PACKAGE",
	"UNFRANKED"
]), S.string()]).register(S.globalRegistry, { description: "The type of the package." }), Mo = S.union([
	S.object({
		group: S.union([S.enum(["PICKING_AND_PACKING"]), S.string()]),
		name: S.union([S.enum(["PACKED"]), S.string()])
	}),
	S.object({
		group: S.union([S.enum(["DISPATCHING"]), S.string()]),
		name: S.union([S.enum(["READY_TO_SHIP"]), S.string()])
	}),
	S.object({
		group: S.union([S.enum(["DISPATCHING"]), S.string()]),
		name: S.union([S.enum(["LABELED"]), S.string()])
	}),
	S.object({
		group: S.union([S.enum(["DISPATCHING"]), S.string()]),
		name: S.union([S.enum(["HANDED_OVER"]), S.string()])
	}),
	S.object({
		group: S.union([S.enum(["UNTRACEABLE"]), S.string()]),
		name: S.union([S.enum(["LABELED"]), S.string()])
	}),
	S.object({
		group: S.union([S.enum(["SORTING"]), S.string()]),
		name: S.union([S.enum(["IN_SORTING_PROCESS"]), S.string()])
	}),
	S.object({
		group: S.union([S.enum(["DISTRIBUTING"]), S.string()]),
		name: S.union([S.enum(["OUT_FOR_DELIVERY"]), S.string()])
	}),
	S.object({
		group: S.union([S.enum(["DISTRIBUTING"]), S.string()]),
		name: S.union([S.enum(["AT_CUSTOMS"]), S.string()])
	}),
	S.object({
		group: S.union([S.enum(["DISTRIBUTING"]), S.string()]),
		name: S.union([S.enum(["AT_PICKUP_POINT"]), S.string()])
	}),
	S.object({
		group: S.union([S.enum(["DELIVERED"]), S.string()]),
		name: S.union([S.enum(["AT_AGREED_LOCATION"]), S.string()])
	}),
	S.object({
		group: S.union([S.enum(["DELIVERED"]), S.string()]),
		name: S.union([S.enum(["AT_RECIPIENT"]), S.string()])
	}),
	S.object({
		group: S.union([S.enum(["DELIVERED"]), S.string()]),
		name: S.union([S.enum(["AT_SENDER"]), S.string()])
	}),
	S.object({
		group: S.union([S.enum(["DELIVERED"]), S.string()]),
		name: S.union([S.enum(["MARKED_AS"]), S.string()])
	}),
	S.object({
		group: S.union([S.enum(["DELIVERED"]), S.string()]),
		name: S.union([S.enum(["PICKED_UP"]), S.string()])
	})
]), No = S.union([S.enum([
	"PAID",
	"PENDING",
	"UNPAID"
]), S.string()]).register(S.globalRegistry, { description: "The current payment status." }), Po = S.object({
	height: S.object({
		unit: S.union([S.enum([
			"mm",
			"cm",
			"m"
		]), S.string()]).register(S.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: S.int().gte(1).lte(1e6).register(S.globalRegistry, { description: "The dimension value." })
	}).register(S.globalRegistry, { description: "The height." }).optional(),
	length: S.object({
		unit: S.union([S.enum([
			"mm",
			"cm",
			"m"
		]), S.string()]).register(S.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: S.int().gte(1).lte(1e6).register(S.globalRegistry, { description: "The dimension value." })
	}).register(S.globalRegistry, { description: "The length." }).optional(),
	weight: S.object({
		unit: S.union([S.enum(["g", "kg"]), S.string()]).register(S.globalRegistry, { description: "The unit of weight." }),
		value: S.int().gte(1).lte(999999999)
	}).register(S.globalRegistry, { description: "The weight." }).optional(),
	width: S.object({
		unit: S.union([S.enum([
			"mm",
			"cm",
			"m"
		]), S.string()]).register(S.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: S.int().gte(1).lte(1e6).register(S.globalRegistry, { description: "The dimension value." })
	}).register(S.globalRegistry, { description: "The width." }).optional()
}), Fo = S.object({
	height: S.object({
		unit: S.union([S.enum([
			"mm",
			"cm",
			"m"
		]), S.string()]).register(S.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: S.int().gte(1).lte(1e6).register(S.globalRegistry, { description: "The dimension value." })
	}).register(S.globalRegistry, { description: "The height." }).optional(),
	length: S.object({
		unit: S.union([S.enum([
			"mm",
			"cm",
			"m"
		]), S.string()]).register(S.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: S.int().gte(1).lte(1e6).register(S.globalRegistry, { description: "The dimension value." })
	}).register(S.globalRegistry, { description: "The length." }).optional(),
	weight: S.object({
		unit: S.union([S.enum(["g", "kg"]), S.string()]).register(S.globalRegistry, { description: "The unit of weight." }),
		value: S.int().gte(1).lte(999999999)
	}).register(S.globalRegistry, { description: "The physical weight." }),
	width: S.object({
		unit: S.union([S.enum([
			"mm",
			"cm",
			"m"
		]), S.string()]).register(S.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: S.int().gte(1).lte(1e6).register(S.globalRegistry, { description: "The dimension value." })
	}).register(S.globalRegistry, { description: "The width." }).optional()
}).register(S.globalRegistry, { description: "The physical dimensions." }), Io = S.union([_o, ko]), Lo = S.union([S.enum(["OUTBOUND", "INBOUND"]), S.string()]).register(S.globalRegistry, { description: "The direction of the shipment. OUTBOUND is from sender to recipient, INBOUND is from recipient to sender." }), Ro = S.object({
	additionalInsurance: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Provides enhanced insurance coverage beyond the standard amount." }).optional(),
	deliverAtPostalPoint: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Indicates that the parcel will be delivered to a designated postal service point rather than the recipient's address, requiring the recipient to collect it from that location." }).optional(),
	freshFood: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Designates the shipment as containing perishable, non-frozen food items, ensuring appropriate handling procedures are applied to maintain freshness and prevent spoilage during transit." }).optional(),
	frozen: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Specifies that the shipment contains items that must remain frozen, necessitating strict, continuous temperature-controlled environments throughout the transit process to prevent thawing." }).optional(),
	hideSender: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Omits the sender's information from the shipping label, maintaining sender anonymity in the delivery process." }).optional(),
	insurance: S.object({ amount: S.object({
		currency: S.string().register(S.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
		micros: S.int().gte(0).lte(9007199254740991).register(S.globalRegistry, { description: "The amount of money in integer micros." })
	}).register(S.globalRegistry, { description: "The amount to insure." }) }).register(S.globalRegistry, { description: "Provides standard insurance coverage up to the specified monetary amount." }).optional(),
	noTracking: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Disables all tracking and tracing capabilities for the shipment." }).optional(),
	oversizedPackage: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Designates the shipment as exceeding standard size limitations, requiring special handling procedures and potentially incurring additional fees." }).optional(),
	printReturnLabelAtDropOff: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Provides the recipient with a digital identifier that can be presented at a drop-off location to print the return label on-site. This option is only applicable for inbound shipments." }).optional(),
	priorityDelivery: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Designates the shipment for expedited processing and transport through the delivery network, often resulting in a faster transit time compared to standard services." }).optional(),
	recipientOnlyDelivery: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Restricts delivery exclusively to the named recipient, requiring verification of recipient identity and prohibiting delivery to anyone else at the same address." }).optional(),
	requiresAgeVerification: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Requires the recipient to provide valid identification to verify they meet the minimum age requirement before the package can be released, typically used for age-restricted items." }).optional(),
	requiresCashOnDelivery: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Mandates that the carrier collect the full order amount in cash from the recipient upon delivery, ensuring payment is secured before the goods are handed over." }).optional(),
	requiresReceiptCode: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Requires the recipient to provide a specific verification code at the time of delivery, adding an extra layer of security and confirmation for sensitive shipments." }).optional(),
	requiresSignature: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Mandates that the recipient or authorized representative must provide a signature upon delivery, creating proof of receipt and transfer of responsibility." }).optional(),
	returnContributionFee: S.object({ amount: S.object({
		currency: S.string().register(S.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
		micros: S.int().gte(0).lte(9007199254740991).register(S.globalRegistry, { description: "The amount of money in integer micros." })
	}).register(S.globalRegistry, { description: "The amount of the contribution." }) }).register(S.globalRegistry, { description: "Specifies that the recipient must pay the designated contribution amount toward the cost of returning the item. This option is only applicable for inbound shipments." }).optional(),
	returnOnFirstFailedDelivery: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Instructs the carrier to return the package to the sender immediately after the first unsuccessful delivery attempt, bypassing the standard redelivery procedures or holding period." }).optional(),
	sameDayDelivery: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Expedited delivery within the same calendar day that the shipping label is created." }).optional(),
	saturdayDelivery: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Enables delivery on Saturday, which is typically outside standard delivery days, ensuring the package arrives before the start of the following work week." }).optional(),
	scheduledCollection: S.record(S.string(), S.never()).register(S.globalRegistry, { description: "Arranges for the carrier to pick up the package from the sender's location, eliminating the need for the sender to drop off the package." }).optional()
}).register(S.globalRegistry, { description: "Options applicable to shipments." }), zo = S.object({ customLabelText: S.object({ text: S.string().register(S.globalRegistry, { description: "Allows adding personalized text to be printed on the shipping label, which can include special handling instructions or reference information." }) }).register(S.globalRegistry, { description: "Defines a custom text to be printed on the shipping label." }).optional() }).register(S.globalRegistry, { description: "Options applicable to individual packages of a shipment." }), Bo = Ro.and(zo), Vo = S.union([S.enum(["ASC", "DESC"]), S.string()]).register(S.globalRegistry, { description: "Specifies the ordering of results: ascending (ASC) or descending (DESC)." }), Ho = S.object({
	emailAddress: S.string().register(S.globalRegistry, { description: "An email address." }).optional(),
	locale: S.union([S.string().register(S.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), S.string().register(S.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: S.string().register(S.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: S.union([S.enum(["BUSINESS"]), S.string()]).register(S.globalRegistry, { description: "Discriminator for business contacts." }),
	company: S.string().register(S.globalRegistry, { description: "The name of the company." }),
	attention: S.string().register(S.globalRegistry, { description: "The name of the contact person." }).optional(),
	vatNumbersByCountry: S.record(S.string(), S.string().register(S.globalRegistry, { description: "The VAT registration number for the given country." })).register(S.globalRegistry, { description: "A collection of VAT registration numbers of the company, indexed by ISO country code." }).optional(),
	voecNumber: S.string().register(S.globalRegistry, { description: "The VOEC number of the company." }).optional(),
	eoriNumber: S.string().register(S.globalRegistry, { description: "The EORI number of the company." }).optional()
}), Uo = S.object({
	emailAddress: S.string().register(S.globalRegistry, { description: "An email address." }).optional(),
	locale: S.union([S.string().register(S.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), S.string().register(S.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: S.string().register(S.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: S.union([S.enum(["PRIVATE"]), S.string()]).register(S.globalRegistry, { description: "Discriminator for private contacts." }),
	name: S.string().register(S.globalRegistry, { description: "The name of the contact person." })
}), Wo = S.union([S.object({ type: S.literal("BUSINESS") }).and(Ho), S.object({ type: S.literal("PRIVATE") }).and(Uo)]), Go = S.object({
	locale: S.union([S.string().register(S.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), S.string().register(S.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: S.string().register(S.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: S.union([S.enum(["BUSINESS"]), S.string()]).register(S.globalRegistry, { description: "Discriminator for business contacts." }),
	company: S.string().register(S.globalRegistry, { description: "The name of the company." }),
	attention: S.string().register(S.globalRegistry, { description: "The name of the contact person." }).optional(),
	vatNumbersByCountry: S.record(S.string(), S.string().register(S.globalRegistry, { description: "The VAT registration number for the given country." })).register(S.globalRegistry, { description: "A collection of VAT registration numbers of the company, indexed by ISO country code." }).optional(),
	voecNumber: S.string().register(S.globalRegistry, { description: "The VOEC number of the company." }).optional(),
	eoriNumber: S.string().register(S.globalRegistry, { description: "The EORI number of the company." }).optional(),
	emailAddresses: S.array(S.string().register(S.globalRegistry, { description: "An email address." })).register(S.globalRegistry, { description: "The email addresses of the contact. The first email address will be used as the primary email address. The remaining will be used as extra email addresses if the right permissions are present." }).optional()
}).register(S.globalRegistry, { description: "A business contact that supports multiple email addresses." }), Ko = S.object({
	locale: S.union([S.string().register(S.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), S.string().register(S.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: S.string().register(S.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: S.union([S.enum(["PRIVATE"]), S.string()]).register(S.globalRegistry, { description: "Discriminator for private contacts." }),
	name: S.string().register(S.globalRegistry, { description: "The name of the contact person." }),
	emailAddresses: S.array(S.string().register(S.globalRegistry, { description: "An email address." })).register(S.globalRegistry, { description: "The email addresses of the contact. The first email address will be used as the primary email address. The remaining will be used as extra email addresses if the right permissions are present." }).optional()
}).register(S.globalRegistry, { description: "A private contact that supports multiple email addresses." }), qo = S.union([S.object({ type: S.literal("BUSINESS") }).and(Go), S.object({ type: S.literal("PRIVATE") }).and(Ko)]), Jo = S.object({
	address: vo.optional(),
	contact: Wo.optional()
}).register(S.globalRegistry, { description: "The billing details of an order." }), Yo = S.object({
	name: S.union([S.enum([
		"BOL",
		"CSCART",
		"GENERIC",
		"LIGHTSPEED",
		"MAGENTO",
		"PRESTA",
		"SHOPIFY",
		"WOOCOMMERCE"
	]), S.string()]).register(S.globalRegistry, { description: "The identifier of the external e-commerce platform." }),
	sourceId: S.string().register(S.globalRegistry, { description: "The order ID as defined in the source system." })
}).register(S.globalRegistry, { description: "The external reference of the ecommerce platform." }), Xo = S.object({
	id: S.string().register(S.globalRegistry, { description: "The unique identifier of the sales channel." }),
	name: S.string().register(S.globalRegistry, { description: "The name of the sales channel at the time of import." })
}).register(S.globalRegistry, { description: "The external reference of the sales channel." }), Zo = S.object({
	source: S.union([S.enum(["SALES_CHANNEL"]), S.string()]),
	salesChannel: Xo,
	ecommercePlatform: Yo
}), Qo = S.object({ source: S.union([S.enum(["MYPARCEL_SHOP"]), S.string()]) }).register(S.globalRegistry, { description: "This external reference is set when the order originates from an \"etiketten\" shipment. The only actions allowed on this type of order is cancel" }), $o = S.object({
	source: S.union([S.enum(["IMPORT"]), S.string()]),
	sourceId: S.string().register(S.globalRegistry, { description: "The order ID as defined in the source system." })
}).register(S.globalRegistry, { description: "This external reference is set when the order originates from a generic ecommerce order import" }), es = S.union([
	S.object({ source: S.literal("SALES_CHANNEL") }).and(Zo),
	S.object({ source: S.literal("MYPARCEL_SHOP") }).and(Qo),
	S.object({ source: S.literal("IMPORT") }).and($o)
]), ts = S.object({ sourceId: S.string().register(S.globalRegistry, { description: "The order line ID as defined in the source system." }) }).register(S.globalRegistry, { description: "The external reference of the order line." }), ns = S.object({
	credited: S.boolean().register(S.globalRegistry, { description: "Whether the label is credited by us." }),
	createdBy: S.union([S.string().register(S.globalRegistry, { description: "A shop principal identifier." }), S.string().register(S.globalRegistry, { description: "A user principal identifier." })]).optional(),
	paymentStatus: No.optional(),
	barcode: S.string().register(S.globalRegistry, { description: "The barcode of the label." }),
	delayed: S.boolean().register(S.globalRegistry, { description: "Whether the shipment is delayed." }),
	partnerBarcodes: S.array(S.string().register(S.globalRegistry, { description: "The barcode identifier associated with the shipment label." })).register(S.globalRegistry, { description: "The partner barcodes when the parcel is taken over by a partner carrier." }).optional()
}), rs = S.object({
	credited: S.boolean().register(S.globalRegistry, { description: "Whether the label is credited by us." }),
	createdBy: S.union([S.string().register(S.globalRegistry, { description: "A shop principal identifier." }), S.string().register(S.globalRegistry, { description: "A user principal identifier." })]).optional(),
	paymentStatus: No.optional()
}), is = S.object({
	type: S.union([S.enum(["IMPORTED"]), S.string()]),
	id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of a note of an order." }),
	notedAt: S.union([S.string(), S.iso.datetime().register(S.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	origin: S.union([S.enum(["SALES_CHANNEL"]), S.string()]).register(S.globalRegistry, { description: "The origin of the note." }),
	text: S.string().register(S.globalRegistry, { description: "The text of the note." }),
	author: S.string().register(S.globalRegistry, { description: "The author of the note." }).optional(),
	locale: S.union([S.string().register(S.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), S.string().register(S.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	updatedAt: S.union([S.string(), S.iso.datetime().register(S.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]).optional()
}), as = S.object({
	type: S.union([S.enum(["PRINCIPAL"]), S.string()]),
	id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of a note of an order." }),
	notedAt: S.union([S.string(), S.iso.datetime().register(S.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	principal: S.string().register(S.globalRegistry, { description: "The principal who crated the note." }),
	text: S.string().register(S.globalRegistry, { description: "The text of the note." }),
	locale: S.union([S.string().register(S.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), S.string().register(S.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	updatedAt: S.union([S.string(), S.iso.datetime().register(S.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]).optional()
}), os = S.union([S.object({ type: S.literal("IMPORTED") }).and(is), S.object({ type: S.literal("PRINCIPAL") }).and(as)]), ss = S.union([
	S.object({
		address: vo,
		location: S.object({
			name: S.string().register(S.globalRegistry, { description: "The name of the pickup location." }),
			code: S.string().register(S.globalRegistry, { description: "The location code of the pickup location." }).optional(),
			type: S.union([S.enum([
				"CLICK_COLLECT",
				"PARCEL_LOCKER",
				"PARCEL_POINT",
				"POST_OFFICE",
				"POST_POINT"
			]), S.string()]).register(S.globalRegistry, { description: "The bpost pickup location type." })
		}).register(S.globalRegistry, { description: "The pickup location details." })
	}).register(S.globalRegistry, { description: "The bpost pickup details." }),
	S.object({
		address: vo,
		location: S.object({
			name: S.string().register(S.globalRegistry, { description: "The name of the pickup location." }),
			code: S.string().register(S.globalRegistry, { description: "The location code of the pickup location." }).optional()
		}).register(S.globalRegistry, { description: "The pickup location details." }),
		retailNetworkId: S.union([S.enum(["PNPNL-01", "PNPBE-01"]), S.string()]).register(S.globalRegistry, { description: "PostNL Retail network ID." })
	}).register(S.globalRegistry, { description: "The PostNL pickup details." }),
	S.object({
		address: vo,
		location: S.object({
			name: S.string().register(S.globalRegistry, { description: "The name of the pickup location." }),
			code: S.string().register(S.globalRegistry, { description: "The location code of the pickup location." }).optional()
		}).register(S.globalRegistry, { description: "The pickup location details." })
	}).register(S.globalRegistry, { description: "The general pickup details." })
]), cs = S.object({
	carrier: yo,
	direction: Lo,
	disableAutoDetectPickup: S.boolean().register(S.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }),
	packageType: jo,
	recipient: S.object({
		address: vo,
		contact: qo
	}).register(S.globalRegistry, { description: "The recipient of the shipment." }),
	customContractId: S.string().register(S.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
	delivery: Eo.optional(),
	options: Ro.optional(),
	pickup: ss.optional(),
	sender: S.object({
		address: vo,
		contact: Wo
	}).register(S.globalRegistry, { description: "The sender of the shipment." }).optional(),
	saveRecipientAddress: S.boolean().register(S.globalRegistry, { description: "When set to true, the recipient address is saved to the user's address book." }).optional()
}), ls = S.object({
	id: S.string().register(S.globalRegistry, { description: "The unique identifier of the shipment." }),
	carrier: yo,
	createdAt: S.union([S.string(), S.iso.datetime().register(S.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	direction: Lo,
	hidden: S.boolean().register(S.globalRegistry, { description: "Whether the shipment is hidden." }),
	packageType: jo,
	recipient: S.object({
		address: vo.optional(),
		contact: qo.optional()
	}).register(S.globalRegistry, { description: "The recipient of the shipment." }),
	customContractId: S.string().register(S.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
	customsDeclaration: So.optional(),
	delivery: Eo.optional(),
	dropOff: Do.optional(),
	label: S.union([ns, rs]).optional(),
	multicollo: S.object({
		id: S.uuid().register(S.globalRegistry, { description: "The unique identifier for a multicollo shipment group." }),
		totalPackages: S.int().gte(2).lte(20).register(S.globalRegistry, { description: "The total number of individual packages included within this specific multicollo shipment group." })
	}).register(S.globalRegistry, { description: "Details if this package is part of a multi-package (multicollo) shipment. A multicollo shipment is a group of packages belonging to the same shipment that are consolidated for combined labeling and potential cost reduction. This object will only be present if the package is part of such a group." }).optional(),
	options: Bo.optional(),
	pickup: ss.optional(),
	price: Oo.optional(),
	sender: S.object({
		address: vo,
		contact: Wo
	}).register(S.globalRegistry, { description: "The sender of the shipment." }).optional()
}).register(S.globalRegistry, { description: "The shipment properties of a package." }), us = S.object({
	id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of a line of an order." }),
	product: S.object({
		name: S.string().register(S.globalRegistry, { description: "The name of the product." }),
		ean: S.string().register(S.globalRegistry, { description: "The EAN of the product." }).optional(),
		sku: S.string().register(S.globalRegistry, { description: "The SKU of the product." }).optional(),
		id: S.uuid().register(S.globalRegistry, { description: "Identifier of the product. This is always undefined when the `status` is `DISCOVERED` or `IMPORT_REQUESTED`, otherwise it is always defined." }).optional()
	}).register(S.globalRegistry, { description: "The product of an order line." }),
	quantity: S.int().gte(1).register(S.globalRegistry, { description: "The quantity of the product of the order line." }),
	externalReference: ts.optional(),
	price: Oo.and(S.unknown().register(S.globalRegistry, { description: "The price of the product of the order line." })).optional()
}).register(S.globalRegistry, { description: "The line of the order" }), ds = S.object({
	customsDeclaration: xo.optional(),
	options: zo.optional(),
	physicalProperties: Fo.optional()
}), fs = S.object({
	lines: S.array(S.object({
		id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of a line of an order." }),
		quantity: S.int().gte(1).register(S.globalRegistry, { description: "The quantity of the product of the order line." })
	})).optional(),
	physicalProperties: Fo.optional()
}), ps = S.object({
	id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the package." }),
	status: Mo,
	physicalProperties: Po.optional(),
	lines: S.array(S.object({
		id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of a line of an order." }),
		quantity: S.int().gte(1).register(S.globalRegistry, { description: "The quantity that the package contains" })
	})).register(S.globalRegistry, { description: "The order lines related to the package." }).optional(),
	shipment: ls.optional()
}), ms = S.object({
	customsDeclaration: xo.optional(),
	options: zo.optional(),
	physicalProperties: Fo.optional(),
	shipment: S.object({
		carrier: bo,
		direction: Lo,
		disableAutoDetectPickup: S.boolean().register(S.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }),
		packageType: jo,
		recipient: S.object({
			address: vo,
			contact: qo
		}).register(S.globalRegistry, { description: "The recipient of the shipment." }),
		customContractId: S.string().register(S.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
		delivery: Eo.optional(),
		options: Ro.optional(),
		pickup: ss.optional(),
		sender: S.object({
			address: vo,
			contact: Wo
		}).register(S.globalRegistry, { description: "The sender of the shipment." }).optional(),
		saveRecipientAddress: S.boolean().register(S.globalRegistry, { description: "When set to true, the recipient address is saved to the user's address book." }).optional()
	})
}), hs = S.object({
	carrier: yo.optional(),
	customContractId: S.string().register(S.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
	customsDeclaration: So.optional(),
	delivery: Eo.optional(),
	direction: Lo.optional(),
	disableAutoDetectPickup: S.boolean().register(S.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }).optional(),
	numberOfLabels: S.int().gte(1).lte(20).optional(),
	options: Bo.optional(),
	packageType: jo.optional(),
	pickup: ss.optional(),
	recipient: S.object({
		address: vo.optional(),
		contact: qo.optional()
	}).register(S.globalRegistry, { description: "The recipient of the shipment." }).optional()
}).register(S.globalRegistry, { description: "The shipping preferences of the order. This should be used as default information when preparing packages for shipment." }), gs = S.union([S.object({
	shopId: S.string().register(S.globalRegistry, { description: "The unique identifier of the shop." }),
	customerReference: Co.optional(),
	package: ms
}), S.object({
	shopId: S.string().register(S.globalRegistry, { description: "The unique identifier of the shop." }),
	customerReference: Co.optional(),
	multicollo: S.object({
		packages: S.array(ds),
		shipment: S.object({
			carrier: bo,
			direction: Lo,
			disableAutoDetectPickup: S.boolean().register(S.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }),
			packageType: jo,
			recipient: S.object({
				address: vo,
				contact: qo
			}).register(S.globalRegistry, { description: "The recipient of the shipment." }),
			customContractId: S.string().register(S.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
			delivery: Eo.optional(),
			options: Ro.optional(),
			pickup: ss.optional(),
			sender: S.object({
				address: vo,
				contact: Wo
			}).register(S.globalRegistry, { description: "The sender of the shipment." }).optional(),
			saveRecipientAddress: S.boolean().register(S.globalRegistry, { description: "When set to true, the recipient address is saved to the user's address book." }).optional()
		})
	})
})]), _s = S.object({
	id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." }),
	packages: S.array(fs)
}), vs = S.object({
	id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the package." }),
	customsDeclaration: xo.optional(),
	options: zo.optional(),
	physicalProperties: Fo.optional()
}), ys = S.union([S.object({
	id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." }),
	shipment: cs,
	packages: S.array(vs)
}), S.object({
	id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." }),
	shipment: cs,
	multicollo: S.array(vs)
})]), bs = S.object({
	id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." }),
	orderedAt: S.union([S.string(), S.iso.datetime().register(S.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	price: Oo,
	shopId: S.string().register(S.globalRegistry, { description: "The unique identifier of the shop." }),
	shortId: S.string().register(S.globalRegistry, { description: "The short ID of the order." }),
	status: Ao,
	assignedUserId: S.string().register(S.globalRegistry, { description: "The user ID assigned to the order." }).optional(),
	billingDetails: Jo.optional(),
	customerReference: Co.optional(),
	externalReferences: es.and(S.unknown().register(S.globalRegistry, { description: "The external references of the order. These are read-only and automatically populated by the system based on the source." })).optional(),
	lines: S.array(us).register(S.globalRegistry, { description: "The lines of the order" }).optional(),
	notes: S.array(os).register(S.globalRegistry, { description: "The notes of the order." }).optional(),
	packages: S.array(ps).register(S.globalRegistry, { description: "The packages of the order." }).optional(),
	rules: S.object({ setShippingPreferences: S.object({
		path: S.array(S.union([S.object({
			id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the rule." }),
			name: S.string().register(S.globalRegistry, { description: "The name of the rule." })
		}), S.object({
			id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the rule group." }),
			condition: S.union([S.object({ countryCode: _o }), S.object({ geoAreaCode: ko })])
		})])).register(S.globalRegistry, { description: "The path of the rule." }),
		appliedAt: S.union([S.string(), S.iso.datetime().register(S.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
		result: S.union([S.enum(["PRESERVE", "REPLACE"]), S.string()]).register(S.globalRegistry, { description: "How the rule was applied." })
	}).optional() }).register(S.globalRegistry, { description: "The rules that have been applied to the order." }).optional(),
	shipping: hs.optional()
}), xs = S.object({
	type: S.union([S.enum([
		"about:blank",
		"urn:problem:client",
		"urn:problem:invalid-request-syntax",
		"urn:problem:not-found",
		"urn:problem:server",
		"urn:problem:unauthorized",
		"urn:problem:unsupported-media-type"
	]), S.string()]).register(S.globalRegistry, { description: "A URI reference that identifies the problem type." }),
	status: S.union([
		S.literal(400),
		S.literal(401),
		S.literal(404),
		S.literal(415),
		S.literal(500)
	]).register(S.globalRegistry, { description: "The HTTP status code generated by the origin server." }),
	title: S.string().register(S.globalRegistry, { description: "A short human-readable summary of the problem type." }),
	detail: S.string().register(S.globalRegistry, { description: "A human-readable explanation specific to this occurrence of the problem." }),
	instance: S.url().register(S.globalRegistry, { description: "A URI reference that identifies the specific occurrence of the problem." }),
	cause: S.unknown().register(S.globalRegistry, { description: "The cause of this problem when debug mode is enabled." }).optional()
}), Ss = xs.and(S.object({
	type: S.union([S.enum(["urn:problem:client"]), S.string()]).register(S.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: S.literal(400).register(S.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: S.array(S.object({
		detail: S.string(),
		pointer: S.string().register(S.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).register(S.globalRegistry, { description: "Detailed information regarding the violations." })
})), Cs = xs.and(S.object({
	type: S.union([S.enum(["urn:problem:server"]), S.string()]).register(S.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: S.literal(500).register(S.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional()
}));
xs.and(S.object({
	type: S.union([S.enum(["urn:problem:invalid-request-syntax"]), S.string()]).register(S.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: S.literal(400).register(S.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: S.array(S.object({
		detail: S.string(),
		pointer: S.string().register(S.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).register(S.globalRegistry, { description: "Detailed information regarding the syntactic violations." })
})), S.object({
	body: S.array(S.object({
		id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." }),
		text: S.string().register(S.globalRegistry, { description: "The text of the note." }),
		locale: S.union([S.string().register(S.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), S.string().register(S.globalRegistry, { description: "ISO 639-1 language code." })]).optional()
	})).register(S.globalRegistry, { description: "Body for adding an order note." }),
	path: S.never().optional(),
	query: S.never().optional()
}), S.array(S.union([
	S.object({
		status: S.literal(200),
		ids: S.array(S.uuid()).min(1)
	}),
	Ss,
	Cs
])).register(S.globalRegistry, { description: "The result per ID." }), S.object({
	body: S.array(S.object({
		id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." }),
		userId: S.string().register(S.globalRegistry, { description: "User to assign to these orders." })
	})).register(S.globalRegistry, { description: "Body for assigning orders to an user." }),
	path: S.never().optional(),
	query: S.never().optional()
}), S.array(S.union([
	S.object({ status: S.literal(200) }),
	Ss,
	Cs
])).register(S.globalRegistry, { description: "The result per ID." }), S.object({
	body: S.array(S.object({ id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." }) })).register(S.globalRegistry, { description: "Body for canceling orders." }),
	path: S.never().optional(),
	query: S.never().optional()
}), S.array(S.union([
	S.object({ status: S.literal(200) }),
	Ss,
	Cs
])).register(S.globalRegistry, { description: "The result per ID." }), S.object({
	body: S.array(gs).register(S.globalRegistry, { description: "Body for creating an order with shippable packages." }),
	path: S.never().optional(),
	query: S.never().optional()
}), S.array(S.union([
	S.object({
		status: S.literal(201),
		id: S.uuid()
	}),
	Ss,
	Cs
])).register(S.globalRegistry, { description: "The result per item." }), S.object({
	body: S.array(_s).register(S.globalRegistry, { description: "Body adding packages to orders" }),
	path: S.never().optional(),
	query: S.never().optional()
}), S.array(S.union([
	S.object({
		status: S.literal(200),
		ids: S.array(S.uuid()).min(1)
	}),
	Ss,
	Cs
])).register(S.globalRegistry, { description: "The result per ID." }), S.object({
	body: S.array(ys).register(S.globalRegistry, { description: "Body preparing packages for shipment" }),
	path: S.never().optional(),
	query: S.never().optional()
}), S.array(S.union([
	S.object({ status: S.literal(200) }),
	Ss,
	Cs
])).register(S.globalRegistry, { description: "The result per ID." }), S.object({
	body: S.array(S.object({
		id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." }),
		packageIds: S.array(S.uuid().register(S.globalRegistry, { description: "The unique identifier of the package." })).min(1).max(25)
	})).register(S.globalRegistry, { description: "Body for unpreparing packages for shipment" }),
	path: S.never().optional(),
	query: S.never().optional()
}), S.array(S.union([
	S.object({ status: S.literal(200) }),
	Ss,
	Cs
])).register(S.globalRegistry, { description: "The result per ID." }), S.object({
	body: S.array(S.object({
		id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." }),
		noteId: S.uuid().register(S.globalRegistry, { description: "The unique identifier of a note of an order." }),
		text: S.string().register(S.globalRegistry, { description: "The text of the note." })
	})).register(S.globalRegistry, { description: "Body for editing an order note." }),
	path: S.never().optional(),
	query: S.never().optional()
}), S.array(S.union([
	S.object({ status: S.literal(200) }),
	Ss,
	Cs
])).register(S.globalRegistry, { description: "The result per ID." }), S.object({
	body: S.array(S.object({ id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." }) })).register(S.globalRegistry, { description: "Body for importing an order." }),
	path: S.never().optional(),
	query: S.never().optional()
}), S.array(S.union([
	S.object({ status: S.literal(200) }),
	Ss,
	Cs
])).register(S.globalRegistry, { description: "The result per ID." }), S.object({
	body: S.never().optional(),
	path: S.never().optional(),
	query: S.object({
		aggregations: S.array(Ao).register(S.globalRegistry, { description: "The statuses to retrieve counts for." }).optional(),
		filter: S.object({
			assignedUserId: S.array(S.string().register(S.globalRegistry, { description: "The unique identifier of the user." })).optional(),
			carrier: S.array(yo).optional(),
			hasAssignedUser: S.union([S.enum(["true", "false"]), S.string()]).register(S.globalRegistry, { description: "Whether the order has an assigned user or not." }).optional(),
			hasNotes: S.union([S.enum(["true", "false"]), S.string()]).register(S.globalRegistry, { description: "Whether the order has notes or not." }).optional(),
			orderId: S.array(S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." })).optional(),
			orderedAt: S.array(S.string().register(S.globalRegistry, { description: "Inequality symbol 'gt', 'gte', 'lt', 'lte' with a datetime in ISO 8601 format." })).optional(),
			packageStatusGroup: S.array(S.union([S.enum([
				"PICKING_AND_PACKING",
				"DISPATCHING",
				"UNTRACEABLE",
				"SORTING",
				"DISTRIBUTING",
				"DELIVERED"
			]), S.string()])).optional(),
			packageType: S.array(jo).optional(),
			price: S.array(S.string().register(S.globalRegistry, { description: "Inequality symbol 'gt', 'gte', 'lt', 'lte' with a number with a maximum precision of 2." })).optional(),
			regionCode: S.array(Io).optional(),
			salesChannelId: S.array(S.string().register(S.globalRegistry, { description: "The unique identifier of the sales channel." })).optional(),
			shipmentDelayed: S.union([S.enum(["true", "false"]), S.string()]).register(S.globalRegistry, { description: "Whether the order has a package with a delayed shipment or not." }).optional(),
			shipmentDirection: S.array(Lo).optional(),
			shipmentPaymentStatus: S.array(No).optional(),
			shopId: S.array(S.string().register(S.globalRegistry, { description: "The unique identifier of the shop." })).optional(),
			status: S.array(Ao).optional()
		}).optional(),
		limit: S.int().gte(0).lte(50).nullish().default(50),
		pageToken: S.string().register(S.globalRegistry, { description: "The page token to retrieve the next page of orders." }).optional(),
		query: S.string().register(S.globalRegistry, { description: "The following operators are supported:\n'+ signifies AND operation'\n'| signifies OR operation'\n'- negates a single token'\n'\" wraps a number of tokens to signify a phrase for searching'\n'* at the end of a term signifies a prefix query'\n'( and ) signify precedence'\n'~N after a word signifies edit distance (fuzziness)'\n'~N after a phrase signifies slop amount'\nTo use one of these characters literally, escape it with a preceding backslash (\\)." }).optional(),
		sort: S.object({
			customerReference: Vo.optional(),
			orderedAt: Vo.optional(),
			price: Vo.optional(),
			sourceId: Vo.optional()
		}).register(S.globalRegistry, { description: "When no `query` is provided the default sort is by `orderedAt` descending. When a `query` is provided the default sort is by relevance." }).optional()
	}).optional()
}), S.object({
	results: S.array(bs).register(S.globalRegistry, { description: "The list of orders." }),
	total: S.object({
		relation: S.union([S.enum(["eq", "gte"]), S.string()]).register(S.globalRegistry, { description: "The relation of the total number of orders." }),
		value: S.int().gte(0).register(S.globalRegistry, { description: "The total number of orders." })
	}),
	aggregations: S.object({ status: S.array(S.object({
		key: Ao,
		count: S.int().gte(0)
	})).optional() }).register(S.globalRegistry, { description: "Count of orders per status, scoped to the active search query and all active filters except the status filter." }).optional(),
	nextPageToken: S.string().register(S.globalRegistry, { description: "The next page token to retrieve the next page of orders." }).optional()
}).register(S.globalRegistry, { description: "The found orders." }), S.object({
	body: S.never().optional(),
	path: S.never().optional(),
	query: S.object({
		shipmentLabelsLayout: S.union([S.enum(["INTERLEAVED"]), S.string()]).register(S.globalRegistry, { description: "How shipment labels are included alongside the packing slips in the resulting PDF. `INTERLEAVED` outputs each packing slip immediately followed by its shipment label. When the parameter is omitted, no shipment labels are included and only packing slips are rendered." }).optional(),
		orderId: S.array(S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." })).register(S.globalRegistry, { description: "The orderId of the order to include in the packing slips. A maximum of 50 orders can be included in the request. When packageId is provided, exactly one orderId is allowed." }),
		packageId: S.array(S.uuid().register(S.globalRegistry, { description: "The unique identifier of the package." })).register(S.globalRegistry, { description: "The packageId of the package to include in the packing slips. The packageIds must belong to the single orderId in the request and a maximum of 20 packageIds can be included." }).optional()
	}),
	headers: S.object({ Accept: S.union([S.enum(["application/pdf", "application/pdf+print"]), S.string()]).register(S.globalRegistry, { description: "Use `application/pdf` to download the packing slip. Use `application/pdf+print; printer-group-id=<uuid>` to send the packing slip directly to a printer group." }) })
}), S.union([S.string().register(S.globalRegistry, { description: "Packing slips PDF. Returned when `Accept: application/pdf`." }), S.void().register(S.globalRegistry, { description: "The packing slip has been sent to the printer. Returned when `Accept: application/pdf+print; printer-group-id=<uuid>`." })]), S.object({
	body: S.never().optional(),
	path: S.never().optional(),
	query: S.object({ orderId: S.array(S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." })).register(S.globalRegistry, { description: "The orderId of the order to include in the picklist. A maximum of 50 orders can be included in the request." }) }),
	headers: S.object({ Accept: S.union([S.enum(["application/pdf", "application/pdf+print"]), S.string()]).register(S.globalRegistry, { description: "Use `application/pdf` to download the picklist. Use `application/pdf+print; printer-group-id=<uuid>` to send the picklist directly to a printer group." }) })
}), S.union([S.string().register(S.globalRegistry, { description: "Picklist PDF. Returned when `Accept: application/pdf`." }), S.void().register(S.globalRegistry, { description: "The picklist has been sent to the printer. Returned when `Accept: application/pdf+print; printer-group-id=<uuid>`." })]), S.object({
	body: S.array(S.object({
		id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." }),
		noteIds: S.array(S.uuid().register(S.globalRegistry, { description: "The unique identifier of a note of an order." })).min(1).max(150).register(S.globalRegistry, { description: "Note IDs to remove from the order." })
	})).register(S.globalRegistry, { description: "Body for removing order notes." }),
	path: S.never().optional(),
	query: S.never().optional()
}), S.array(S.union([
	S.object({ status: S.literal(200) }),
	Ss,
	Cs
])).register(S.globalRegistry, { description: "The result per ID." }), S.object({
	body: S.array(S.object({ id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." }) })).register(S.globalRegistry, { description: "Body for unassigning orders from an user." }),
	path: S.never().optional(),
	query: S.never().optional()
}), S.array(S.union([
	S.object({ status: S.literal(200) }),
	Ss,
	Cs
])).register(S.globalRegistry, { description: "The result per ID." }), S.object({
	body: S.array(S.object({ id: S.uuid().register(S.globalRegistry, { description: "The unique identifier of the order." }) })).register(S.globalRegistry, { description: "Body for evaluating order rules." }),
	path: S.never().optional(),
	query: S.never().optional()
}), S.array(S.union([
	S.object({ status: S.literal(200) }),
	Ss,
	Cs
])).register(S.globalRegistry, { description: "The result per ID." });
//#endregion
//#region ../../services/order-service/dist/shippablePackages-Cf3JSF1b.js
var ws = {
	type: "object",
	properties: {
		city: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The city of the address."
		},
		countryCode: { $ref: "#/components/schemas/CountryCode" },
		street: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The street of the address."
		},
		additionalInformation: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "Additional information about the address."
		},
		boxNumber: {
			type: "string",
			minLength: 1,
			maxLength: 20,
			description: "The box number of the address, only applicable for specific country codes."
		},
		houseNumber: {
			type: "string",
			minLength: 1,
			maxLength: 25,
			description: "The house number of the address."
		},
		houseNumberSuffix: {
			type: "string",
			minLength: 1,
			maxLength: 25,
			description: "The house number suffix of the address."
		},
		postalCode: {
			type: "string",
			minLength: 1,
			maxLength: 15,
			description: "The postal code of the address."
		},
		region: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The region of the address."
		},
		state: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The state of the address."
		}
	},
	required: [
		"city",
		"countryCode",
		"street"
	],
	description: "A physical address."
}, Ts = {
	type: "object",
	properties: {
		groups: {
			type: "array",
			items: {
				type: "object",
				properties: {
					description: {
						type: "string",
						minLength: 1,
						maxLength: 50,
						description: "A clear and detailed description of the goods within this group."
					},
					hsCode: {
						type: "string",
						minLength: 6,
						maxLength: 12,
						description: "The Harmonized System (HS) code for the goods in this group, a globally recognized classification for traded products."
					},
					numberOfItems: {
						type: "integer",
						minimum: 1,
						maximum: 99999,
						description: "The total quantity of individual items within this specific group."
					},
					totalValue: {
						type: "object",
						properties: {
							currency: {
								type: "string",
								minLength: 3,
								maxLength: 3,
								description: "ISO 4217 three-letter currency code."
							},
							micros: {
								type: "integer",
								minimum: 0,
								maximum: 9007199254740991,
								description: "The amount of money in integer micros."
							}
						},
						required: ["currency", "micros"],
						description: "The total declared value of all items within this group."
					},
					totalWeight: {
						type: "object",
						properties: {
							unit: {
								type: "string",
								enum: ["g", "kg"],
								description: "The unit of weight."
							},
							value: {
								type: "integer",
								minimum: 1,
								maximum: 999999999
							}
						},
						required: ["unit", "value"],
						description: "The total weight of all items within this specific group."
					},
					countryCodeOfOrigin: { allOf: [{ $ref: "#/components/schemas/CountryCode" }, { description: "The ISO 3166-1 alpha-2 country code indicating where the goods in this group originated." }] }
				},
				required: [
					"description",
					"hsCode",
					"numberOfItems",
					"totalValue",
					"totalWeight"
				],
				description: "A consolidated group of items within a customs declaration that share common customs attributes."
			},
			minItems: 1,
			maxItems: 100,
			description: "The list of item groups."
		},
		purpose: {
			type: "string",
			enum: [
				"COMMERCIAL_GOODS",
				"COMMERCIAL_SAMPLE",
				"DOCUMENTS",
				"GIFT",
				"RETURNED_GOODS"
			],
			description: "The primary reason or purpose for the international shipment."
		},
		totalWeight: {
			type: "object",
			properties: {
				unit: {
					type: "string",
					enum: ["g", "kg"],
					description: "The unit of weight."
				},
				value: {
					type: "integer",
					minimum: 1,
					maximum: 999999999
				}
			},
			required: ["unit", "value"],
			description: "The total weight of all items declared within this customs declaration."
		},
		invoiceNumber: {
			type: "string",
			minLength: 1,
			maxLength: 150,
			description: "The identifying number of the commercial invoice associated with this shipment."
		}
	},
	required: [
		"groups",
		"purpose",
		"totalWeight"
	],
	description: "The official declaration of goods for customs clearance purposes during international shipment."
}, k = {
	BPOST: "BPOST",
	BRT: "BRT",
	CHEAP_CARGO: "CHEAP_CARGO",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DHL_FREIGHT: "DHL_FREIGHT",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DPD: "DPD",
	GLS: "GLS",
	INPOST: "INPOST",
	POSTNL: "POSTNL",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	SPRING: "SPRING",
	TRUNKRS: "TRUNKRS",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	UPS_STANDARD: "UPS_STANDARD",
	VIA_TIM: "VIA_TIM",
	BOL: "BOL"
}, Es = {
	EARLY_MORNING_DELIVERY: "EARLY_MORNING_DELIVERY",
	EVENING_DELIVERY: "EVENING_DELIVERY",
	EXPRESS_DELIVERY: "EXPRESS_DELIVERY",
	MORNING_DELIVERY: "MORNING_DELIVERY",
	PICKUP_EXPRESS_DELIVERY: "PICKUP_EXPRESS_DELIVERY",
	PICKUP_DELIVERY: "PICKUP_DELIVERY",
	SAME_DAY_DELIVERY: "SAME_DAY_DELIVERY",
	STANDARD_DELIVERY: "STANDARD_DELIVERY"
}, Ds = {
	CANCELED: "CANCELED",
	COMPLETED: "COMPLETED",
	DISCOVERED: "DISCOVERED",
	IMPORT_REQUESTED: "IMPORT_REQUESTED",
	OPEN: "OPEN",
	PROCESSING: "PROCESSING",
	RETURNING: "RETURNING"
}, Os = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
}, ks = {
	PAID: "PAID",
	PENDING: "PENDING",
	UNPAID: "UNPAID"
}, As = {
	OUTBOUND: "OUTBOUND",
	INBOUND: "INBOUND"
}, js = process.env.NODE_ENV === "production" ? {} : Object.freeze({});
process.env.NODE_ENV === "production" || Object.freeze([]);
var Ms = () => {}, Ns = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && (e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), Ps = (e) => e.startsWith("onUpdate:"), Fs = Object.assign, Is = Array.isArray, Ls = (e) => typeof e == "function", Rs = (e) => typeof e == "string", zs = (e) => typeof e == "symbol", Bs = (e) => typeof e == "object" && !!e, Vs, Hs = () => Vs ||= typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
function Us(e) {
	if (Is(e)) {
		let t = {};
		for (let n = 0; n < e.length; n++) {
			let r = e[n], i = Rs(r) ? qs(r) : Us(r);
			if (i) for (let e in i) t[e] = i[e];
		}
		return t;
	}
	if (Rs(e) || Bs(e)) return e;
}
var Ws = /;(?![^(]*\))/g, Gs = /:([^]+)/, Ks = /\/\*[^]*?\*\//g;
function qs(e) {
	let t = {};
	return e.replace(Ks, "").split(Ws).forEach((e) => {
		if (e) {
			let n = e.split(Gs);
			n.length > 1 && (t[n[0].trim()] = n[1].trim());
		}
	}), t;
}
function Js(e) {
	let t = "";
	if (Rs(e)) t = e;
	else if (Is(e)) for (let n = 0; n < e.length; n++) {
		let r = Js(e[n]);
		r && (t += r + " ");
	}
	else if (Bs(e)) for (let n in e) e[n] && (t += n + " ");
	return t.trim();
}
var Ys = !0, Xs = [];
function Zs() {
	Xs.push(Ys), Ys = !1;
}
function Qs() {
	let e = Xs.pop();
	Ys = e === void 0 || e;
}
process.env.NODE_ENV, process.env.NODE_ENV, process.env.NODE_ENV, Array.prototype, new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(zs));
// @__NO_SIDE_EFFECTS__
function $s(e) {
	return /* @__PURE__ */ ec(e) ? /* @__PURE__ */ $s(e.__v_raw) : !!(e && e.__v_isReactive);
}
// @__NO_SIDE_EFFECTS__
function ec(e) {
	return !!(e && e.__v_isReadonly);
}
// @__NO_SIDE_EFFECTS__
function tc(e) {
	return !!(e && e.__v_isShallow);
}
// @__NO_SIDE_EFFECTS__
function nc(e) {
	return e ? !!e.__v_raw : !1;
}
// @__NO_SIDE_EFFECTS__
function rc(e) {
	let t = e && e.__v_raw;
	return t ? /* @__PURE__ */ rc(t) : e;
}
// @__NO_SIDE_EFFECTS__
function ic(e) {
	return e ? e.__v_isRef === !0 : !1;
}
var ac = [];
function oc(e) {
	ac.push(e);
}
function sc() {
	ac.pop();
}
var cc = !1;
function lc(e, ...t) {
	if (cc) return;
	cc = !0, Zs();
	let n = ac.length ? ac[ac.length - 1].component : null, r = n && n.appContext.config.warnHandler, i = uc();
	if (r) gc(r, n, 11, [
		e + t.map((e) => e.toString?.call(e) ?? JSON.stringify(e)).join(""),
		n && n.proxy,
		i.map(({ vnode: e }) => `at <${xl(n, e.type)}>`).join("\n"),
		i
	]);
	else {
		let n = [`[Vue warn]: ${e}`, ...t];
		i.length && n.push("\n", ...dc(i)), console.warn(...n);
	}
	Qs(), cc = !1;
}
function uc() {
	let e = ac[ac.length - 1];
	if (!e) return [];
	let t = [];
	for (; e;) {
		let n = t[0];
		n && n.vnode === e ? n.recurseCount++ : t.push({
			vnode: e,
			recurseCount: 0
		});
		let r = e.component && e.component.parent;
		e = r && r.vnode;
	}
	return t;
}
function dc(e) {
	let t = [];
	return e.forEach((e, n) => {
		t.push(...n === 0 ? [] : ["\n"], ...fc(e));
	}), t;
}
function fc({ vnode: e, recurseCount: t }) {
	let n = t > 0 ? `... (${t} recursive calls)` : "", r = e.component ? e.component.parent == null : !1, i = ` at <${xl(e.component, e.type, r)}`, a = ">" + n;
	return e.props ? [
		i,
		...pc(e.props),
		a
	] : [i + a];
}
function pc(e) {
	let t = [], n = Object.keys(e);
	return n.slice(0, 3).forEach((n) => {
		t.push(...mc(n, e[n]));
	}), n.length > 3 && t.push(" ..."), t;
}
function mc(e, t, n) {
	return Rs(t) ? (t = JSON.stringify(t), n ? t : [`${e}=${t}`]) : typeof t == "number" || typeof t == "boolean" || t == null ? n ? t : [`${e}=${t}`] : /* @__PURE__ */ ic(t) ? (t = mc(e, /* @__PURE__ */ rc(t.value), !0), n ? t : [
		`${e}=Ref<`,
		t,
		">"
	]) : Ls(t) ? [`${e}=fn${t.name ? `<${t.name}>` : ""}`] : (t = /* @__PURE__ */ rc(t), n ? t : [`${e}=`, t]);
}
var hc = {
	sp: "serverPrefetch hook",
	bc: "beforeCreate hook",
	c: "created hook",
	bm: "beforeMount hook",
	m: "mounted hook",
	bu: "beforeUpdate hook",
	u: "updated",
	bum: "beforeUnmount hook",
	um: "unmounted hook",
	a: "activated hook",
	da: "deactivated hook",
	ec: "errorCaptured hook",
	rtc: "renderTracked hook",
	rtg: "renderTriggered hook",
	0: "setup function",
	1: "render function",
	2: "watcher getter",
	3: "watcher callback",
	4: "watcher cleanup function",
	5: "native event handler",
	6: "component event handler",
	7: "vnode hook",
	8: "directive hook",
	9: "transition hook",
	10: "app errorHandler",
	11: "app warnHandler",
	12: "ref function",
	13: "async component loader",
	14: "scheduler flush",
	15: "component update",
	16: "app unmount cleanup function"
};
function gc(e, t, n, r) {
	try {
		return r ? e(...r) : e();
	} catch (e) {
		_c(e, t, n);
	}
}
function _c(e, t, n, r = !0) {
	let i = t ? t.vnode : null, { errorHandler: a, throwUnhandledErrorInProduction: o } = t && t.appContext.config || js;
	if (t) {
		let r = t.parent, i = t.proxy, o = process.env.NODE_ENV === "production" ? `https://vuejs.org/error-reference/#runtime-${n}` : hc[n];
		for (; r;) {
			let t = r.ec;
			if (t) {
				for (let n = 0; n < t.length; n++) if (t[n](e, i, o) === !1) return;
			}
			r = r.parent;
		}
		if (a) {
			Zs(), gc(a, null, 10, [
				e,
				i,
				o
			]), Qs();
			return;
		}
	}
	vc(e, n, i, r, o);
}
function vc(e, t, n, r = !0, i = !1) {
	if (process.env.NODE_ENV !== "production") {
		let i = hc[t];
		if (n && oc(n), lc(`Unhandled error${i ? ` during execution of ${i}` : ""}`), n && sc(), r) throw e;
		console.error(e);
	} else if (i) throw e;
	else console.error(e);
}
var yc = [], bc = -1, xc = [], Sc = null, Cc = 0, wc = /* @__PURE__ */ Promise.resolve(), Tc = null, Ec = 100;
function Dc(e) {
	let t = bc + 1, n = yc.length;
	for (; t < n;) {
		let r = t + n >>> 1, i = yc[r], a = Mc(i);
		a < e || a === e && i.flags & 2 ? t = r + 1 : n = r;
	}
	return t;
}
function Oc(e) {
	if (!(e.flags & 1)) {
		let t = Mc(e), n = yc[yc.length - 1];
		!n || !(e.flags & 2) && t >= Mc(n) ? yc.push(e) : yc.splice(Dc(t), 0, e), e.flags |= 1, kc();
	}
}
function kc() {
	Tc ||= wc.then(Nc);
}
function Ac(e) {
	if (!Is(e)) Sc && e.id === -1 ? Sc.splice(Cc + 1, 0, e) : e.flags & 1 || (xc.push(e), e.flags |= 1);
	else for (let t = 0; t < e.length; t++) xc.push(e[t]);
	kc();
}
function jc(e) {
	if (xc.length) {
		let t = [...new Set(xc)].sort((e, t) => Mc(e) - Mc(t));
		if (xc.length = 0, Sc) {
			for (let e = 0; e < t.length; e++) Sc.push(t[e]);
			return;
		}
		for (Sc = t, process.env.NODE_ENV !== "production" && (e ||= /* @__PURE__ */ new Map()), Cc = 0; Cc < Sc.length; Cc++) {
			let t = Sc[Cc];
			process.env.NODE_ENV !== "production" && Pc(e, t) || (t.flags & 4 && (t.flags &= -2), t.flags & 8 || t(), t.flags &= -2);
		}
		Sc = null, Cc = 0;
	}
}
var Mc = (e) => e.id == null ? e.flags & 2 ? -1 : Infinity : e.id;
function Nc(e) {
	process.env.NODE_ENV !== "production" && (e ||= /* @__PURE__ */ new Map());
	let t = process.env.NODE_ENV === "production" ? Ms : (t) => Pc(e, t);
	try {
		for (bc = 0; bc < yc.length; bc++) {
			let e = yc[bc];
			if (e && !(e.flags & 8)) {
				if (process.env.NODE_ENV !== "production" && t(e)) continue;
				e.flags & 4 && (e.flags &= -2), gc(e, e.i, e.i ? 15 : 14), e.flags & 4 || (e.flags &= -2);
			}
		}
	} finally {
		for (; bc < yc.length; bc++) {
			let e = yc[bc];
			e && (e.flags &= -2);
		}
		bc = -1, yc.length = 0, jc(e), Tc = null, (yc.length || xc.length) && Nc(e);
	}
}
function Pc(e, t) {
	let n = e.get(t) || 0;
	if (n > Ec) {
		let e = t.i, n = e && bl(e.type);
		return _c(`Maximum recursive updates exceeded${n ? ` in component <${n}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10), !0;
	}
	return e.set(t, n + 1), !1;
}
var Fc = /* @__PURE__ */ new Map();
process.env.NODE_ENV !== "production" && (Hs().__VUE_HMR_RUNTIME__ = {
	createRecord: Hc(Lc),
	rerender: Hc(zc),
	reload: Hc(Bc)
});
var Ic = /* @__PURE__ */ new Map();
function Lc(e, t) {
	return !Ic.has(e) && (Ic.set(e, {
		initialDef: Rc(t),
		instances: /* @__PURE__ */ new Set()
	}), !0);
}
function Rc(e) {
	return Sl(e) ? e.__vccOpts : e;
}
function zc(e, t) {
	let n = Ic.get(e);
	n && (n.initialDef.render = t, [...n.instances].forEach((e) => {
		t && (e.render = t, Rc(e.type).render = t), e.renderCache = [], e.job.flags & 8 || e.update();
	}));
}
function Bc(e, t) {
	let n = Ic.get(e);
	if (!n) return;
	t = Rc(t), Vc(n.initialDef, t);
	let r = [...n.instances];
	for (let e = 0; e < r.length; e++) {
		let i = r[e], a = Rc(i.type), o = Fc.get(a);
		o || (a !== n.initialDef && Vc(a, t), Fc.set(a, o = /* @__PURE__ */ new Set())), o.add(i), i.appContext.propsCache.delete(i.type), i.appContext.emitsCache.delete(i.type), i.appContext.optionsCache.delete(i.type), i.ceReload ? (o.add(i), i.ceReload(t.styles), o.delete(i)) : i.parent ? Oc(() => {
			i.job.flags & 8 || (i.parent.update(), o.delete(i));
		}) : i.appContext.reload ? i.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn("[HMR] Root or manually mounted instance modified. Full reload required."), i.root.ce && i !== i.root && i.root.ce._removeChildStyle(a);
	}
	Ac(() => {
		Fc.clear();
	});
}
function Vc(e, t) {
	Fs(e, t);
	for (let n in e) n !== "__file" && !(n in t) && delete e[n];
}
function Hc(e) {
	return (t, n) => {
		try {
			return e(t, n);
		} catch (e) {
			console.error(e), console.warn("[HMR] Something went wrong during Vue component hot-reload. Full reload required.");
		}
	};
}
var Uc = null, Wc = null, Gc = (e) => e.__isTeleport;
function Kc(e) {
	let t = e[0];
	if (e.length > 1) {
		let n = !1;
		for (let r of e) if (r.type !== nl) {
			if (process.env.NODE_ENV !== "production" && n) {
				lc("<transition> can only be used on a single element or component. Use <transition-group> for lists.");
				break;
			}
			if (t = r, n = !0, process.env.NODE_ENV === "production") break;
		}
	}
	return t;
}
function qc(e) {
	if (!Yc(e)) return Gc(e.type) && e.children ? Kc(e.children) : e;
	if (e.component) return e.component.subTree;
	let { shapeFlag: t, children: n } = e;
	if (n) {
		if (t & 16) return n[0];
		if (t & 32 && Ls(n.default)) return n.default();
	}
}
function Jc(e, t) {
	if (e.shapeFlag & 6 && e.component) {
		e.transition = t;
		let n = e.component.subTree;
		Jc(Gc(n.type) && qc(n) || n, t);
	} else e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
Hs().requestIdleCallback, Hs().cancelIdleCallback;
var Yc = (e) => e.type.__isKeepAlive, Xc = /* @__PURE__ */ Symbol.for("v-ndc");
process.env.NODE_ENV;
var Zc = {}, Qc = (e) => Object.getPrototypeOf(e) === Zc, $c = (e) => e.__isSuspense, el = /* @__PURE__ */ Symbol.for("v-fgt"), tl = /* @__PURE__ */ Symbol.for("v-txt"), nl = /* @__PURE__ */ Symbol.for("v-cmt");
function rl(e) {
	return e ? e.__v_isVNode === !0 : !1;
}
var il = (...e) => ul(...e), al = ({ key: e }) => e ?? null, ol = ({ ref: e, ref_key: t, ref_for: n }) => (typeof e == "number" && (e = "" + e), e == null ? null : Rs(e) || /* @__PURE__ */ ic(e) || Ls(e) ? {
	i: Uc,
	r: e,
	k: t,
	f: !!n
} : e);
function sl(e, t = null, n = null, r = 0, i = null, a = e === el ? 0 : 1, o = !1, s = !1) {
	let c = {
		__v_isVNode: !0,
		__v_skip: !0,
		type: e,
		props: t,
		key: t && al(t),
		ref: t && ol(t),
		scopeId: Wc,
		slotScopeIds: null,
		children: n,
		component: null,
		suspense: null,
		ssContent: null,
		ssFallback: null,
		dirs: null,
		transition: null,
		el: null,
		anchor: null,
		target: null,
		targetStart: null,
		targetAnchor: null,
		staticCount: 0,
		shapeFlag: a,
		patchFlag: r,
		dynamicProps: i,
		dynamicChildren: null,
		appContext: null,
		ctx: Uc
	};
	if (s ? (hl(c, n), a & 128 && e.normalize(c)) : n && (c.shapeFlag |= Rs(n) ? 8 : 16), process.env.NODE_ENV !== "production" && c.key !== c.key && lc("VNode created with invalid key (NaN). VNode type:", c.type), process.env.NODE_ENV !== "production" && t && c.shapeFlag & 1) {
		let e = t.innerHTML == null ? t.textContent == null ? null : "textContent" : "innerHTML";
		e && cl(c.children) && lc(`The \`${e}\` prop on <${c.type}> will override its children. Remove either the \`${e}\` prop or the children.`);
	}
	return c;
}
function cl(e) {
	return Rs(e) ? e !== "" : Is(e) ? e.length > 0 : !1;
}
var ll = process.env.NODE_ENV === "production" ? ul : il;
function ul(e, t = null, n = null, r = 0, i = null, a = !1) {
	if ((!e || e === Xc) && (process.env.NODE_ENV !== "production" && !e && lc(`Invalid vnode type when creating vnode: ${e}.`), e = nl), rl(e)) {
		let r = fl(e, t, !0);
		return n && hl(r, n), r.patchFlag = -2, r;
	}
	if (Sl(e) && (e = e.__vccOpts), t) {
		t = dl(t);
		let { class: e, style: n } = t;
		e && !Rs(e) && (t.class = Js(e)), Bs(n) && (/* @__PURE__ */ nc(n) && !Is(n) && (n = Fs({}, n)), t.style = Us(n));
	}
	let o = Rs(e) ? 1 : $c(e) ? 128 : Gc(e) ? 64 : Bs(e) ? 4 : Ls(e) ? 2 : 0;
	return process.env.NODE_ENV !== "production" && o & 4 && /* @__PURE__ */ nc(e) && (e = /* @__PURE__ */ rc(e), lc("Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.", "\nComponent that was made reactive: ", e)), sl(e, t, n, r, i, o, a, !0);
}
function dl(e) {
	return e ? /* @__PURE__ */ nc(e) || Qc(e) ? Fs({}, e) : e : null;
}
function fl(e, t, n = !1, r = !1) {
	let { props: i, ref: a, patchFlag: o, children: s, transition: c } = e, l = t ? gl(i || {}, t) : i, u = {
		__v_isVNode: !0,
		__v_skip: !0,
		type: e.type,
		props: l,
		key: l && al(l),
		ref: t && t.ref ? n && a ? Is(a) ? a.concat(ol(t)) : [a, ol(t)] : ol(t) : a,
		scopeId: e.scopeId,
		slotScopeIds: e.slotScopeIds,
		children: process.env.NODE_ENV !== "production" && o === -1 && Is(s) ? s.map(pl) : s,
		target: e.target,
		targetStart: e.targetStart,
		targetAnchor: e.targetAnchor,
		staticCount: e.staticCount,
		shapeFlag: e.shapeFlag,
		patchFlag: t && e.type !== el ? o === -1 ? 16 : o | 16 : o,
		dynamicProps: e.dynamicProps,
		dynamicChildren: e.dynamicChildren,
		appContext: e.appContext,
		dirs: e.dirs,
		transition: c,
		component: e.component,
		suspense: e.suspense,
		ssContent: e.ssContent && fl(e.ssContent),
		ssFallback: e.ssFallback && fl(e.ssFallback),
		placeholder: e.placeholder,
		el: e.el,
		anchor: e.anchor,
		ctx: e.ctx,
		ce: e.ce
	};
	return c && r && Jc(u, c.clone(u)), u;
}
function pl(e) {
	let t = fl(e);
	return Is(e.children) && (t.children = e.children.map(pl)), t;
}
function ml(e = " ", t = 0) {
	return ll(tl, null, e, t);
}
function hl(e, t) {
	let n = 0, { shapeFlag: r } = e;
	if (t == null) t = null;
	else if (Is(t)) n = 16;
	else if (typeof t == "object") {
		if (r & 65) {
			let n = t.default;
			n && (n._c && (n._d = !1), hl(e, n()), n._c && (n._d = !0));
			return;
		}
		n = 32, !t._ && !Qc(t) && (t._ctx = Uc);
	} else if (Ls(t)) {
		if (r & 65) {
			hl(e, { default: t });
			return;
		}
		t = {
			default: t,
			_ctx: Uc
		}, n = 32;
	} else t = String(t), r & 64 ? (n = 16, t = [ml(t)]) : n = 8;
	e.children = t, e.shapeFlag |= n;
}
function gl(...e) {
	let t = {};
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		for (let e in r) if (e === "class") t.class !== r.class && (t.class = Js([t.class, r.class]));
		else if (e === "style") t.style = Us([t.style, r.style]);
		else if (Ns(e)) {
			let n = t[e], i = r[e];
			i && n !== i && !(Is(n) && n.includes(i)) ? t[e] = n ? [].concat(n, i) : i : i == null && n == null && !Ps(e) && (t[e] = i);
		} else e !== "" && (t[e] = r[e]);
	}
	return t;
}
{
	let e = Hs(), t = (t, n) => {
		let r;
		return (r = e[t]) || (r = e[t] = []), r.push(n), (e) => {
			r.length > 1 ? r.forEach((t) => t(e)) : r[0](e);
		};
	};
	t("__VUE_INSTANCE_SETTERS__", (e) => e), t("__VUE_SSR_SETTERS__", (e) => _l = e);
}
var _l = !1;
process.env.NODE_ENV;
var vl = /(?:^|[-_])\w/g, yl = (e) => e.replace(vl, (e) => e.toUpperCase()).replace(/[-_]/g, "");
function bl(e, t = !0) {
	return Ls(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function xl(e, t, n = !1) {
	let r = bl(t);
	if (!r && t.__file) {
		let e = t.__file.match(/([^/\\]+)\.\w+$/);
		e && (r = e[1]);
	}
	if (!r && e) {
		let n = (e) => {
			for (let n in e) if (e[n] === t) return n;
		};
		r = n(e.components) || e.parent && n(e.parent.type.components) || n(e.appContext.components);
	}
	return r ? yl(r) : n ? "App" : "Anonymous";
}
function Sl(e) {
	return Ls(e) && "__vccOpts" in e;
}
function Cl() {
	if (process.env.NODE_ENV === "production" || typeof window > "u") return;
	let e = { style: "color:#3ba776" }, t = { style: "color:#1677ff" }, n = { style: "color:#f5222d" }, r = { style: "color:#eb2f96" }, i = {
		__vue_custom_formatter: !0,
		header(t) {
			if (!Bs(t)) return null;
			if (t.__isVue) return [
				"div",
				e,
				"VueInstance"
			];
			if (/* @__PURE__ */ ic(t)) {
				Zs();
				let n = t.value;
				return Qs(), [
					"div",
					{},
					[
						"span",
						e,
						u(t)
					],
					"<",
					s(n),
					">"
				];
			}
			return /* @__PURE__ */ $s(t) ? [
				"div",
				{},
				[
					"span",
					e,
					/* @__PURE__ */ tc(t) ? "ShallowReactive" : "Reactive"
				],
				"<",
				s(t),
				`>${/* @__PURE__ */ ec(t) ? " (readonly)" : ""}`
			] : /* @__PURE__ */ ec(t) ? [
				"div",
				{},
				[
					"span",
					e,
					/* @__PURE__ */ tc(t) ? "ShallowReadonly" : "Readonly"
				],
				"<",
				s(t),
				">"
			] : null;
		},
		hasBody(e) {
			return e && e.__isVue;
		},
		body(e) {
			if (e && e.__isVue) return [
				"div",
				{},
				...a(e.$)
			];
		}
	};
	function a(e) {
		let t = [];
		e.type.props && e.props && t.push(o("props", /* @__PURE__ */ rc(e.props))), e.setupState !== js && t.push(o("setup", e.setupState)), e.data !== js && t.push(o("data", /* @__PURE__ */ rc(e.data)));
		let n = c(e, "computed");
		n && t.push(o("computed", n));
		let i = c(e, "inject");
		return i && t.push(o("injected", i)), t.push([
			"div",
			{},
			[
				"span",
				{ style: r.style + ";opacity:0.66" },
				"$ (internal): "
			],
			["object", { object: e }]
		]), t;
	}
	function o(e, t) {
		return t = Fs({}, t), Object.keys(t).length ? [
			"div",
			{ style: "line-height:1.25em;margin-bottom:0.6em" },
			[
				"div",
				{ style: "color:#476582" },
				e
			],
			[
				"div",
				{ style: "padding-left:1.25em" },
				...Object.keys(t).map((e) => [
					"div",
					{},
					[
						"span",
						r,
						e + ": "
					],
					s(t[e], !1)
				])
			]
		] : ["span", {}];
	}
	function s(e, i = !0) {
		return typeof e == "number" ? [
			"span",
			t,
			e
		] : typeof e == "string" ? [
			"span",
			n,
			JSON.stringify(e)
		] : typeof e == "boolean" ? [
			"span",
			r,
			e
		] : Bs(e) ? ["object", { object: i ? /* @__PURE__ */ rc(e) : e }] : [
			"span",
			n,
			String(e)
		];
	}
	function c(e, t) {
		let n = e.type;
		if (Ls(n)) return;
		let r = {};
		for (let i in e.ctx) l(n, i, t) && (r[i] = e.ctx[i]);
		return r;
	}
	function l(e, t, n) {
		let r = e[n];
		if (Is(r) && r.includes(t) || Bs(r) && t in r || e.extends && l(e.extends, t, n) || e.mixins && e.mixins.some((e) => l(e, t, n))) return !0;
	}
	function u(e) {
		return /* @__PURE__ */ tc(e) ? "ShallowRef" : e.effect ? "ComputedRef" : "Ref";
	}
	window.devtoolsFormatters ? window.devtoolsFormatters.push(i) : window.devtoolsFormatters = [i];
}
process.env.NODE_ENV, process.env.NODE_ENV, process.env.NODE_ENV;
function wl() {
	Cl();
}
process.env.NODE_ENV !== "production" && wl();
var Tl = {
	CommercialGoods: "COMMERCIAL_GOODS",
	CommercialSample: "COMMERCIAL_SAMPLE",
	Documents: "DOCUMENTS",
	Gift: "GIFT",
	ReturnedGoods: "RETURNED_GOODS"
}, El = (e) => e.type === "BUSINESS" || "company" in e && typeof e.company == "string" && e.company.length > 0, Dl = (e) => e.type === "PRIVATE" || "name" in e && typeof e.name == "string";
function Ol(e) {
	return e !== void 0 && "barcode" in e;
}
var A = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18,
	Spring: 19,
	ViaTim: 20,
	DhlFreight: 21
}, j = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	Spring: "spring",
	SPRING: "SPRING",
	ViaTim: "viatim",
	VIA_TIM: "VIA_TIM",
	DhlFreight: "dhlfreight",
	DHL_FREIGHT: "DHL_FREIGHT"
};
A.Dhl, A.Instabox, A.PostNl, j.PostNl, A.Bpost, j.Bpost, A.CheapCargo, j.CheapCargo, A.Dpd, j.Dpd, A.Instabox, j.Instabox, A.Dhl, j.Dhl, A.Bol, j.Bol, A.Ups, j.Ups, A.DhlForYou, j.DhlForYou, A.DhlParcelConnect, j.DhlParcelConnect, A.DhlEuroPlus, j.DhlEuroPlus, A.UpsStandard, j.UpsStandard, A.UpsExpressSaver, j.UpsExpressSaver, A.Gls, j.Gls, A.Brt, j.Brt, A.Trunkrs, j.Trunkrs, A.InPost, j.InPost, A.PosteItaliane, j.PosteItaliane, A.Spring, j.Spring, A.ViaTim, j.ViaTim, A.DhlFreight, j.DhlFreight, A.PostNl, j.POSTNL, A.Bpost, j.BPOST, A.CheapCargo, j.CHEAP_CARGO, A.Dpd, j.DPD, A.Instabox, j.INSTABOX, A.Dhl, j.DHL, A.Bol, j.BOL, A.Ups, j.UPS, A.DhlForYou, j.DHL_FOR_YOU, A.DhlParcelConnect, j.DHL_PARCEL_CONNECT, A.DhlEuroPlus, j.DHL_EUROPLUS, A.UpsStandard, j.UPS_STANDARD, A.UpsExpressSaver, j.UPS_EXPRESS_SAVER, A.Gls, j.GLS, A.Brt, j.BRT, A.Trunkrs, j.TRUNKRS, A.InPost, j.INPOST, A.PosteItaliane, j.POSTE_ITALIANE, A.Spring, j.SPRING, A.ViaTim, j.VIA_TIM, A.DhlFreight, j.DHL_FREIGHT, j.POSTNL, A.PostNl, j.BPOST, A.Bpost, j.CHEAP_CARGO, A.CheapCargo, j.DPD, A.Dpd, j.INSTABOX, A.Instabox, j.DHL, A.Dhl, j.BOL, A.Bol, j.UPS, A.Ups, j.DHL_FOR_YOU, A.DhlForYou, j.DHL_PARCEL_CONNECT, A.DhlParcelConnect, j.DHL_EUROPLUS, A.DhlEuroPlus, j.UPS_STANDARD, A.UpsStandard, j.UPS_EXPRESS_SAVER, A.UpsExpressSaver, j.GLS, A.Gls, j.BRT, A.Brt, j.TRUNKRS, A.Trunkrs, j.INPOST, A.InPost, j.POSTE_ITALIANE, A.PosteItaliane, j.SPRING, A.Spring, j.VIA_TIM, A.ViaTim, j.DHL_FREIGHT, A.DhlFreight, j.PostNl, A.PostNl, j.POSTNL, A.PostNl, j.Bpost, A.Bpost, j.BPOST, A.Bpost, j.CheapCargo, A.CheapCargo, j.CHEAP_CARGO, A.CheapCargo, j.Dpd, A.Dpd, j.DPD, A.Dpd, j.Instabox, A.Instabox, j.Dhl, A.Dhl, j.BolCom, A.Bol, j.Bol, A.Bol, j.BOL, A.Bol, j.Ups, A.Ups, j.DhlForYou, A.DhlForYou, j.DHL_FOR_YOU, A.DhlForYou, j.DhlParcelConnect, A.DhlParcelConnect, j.DHL_PARCEL_CONNECT, A.DhlParcelConnect, j.DhlEuroPlus, A.DhlEuroPlus, j.DHL_EUROPLUS, A.DhlEuroPlus, j.UpsStandard, A.UpsStandard, j.UPS_STANDARD, A.UpsStandard, j.UpsExpressSaver, A.UpsExpressSaver, j.UPS_EXPRESS_SAVER, A.UpsExpressSaver, j.Gls, A.Gls, j.GLS, A.Gls, j.Brt, A.Brt, j.BRT, A.Brt, j.Trunkrs, A.Trunkrs, j.TRUNKRS, A.Trunkrs, j.InPost, A.InPost, j.INPOST, A.InPost, j.PosteItaliane, A.PosteItaliane, j.POSTE_ITALIANE, A.PosteItaliane, j.Spring, A.Spring, j.SPRING, A.Spring, j.ViaTim, A.ViaTim, j.VIA_TIM, A.ViaTim, j.DhlFreight, A.DhlFreight, j.DHL_FREIGHT, A.DhlFreight, A.PostNl, A.Bpost, A.CheapCargo, A.Dpd, A.Instabox, A.Dhl, A.Bol, A.Ups, A.DhlForYou, A.DhlParcelConnect, A.DhlEuroPlus, A.UpsStandard, A.UpsExpressSaver, A.Gls, A.Brt, A.Trunkrs, A.InPost, A.PosteItaliane, A.Spring, A.ViaTim, A.DhlFreight;
var M = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
};
M.Austria, M.Belgium, M.Bulgaria, M.Croatia, M.Cyprus, M.CzechRepublic, M.Denmark, M.Estonia, M.Finland, M.France, M.Germany, M.Greece, M.Hungary, M.Ireland, M.Italy, M.Latvia, M.Lithuania, M.Luxembourg, M.Malta, M.Netherlands, M.Poland, M.Portugal, M.Romania, M.Slovakia, M.Slovenia, M.Spain, M.Sweden, Object.values(M), M.Angola, M.AntiguaAndBarbuda, M.Aruba, M.Bahamas, M.Belize, M.Benin, M.Bermuda, M.BonaireSintEustatiusAndSaba, M.Botswana, M.BurkinaFaso, M.Burundi, M.Cameroon, M.CanaryIslands, M.CentralAfricanRepublic, M.Comoros, M.CongoBrazzaville, M.CongoKinshasa, M.CoteDIvoire, M.Curacao, M.Djibouti, M.Dominica, M.DutchAntilles, M.EquatorialGuinea, M.Eritrea, M.Fiji, M.Gabon, M.Gambia, M.Ghana, M.Grenada, M.Guyana, M.HongKong, M.Kiribati, M.KoreaPeoplesDemocraticRepublic, M.Macao, M.Malawi, M.Mali, M.Mauritania, M.Nauru, M.Qatar, M.Rwanda, M.SaintKittsAndNevis, M.SaoTomeAndPrincipe, M.Seychelles, M.SierraLeone, M.SintMaarten, M.Suriname, M.SyrianArabRepublic, M.TimorLeste, M.Togo, M.Tonga, M.Tuvalu, M.Uganda, M.UnitedArabEmirates, M.Vanuatu, M.Yemen, M.Zimbabwe, M.Austria, M.Belgium, M.Bulgaria, M.Croatia, M.CzechRepublic, M.Estonia, M.Finland, M.France, M.Germany, M.Greece, M.Hungary, M.Ireland, M.Italy, M.Latvia, M.Lithuania, M.Luxembourg, M.Malta, M.Netherlands, M.Portugal, M.Romania, M.Slovakia, M.Slovenia, M.Spain, M.UnitedKingdom, M.Denmark, M.Germany, M.Sweden;
var kl = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, Al = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, jl = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
};
kl.EarlyMorning, Al.EarlyMorning, kl.Morning, Al.Morning, kl.Standard, Al.Standard, kl.Evening, Al.Evening, kl.Pickup, Al.Pickup, kl.PickupExpress, Al.PickupExpress, kl.SameDayDelivery, Al.SameDayDelivery, kl.Express, Al.Express, Al.EarlyMorning, kl.EarlyMorning, Al.Morning, kl.Morning, Al.Standard, kl.Standard, Al.Evening, kl.Evening, Al.Pickup, kl.Pickup, Al.PickupExpress, kl.PickupExpress, Al.SameDayDelivery, kl.SameDayDelivery, Al.Express, kl.Express, kl.EarlyMorning, jl.EarlyMorning, kl.Morning, jl.Morning, kl.Standard, jl.Standard, kl.Evening, jl.Evening, kl.Pickup, jl.Pickup, kl.PickupExpress, jl.PickupExpress, kl.SameDayDelivery, jl.SameDayDelivery, kl.Express, jl.Express, jl.EarlyMorning, Al.EarlyMorning, jl.Morning, Al.Morning, jl.Standard, Al.Standard, jl.Evening, Al.Evening, jl.Pickup, Al.Pickup, jl.PickupExpress, Al.PickupExpress, jl.SameDayDelivery, Al.SameDayDelivery, jl.Express, Al.Express, kl.EarlyMorning, kl.Morning, kl.Standard, kl.Evening, kl.Pickup, kl.PickupExpress, kl.SameDayDelivery, kl.Express, { Vasco: 1 }.Vasco, { Vasco: "vasco" }.Vasco;
var Ml = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, Nl = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
};
Nl.Sunday, Ml.Sunday, Nl.Monday, Ml.Monday, Nl.Tuesday, Ml.Tuesday, Nl.Wednesday, Ml.Wednesday, Nl.Thursday, Ml.Thursday, Nl.Friday, Ml.Friday, Nl.Saturday, Ml.Saturday, Ml.Sunday, Nl.Sunday, Ml.Monday, Nl.Monday, Ml.Tuesday, Nl.Tuesday, Ml.Wednesday, Nl.Wednesday, Ml.Thursday, Nl.Thursday, Ml.Friday, Nl.Friday, Ml.Saturday, Nl.Saturday;
var Pl = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
};
Pl.Bytes, Pl.Kilobytes, Pl.Megabytes, Pl.Gigabytes, Pl.Terabytes;
var Fl = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, Il = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
};
Fl.Bol, Il.Bol, Fl.Exact, Il.Exact, Fl.Amazon, Il.Amazon, Fl.Wix, Il.Wix, Fl.ExactDe, Il.ExactDe, Fl.Etsy, Il.Etsy, Il.Bol, Fl.Bol, Il.Exact, Fl.Exact, Il.Amazon, Fl.Amazon, Il.Wix, Fl.Wix, Il.ExactDe, Fl.ExactDe, Il.Etsy, Fl.Etsy;
var Ll = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, Rl = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
};
Ll.Unpaid, Rl.Unpaid, Ll.Due, Rl.Due, Ll.DuePrepayment, Rl.DuePrepayment, Ll.Reminder1, Rl.Reminder1, Ll.Reminder2, Rl.Reminder2, Ll.Dun, Rl.Dun, Ll.Collection, Rl.Collection, Ll.Instalments, Rl.Instalments, Ll.PaymentArrangement, Rl.PaymentArrangement, Ll.Dispute, Rl.Dispute, Ll.LegalProcedure, Rl.LegalProcedure, Ll.Insolvency, Rl.Insolvency, Ll.WriteOff, Rl.WriteOff, Ll.Pending, Rl.Pending, Ll.Cancelled, Rl.Cancelled, Ll.Paid, Rl.Paid, Ll.PaidOnline, Rl.PaidOnline, Ll.PaidAutomatic, Rl.PaidAutomatic, Ll.PaidCredit, Rl.PaidCredit, Ll.PaidZeroItems, Rl.PaidZeroItems, Ll.InvoiceWith0InvoiceItemsPaidZeroBalance, Rl.PaidZeroBalance, Ll.Due, Ll.Reminder1, Ll.Reminder2, Ll.Dun, Ll.Collection, Ll.Instalments, Ll.PaymentArrangement, Ll.Dispute, Ll.Paid, Ll.PaidOnline, Ll.PaidAutomatic, Ll.PaidCredit, Ll.PaidZeroItems;
var zl = {
	Gram: "g",
	Kilogram: "kg"
};
zl.Gram, zl.Kilogram;
var Bl = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
};
Bl.Millimeter, Bl.Centimeter, Bl.Meter;
var Vl = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, Hl = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnRouteHandedToCarrier: 3,
	EnRouteSorting: 4,
	EnRouteDistribution: 5,
	EnRouteCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedLetter: 12,
	InactiveCredited: 13,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnRouteHandedToCarrier: 32,
	InactiveEnRouteSorting: 33,
	InactiveEnRouteDistribution: 34,
	InactiveEnRouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38
};
Hl.PendingConcept, Hl.PendingRegistered, Hl.EnRouteHandedToCarrier, Hl.EnRouteSorting, Hl.EnRouteDistribution, Hl.EnRouteCustoms, Hl.DeliveredReadyForPickup, Hl.DeliveredAtRecipient, Hl.DeliveredPackagePickedUp;
var Ul = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, Wl = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
};
Wl.Light, Ul.Light, Wl.Start, Ul.Start, Wl.Plus, Ul.Plus, Wl.Premium, Ul.Premium, Wl.Max, Ul.Max, Ul.Light, Wl.Light, Ul.Start, Wl.Start, Ul.Plus, Wl.Plus, Ul.Premium, Wl.Premium, Ul.Max, Wl.Max;
var Gl = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, Kl = {
	Start: Ul.Start,
	Plus: Ul.Plus,
	Premium: Ul.Premium,
	Max: Ul.Max
};
Gl.Start, Kl.Start, Gl.Plus, Kl.Plus, Gl.Premium, Kl.Premium, Gl.Max, Kl.Max, Kl.Start, Gl.Start, Kl.Plus, Gl.Plus, Kl.Premium, Gl.Premium, Kl.Max, Gl.Max;
var ql = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, Jl = {
	Start: Ul.Start,
	Plus: Ul.Plus,
	Premium: Ul.Premium,
	Max: Ul.Max
};
ql.Start, Jl.Start, ql.Plus, Jl.Plus, ql.Premium, Jl.Premium, ql.Max, Jl.Max, Jl.Start, ql.Start, Jl.Plus, ql.Plus, Jl.Premium, ql.Premium, Jl.Max, ql.Max;
var Yl = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, Xl = {
	Light: Ul.Light,
	Start: Ul.Start,
	Plus: Ul.Plus,
	Premium: Ul.Premium,
	Max: Ul.Max
};
Yl.Light, Xl.Light, Yl.Start, Xl.Start, Yl.Plus, Xl.Plus, Yl.Premium, Xl.Premium, Yl.Max, Xl.Max, Xl.Light, Yl.Light, Xl.Start, Yl.Start, Xl.Plus, Yl.Plus, Xl.Premium, Yl.Premium, Xl.Max, Yl.Max;
var Zl = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, Ql = {
	Start: Ul.Start,
	Plus: Ul.Plus,
	Premium: Ul.Premium,
	Max: Ul.Max
};
Zl.Start, Ql.Start, Zl.Plus, Ql.Plus, Zl.Premium, Ql.Premium, Zl.Max, Ql.Max, Ql.Start, Zl.Start, Ql.Plus, Zl.Plus, Ql.Premium, Zl.Premium, Ql.Max, Zl.Max;
var $l = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, eu = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, tu = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
};
$l.MyParcel, eu.MyParcel, $l.Flespakket, eu.Flespakket, $l.SendMyParcel, eu.SendMyParcel, $l.MyParcelIt, eu.MyParcelIt, $l.DeliverDutch, eu.DeliverDutch, $l.PostNlPlugin, eu.PostNlPlugin, $l.MyParcel, tu.MyParcelNl, $l.Flespakket, tu.MyParcelNl, $l.SendMyParcel, tu.MyParcelBe, $l.MyParcelIt, tu.MyParcelIt, $l.DeliverDutch, tu.DeliverDutch, $l.PostNlPlugin, tu.PostNlPlugin, tu.MyParcelNl, $l.MyParcel, tu.MyParcelBe, $l.SendMyParcel, tu.MyParcelIt, $l.MyParcelIt, tu.MyParcelNl, Vl.HomeCountry, M.Netherlands, Vl.Eu, Vl.Row, M.Belgium, tu.MyParcelBe, Vl.HomeCountry, M.Belgium, M.Netherlands, Vl.Eu, Vl.Row, tu.MyParcelBe, Vl.HomeCountry, M.Belgium, Vl.Eu, Vl.Row, tu.MyParcelNl, Vl.HomeCountry, M.Netherlands, Vl.Eu, Vl.Row, tu.MyParcelNl, Vl.HomeCountry, M.Netherlands, M.Belgium, M.Luxembourg, A.Bpost, A.PostNl, A.DhlForYou, A.DhlParcelConnect, A.DhlEuroPlus, A.Ups, A.UpsStandard, A.UpsExpressSaver;
var nu = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, ru = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
};
nu.Package, ru.Package, nu.Mailbox, ru.Mailbox, nu.Letter, ru.Letter, nu.DigitalStamp, ru.DigitalStamp, nu.Pallet, ru.Pallet, nu.PackageSmall, ru.PackageSmall, nu.Envelope, ru.Envelope, ru.Package, nu.Package, ru.Mailbox, nu.Mailbox, ru.Letter, nu.Letter, ru.DigitalStamp, nu.DigitalStamp, ru.Pallet, nu.Pallet, ru.PackageSmall, nu.PackageSmall, ru.Envelope, nu.Envelope;
var iu = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
};
nu.Package, iu.PACKAGE, nu.Mailbox, iu.MAILBOX, nu.Letter, iu.UNFRANKED, nu.DigitalStamp, iu.DIGITAL_STAMP, nu.Pallet, iu.PALLET, nu.PackageSmall, iu.SMALL_PACKAGE, nu.Envelope, iu.ENVELOPE, iu.PACKAGE, nu.Package, iu.MAILBOX, nu.Mailbox, iu.UNFRANKED, nu.Letter, iu.DIGITAL_STAMP, nu.DigitalStamp, iu.PALLET, nu.Pallet, iu.SMALL_PACKAGE, nu.PackageSmall, iu.ENVELOPE, nu.Envelope, nu.Package, nu.Mailbox, nu.Letter, nu.DigitalStamp, nu.Pallet, nu.PackageSmall, nu.Envelope;
var au = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
};
au.PendingConcept, au.PendingRegistered, au.EnrouteHandedToCarrier, au.EnrouteSorting, au.EnrouteDistribution, au.DeliveredAtCustoms, au.DeliveredAtRecipient, au.DeliveredPackagePickedUp, au.DeliveredReturnShipmentPackagePickedUp, au.DeliveredAtAgreedLocation, au.PrintedLetter, au.PrintedDigitalStamp, au.InactiveConcept, au.InactiveRegistered, au.InactiveEnrouteHandedToCarrier, au.InactiveEnrouteSorting, au.InactiveEnrouteDistribution, au.InactiveEnrouteCustoms, au.InactiveDeliveredAtRecipient, au.InactiveDeliveredReadyForPickup, au.InactiveDeliveredPackagePickedUp, Es.EVENING_DELIVERY, Es.EARLY_MORNING_DELIVERY, Es.MORNING_DELIVERY, Es.STANDARD_DELIVERY;
var ou = {
	[Al.EarlyMorning]: Es.EARLY_MORNING_DELIVERY,
	[Al.Morning]: Es.MORNING_DELIVERY,
	[Al.Standard]: Es.STANDARD_DELIVERY,
	[Al.Evening]: Es.EVENING_DELIVERY,
	[Al.SameDayDelivery]: Es.SAME_DAY_DELIVERY,
	[Al.Express]: Es.EXPRESS_DELIVERY,
	[Al.Pickup]: Es.PICKUP_DELIVERY,
	[Al.PickupExpress]: Es.PICKUP_EXPRESS_DELIVERY
};
Es.EARLY_MORNING_DELIVERY, Al.EarlyMorning, Es.MORNING_DELIVERY, Al.Morning, Es.STANDARD_DELIVERY, Al.Standard, Es.EVENING_DELIVERY, Al.Evening, Es.SAME_DAY_DELIVERY, Al.SameDayDelivery, Es.EXPRESS_DELIVERY, Al.Express, Es.PICKUP_DELIVERY, Al.Pickup, Es.PICKUP_EXPRESS_DELIVERY, Al.PickupExpress;
var su = (e) => ou[e], cu = [Es.PICKUP_DELIVERY, Es.PICKUP_EXPRESS_DELIVERY], lu = (e) => cu.includes(e), uu = Object.create, du = Object.defineProperty, fu = Object.getOwnPropertyDescriptor, pu = Object.getOwnPropertyNames, mu = Object.getPrototypeOf, hu = Object.prototype.hasOwnProperty, gu = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), _u = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = pu(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !hu.call(e, s) && s !== n && du(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = fu(t, s)) || r.enumerable
	});
	return e;
}, vu = (e, t, n) => (n = e == null ? {} : uu(mu(e)), _u(t || !e || !e.__esModule || !hu.call(e, "default") ? du(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), N = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18,
	Spring: 19,
	ViaTim: 20,
	DhlFreight: 21
}, P = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	Spring: "spring",
	SPRING: "SPRING",
	ViaTim: "viatim",
	VIA_TIM: "VIA_TIM",
	DhlFreight: "dhlfreight",
	DHL_FREIGHT: "DHL_FREIGHT"
};
N.Dhl, N.Instabox, N.PostNl, P.PostNl, N.Bpost, P.Bpost, N.CheapCargo, P.CheapCargo, N.Dpd, P.Dpd, N.Instabox, P.Instabox, N.Dhl, P.Dhl, N.Bol, P.Bol, N.Ups, P.Ups, N.DhlForYou, P.DhlForYou, N.DhlParcelConnect, P.DhlParcelConnect, N.DhlEuroPlus, P.DhlEuroPlus, N.UpsStandard, P.UpsStandard, N.UpsExpressSaver, P.UpsExpressSaver, N.Gls, P.Gls, N.Brt, P.Brt, N.Trunkrs, P.Trunkrs, N.InPost, P.InPost, N.PosteItaliane, P.PosteItaliane, N.Spring, P.Spring, N.ViaTim, P.ViaTim, N.DhlFreight, P.DhlFreight, N.PostNl, P.POSTNL, N.Bpost, P.BPOST, N.CheapCargo, P.CHEAP_CARGO, N.Dpd, P.DPD, N.Instabox, P.INSTABOX, N.Dhl, P.DHL, N.Bol, P.BOL, N.Ups, P.UPS, N.DhlForYou, P.DHL_FOR_YOU, N.DhlParcelConnect, P.DHL_PARCEL_CONNECT, N.DhlEuroPlus, P.DHL_EUROPLUS, N.UpsStandard, P.UPS_STANDARD, N.UpsExpressSaver, P.UPS_EXPRESS_SAVER, N.Gls, P.GLS, N.Brt, P.BRT, N.Trunkrs, P.TRUNKRS, N.InPost, P.INPOST, N.PosteItaliane, P.POSTE_ITALIANE, N.Spring, P.SPRING, N.ViaTim, P.VIA_TIM, N.DhlFreight, P.DHL_FREIGHT, P.POSTNL, N.PostNl, P.BPOST, N.Bpost, P.CHEAP_CARGO, N.CheapCargo, P.DPD, N.Dpd, P.INSTABOX, N.Instabox, P.DHL, N.Dhl, P.BOL, N.Bol, P.UPS, N.Ups, P.DHL_FOR_YOU, N.DhlForYou, P.DHL_PARCEL_CONNECT, N.DhlParcelConnect, P.DHL_EUROPLUS, N.DhlEuroPlus, P.UPS_STANDARD, N.UpsStandard, P.UPS_EXPRESS_SAVER, N.UpsExpressSaver, P.GLS, N.Gls, P.BRT, N.Brt, P.TRUNKRS, N.Trunkrs, P.INPOST, N.InPost, P.POSTE_ITALIANE, N.PosteItaliane, P.SPRING, N.Spring, P.VIA_TIM, N.ViaTim, P.DHL_FREIGHT, N.DhlFreight, P.PostNl, N.PostNl, P.POSTNL, N.PostNl, P.Bpost, N.Bpost, P.BPOST, N.Bpost, P.CheapCargo, N.CheapCargo, P.CHEAP_CARGO, N.CheapCargo, P.Dpd, N.Dpd, P.DPD, N.Dpd, P.Instabox, N.Instabox, P.Dhl, N.Dhl, P.BolCom, N.Bol, P.Bol, N.Bol, P.BOL, N.Bol, P.Ups, N.Ups, P.DhlForYou, N.DhlForYou, P.DHL_FOR_YOU, N.DhlForYou, P.DhlParcelConnect, N.DhlParcelConnect, P.DHL_PARCEL_CONNECT, N.DhlParcelConnect, P.DhlEuroPlus, N.DhlEuroPlus, P.DHL_EUROPLUS, N.DhlEuroPlus, P.UpsStandard, N.UpsStandard, P.UPS_STANDARD, N.UpsStandard, P.UpsExpressSaver, N.UpsExpressSaver, P.UPS_EXPRESS_SAVER, N.UpsExpressSaver, P.Gls, N.Gls, P.GLS, N.Gls, P.Brt, N.Brt, P.BRT, N.Brt, P.Trunkrs, N.Trunkrs, P.TRUNKRS, N.Trunkrs, P.InPost, N.InPost, P.INPOST, N.InPost, P.PosteItaliane, N.PosteItaliane, P.POSTE_ITALIANE, N.PosteItaliane, P.Spring, N.Spring, P.SPRING, N.Spring, P.ViaTim, N.ViaTim, P.VIA_TIM, N.ViaTim, P.DhlFreight, N.DhlFreight, P.DHL_FREIGHT, N.DhlFreight, N.PostNl, N.Bpost, N.CheapCargo, N.Dpd, N.Instabox, N.Dhl, N.Bol, N.Ups, N.DhlForYou, N.DhlParcelConnect, N.DhlEuroPlus, N.UpsStandard, N.UpsExpressSaver, N.Gls, N.Brt, N.Trunkrs, N.InPost, N.PosteItaliane, N.Spring, N.ViaTim, N.DhlFreight;
var F = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
};
F.Austria, F.Belgium, F.Bulgaria, F.Croatia, F.Cyprus, F.CzechRepublic, F.Denmark, F.Estonia, F.Finland, F.France, F.Germany, F.Greece, F.Hungary, F.Ireland, F.Italy, F.Latvia, F.Lithuania, F.Luxembourg, F.Malta, F.Netherlands, F.Poland, F.Portugal, F.Romania, F.Slovakia, F.Slovenia, F.Spain, F.Sweden, Object.values(F), F.Angola, F.AntiguaAndBarbuda, F.Aruba, F.Bahamas, F.Belize, F.Benin, F.Bermuda, F.BonaireSintEustatiusAndSaba, F.Botswana, F.BurkinaFaso, F.Burundi, F.Cameroon, F.CanaryIslands, F.CentralAfricanRepublic, F.Comoros, F.CongoBrazzaville, F.CongoKinshasa, F.CoteDIvoire, F.Curacao, F.Djibouti, F.Dominica, F.DutchAntilles, F.EquatorialGuinea, F.Eritrea, F.Fiji, F.Gabon, F.Gambia, F.Ghana, F.Grenada, F.Guyana, F.HongKong, F.Kiribati, F.KoreaPeoplesDemocraticRepublic, F.Macao, F.Malawi, F.Mali, F.Mauritania, F.Nauru, F.Qatar, F.Rwanda, F.SaintKittsAndNevis, F.SaoTomeAndPrincipe, F.Seychelles, F.SierraLeone, F.SintMaarten, F.Suriname, F.SyrianArabRepublic, F.TimorLeste, F.Togo, F.Tonga, F.Tuvalu, F.Uganda, F.UnitedArabEmirates, F.Vanuatu, F.Yemen, F.Zimbabwe, F.Austria, F.Belgium, F.Bulgaria, F.Croatia, F.CzechRepublic, F.Estonia, F.Finland, F.France, F.Germany, F.Greece, F.Hungary, F.Ireland, F.Italy, F.Latvia, F.Lithuania, F.Luxembourg, F.Malta, F.Netherlands, F.Portugal, F.Romania, F.Slovakia, F.Slovenia, F.Spain, F.UnitedKingdom, F.Denmark, F.Germany, F.Sweden;
var yu = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, bu = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, xu = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
};
yu.EarlyMorning, bu.EarlyMorning, yu.Morning, bu.Morning, yu.Standard, bu.Standard, yu.Evening, bu.Evening, yu.Pickup, bu.Pickup, yu.PickupExpress, bu.PickupExpress, yu.SameDayDelivery, bu.SameDayDelivery, yu.Express, bu.Express, bu.EarlyMorning, yu.EarlyMorning, bu.Morning, yu.Morning, bu.Standard, yu.Standard, bu.Evening, yu.Evening, bu.Pickup, yu.Pickup, bu.PickupExpress, yu.PickupExpress, bu.SameDayDelivery, yu.SameDayDelivery, bu.Express, yu.Express, yu.EarlyMorning, xu.EarlyMorning, yu.Morning, xu.Morning, yu.Standard, xu.Standard, yu.Evening, xu.Evening, yu.Pickup, xu.Pickup, yu.PickupExpress, xu.PickupExpress, yu.SameDayDelivery, xu.SameDayDelivery, yu.Express, xu.Express, xu.EarlyMorning, bu.EarlyMorning, xu.Morning, bu.Morning, xu.Standard, bu.Standard, xu.Evening, bu.Evening, xu.Pickup, bu.Pickup, xu.PickupExpress, bu.PickupExpress, xu.SameDayDelivery, bu.SameDayDelivery, xu.Express, bu.Express, yu.EarlyMorning, yu.Morning, yu.Standard, yu.Evening, yu.Pickup, yu.PickupExpress, yu.SameDayDelivery, yu.Express, { Vasco: 1 }.Vasco, { Vasco: "vasco" }.Vasco;
var Su = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, Cu = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
};
Cu.Sunday, Su.Sunday, Cu.Monday, Su.Monday, Cu.Tuesday, Su.Tuesday, Cu.Wednesday, Su.Wednesday, Cu.Thursday, Su.Thursday, Cu.Friday, Su.Friday, Cu.Saturday, Su.Saturday, Su.Sunday, Cu.Sunday, Su.Monday, Cu.Monday, Su.Tuesday, Cu.Tuesday, Su.Wednesday, Cu.Wednesday, Su.Thursday, Cu.Thursday, Su.Friday, Cu.Friday, Su.Saturday, Cu.Saturday;
var wu = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
};
wu.Bytes, wu.Kilobytes, wu.Megabytes, wu.Gigabytes, wu.Terabytes;
var Tu = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, Eu = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
};
Tu.Bol, Eu.Bol, Tu.Exact, Eu.Exact, Tu.Amazon, Eu.Amazon, Tu.Wix, Eu.Wix, Tu.ExactDe, Eu.ExactDe, Tu.Etsy, Eu.Etsy, Eu.Bol, Tu.Bol, Eu.Exact, Tu.Exact, Eu.Amazon, Tu.Amazon, Eu.Wix, Tu.Wix, Eu.ExactDe, Tu.ExactDe, Eu.Etsy, Tu.Etsy;
var Du = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, Ou = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
};
Du.Unpaid, Ou.Unpaid, Du.Due, Ou.Due, Du.DuePrepayment, Ou.DuePrepayment, Du.Reminder1, Ou.Reminder1, Du.Reminder2, Ou.Reminder2, Du.Dun, Ou.Dun, Du.Collection, Ou.Collection, Du.Instalments, Ou.Instalments, Du.PaymentArrangement, Ou.PaymentArrangement, Du.Dispute, Ou.Dispute, Du.LegalProcedure, Ou.LegalProcedure, Du.Insolvency, Ou.Insolvency, Du.WriteOff, Ou.WriteOff, Du.Pending, Ou.Pending, Du.Cancelled, Ou.Cancelled, Du.Paid, Ou.Paid, Du.PaidOnline, Ou.PaidOnline, Du.PaidAutomatic, Ou.PaidAutomatic, Du.PaidCredit, Ou.PaidCredit, Du.PaidZeroItems, Ou.PaidZeroItems, Du.InvoiceWith0InvoiceItemsPaidZeroBalance, Ou.PaidZeroBalance, Du.Due, Du.Reminder1, Du.Reminder2, Du.Dun, Du.Collection, Du.Instalments, Du.PaymentArrangement, Du.Dispute, Du.Paid, Du.PaidOnline, Du.PaidAutomatic, Du.PaidCredit, Du.PaidZeroItems;
var ku = {
	Gram: "g",
	Kilogram: "kg"
};
ku.Gram, ku.Kilogram;
var Au = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
};
Au.Millimeter, Au.Centimeter, Au.Meter;
var ju = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, Mu = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnRouteHandedToCarrier: 3,
	EnRouteSorting: 4,
	EnRouteDistribution: 5,
	EnRouteCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedLetter: 12,
	InactiveCredited: 13,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnRouteHandedToCarrier: 32,
	InactiveEnRouteSorting: 33,
	InactiveEnRouteDistribution: 34,
	InactiveEnRouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38
};
Mu.PendingConcept, Mu.PendingRegistered, Mu.EnRouteHandedToCarrier, Mu.EnRouteSorting, Mu.EnRouteDistribution, Mu.EnRouteCustoms, Mu.DeliveredReadyForPickup, Mu.DeliveredAtRecipient, Mu.DeliveredPackagePickedUp;
var Nu = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, Pu = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
};
Pu.Light, Nu.Light, Pu.Start, Nu.Start, Pu.Plus, Nu.Plus, Pu.Premium, Nu.Premium, Pu.Max, Nu.Max, Nu.Light, Pu.Light, Nu.Start, Pu.Start, Nu.Plus, Pu.Plus, Nu.Premium, Pu.Premium, Nu.Max, Pu.Max;
var Fu = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, Iu = {
	Start: Nu.Start,
	Plus: Nu.Plus,
	Premium: Nu.Premium,
	Max: Nu.Max
};
Fu.Start, Iu.Start, Fu.Plus, Iu.Plus, Fu.Premium, Iu.Premium, Fu.Max, Iu.Max, Iu.Start, Fu.Start, Iu.Plus, Fu.Plus, Iu.Premium, Fu.Premium, Iu.Max, Fu.Max;
var Lu = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, Ru = {
	Start: Nu.Start,
	Plus: Nu.Plus,
	Premium: Nu.Premium,
	Max: Nu.Max
};
Lu.Start, Ru.Start, Lu.Plus, Ru.Plus, Lu.Premium, Ru.Premium, Lu.Max, Ru.Max, Ru.Start, Lu.Start, Ru.Plus, Lu.Plus, Ru.Premium, Lu.Premium, Ru.Max, Lu.Max;
var zu = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, Bu = {
	Light: Nu.Light,
	Start: Nu.Start,
	Plus: Nu.Plus,
	Premium: Nu.Premium,
	Max: Nu.Max
};
zu.Light, Bu.Light, zu.Start, Bu.Start, zu.Plus, Bu.Plus, zu.Premium, Bu.Premium, zu.Max, Bu.Max, Bu.Light, zu.Light, Bu.Start, zu.Start, Bu.Plus, zu.Plus, Bu.Premium, zu.Premium, Bu.Max, zu.Max;
var Vu = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, Hu = {
	Start: Nu.Start,
	Plus: Nu.Plus,
	Premium: Nu.Premium,
	Max: Nu.Max
};
Vu.Start, Hu.Start, Vu.Plus, Hu.Plus, Vu.Premium, Hu.Premium, Vu.Max, Hu.Max, Hu.Start, Vu.Start, Hu.Plus, Vu.Plus, Hu.Premium, Vu.Premium, Hu.Max, Vu.Max;
var Uu = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, Wu = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, Gu = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
};
Uu.MyParcel, Wu.MyParcel, Uu.Flespakket, Wu.Flespakket, Uu.SendMyParcel, Wu.SendMyParcel, Uu.MyParcelIt, Wu.MyParcelIt, Uu.DeliverDutch, Wu.DeliverDutch, Uu.PostNlPlugin, Wu.PostNlPlugin, Uu.MyParcel, Gu.MyParcelNl, Uu.Flespakket, Gu.MyParcelNl, Uu.SendMyParcel, Gu.MyParcelBe, Uu.MyParcelIt, Gu.MyParcelIt, Uu.DeliverDutch, Gu.DeliverDutch, Uu.PostNlPlugin, Gu.PostNlPlugin, Gu.MyParcelNl, Uu.MyParcel, Gu.MyParcelBe, Uu.SendMyParcel, Gu.MyParcelIt, Uu.MyParcelIt, Gu.MyParcelNl, ju.HomeCountry, F.Netherlands, ju.Eu, ju.Row, F.Belgium, Gu.MyParcelBe, ju.HomeCountry, F.Belgium, F.Netherlands, ju.Eu, ju.Row, Gu.MyParcelBe, ju.HomeCountry, F.Belgium, ju.Eu, ju.Row, Gu.MyParcelNl, ju.HomeCountry, F.Netherlands, ju.Eu, ju.Row, Gu.MyParcelNl, ju.HomeCountry, F.Netherlands, F.Belgium, F.Luxembourg, N.Bpost, N.PostNl, N.DhlForYou, N.DhlParcelConnect, N.DhlEuroPlus, N.Ups, N.UpsStandard, N.UpsExpressSaver;
var Ku = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, qu = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
};
Ku.Package, qu.Package, Ku.Mailbox, qu.Mailbox, Ku.Letter, qu.Letter, Ku.DigitalStamp, qu.DigitalStamp, Ku.Pallet, qu.Pallet, Ku.PackageSmall, qu.PackageSmall, Ku.Envelope, qu.Envelope, qu.Package, Ku.Package, qu.Mailbox, Ku.Mailbox, qu.Letter, Ku.Letter, qu.DigitalStamp, Ku.DigitalStamp, qu.Pallet, Ku.Pallet, qu.PackageSmall, Ku.PackageSmall, qu.Envelope, Ku.Envelope;
var Ju = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
};
Ku.Package, Ju.PACKAGE, Ku.Mailbox, Ju.MAILBOX, Ku.Letter, Ju.UNFRANKED, Ku.DigitalStamp, Ju.DIGITAL_STAMP, Ku.Pallet, Ju.PALLET, Ku.PackageSmall, Ju.SMALL_PACKAGE, Ku.Envelope, Ju.ENVELOPE, Ju.PACKAGE, Ku.Package, Ju.MAILBOX, Ku.Mailbox, Ju.UNFRANKED, Ku.Letter, Ju.DIGITAL_STAMP, Ku.DigitalStamp, Ju.PALLET, Ku.Pallet, Ju.SMALL_PACKAGE, Ku.PackageSmall, Ju.ENVELOPE, Ku.Envelope, Ku.Package, Ku.Mailbox, Ku.Letter, Ku.DigitalStamp, Ku.Pallet, Ku.PackageSmall, Ku.Envelope;
var Yu = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
};
Yu.PendingConcept, Yu.PendingRegistered, Yu.EnrouteHandedToCarrier, Yu.EnrouteSorting, Yu.EnrouteDistribution, Yu.DeliveredAtCustoms, Yu.DeliveredAtRecipient, Yu.DeliveredPackagePickedUp, Yu.DeliveredReturnShipmentPackagePickedUp, Yu.DeliveredAtAgreedLocation, Yu.PrintedLetter, Yu.PrintedDigitalStamp, Yu.InactiveConcept, Yu.InactiveRegistered, Yu.InactiveEnrouteHandedToCarrier, Yu.InactiveEnrouteSorting, Yu.InactiveEnrouteDistribution, Yu.InactiveEnrouteCustoms, Yu.InactiveDeliveredAtRecipient, Yu.InactiveDeliveredReadyForPickup, Yu.InactiveDeliveredPackagePickedUp;
var Xu = {
	MILLIMETER: "mm",
	CENTIMETER: "cm",
	DECIMETER: "dm",
	METER: "m",
	KILOMETER: "km"
}, Zu = {
	GRAM: "g",
	KILOGRAM: "kg"
}, Qu = /* @__PURE__ */ gu(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs = r();
	})(e, (function() {
		var e = 1e3, t = 6e4, n = 36e5, r = "millisecond", i = "second", a = "minute", o = "hour", s = "day", c = "week", l = "month", u = "quarter", d = "year", f = "date", p = "Invalid Date", m = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, h = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, g = {
			name: "en",
			weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
			months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
			ordinal: function(e) {
				var t = [
					"th",
					"st",
					"nd",
					"rd"
				], n = e % 100;
				return "[" + e + (t[(n - 20) % 10] || t[n] || t[0]) + "]";
			}
		}, _ = function(e, t, n) {
			var r = String(e);
			return !r || r.length >= t ? e : "" + Array(t + 1 - r.length).join(n) + e;
		}, v = {
			s: _,
			z: function(e) {
				var t = -e.utcOffset(), n = Math.abs(t), r = Math.floor(n / 60), i = n % 60;
				return (t <= 0 ? "+" : "-") + _(r, 2, "0") + ":" + _(i, 2, "0");
			},
			m: function e(t, n) {
				if (t.date() < n.date()) return -e(n, t);
				var r = 12 * (n.year() - t.year()) + (n.month() - t.month()), i = t.clone().add(r, l), a = n - i < 0, o = t.clone().add(r + (a ? -1 : 1), l);
				return +(-(r + (n - i) / (a ? i - o : o - i)) || 0);
			},
			a: function(e) {
				return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
			},
			p: function(e) {
				return {
					M: l,
					y: d,
					w: c,
					d: s,
					D: f,
					h: o,
					m: a,
					s: i,
					ms: r,
					Q: u
				}[e] || String(e || "").toLowerCase().replace(/s$/, "");
			},
			u: function(e) {
				return e === void 0;
			}
		}, ee = "en", y = {};
		y[ee] = g;
		var te = "$isDayjsObject", ne = function(e) {
			return e instanceof ie || !(!e || !e[te]);
		}, re = function e(t, n, r) {
			var i;
			if (!t) return ee;
			if (typeof t == "string") {
				var a = t.toLowerCase();
				y[a] && (i = a), n && (y[a] = n, i = a);
				var o = t.split("-");
				if (!i && o.length > 1) return e(o[0]);
			} else {
				var s = t.name;
				y[s] = t, i = s;
			}
			return !r && i && (ee = i), i || !r && ee;
		}, b = function(e, t) {
			if (ne(e)) return e.clone();
			var n = typeof t == "object" ? t : {};
			return n.date = e, n.args = arguments, new ie(n);
		}, x = v;
		x.l = re, x.i = ne, x.w = function(e, t) {
			return b(e, {
				locale: t.$L,
				utc: t.$u,
				x: t.$x,
				$offset: t.$offset
			});
		};
		var ie = function() {
			function g(e) {
				this.$L = re(e.locale, null, !0), this.parse(e), this.$x = this.$x || e.x || {}, this[te] = !0;
			}
			var _ = g.prototype;
			return _.parse = function(e) {
				this.$d = function(e) {
					var t = e.date, n = e.utc;
					if (t === null) return /* @__PURE__ */ new Date(NaN);
					if (x.u(t)) return /* @__PURE__ */ new Date();
					if (t instanceof Date) return new Date(t);
					if (typeof t == "string" && !/Z$/i.test(t)) {
						var r = t.match(m);
						if (r) {
							var i = r[2] - 1 || 0, a = (r[7] || "0").substring(0, 3);
							return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a);
						}
					}
					return new Date(t);
				}(e), this.init();
			}, _.init = function() {
				var e = this.$d;
				this.$y = e.getFullYear(), this.$M = e.getMonth(), this.$D = e.getDate(), this.$W = e.getDay(), this.$H = e.getHours(), this.$m = e.getMinutes(), this.$s = e.getSeconds(), this.$ms = e.getMilliseconds();
			}, _.$utils = function() {
				return x;
			}, _.isValid = function() {
				return this.$d.toString() !== p;
			}, _.isSame = function(e, t) {
				var n = b(e);
				return this.startOf(t) <= n && n <= this.endOf(t);
			}, _.isAfter = function(e, t) {
				return b(e) < this.startOf(t);
			}, _.isBefore = function(e, t) {
				return this.endOf(t) < b(e);
			}, _.$g = function(e, t, n) {
				return x.u(e) ? this[t] : this.set(n, e);
			}, _.unix = function() {
				return Math.floor(this.valueOf() / 1e3);
			}, _.valueOf = function() {
				return this.$d.getTime();
			}, _.startOf = function(e, t) {
				var n = this, r = !!x.u(t) || t, u = x.p(e), p = function(e, t) {
					var i = x.w(n.$u ? Date.UTC(n.$y, t, e) : new Date(n.$y, t, e), n);
					return r ? i : i.endOf(s);
				}, m = function(e, t) {
					return x.w(n.toDate()[e].apply(n.toDate("s"), (r ? [
						0,
						0,
						0,
						0
					] : [
						23,
						59,
						59,
						999
					]).slice(t)), n);
				}, h = this.$W, g = this.$M, _ = this.$D, v = "set" + (this.$u ? "UTC" : "");
				switch (u) {
					case d: return r ? p(1, 0) : p(31, 11);
					case l: return r ? p(1, g) : p(0, g + 1);
					case c:
						var ee = this.$locale().weekStart || 0, y = (h < ee ? h + 7 : h) - ee;
						return p(r ? _ - y : _ + (6 - y), g);
					case s:
					case f: return m(v + "Hours", 0);
					case o: return m(v + "Minutes", 1);
					case a: return m(v + "Seconds", 2);
					case i: return m(v + "Milliseconds", 3);
					default: return this.clone();
				}
			}, _.endOf = function(e) {
				return this.startOf(e, !1);
			}, _.$set = function(e, t) {
				var n, c = x.p(e), u = "set" + (this.$u ? "UTC" : ""), p = (n = {}, n[s] = u + "Date", n[f] = u + "Date", n[l] = u + "Month", n[d] = u + "FullYear", n[o] = u + "Hours", n[a] = u + "Minutes", n[i] = u + "Seconds", n[r] = u + "Milliseconds", n)[c], m = c === s ? this.$D + (t - this.$W) : t;
				if (c === l || c === d) {
					var h = this.clone().set(f, 1);
					h.$d[p](m), h.init(), this.$d = h.set(f, Math.min(this.$D, h.daysInMonth())).$d;
				} else p && this.$d[p](m);
				return this.init(), this;
			}, _.set = function(e, t) {
				return this.clone().$set(e, t);
			}, _.get = function(e) {
				return this[x.p(e)]();
			}, _.add = function(r, u) {
				var f, p = this;
				r = Number(r);
				var m = x.p(u), h = function(e) {
					var t = b(p);
					return x.w(t.date(t.date() + Math.round(e * r)), p);
				};
				if (m === l) return this.set(l, this.$M + r);
				if (m === d) return this.set(d, this.$y + r);
				if (m === s) return h(1);
				if (m === c) return h(7);
				var g = (f = {}, f[a] = t, f[o] = n, f[i] = e, f)[m] || 1, _ = this.$d.getTime() + r * g;
				return x.w(_, this);
			}, _.subtract = function(e, t) {
				return this.add(-1 * e, t);
			}, _.format = function(e) {
				var t = this, n = this.$locale();
				if (!this.isValid()) return n.invalidDate || p;
				var r = e || "YYYY-MM-DDTHH:mm:ssZ", i = x.z(this), a = this.$H, o = this.$m, s = this.$M, c = n.weekdays, l = n.months, u = n.meridiem, d = function(e, n, i, a) {
					return e && (e[n] || e(t, r)) || i[n].slice(0, a);
				}, f = function(e) {
					return x.s(a % 12 || 12, e, "0");
				}, m = u || function(e, t, n) {
					var r = e < 12 ? "AM" : "PM";
					return n ? r.toLowerCase() : r;
				};
				return r.replace(h, (function(e, r) {
					return r || function(e) {
						switch (e) {
							case "YY": return String(t.$y).slice(-2);
							case "YYYY": return x.s(t.$y, 4, "0");
							case "M": return s + 1;
							case "MM": return x.s(s + 1, 2, "0");
							case "MMM": return d(n.monthsShort, s, l, 3);
							case "MMMM": return d(l, s);
							case "D": return t.$D;
							case "DD": return x.s(t.$D, 2, "0");
							case "d": return String(t.$W);
							case "dd": return d(n.weekdaysMin, t.$W, c, 2);
							case "ddd": return d(n.weekdaysShort, t.$W, c, 3);
							case "dddd": return c[t.$W];
							case "H": return String(a);
							case "HH": return x.s(a, 2, "0");
							case "h": return f(1);
							case "hh": return f(2);
							case "a": return m(a, o, !0);
							case "A": return m(a, o, !1);
							case "m": return String(o);
							case "mm": return x.s(o, 2, "0");
							case "s": return String(t.$s);
							case "ss": return x.s(t.$s, 2, "0");
							case "SSS": return x.s(t.$ms, 3, "0");
							case "Z": return i;
						}
						return null;
					}(e) || i.replace(":", "");
				}));
			}, _.utcOffset = function() {
				return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
			}, _.diff = function(r, f, p) {
				var m, h = this, g = x.p(f), _ = b(r), v = (_.utcOffset() - this.utcOffset()) * t, ee = this - _, y = function() {
					return x.m(h, _);
				};
				switch (g) {
					case d:
						m = y() / 12;
						break;
					case l:
						m = y();
						break;
					case u:
						m = y() / 3;
						break;
					case c:
						m = (ee - v) / 6048e5;
						break;
					case s:
						m = (ee - v) / 864e5;
						break;
					case o:
						m = ee / n;
						break;
					case a:
						m = ee / t;
						break;
					case i:
						m = ee / e;
						break;
					default: m = ee;
				}
				return p ? m : x.a(m);
			}, _.daysInMonth = function() {
				return this.endOf(l).$D;
			}, _.$locale = function() {
				return y[this.$L];
			}, _.locale = function(e, t) {
				if (!e) return this.$L;
				var n = this.clone(), r = re(e, t, !0);
				return r && (n.$L = r), n;
			}, _.clone = function() {
				return x.w(this.$d, this);
			}, _.toDate = function() {
				return new Date(this.valueOf());
			}, _.toJSON = function() {
				return this.isValid() ? this.toISOString() : null;
			}, _.toISOString = function() {
				return this.$d.toISOString();
			}, _.toString = function() {
				return this.$d.toUTCString();
			}, g;
		}(), ae = ie.prototype;
		return b.prototype = ae, [
			["$ms", r],
			["$s", i],
			["$m", a],
			["$H", o],
			["$W", s],
			["$M", l],
			["$y", d],
			["$D", f]
		].forEach((function(e) {
			ae[e[1]] = function(t) {
				return this.$g(t, e[0], e[1]);
			};
		})), b.extend = function(e, t) {
			return e.$i ||= (e(t, ie, b), !0), b;
		}, b.locale = re, b.isDayjs = ne, b.unix = function(e) {
			return b(1e3 * e);
		}, b.en = y[ee], b.Ls = y, b.p = {}, b;
	}));
})), $u = /* @__PURE__ */ gu(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(Qu()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_nl = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "nl",
			weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
			weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
			weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
			months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
			monthsShort: "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
			ordinal: function(e) {
				return "[" + e + (e === 1 || e === 8 || e >= 20 ? "ste" : "de") + "]";
			},
			weekStart: 1,
			yearStart: 4,
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD-MM-YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "over %s",
				past: "%s geleden",
				s: "een paar seconden",
				m: "een minuut",
				mm: "%d minuten",
				h: "een uur",
				hh: "%d uur",
				d: "een dag",
				dd: "%d dagen",
				M: "een maand",
				MM: "%d maanden",
				y: "een jaar",
				yy: "%d jaar"
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), ed = /* @__PURE__ */ gu(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(Qu()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_it = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "it",
			weekdays: "domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"),
			weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
			weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
			months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),
			weekStart: 1,
			monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD/MM/YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "tra %s",
				past: "%s fa",
				s: "qualche secondo",
				m: "un minuto",
				mm: "%d minuti",
				h: "un' ora",
				hh: "%d ore",
				d: "un giorno",
				dd: "%d giorni",
				M: "un mese",
				MM: "%d mesi",
				y: "un anno",
				yy: "%d anni"
			},
			ordinal: function(e) {
				return e + "º";
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), td = /* @__PURE__ */ gu(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(Qu()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_fr = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "fr",
			weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
			weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
			weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
			months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
			monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
			weekStart: 1,
			yearStart: 4,
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD/MM/YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "dans %s",
				past: "il y a %s",
				s: "quelques secondes",
				m: "une minute",
				mm: "%d minutes",
				h: "une heure",
				hh: "%d heures",
				d: "un jour",
				dd: "%d jours",
				M: "un mois",
				MM: "%d mois",
				y: "un an",
				yy: "%d ans"
			},
			ordinal: function(e) {
				return "" + e + (e === 1 ? "er" : "");
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), nd = /* @__PURE__ */ gu(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_calendar = r();
	})(e, (function() {
		return function(e, t, n) {
			var r = "h:mm A", i = {
				lastDay: "[Yesterday at] " + r,
				sameDay: "[Today at] " + r,
				nextDay: "[Tomorrow at] " + r,
				nextWeek: "dddd [at] " + r,
				lastWeek: "[Last] dddd [at] " + r,
				sameElse: "MM/DD/YYYY"
			};
			t.prototype.calendar = function(e, t) {
				var r = t || this.$locale().calendar || i, a = n(e || void 0).startOf("d"), o = this.diff(a, "d", !0), s = "sameElse", c = o < -6 ? s : o < -1 ? "lastWeek" : o < 0 ? "lastDay" : o < 1 ? "sameDay" : o < 2 ? "nextDay" : o < 7 ? "nextWeek" : s, l = r[c] || i[c];
				return typeof l == "function" ? l.call(this, n()) : this.format(l);
			};
		};
	}));
})), rd = /* @__PURE__ */ gu(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_customParseFormat = r();
	})(e, (function() {
		var e = {
			LTS: "h:mm:ss A",
			LT: "h:mm A",
			L: "MM/DD/YYYY",
			LL: "MMMM D, YYYY",
			LLL: "MMMM D, YYYY h:mm A",
			LLLL: "dddd, MMMM D, YYYY h:mm A"
		}, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d\d/, r = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, a = {}, o = function(e) {
			return (e = +e) + (e > 68 ? 1900 : 2e3);
		}, s = function(e) {
			return function(t) {
				this[e] = +t;
			};
		}, c = [/[+-]\d\d:?(\d\d)?|Z/, function(e) {
			(this.zone ||= {}).offset = function(e) {
				if (!e || e === "Z") return 0;
				var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
				return n === 0 ? 0 : t[0] === "+" ? -n : n;
			}(e);
		}], l = function(e) {
			var t = a[e];
			return t && (t.indexOf ? t : t.s.concat(t.f));
		}, u = function(e, t) {
			var n, r = a.meridiem;
			if (r) {
				for (var i = 1; i <= 24; i += 1) if (e.indexOf(r(i, 0, t)) > -1) {
					n = i > 12;
					break;
				}
			} else n = e === (t ? "pm" : "PM");
			return n;
		}, d = {
			A: [i, function(e) {
				this.afternoon = u(e, !1);
			}],
			a: [i, function(e) {
				this.afternoon = u(e, !0);
			}],
			S: [/\d/, function(e) {
				this.milliseconds = 100 * e;
			}],
			SS: [n, function(e) {
				this.milliseconds = 10 * e;
			}],
			SSS: [/\d{3}/, function(e) {
				this.milliseconds = +e;
			}],
			s: [r, s("seconds")],
			ss: [r, s("seconds")],
			m: [r, s("minutes")],
			mm: [r, s("minutes")],
			H: [r, s("hours")],
			h: [r, s("hours")],
			HH: [r, s("hours")],
			hh: [r, s("hours")],
			D: [r, s("day")],
			DD: [n, s("day")],
			Do: [i, function(e) {
				var t = a.ordinal, n = e.match(/\d+/);
				if (this.day = n[0], t) for (var r = 1; r <= 31; r += 1) t(r).replace(/\[|\]/g, "") === e && (this.day = r);
			}],
			M: [r, s("month")],
			MM: [n, s("month")],
			MMM: [i, function(e) {
				var t = l("months"), n = (l("monthsShort") || t.map((function(e) {
					return e.slice(0, 3);
				}))).indexOf(e) + 1;
				if (n < 1) throw Error();
				this.month = n % 12 || n;
			}],
			MMMM: [i, function(e) {
				var t = l("months").indexOf(e) + 1;
				if (t < 1) throw Error();
				this.month = t % 12 || t;
			}],
			Y: [/[+-]?\d+/, s("year")],
			YY: [n, function(e) {
				this.year = o(e);
			}],
			YYYY: [/\d{4}/, s("year")],
			Z: c,
			ZZ: c
		};
		function f(n) {
			for (var r = n, i = a && a.formats, o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (function(t, n, r) {
				var a = r && r.toUpperCase();
				return n || i[r] || e[r] || i[a].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (function(e, t, n) {
					return t || n.slice(1);
				}));
			}))).match(t), s = o.length, c = 0; c < s; c += 1) {
				var l = o[c], u = d[l], f = u && u[0], p = u && u[1];
				o[c] = p ? {
					regex: f,
					parser: p
				} : l.replace(/^\[|\]$/g, "");
			}
			return function(e) {
				for (var t = {}, n = 0, r = 0; n < s; n += 1) {
					var i = o[n];
					if (typeof i == "string") r += i.length;
					else {
						var a = i.regex, c = i.parser, l = e.slice(r), u = a.exec(l)[0];
						c.call(t, u), e = e.replace(u, "");
					}
				}
				return function(e) {
					var t = e.afternoon;
					if (t !== void 0) {
						var n = e.hours;
						t ? n < 12 && (e.hours += 12) : n === 12 && (e.hours = 0), delete e.afternoon;
					}
				}(t), t;
			};
		}
		return function(e, t, n) {
			n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (o = e.parseTwoDigitYear);
			var r = t.prototype, i = r.parse;
			r.parse = function(e) {
				var t = e.date, r = e.utc, o = e.args;
				this.$u = r;
				var s = o[1];
				if (typeof s == "string") {
					var c = !0 === o[2], l = !0 === o[3], u = c || l, d = o[2];
					l && (d = o[2]), a = this.$locale(), !c && d && (a = n.Ls[d]), this.$d = function(e, t, n) {
						try {
							if (["x", "X"].indexOf(t) > -1) return /* @__PURE__ */ new Date((t === "X" ? 1e3 : 1) * e);
							var r = f(t)(e), i = r.year, a = r.month, o = r.day, s = r.hours, c = r.minutes, l = r.seconds, u = r.milliseconds, d = r.zone, p = /* @__PURE__ */ new Date(), m = o || (i || a ? 1 : p.getDate()), h = i || p.getFullYear(), g = 0;
							i && !a || (g = a > 0 ? a - 1 : p.getMonth());
							var _ = s || 0, v = c || 0, ee = l || 0, y = u || 0;
							return d ? new Date(Date.UTC(h, g, m, _, v, ee, y + 60 * d.offset * 1e3)) : n ? new Date(Date.UTC(h, g, m, _, v, ee, y)) : new Date(h, g, m, _, v, ee, y);
						} catch {
							return /* @__PURE__ */ new Date("");
						}
					}(t, s, r), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(s) && (this.$d = /* @__PURE__ */ new Date("")), a = {};
				} else if (s instanceof Array) for (var p = s.length, m = 1; m <= p; m += 1) {
					o[1] = s[m - 1];
					var h = n.apply(this, o);
					if (h.isValid()) {
						this.$d = h.$d, this.$L = h.$L, this.init();
						break;
					}
					m === p && (this.$d = /* @__PURE__ */ new Date(""));
				}
				else i.call(this, e);
			};
		};
	}));
})), id = /* @__PURE__ */ gu(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isBetween = r();
	})(e, (function() {
		return function(e, t, n) {
			t.prototype.isBetween = function(e, t, r, i) {
				var a = n(e), o = n(t), s = (i ||= "()")[0] === "(", c = i[1] === ")";
				return (s ? this.isAfter(a, r) : !this.isBefore(a, r)) && (c ? this.isBefore(o, r) : !this.isAfter(o, r)) || (s ? this.isBefore(a, r) : !this.isAfter(a, r)) && (c ? this.isAfter(o, r) : !this.isBefore(o, r));
			};
		};
	}));
})), ad = /* @__PURE__ */ gu(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isLeapYear = r();
	})(e, (function() {
		return function(e, t) {
			t.prototype.isLeapYear = function() {
				return this.$y % 4 == 0 && this.$y % 100 != 0 || this.$y % 400 == 0;
			};
		};
	}));
})), od = /* @__PURE__ */ gu(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isToday = r();
	})(e, (function() {
		return function(e, t, n) {
			t.prototype.isToday = function() {
				var e = "YYYY-MM-DD", t = n();
				return this.format(e) === t.format(e);
			};
		};
	}));
})), sd = /* @__PURE__ */ gu(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isYesterday = r();
	})(e, (function() {
		return function(e, t, n) {
			t.prototype.isYesterday = function() {
				var e = "YYYY-MM-DD", t = n().subtract(1, "day");
				return this.format(e) === t.format(e);
			};
		};
	}));
})), cd = /* @__PURE__ */ gu(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_timezone = r();
	})(e, (function() {
		var e = {
			year: 0,
			month: 1,
			day: 2,
			hour: 3,
			minute: 4,
			second: 5
		}, t = {};
		return function(n, r, i) {
			var a, o = function(e, n, r) {
				r === void 0 && (r = {});
				var i = new Date(e);
				return function(e, n) {
					n === void 0 && (n = {});
					var r = n.timeZoneName || "short", i = e + "|" + r, a = t[i];
					return a || (a = new Intl.DateTimeFormat("en-US", {
						hour12: !1,
						timeZone: e,
						year: "numeric",
						month: "2-digit",
						day: "2-digit",
						hour: "2-digit",
						minute: "2-digit",
						second: "2-digit",
						timeZoneName: r
					}), t[i] = a), a;
				}(n, r).formatToParts(i);
			}, s = function(t, n) {
				for (var r = o(t, n), a = [], s = 0; s < r.length; s += 1) {
					var c = r[s], l = c.type, u = c.value, d = e[l];
					d >= 0 && (a[d] = parseInt(u, 10));
				}
				var f = a[3], p = f === 24 ? 0 : f, m = a[0] + "-" + a[1] + "-" + a[2] + " " + p + ":" + a[4] + ":" + a[5] + ":000", h = +t;
				return (i.utc(m).valueOf() - (h -= h % 1e3)) / 6e4;
			}, c = r.prototype;
			c.tz = function(e, t) {
				e === void 0 && (e = a);
				var n = this.utcOffset(), r = this.toDate(), o = r.toLocaleString("en-US", { timeZone: e }), s = Math.round((r - new Date(o)) / 1e3 / 60), c = i(o, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(r.getTimezoneOffset() / 15) - s, !0);
				if (t) {
					var l = c.utcOffset();
					c = c.add(n - l, "minute");
				}
				return c.$x.$timezone = e, c;
			}, c.offsetName = function(e) {
				var t = this.$x.$timezone || i.tz.guess(), n = o(this.valueOf(), t, { timeZoneName: e }).find((function(e) {
					return e.type.toLowerCase() === "timezonename";
				}));
				return n && n.value;
			};
			var l = c.startOf;
			c.startOf = function(e, t) {
				if (!this.$x || !this.$x.$timezone) return l.call(this, e, t);
				var n = i(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
				return l.call(n, e, t).tz(this.$x.$timezone, !0);
			}, i.tz = function(e, t, n) {
				var r = n && t, o = n || t || a, c = s(+i(), o);
				if (typeof e != "string") return i(e).tz(o);
				var l = function(e, t, n) {
					var r = e - 60 * t * 1e3, i = s(r, n);
					if (t === i) return [r, t];
					var a = s(r -= 60 * (i - t) * 1e3, n);
					return i === a ? [r, i] : [e - 60 * Math.min(i, a) * 1e3, Math.max(i, a)];
				}(i.utc(e, r).valueOf(), c, o), u = l[0], d = l[1], f = i(u).utcOffset(d);
				return f.$x.$timezone = o, f;
			}, i.tz.guess = function() {
				return Intl.DateTimeFormat().resolvedOptions().timeZone;
			}, i.tz.setDefault = function(e) {
				a = e;
			};
		};
	}));
})), ld = /* @__PURE__ */ gu(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_utc = r();
	})(e, (function() {
		var e = "minute", t = /[+-]\d\d(?::?\d\d)?/g, n = /([+-]|\d\d)/g;
		return function(r, i, a) {
			var o = i.prototype;
			a.utc = function(e) {
				return new i({
					date: e,
					utc: !0,
					args: arguments
				});
			}, o.utc = function(t) {
				var n = a(this.toDate(), {
					locale: this.$L,
					utc: !0
				});
				return t ? n.add(this.utcOffset(), e) : n;
			}, o.local = function() {
				return a(this.toDate(), {
					locale: this.$L,
					utc: !1
				});
			};
			var s = o.parse;
			o.parse = function(e) {
				e.utc && (this.$u = !0), this.$utils().u(e.$offset) || (this.$offset = e.$offset), s.call(this, e);
			};
			var c = o.init;
			o.init = function() {
				if (this.$u) {
					var e = this.$d;
					this.$y = e.getUTCFullYear(), this.$M = e.getUTCMonth(), this.$D = e.getUTCDate(), this.$W = e.getUTCDay(), this.$H = e.getUTCHours(), this.$m = e.getUTCMinutes(), this.$s = e.getUTCSeconds(), this.$ms = e.getUTCMilliseconds();
				} else c.call(this);
			};
			var l = o.utcOffset;
			o.utcOffset = function(r, i) {
				var a = this.$utils().u;
				if (a(r)) return this.$u ? 0 : a(this.$offset) ? l.call(this) : this.$offset;
				if (typeof r == "string" && (r = function(e) {
					e === void 0 && (e = "");
					var r = e.match(t);
					if (!r) return null;
					var i = ("" + r[0]).match(n) || [
						"-",
						0,
						0
					], a = i[0], o = 60 * i[1] + +i[2];
					return o === 0 ? 0 : a === "+" ? o : -o;
				}(r), r === null)) return this;
				var o = Math.abs(r) <= 16 ? 60 * r : r, s = this;
				if (i) return s.$offset = o, s.$u = r === 0, s;
				if (r !== 0) {
					var c = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
					(s = this.local().add(o + c, e)).$offset = o, s.$x.$localOffset = c;
				} else s = this.utc();
				return s;
			};
			var u = o.format;
			o.format = function(e) {
				var t = e || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
				return u.call(this, t);
			}, o.valueOf = function() {
				var e = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
				return this.$d.valueOf() - 6e4 * e;
			}, o.isUTC = function() {
				return !!this.$u;
			}, o.toISOString = function() {
				return this.toDate().toISOString();
			}, o.toString = function() {
				return this.toDate().toUTCString();
			};
			var d = o.toDate;
			o.toDate = function(e) {
				return e === "s" && this.$offset ? a(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : d.call(this);
			};
			var f = o.diff;
			o.diff = function(e, t, n) {
				if (e && this.$u === e.$u) return f.call(this, e, t, n);
				var r = this.local(), i = a(e).local();
				return f.call(r, i, t, n);
			};
		};
	}));
}));
$u(), ed(), td();
var ud = /* @__PURE__ */ vu(Qu(), 1), dd = /* @__PURE__ */ vu(nd(), 1), fd = /* @__PURE__ */ vu(rd(), 1), pd = /* @__PURE__ */ vu(id(), 1), md = /* @__PURE__ */ vu(ad(), 1), hd = /* @__PURE__ */ vu(od(), 1), gd = /* @__PURE__ */ vu(sd(), 1), _d = /* @__PURE__ */ vu(cd(), 1), vd = /* @__PURE__ */ vu(ld(), 1);
ud.default.extend(fd.default), ud.default.extend(md.default), ud.default.extend(dd.default), ud.default.extend(vd.default), ud.default.extend(pd.default), ud.default.extend(hd.default), ud.default.extend(gd.default), ud.default.extend(_d.default), ud.default.locale("nl"), ud.default.tz.setDefault("Europe/Amsterdam"), ud.default, Xu.MILLIMETER, Xu.CENTIMETER, Xu.DECIMETER, Xu.METER, Xu.KILOMETER, Zu.GRAM, Zu.KILOGRAM, Xu.MILLIMETER, Xu.CENTIMETER, Xu.DECIMETER, Xu.METER, Xu.KILOMETER, Zu.GRAM, Zu.KILOGRAM, Object.values(Ds).filter((e) => e !== Ds.DISCOVERED);
var yd = (e) => e === Ds.DISCOVERED || e === Ds.IMPORT_REQUESTED;
Object.values(Ds).filter((e) => !yd(e));
var bd = (e) => e === Ds.CANCELED, xd = (e) => e === Ds.IMPORT_REQUESTED, Sd = (e) => e === Os.ENVELOPE, Cd = (e) => e === Os.PACKAGE, wd = (e) => e === Os.SMALL_PACKAGE, Td = (e) => e === Os.MAILBOX, Ed = (e) => e === Os.DIGITAL_STAMP, Dd = (e) => e === Os.UNFRANKED, Od = (e) => e === Os.PALLET, kd = (e) => e === k.POSTNL, Ad = (e, t) => kd(e) && t !== null && t === mt.Cd, jd = (e, t) => kd(e) && t !== null && t !== mt.Cd, Md = (e) => e === k.BPOST, Nd = (e) => e === k.CHEAP_CARGO, Pd = (e) => e === k.DPD, Fd = (e) => e === k.DHL_PARCEL_CONNECT, Id = (e) => e === k.DHL_FOR_YOU, Ld = (e) => e === k.DHL_EUROPLUS, Rd = (e) => Id(e) || Ld(e) || Fd(e), zd = (e, t) => Rd(e) && wd(t), Bd = (e) => e === k.BOL, Vd = (e) => e === "UPS", Hd = (e) => e === k.UPS_STANDARD, Ud = (e) => e === k.UPS_EXPRESS_SAVER, Wd = (e) => Hd(e) || Ud(e), Gd = (e) => e === k.GLS, Kd = (e) => e === k.BRT, qd = (e) => e === k.TRUNKRS, Jd = (e) => e === k.INPOST, Yd = (e) => e === k.POSTE_ITALIANE, Xd = {
	[C.PostNl]: k.POSTNL,
	[C.Bpost]: k.BPOST,
	[C.CheapCargo]: k.CHEAP_CARGO,
	[C.Dpd]: k.DPD,
	[C.Bol]: k.BOL,
	[C.DhlForYou]: k.DHL_FOR_YOU,
	[C.DhlParcelConnect]: k.DHL_PARCEL_CONNECT,
	[C.DhlEuroPlus]: k.DHL_EUROPLUS,
	[C.UpsStandard]: k.UPS_STANDARD,
	[C.UpsExpressSaver]: k.UPS_EXPRESS_SAVER,
	[C.Gls]: k.GLS,
	[C.Brt]: k.BRT,
	[C.Trunkrs]: k.TRUNKRS,
	[C.InPost]: k.INPOST,
	[C.PosteItaliane]: k.POSTE_ITALIANE,
	[C.ViaTim]: k.VIA_TIM,
	[C.DhlFreight]: k.DHL_FREIGHT
};
C.Ups, C.Dhl, C.Instabox;
var Zd = (e) => Xd[e], Qd = {
	[k.POSTNL]: C.PostNl,
	[k.BPOST]: C.Bpost,
	[k.CHEAP_CARGO]: C.CheapCargo,
	[k.DPD]: C.Dpd,
	[k.BOL]: C.Bol,
	[k.DHL_FOR_YOU]: C.DhlForYou,
	[k.DHL_PARCEL_CONNECT]: C.DhlParcelConnect,
	[k.DHL_EUROPLUS]: C.DhlEuroPlus,
	[k.UPS_STANDARD]: C.UpsStandard,
	[k.UPS_EXPRESS_SAVER]: C.UpsExpressSaver,
	[k.GLS]: C.Gls,
	[k.BRT]: C.Brt,
	[k.TRUNKRS]: C.Trunkrs,
	[k.INPOST]: C.InPost,
	[k.POSTE_ITALIANE]: C.PosteItaliane,
	[k.VIA_TIM]: C.ViaTim,
	[k.DHL_FREIGHT]: C.DhlFreight
}, $d = (e) => Qd[e];
//#endregion
//#region ../../node_modules/.pnpm/es-toolkit@1.51.0/node_modules/es-toolkit/dist/string/capitalize.mjs
function ef(e) {
	return e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
}
//#endregion
//#region ../../node_modules/.pnpm/es-toolkit@1.51.0/node_modules/es-toolkit/dist/string/words.mjs
var tf = /\p{Lu}?\p{Ll}+|[0-9]+|\p{Lu}+(?!\p{Ll})|\p{Emoji_Presentation}|\p{Extended_Pictographic}|\p{L}+/gu;
function nf(e) {
	return Array.from(e.match(tf) ?? []);
}
//#endregion
//#region ../../node_modules/.pnpm/es-toolkit@1.51.0/node_modules/es-toolkit/dist/string/camelCase.mjs
function rf(e) {
	let t = nf(e);
	if (t.length === 0) return "";
	let [n, ...r] = t;
	return `${n.toLowerCase()}${r.map((e) => ef(e)).join("")}`;
}
//#endregion
//#region src/composables/useDeliveryOptions/useDeliveryOptions.ts
var af = () => ({
	fetchDeliveryOptions: (e) => {
		let { sdk: t } = Le();
		return t.getDeliveryOptions({ parameters: {
			include: "price",
			monday_delivery: 1,
			dropoff_days: "0;1;2;3;4;5;6",
			...e
		} });
	},
	postponedDeliveryDateMessage: (e, t) => {
		let n;
		if (!(!kd(e) && !Id(e)) && (t?.deliveryType && ci(t.deliveryType) ? n = "morning" : t?.deliveryType && li(t.deliveryType) && (n = "evening"), n)) return `shipping.adjustedDelivery.notification.${rf(e)}.${n}Delivery`;
	},
	postponedNormalMessage: (e) => {
		let t = e?.date;
		if (!t) return;
		let n = si(t), r = si().add(1, "days");
		return n.isAfter(r, "day") ? "shipping.adjustedDelivery.notification.normal.postponed" : void 0;
	}
});
//#endregion
//#region src/composables/usePickupLocations/usePickupLocations.ts
function of() {
	return { fetchPickupLocations: (e) => {
		let { sdk: t } = Le();
		return t.getPickupLocations({ parameters: e });
	} };
}
//#endregion
//#region src/composables/useAdjustedDelivery/useAdjustedDelivery.ts
function sf() {
	let { fetchDeliveryOptions: e } = af(), { fetchPickupLocations: t } = of(), n = (e) => Ze.includes(e), r = (e) => e === T.Belgium || e === T.Netherlands, i = (e, t) => r(e) ? {
		street: e === T.Belgium && kd(t) || Fd(t),
		city: Md(t) || Pd(t) || Fd(t),
		postalCode: !Fd(t)
	} : {
		street: !0,
		city: !0,
		postalCode: !0
	};
	return {
		getVisibleFields: i,
		getRequiredFields: (e, t) => {
			if (!r(e)) return {
				postalCode: !1,
				houseNumber: !1,
				street: !1,
				city: !1
			};
			let { street: n, city: a, postalCode: o } = i(e, t);
			return {
				postalCode: o,
				houseNumber: !0,
				street: n,
				city: a
			};
		},
		isPudo: n,
		getAdjustedDeliveryData: (n, r) => {
			let a = { ...n }, o = qe(a.carrier), s = i(a.cc, o);
			s.city || delete a.city, s.street || delete a.street, s.postalCode || delete a.postal_code;
			let c = Object.fromEntries(Object.entries(a).filter(([e, t]) => t != null));
			return r === "delivery" ? e(c) : t(c);
		}
	};
}
//#endregion
//#region src/components/AdjustedDeliveryOption/AdjustedDeliveryOption.vue?vue&type=script&setup=true&lang.ts
var cf = { key: 0 }, lf = { key: 1 }, uf = "D MMMM YYYY", df = /* @__PURE__ */ l({
	__name: "AdjustedDeliveryOption",
	props: {
		title: {},
		countryCode: {},
		option: {}
	},
	setup(e) {
		let n = e, { t: a, locale: o } = Fe(), { isPudo: l } = sf(), u = (e, t) => si(e).locale(o.value).format(t), d = t(() => n.option.date ? u(n.option.date, uf) : ""), p = t(() => !l(n.countryCode) && di(n.option.deliveryType));
		return (t, n) => (f(), i("div", null, [
			c(y(ye), {
				class: "text-black",
				level: "4"
			}, {
				default: x(() => [s(v(y(a)(e.title)) + ": ", 1)]),
				_: 1
			}),
			e.option.location?.name ? (f(), i("p", cf, v(e.option.location.name), 1)) : r("", !0),
			p.value && d.value ? (f(), i("p", lf, v(d.value) + " - " + v(y(a)(`shipping.deliveryType.${y(it)(e.option.deliveryType)}`)), 1)) : r("", !0)
		]));
	}
}), ff = {
	Normal: "0 0 16 16",
	Medium: "0 0 24 24",
	MediumLarge: "0 0 32 32",
	Large: "0 0 48 48",
	Social: "0 0 50 50",
	XLarge: "0 0 88 88",
	XXLarge: "0 0 200 200"
}, pf = {
	Normal: 16,
	Medium: 24,
	MediumLarge: 32,
	Large: 48,
	Social: 50,
	XLarge: 88,
	XXLarge: 200
}, mf = [
	"aria-label",
	"height",
	"role",
	"viewBox",
	"width"
], hf = /* @__PURE__ */ l({
	__name: "IconBase",
	props: {
		width: { default: void 0 },
		height: { default: void 0 },
		viewbox: { default: void 0 },
		size: { default: pf.Normal },
		ariaLabel: { default: void 0 }
	},
	setup(e) {
		let n = te(), r = e, a = Object.entries(pf).find(([, e]) => e === r.size)[0], o = t(() => String(r.height ?? pf[a])), s = t(() => String(r.width ?? pf[a])), c = t(() => String(r.viewbox ?? ff[a])), l = t(() => r.ariaLabel ? "img" : "presentation");
		return (t, r) => (f(), i("svg", {
			"aria-label": e.ariaLabel,
			class: d(y(Ar)("align-baseline inline-block overflow-visible", y(n).class)),
			height: o.value,
			role: l.value,
			viewBox: c.value,
			width: s.value,
			xmlns: "http://www.w3.org/2000/svg"
		}, [g(t.$slots, "default")], 10, mf));
	}
}), gf = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
}, _f = {};
function vf(t, n) {
	return f(), i(e, null, [n[0] ||= a("path", {
		d: "M16.2347 18.7383C16.2347 18.7383 21.2379 17.4919 22 18C22.7621 18.5081 23.254 18.9919 23 19.5C22.746 20.0081 15.5405 23.5 13 23.5C10.4595 23.5 7.52428 22.5 6 22.5C5.09633 22.5 3.85827 22.5 2.99991 22.5C2.44763 22.5 2 22.0523 2 21.5V17.3015C2 16.8331 2.32352 16.428 2.78153 16.3298C4.11303 16.0443 6.75027 15.5 7.5 15.5C8.51619 15.5 11.4919 17.5 12 17.5C12.5081 17.5 13.9838 17.5 15 17.5C16.0162 17.5 16.2347 18.7383 16.2347 18.7383ZM16.2347 18.7383C16.2347 18.7383 14.0162 20.5 13 20.5C11.9838 20.5 10 19.5 10 19.5",
		fill: "none",
		stroke: "currentColor",
		"stroke-linecap": "round"
	}, null, -1), n[1] ||= a("path", {
		"clip-rule": "evenodd",
		d: "M16.1286 0.23944C15.7297 0.0553592 15.2703 0.055359 14.8714 0.23944L9.37141 2.7779C8.84019 3.02308 8.5 3.55476 8.5 4.13984V11.8602C8.5 12.4453 8.84019 12.9769 9.37141 13.2221L14.8714 15.7606C15.2703 15.9447 15.7297 15.9447 16.1286 15.7606L21.6286 13.2221C22.1598 12.9769 22.5 12.4453 22.5 11.8602V4.13984C22.5 3.55476 22.1598 3.02308 21.6286 2.7779L16.1286 0.23944ZM15.2905 1.1474C15.4234 1.08604 15.5766 1.08604 15.7095 1.1474L20.8069 3.50003L18.8493 4.40352C18.7802 4.35602 18.7064 4.31394 18.6286 4.27801L13.568 1.94237L15.2905 1.1474ZM12.3749 2.49306L10.1931 3.50003L15.2905 5.85267C15.4234 5.91403 15.5766 5.91403 15.7095 5.85267L17.6818 4.9424L12.3749 2.49306ZM18.5 5.66613L16.1286 6.76063C16.0864 6.78012 16.0434 6.79755 16 6.81291V14.7186L21.2095 12.3142C21.3866 12.2324 21.5 12.0552 21.5 11.8602V4.28151L19.4432 5.23081C19.4804 5.36196 19.5 5.49942 19.5 5.63995V7.50012C19.5 7.77626 19.2761 8.00012 19 8.00012C18.7239 8.00012 18.5 7.77626 18.5 7.50012V5.66613ZM9.5 4.28151V11.8602C9.5 12.0552 9.6134 12.2324 9.79047 12.3142L15 14.7186V6.81291C14.9566 6.79755 14.9136 6.78012 14.8714 6.76063L9.5 4.28151Z",
		fill: "currentColor",
		"fill-rule": "evenodd"
	}, null, -1)], 64);
}
var yf = /*#__PURE__*/ gf(_f, [["render", vf]]), bf = {}, xf = {
	d: "M3.97679 22.3652C3.17927 22.3652 2.54585 22.0468 2.07653 21.4099C1.60741 20.7728 1.46849 20.0676 1.65976 19.2943L3.92425 10.5398C3.28277 10.3146 2.73274 9.88471 2.27417 9.25006C1.8156 8.61541 1.58631 7.88474 1.58631 7.05806C1.58631 6.04466 1.93711 5.17713 2.6387 4.45547C3.34029 3.73381 4.18369 3.37298 5.1689 3.37298H13.5283C14.2497 3.37298 14.7949 3.68714 15.1637 4.31544C15.5325 4.94375 15.5561 5.58863 15.2345 6.2501L13.5811 9.65173C13.4048 9.98257 13.1684 10.2472 12.872 10.4456C12.5757 10.6439 12.2433 10.7431 11.8749 10.7431H8.81357L8.37023 12.4674H8.45293C8.71466 12.4832 8.93708 12.5839 9.12018 12.7696C9.3031 12.9553 9.39455 13.1853 9.39455 13.4596V15.1606C9.39455 15.4417 9.3021 15.6773 9.1172 15.8675C8.9323 16.0575 8.70321 16.1525 8.42994 16.1525H7.41488L6.28965 20.5841C6.14336 21.1105 5.85755 21.5389 5.43222 21.8693C5.00688 22.1999 4.52174 22.3652 3.97679 22.3652ZM3.9747 21.1369C4.25335 21.1369 4.49219 21.055 4.69122 20.8912C4.89025 20.7274 5.02957 20.5125 5.10919 20.2463L7.57579 10.7431H5.09784L2.81036 19.6014C2.71085 19.9904 2.78051 20.3436 3.01935 20.6609C3.25819 20.9782 3.57664 21.1369 3.9747 21.1369ZM5.1689 9.51477H11.8749C12.0126 9.51477 12.1427 9.47536 12.2651 9.39654C12.3877 9.31793 12.4796 9.21557 12.5407 9.08945L14.1943 5.68782C14.3167 5.43601 14.3052 5.19198 14.1597 4.95572C14.0144 4.71947 13.8039 4.60134 13.5283 4.60134H5.1689C4.51209 4.60134 3.94982 4.8419 3.4821 5.323C3.01437 5.80411 2.78051 6.38246 2.78051 7.05806C2.78051 7.73365 3.01437 8.31201 3.4821 8.79311C3.94982 9.27422 4.51209 9.51477 5.1689 9.51477ZM18.282 4.17602L17.8112 3.10827L21.5431 1.36523L22.007 2.44005L18.282 4.17602ZM21.5431 12.7509L17.8112 11.0385L18.282 9.96374L22.007 11.7068L21.5431 12.7509ZM18.443 7.64859V6.46753H22.5767V7.64859H18.443Z",
	fill: "currentColor"
};
function Sf(e, t) {
	return f(), i("path", xf);
}
var Cf = /*#__PURE__*/ gf(bf, [["render", Sf]]), wf = {}, Tf = {
	"clip-rule": "evenodd",
	d: "M0.169434 5.54443C0.169434 4.78504 0.785042 4.16943 1.54443 4.16943H12.6339C13.3491 4.16943 13.9368 4.71543 14.0028 5.41333C14.1918 5.3155 14.4064 5.26024 14.6339 5.26024H17.4309C17.9139 5.26024 18.3614 5.51365 18.6099 5.92781L21.4412 10.6466C21.5023 10.7485 21.5913 10.8309 21.6976 10.884L23.0659 11.5682C23.5318 11.8011 23.826 12.2772 23.826 12.798V16.634C23.826 17.3933 23.2104 18.009 22.451 18.009H21.6172C21.4358 19.2431 20.3725 20.1905 19.088 20.1905C17.7854 20.1905 16.7104 19.2164 16.5516 17.9569C16.4957 17.99 16.4305 18.009 16.3609 18.009H13.6339L13.6302 18.0089H8.52778C8.34637 19.2431 7.28308 20.1905 5.99851 20.1905C4.71395 20.1905 3.65065 19.2431 3.46924 18.0089L1.54443 18.0089C0.785042 18.0089 0.169434 17.3933 0.169434 16.6339V5.54443ZM16.5516 17.311C16.7103 16.0515 17.7854 15.0773 19.088 15.0773C20.3726 15.0773 21.4359 16.0248 21.6173 17.259H22.451C22.7962 17.259 23.076 16.9791 23.076 16.634V12.798C23.076 12.5613 22.9423 12.3449 22.7305 12.239L21.3622 11.5548C21.3083 11.5279 21.2565 11.4976 21.207 11.4641H16.8156C16.0562 11.4641 15.4406 10.8485 15.4406 10.0891V8.81673C15.4406 8.05734 16.0562 7.44173 16.8156 7.44173H18.6436L17.9668 6.31368C17.8539 6.12543 17.6504 6.01024 17.4309 6.01024H14.6339C14.2913 6.01024 14.013 6.28594 14.0089 6.6276V17.259H16.3609C16.4305 17.259 16.4957 17.2779 16.5516 17.311ZM20.8945 17.6254C20.89 16.6316 20.0829 15.8273 19.088 15.8273C18.0902 15.8273 17.2814 16.6362 17.2814 17.6339C17.2814 18.6317 18.0902 19.4405 19.088 19.4405C20.0829 19.4405 20.8899 18.6363 20.8945 17.6425C20.8945 17.6396 20.8944 17.6368 20.8944 17.634C20.8944 17.6311 20.8945 17.6283 20.8945 17.6254ZM7.80498 17.6339L7.80507 17.6254C7.80047 16.6316 6.99341 15.8273 5.99851 15.8273C5.00076 15.8273 4.19193 16.6362 4.19193 17.6339C4.19193 18.6317 5.00076 19.4405 5.99851 19.4405C6.9934 19.4405 7.80045 18.6363 7.80507 17.6425L7.80498 17.6339ZM13.2589 17.2589H8.52779C8.34639 16.0247 7.28309 15.0773 5.99851 15.0773C4.71393 15.0773 3.65063 16.0247 3.46923 17.2589L1.54443 17.2589C1.19926 17.2589 0.919434 16.9791 0.919434 16.6339V5.54443C0.919434 5.19926 1.19926 4.91943 1.54443 4.91943H12.6339C12.9791 4.91943 13.2589 5.19926 13.2589 5.54443V6.6239L13.2589 6.63524V17.2589ZM19.0936 8.19169L19.088 8.19173H16.8156C16.4705 8.19173 16.1906 8.47156 16.1906 8.81673V10.0891C16.1906 10.4343 16.4705 10.7141 16.8156 10.7141H20.6071L19.0936 8.19169Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function Ef(e, t) {
	return f(), i("path", Tf);
}
var Df = /*#__PURE__*/ gf(wf, [["render", Ef]]), Of = {};
function kf(t, n) {
	return f(), i(e, null, [
		n[0] ||= a("path", {
			"clip-rule": "evenodd",
			d: "M13.1286 1.23944C12.7297 1.05536 12.2703 1.05536 11.8714 1.23944L6.37141 3.7779C5.84019 4.02308 5.5 4.55476 5.5 5.13984V12.8602C5.5 13.4453 5.84019 13.9769 6.37141 14.2221L11.8714 16.7606C12.2703 16.9447 12.7297 16.9447 13.1286 16.7606L18.6286 14.2221C19.1598 13.9769 19.5 13.4453 19.5 12.8602V5.13984C19.5 4.55476 19.1598 4.02308 18.6286 3.7779L13.1286 1.23944ZM12.2905 2.1474C12.4234 2.08604 12.5766 2.08604 12.7095 2.1474L17.8069 4.50003L15.8493 5.40352C15.7802 5.35602 15.7064 5.31394 15.6286 5.27801L10.568 2.94237L12.2905 2.1474ZM9.37488 3.49306L7.1931 4.50003L12.2905 6.85267C12.4234 6.91403 12.5766 6.91403 12.7095 6.85267L14.6818 5.9424L9.37488 3.49306ZM15.5 6.66613L13.1286 7.76063C13.0864 7.78012 13.0434 7.79755 13 7.81291V15.7186L18.2095 13.3142C18.3866 13.2324 18.5 13.0552 18.5 12.8602V5.28151L16.4432 6.23081C16.4804 6.36196 16.5 6.49942 16.5 6.63995V8.50012C16.5 8.77626 16.2761 9.00012 16 9.00012C15.7239 9.00012 15.5 8.77626 15.5 8.50012V6.66613ZM6.5 5.28151V12.8602C6.5 13.0552 6.6134 13.2324 6.79047 13.3142L12 15.7186V7.81291C11.9566 7.79755 11.9136 7.78012 11.8714 7.76063L6.5 5.28151Z",
			fill: "currentColor",
			"fill-rule": "evenodd"
		}, null, -1),
		n[1] ||= a("path", {
			d: "M1 8C0.723858 8 0.5 8.22386 0.5 8.5C0.5 8.77614 0.723858 9 1 9V8ZM5 9H5.5V8H5V9ZM1 9H5V8H1V9Z",
			fill: "currentColor"
		}, null, -1),
		n[2] ||= a("path", {
			d: "M20 8H19.5V9H20V8ZM23 9C23.2761 9 23.5 8.77614 23.5 8.5C23.5 8.22386 23.2761 8 23 8V9ZM20 9H23V8H20V9Z",
			fill: "currentColor"
		}, null, -1),
		n[3] ||= a("path", {
			d: "M1 18.5H23",
			stroke: "currentColor",
			"stroke-linecap": "round",
			"stroke-linejoin": "round"
		}, null, -1),
		n[4] ||= a("path", {
			d: "M3 21.5C3 22.0523 2.55228 22.5 2 22.5C1.44772 22.5 1 22.0523 1 21.5C1 20.9477 1.44772 20.5 2 20.5C2.55228 20.5 3 20.9477 3 21.5Z",
			fill: "none",
			stroke: "currentColor",
			"stroke-linecap": "round",
			"stroke-linejoin": "round"
		}, null, -1),
		n[5] ||= a("path", {
			d: "M7 21.5C7 22.0523 6.55228 22.5 6 22.5C5.44772 22.5 5 22.0523 5 21.5C5 20.9477 5.44772 20.5 6 20.5C6.55228 20.5 7 20.9477 7 21.5Z",
			fill: "none",
			stroke: "currentColor",
			"stroke-linecap": "round",
			"stroke-linejoin": "round"
		}, null, -1),
		n[6] ||= a("path", {
			d: "M11 21.5C11 22.0523 10.5523 22.5 10 22.5C9.44772 22.5 9 22.0523 9 21.5C9 20.9477 9.44772 20.5 10 20.5C10.5523 20.5 11 20.9477 11 21.5Z",
			fill: "none",
			stroke: "currentColor",
			"stroke-linecap": "round",
			"stroke-linejoin": "round"
		}, null, -1),
		n[7] ||= a("path", {
			d: "M15 21.5C15 22.0523 14.5523 22.5 14 22.5C13.4477 22.5 13 22.0523 13 21.5C13 20.9477 13.4477 20.5 14 20.5C14.5523 20.5 15 20.9477 15 21.5Z",
			fill: "none",
			stroke: "currentColor",
			"stroke-linecap": "round",
			"stroke-linejoin": "round"
		}, null, -1),
		n[8] ||= a("path", {
			d: "M19 21.5C19 22.0523 18.5523 22.5 18 22.5C17.4477 22.5 17 22.0523 17 21.5C17 20.9477 17.4477 20.5 18 20.5C18.5523 20.5 19 20.9477 19 21.5Z",
			fill: "none",
			stroke: "currentColor",
			"stroke-linecap": "round",
			"stroke-linejoin": "round"
		}, null, -1),
		n[9] ||= a("path", {
			d: "M23 21.5C23 22.0523 22.5523 22.5 22 22.5C21.4477 22.5 21 22.0523 21 21.5C21 20.9477 21.4477 20.5 22 20.5C22.5523 20.5 23 20.9477 23 21.5Z",
			fill: "none",
			stroke: "currentColor",
			"stroke-linecap": "round",
			"stroke-linejoin": "round"
		}, null, -1)
	], 64);
}
var Af = /*#__PURE__*/ gf(Of, [["render", kf]]), jf = {}, Mf = {
	"clip-rule": "evenodd",
	d: "M5.5 6.5C5.5 5.67157 6.17157 5 7 5H10C10.2761 5 10.5 4.77614 10.5 4.5C10.5 4.22386 10.2761 4 10 4H7C5.61929 4 4.5 5.11929 4.5 6.5V17.5C4.5 18.8807 5.61929 20 7 20H18C19.3807 20 20.5 18.8807 20.5 17.5V14.5C20.5 14.2239 20.2761 14 20 14C19.7239 14 19.5 14.2239 19.5 14.5V17.5C19.5 18.3284 18.8284 19 18 19H7C6.17157 19 5.5 18.3284 5.5 17.5V6.5ZM15 4C14.7239 4 14.5 4.22386 14.5 4.5C14.5 4.77614 14.7239 5 15 5H18.7929L11.6464 12.1464C11.4512 12.3417 11.4512 12.6583 11.6464 12.8536C11.8417 13.0488 12.1583 13.0488 12.3536 12.8536L19.5 5.70711V9.5C19.5 9.77614 19.7239 10 20 10C20.2761 10 20.5 9.77614 20.5 9.5V4.5C20.5 4.22386 20.2761 4 20 4H15Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function Nf(e, t) {
	return f(), i("path", Mf);
}
var Pf = /*#__PURE__*/ gf(jf, [["render", Nf]]), Ff = {}, If = {
	fill: "none",
	height: "24",
	width: "24",
	xmlns: "http://www.w3.org/2000/svg"
};
function Lf(e, t) {
	return f(), i("svg", If, [...t[0] ||= [a("mask", {
		id: "a",
		height: "24",
		maskUnits: "userSpaceOnUse",
		style: { "mask-type": "alpha" },
		width: "24",
		x: "0",
		y: "0"
	}, [a("path", {
		d: "M0 0h24v24H0z",
		fill: "#D9D9D9"
	})], -1), a("g", { mask: "url(#a)" }, [a("path", {
		d: "m10.562 15.908 6.396-6.396-.708-.708-5.688 5.688-2.85-2.85-.708.708 3.558 3.558ZM12.003 21a8.772 8.772 0 0 1-3.51-.709 9.095 9.095 0 0 1-2.859-1.922 9.081 9.081 0 0 1-1.925-2.857A8.752 8.752 0 0 1 3 12.003c0-1.244.236-2.414.708-3.51a9.096 9.096 0 0 1 1.923-2.859 9.081 9.081 0 0 1 2.857-1.925A8.752 8.752 0 0 1 11.997 3c1.244 0 2.414.236 3.51.708a9.096 9.096 0 0 1 2.859 1.923 9.082 9.082 0 0 1 1.925 2.857A8.752 8.752 0 0 1 21 11.997a8.772 8.772 0 0 1-.709 3.51 9.095 9.095 0 0 1-1.922 2.859 9.082 9.082 0 0 1-2.857 1.925 8.752 8.752 0 0 1-3.509.709ZM12 20c2.233 0 4.125-.775 5.675-2.325C19.225 16.125 20 14.233 20 12c0-2.233-.775-4.125-2.325-5.675C16.125 4.775 14.233 4 12 4c-2.233 0-4.125.775-5.675 2.325C4.775 7.875 4 9.767 4 12c0 2.233.775 4.125 2.325 5.675C7.875 19.225 9.767 20 12 20Z",
		fill: "#1C1B1F"
	})], -1)]]);
}
var Rf = /*#__PURE__*/ gf(Ff, [["render", Lf]]), zf = { class: "flex gap-x-2 items-center my-2" }, Bf = { class: "first-letter:capitalize font-bold px-4 block" }, Vf = { class: "flex justify-between leading-none w-full" }, Hf = { class: "w-1/3" }, Uf = { class: "w-1/3" }, Wf = { class: "w-1/3" }, Gf = /* @__PURE__ */ l({
	__name: "DeliveryOptionRadioGroup",
	props: /*@__PURE__*/ u({
		name: {},
		deliveryOptions: {}
	}, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let n = e, { t: r, locale: o } = Fe(), s = (e) => `${si(e[0].date_time.date).format()} - ${si(e[1].date_time.date).format()}`, l = (e) => `${si(e[0].date_time.date).locale(o.value).format("HH:mm")} - ${si(e[1].date_time.date).locale(o.value).format("HH:mm")}`, u = (e) => d.value.find((t) => s(t.delivery_time_frames) === e), d = t(() => n.deliveryOptions.flatMap((e) => e.possibilities)), p = t(() => n.deliveryOptions.reduce((e, t) => {
			let n = [{
				isGroupLabel: !0,
				label: si(t.date.date).locale(o.value).format("dddd D MMMM"),
				value: t.date.date
			}], r = t.possibilities.map((e) => {
				let t = l(e.delivery_time_frames), n = s(e.delivery_time_frames);
				return {
					label: "",
					time: t,
					type: e.type,
					price: Si.currency.format(e?.price.amount),
					value: n
				};
			});
			return e.push(...n, ...r), e;
		}, [])), h = ne(e, "modelValue"), g = m("");
		return b(h, (e) => {
			e ? g.value = s(e.deliveryTimeFrame) : g.value = "";
		}, { immediate: !0 }), b(g, (e) => {
			let t = u(e);
			if (!t) {
				h.value = void 0;
				return;
			}
			h.value && s(h.value.deliveryTimeFrame) === e || (h.value = {
				deliveryTimeFrame: t.delivery_time_frames,
				type: t.type
			});
		}), (t, n) => (f(), i("div", null, [c(y(Oe), {
			modelValue: g.value,
			"onUpdate:modelValue": n[0] ||= (e) => g.value = e,
			"active-class": "bg-gray-100",
			class: "gap-y-0 shrink border-0 border-b-1 rounded-none",
			name: e.name,
			options: p.value,
			"radio-class": "p-4 shrink items-start! border-b hover:bg-gray-100 focus:z-10"
		}, {
			groupLabel: x(({ option: e }) => [a("div", zf, [a("p", Bf, v(e.label), 1)])]),
			default: x(({ option: e }) => [a("div", Vf, [
				a("div", Hf, v(e.time), 1),
				a("div", Uf, v(y(r)(`shipping.adjustedDelivery.deliveryMoments.${y(rf)(e.type)}`)), 1),
				a("div", Wf, v(e.price), 1)
			])]),
			_: 1
		}, 8, [
			"modelValue",
			"name",
			"options"
		])]));
	}
}), Kf = { class: "flex grow" }, qf = { class: "flex flex-col" }, Jf = { class: "flex gap-x-2 items-center" }, Yf = { class: "font-bold leading-none" }, Xf = { class: "font-normal text-xs w-40" }, Zf = { class: "text-left" }, Qf = { class: "mb-1 text-black-light" }, $f = { class: "ml-auto self-center shrink-0 text-black-light" }, ep = /* @__PURE__ */ l({
	__name: "PickupLocationOption",
	props: { option: {} },
	setup(o) {
		let s = o, { t: c } = Fe(), l = t(() => {
			let e = Ii.transformMetersToKilometers(s.option.location.distance);
			return `${s.option.location.location_name} (${e} km)`;
		}), u = t(() => s.option.location.location_name), d = t(() => Object.entries(s.option.location.opening_hours).reduce((e, [t, n]) => {
			e[t] = {
				start: "-",
				end: "-"
			};
			let r = n[0];
			return r?.start && (e[t].start = si(r.start.date).format("HH:mm")), r?.end && (e[t].end = si(r.end.date).format("HH:mm")), e;
		}, {})), p = t(() => `${s.option.address.street} ${s.option.address.number}${s.option.address.number_suffix ?? ""}, ${s.option.address.postal_code} ${s.option.address.city}`), m = t(() => s.option.possibilities.map((e) => {
			if (!e.moment?.start?.date) return "";
			let { date: t } = e.moment.start;
			return si(t).format(`dddd D MMMM [${c("from")}] HH:mm`);
		})), g = t(() => s.option.possibilities[0].price ? Si.currency.format(s.option.possibilities[0].price) : Si.currency.format(0));
		return (t, s) => (f(), i("div", Kf, [a("div", qf, [
			a("div", Jf, [a("h4", Yf, v(l.value), 1), o.option.location.opening_hours ? (f(), n(y(De), {
				key: 0,
				class: "pointer-events-auto"
			}, {
				default: x(() => [a("table", Xf, [a("thead", Zf, [a("tr", null, [
					a("th", null, v(y(c)("calendar.index.day")), 1),
					a("th", null, v(y(c)("from")), 1),
					a("th", null, v(y(c)("to")), 1)
				])]), a("tbody", null, [(f(!0), i(e, null, h(d.value, (e, t) => (f(), i("tr", { key: `${u.value}-${t}` }, [
					a("td", null, v(y(c)(`calendar.day.${t}`)), 1),
					a("td", null, v(e.start), 1),
					a("td", null, v(e.end), 1)
				]))), 128))])])]),
				_: 1
			})) : r("", !0)]),
			a("span", Qf, v(p.value), 1),
			(f(!0), i(e, null, h(m.value, (e) => (f(), i("span", {
				key: e,
				class: "first-letter:capitalize"
			}, v(e), 1))), 128))
		]), a("span", $f, v(g.value), 1)]));
	}
}), tp = /* @__PURE__ */ l({
	__name: "PickupLocationRadioGroup",
	props: /*@__PURE__*/ u({
		pickupLocations: {},
		name: {}
	}, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let r = e, i = ne(e, "modelValue"), a = m(""), o = (e) => `[${e.address.postal_code}][${e.address.number}][${e.address.street}][${e.address.number_suffix ?? ""}]`, s = (e) => {
			let [t, n, i, a] = e.slice(1, -1).split("][");
			return r.pickupLocations.find((e) => e.address.street === i && e.address.postal_code === t && e.address.number === n && (e.address.number_suffix ?? "") === a);
		}, l = t(() => r.pickupLocations.map((e) => ({
			...e,
			value: o(e),
			label: ""
		})));
		return b(i, (e) => {
			e ? a.value = o(e) : a.value = "";
		}, { immediate: !0 }), b(a, (e) => {
			if (!e) {
				i.value = void 0;
				return;
			}
			i.value = s(e);
		}), (t, r) => (f(), n(y(Oe), {
			modelValue: a.value,
			"onUpdate:modelValue": r[0] ||= (e) => a.value = e,
			"active-class": "bg-gray-100",
			class: "py-0! gap-y-0 border-0!",
			name: e.name,
			options: l.value,
			"radio-class": "p-4! items-start! hover:bg-gray-100 focus:z-10"
		}, {
			default: x(({ option: e }) => [c(ep, { option: e }, null, 8, ["option"])]),
			_: 1
		}, 8, [
			"modelValue",
			"name",
			"options"
		]));
	}
}), np = {
	key: 0,
	class: "flex flex-col gap-y-4"
}, rp = {
	key: 0,
	class: "px-4 block"
}, ip = { class: "flex flex-col gap-y-1" }, ap = {
	key: 1,
	class: "text-center"
}, op = { class: "px-4 block mb-4" }, sp = {
	key: 1,
	class: "text-center"
}, cp = {
	key: 1,
	class: "flex flex-col items-center justify-center"
}, lp = /* @__PURE__ */ l({
	__name: "AdjustedDeliveryResults",
	props: {
		activeTab: {},
		pickupLocations: {},
		deliveryOptions: {},
		selectedOption: {},
		initialSelection: {},
		hasDeliveryData: { type: Boolean },
		hasPickupData: { type: Boolean },
		isLoading: { type: Boolean },
		userHasSearched: { type: Boolean }
	},
	emits: ["selectPickupOption", "selectDeliveryOption"],
	setup(t, { emit: o }) {
		let s = t, l = o, { t: u } = Fe(), d = m(!1), p = m(), h = m();
		return b(h, () => {
			if (h.value) {
				if (d.value) {
					d.value = !1;
					return;
				}
				l("selectDeliveryOption", h.value), p.value = void 0;
			}
		}), b(p, () => {
			if (p.value) {
				if (d.value) {
					d.value = !1;
					return;
				}
				l("selectPickupOption", p.value), h.value = void 0;
			}
		}), b(() => s.initialSelection, (e) => {
			e && (d.value = !0, "location" in e ? p.value = e : h.value = {
				deliveryTimeFrame: e.delivery_time_frames,
				type: e.type
			});
		}), b(() => s.selectedOption, (e) => {
			if (!e) {
				h.value = void 0, p.value = void 0;
				return;
			}
		}, { immediate: !0 }), (o, s) => (f(), i("div", null, [t.userHasSearched ? (f(), i(e, { key: 0 }, [t.isLoading ? (f(), n(y(Ae), {
			key: 1,
			class: "flex justify-center mt-6",
			size: "small"
		})) : (f(), i(e, { key: 0 }, [t.activeTab === "delivery" ? (f(), i("div", np, [
			t.hasDeliveryData ? (f(), i("p", rp, v(y(u)("shipping.adjustedDelivery.choose.delivery")), 1)) : r("", !0),
			a("div", ip, [c(Gf, {
				modelValue: h.value,
				"onUpdate:modelValue": s[0] ||= (e) => h.value = e,
				"delivery-options": t.deliveryOptions,
				name: "delivery_options"
			}, null, 8, ["modelValue", "delivery-options"])]),
			t.hasDeliveryData ? r("", !0) : (f(), i("p", ap, v(y(u)("shipping.adjustedDelivery.noDeliveriesFound")), 1))
		])) : r("", !0), t.activeTab === "pickup" ? (f(), i(e, { key: 1 }, [t.hasPickupData ? (f(), i(e, { key: 0 }, [a("p", op, v(y(u)("shipping.adjustedDelivery.choose.pickup")), 1), c(tp, {
			modelValue: p.value,
			"onUpdate:modelValue": s[1] ||= (e) => p.value = e,
			name: "pickup_locations",
			"pickup-locations": t.pickupLocations
		}, null, 8, ["modelValue", "pickup-locations"])], 64)) : r("", !0), t.hasPickupData ? r("", !0) : (f(), i("p", sp, v(y(u)("shipping.adjustedDelivery.noPickupsFound")), 1))], 64)) : r("", !0)], 64))], 64)) : (f(), i("div", cp, [c(y(hf), {
			class: "text-secondary-200",
			size: y(xe).Large
		}, {
			default: x(() => [c(y(fe))]),
			_: 1
		}, 8, ["size"]), a("p", null, v(y(u)("shipping.adjustedDelivery.empty")), 1)]))]));
	}
}), up = (e, t, n, r, i, a) => Ie.object({
	postalCode: Ve.schema.handleEmptyAndNullAsUndefined(Ve.schema.requiredIf(t, Ie.string().min(ws.properties.postalCode.minLength).max(ws.properties.postalCode.maxLength).refine((e) => a(e), { message: e("errors.specificField.postalCode.invalid") }))),
	houseNumber: Ve.schema.handleEmptyAndNullAsUndefined(Ve.schema.requiredIf(n, Ie.string().min(ws.properties.houseNumber.minLength))),
	street: Ve.schema.handleEmptyAndNullAsUndefined(Ve.schema.requiredIf(r, Ie.string())),
	city: Ve.schema.handleEmptyAndNullAsUndefined(Ve.schema.requiredIf(i, Ie.string()))
}), dp = { class: "flex gap-2" }, fp = /* @__PURE__ */ l({
	__name: "AdjustedDeliverySearchForm",
	props: {
		address: {},
		type: {},
		carrierId: {},
		isLoading: { type: Boolean },
		isSearchable: { type: Boolean }
	},
	emits: ["search"],
	setup(e, { emit: i }) {
		let o = e, l = i, { t: u } = Fe(), { getVisibleFields: d, getRequiredFields: p } = sf(), m = t(() => qe(o.carrierId)), h = t(() => d(o.address.countryCode, m.value)), g = t(() => p(o.address.countryCode, m.value)), _ = {
			...o.address.postalCode && { postalCode: o.address.postalCode },
			...o.address.houseNumber && { houseNumber: o.address.houseNumber },
			...o.address.street && { street: o.address.street },
			...o.address.city && { city: o.address.city }
		}, ee = t(() => up(u, g.value.postalCode, g.value.houseNumber, g.value.street, g.value.city, (e) => Re(e, o.address.countryCode))), { handleSubmit: te, values: ne, meta: re, resetForm: ie, setValues: ae } = He({
			validationSchema: ee,
			initialValues: _,
			validateOnMount: !1
		}), oe = te((e) => l("search", e)), se = t(() => !!(ne.postalCode || ne.houseNumber || ne.street || ne.city));
		return b(() => o.type, async () => {
			!o.isSearchable || !re.value.valid || !se.value || (await oe(), ie({ values: ne }));
		}), b(() => o.isSearchable, async (e) => {
			if (!e) {
				ie({ values: {
					postalCode: o.address.postalCode,
					houseNumber: o.address.houseNumber,
					street: o.address.street,
					city: o.address.city
				} });
				return;
			}
			!(await up(u, g.value.postalCode, g.value.houseNumber, g.value.street, g.value.city, () => !0).safeParseAsync(ne)).success || !se.value || await oe();
		}, { immediate: !0 }), b(() => [
			o.address.postalCode,
			o.address.houseNumber,
			o.address.street,
			o.address.city
		], () => {
			ae({
				postalCode: o.address.postalCode,
				houseNumber: o.address.houseNumber,
				street: o.address.street,
				city: o.address.city
			}, !1);
		}, { immediate: !0 }), (t, i) => (f(), n(y(ze), { onSubmit: y(oe) }, {
			default: x(() => [a("div", dp, [
				h.value.postalCode ? (f(), n(y(Be), {
					key: 0,
					class: "flex flex-col grow",
					"hide-label": "",
					label: y(u)("location.address.postalCode"),
					name: "postalCode",
					placeholder: y(u)("location.address.postalCode"),
					"preserve-label-gap": !1
				}, null, 8, ["label", "placeholder"])) : r("", !0),
				c(y(Be), {
					class: "flex flex-col grow",
					"hide-label": "",
					label: y(u)("location.address.houseNumber"),
					name: "houseNumber",
					placeholder: y(u)("location.address.houseNumber"),
					"preserve-label-gap": !1
				}, null, 8, ["label", "placeholder"]),
				h.value.street ? (f(), n(y(Be), {
					key: 1,
					class: "flex flex-col grow",
					"hide-label": "",
					label: y(u)("location.address.street"),
					name: "street",
					placeholder: y(u)("location.address.street"),
					"preserve-label-gap": !1
				}, null, 8, ["label", "placeholder"])) : r("", !0),
				h.value.city ? (f(), n(y(Be), {
					key: 2,
					class: "flex flex-col grow",
					"hide-label": "",
					label: y(u)("location.address.city"),
					name: "city",
					placeholder: y(u)("location.address.city"),
					"preserve-label-gap": !1
				}, null, 8, ["label", "placeholder"])) : r("", !0),
				c(y(ve), {
					"hide-label": "",
					"preserve-label-gap": !1
				}, {
					default: x(() => [c(y(ue), {
						"is-loading": e.isLoading,
						type: "submit"
					}, {
						default: x(() => [s(v(y(u)("search.label")), 1)]),
						_: 1
					}, 8, ["is-loading"])]),
					_: 1
				})
			])]),
			_: 1
		}, 8, ["onSubmit"]));
	}
}), pp = {
	Pickup: "pickup",
	Delivery: "delivery"
}, mp = { class: "border-b flex gap-4 px-4" }, hp = /* @__PURE__ */ l({
	__name: "AdjustedDeliveryTabs",
	props: /*@__PURE__*/ u({
		hasAdjustedDelivery: { type: Boolean },
		hasAdjustedPickup: { type: Boolean },
		pickupRequired: { type: Boolean }
	}, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let o = e, { t: c } = Fe(), l = ne(e, "modelValue"), u = (e) => {
			o.pickupRequired || e === l.value || (l.value = e);
		}, p = t(() => l.value === pp.Pickup), m = t(() => l.value === pp.Delivery);
		return (t, o) => (f(), i("nav", null, [a("ul", mp, [e.hasAdjustedDelivery ? (f(), n(y(je), {
			key: 0,
			active: m.value,
			"aria-label": y(c)("shipping.adjustedDelivery.delivery"),
			class: d({ "cursor-not-allowed!": e.pickupRequired }),
			onClick: o[0] ||= () => u("delivery")
		}, {
			default: x(() => [s(v(y(c)("shipping.adjustedDelivery.delivery")), 1)]),
			_: 1
		}, 8, [
			"active",
			"aria-label",
			"class"
		])) : r("", !0), e.hasAdjustedPickup ? (f(), n(y(je), {
			key: 1,
			active: p.value,
			"aria-label": y(c)("shipping.adjustedDelivery.pickup"),
			onClick: o[1] ||= () => u("pickup")
		}, {
			default: x(() => [s(v(y(c)("shipping.adjustedDelivery.pickup")), 1)]),
			_: 1
		}, 8, ["active", "aria-label"])) : r("", !0)])]));
	}
}), gp = (e, t) => e.flatMap((e) => e.possibilities).find((e) => t?.deliveryType && e.type === t.deliveryType && si(e.delivery_time_frames[0].date_time.date).isSame(t.date, "day")), _p = (e, t) => e.find((e) => e.location.location_code === t?.location?.code), vp = /* @__PURE__ */ l({
	__name: "AdjustedDeliveryModal",
	props: {
		address: {},
		carrier: {},
		platform: {},
		dropOffDays: { default: () => [] },
		selectedOption: { default: void 0 },
		mondayDelivery: { type: Boolean },
		hasAdjustedDelivery: { type: Boolean },
		hasAdjustedPickup: { type: Boolean },
		isPickupRequired: { type: Boolean }
	},
	emits: ["selectPickupOption", "selectDeliveryOption"],
	setup(e, { expose: i, emit: a }) {
		let o = e, l = a, u = p({
			postalCode: "",
			houseNumber: "",
			street: "",
			city: ""
		}), { t: d } = Fe(), { addNotification: h } = ae(), { getAdjustedDeliveryData: g } = sf(), _ = m(!0), ee = m(pp.Pickup), te = m(!1), ne = m([]), oe = m([]), se = re("adjustedDeliveryModal"), ce = t(() => Ye(o.carrier)), le = t(() => oe.value.length > 0), ue = t(() => ne.value.length > 0), de = t(() => ui(o.selectedOption?.deliveryType)), fe = t(() => di(o.selectedOption?.deliveryType)), pe = t(() => de.value ? "shipping.adjustedDelivery.chosen.pickup" : "shipping.adjustedDelivery.chosen.delivery"), me = () => {
			ne.value = [], oe.value = [], te.value = !1, _.value = !0;
		}, he = async (e) => {
			u.postalCode = e.postalCode, u.houseNumber = e.houseNumber, u.street = e.street, u.city = e.city, te.value = !0, ne.value = [], oe.value = [], await be(e);
		}, ge = () => {
			me(), _e.value = void 0;
		}, _e = m(), ve = m(!1), { isLoading: ye, executeImmediate: be } = Pe(async (e) => {
			let { postalCode: t, houseNumber: n, street: r, city: i } = e;
			return g({
				cc: o.address.countryCode,
				postal_code: t,
				number: Number(n),
				city: i,
				street: r,
				carrier: ce.value,
				monday_delivery: o.mondayDelivery,
				dropoff_days: o.dropOffDays.join(";"),
				platform: o.platform
			}, ee.value);
		}, [], {
			onSuccess: (e) => {
				if (_.value = !0, ee.value === pp.Pickup) {
					ne.value = e, ve.value &&= (_e.value = _p(ne.value, o.selectedOption), !1);
					return;
				}
				oe.value = e, ve.value &&= (_e.value = gp(oe.value, o.selectedOption), !1);
			},
			onError: (e) => {
				if (e?.data?.errors?.[0]?.code === 3501) _.value = !1, h({
					variant: "alert",
					body: d("apiError.3501")
				});
				else {
					let e = ee.value === pp.Delivery ? "deliveryOptions" : "pickupLocations";
					h({
						variant: "alert",
						body: d(`shipping.adjustedDelivery.notification.${e}.error`)
					});
				}
				ne.value = [], oe.value = [];
			},
			immediate: !1
		});
		/* c8 ignore end */
		return b(() => [o.isPickupRequired, o.hasAdjustedDelivery], () => {
			ee.value = o.isPickupRequired || !o.hasAdjustedDelivery ? pp.Pickup : pp.Delivery;
		}, { immediate: !0 }), b(() => o.address.countryCode, () => {
			me();
		}), i({
			show: () => {
				de.value ? (ee.value = pp.Pickup, ve.value = !0) : fe.value && o.hasAdjustedDelivery && (ee.value = pp.Delivery, ve.value = !0), _e.value = void 0, se.value?.show();
			},
			confirm: () => {
				se.value?.confirm();
			},
			cancel: () => {
				se.value?.cancel();
			}
		}), (t, i) => (f(), n(y(Ce), {
			ref: "adjustedDeliveryModal",
			"body-class": "flex flex-col gap-4",
			"full-width-content": "",
			"hide-confirm": "",
			"show-cancel": "",
			title: y(d)("shipping.adjustedDelivery.deliveryOption", 2),
			onClose: ge
		}, {
			default: x(() => [
				_.value ? r("", !0) : (f(), n(y(ie), {
					key: 0,
					id: "invalid-address",
					class: "mx-4 mb-0!",
					variant: "alert"
				}, {
					default: x(() => [s(v(y(d)("shipping.adjustedDelivery.notification.provideValidAddress")), 1)]),
					_: 1
				})),
				c(fp, {
					address: e.address,
					"carrier-id": ce.value,
					class: "px-4",
					"is-loading": y(ye),
					"is-searchable": se.value?.isOpen,
					type: ee.value,
					onSearch: he
				}, null, 8, [
					"address",
					"carrier-id",
					"is-loading",
					"is-searchable",
					"type"
				]),
				e.selectedOption ? (f(), n(df, {
					key: 1,
					class: "px-4",
					"country-code": e.address.countryCode,
					option: e.selectedOption,
					title: pe.value
				}, null, 8, [
					"country-code",
					"option",
					"title"
				])) : r("", !0),
				c(hp, {
					modelValue: ee.value,
					"onUpdate:modelValue": i[0] ||= (e) => ee.value = e,
					"has-adjusted-delivery": e.hasAdjustedDelivery,
					"has-adjusted-pickup": e.hasAdjustedPickup,
					"pickup-required": e.isPickupRequired
				}, null, 8, [
					"modelValue",
					"has-adjusted-delivery",
					"has-adjusted-pickup",
					"pickup-required"
				]),
				c(lp, {
					"active-tab": ee.value,
					"delivery-options": oe.value,
					"has-delivery-data": le.value,
					"has-pickup-data": ue.value,
					"initial-selection": _e.value,
					"is-loading": y(ye),
					"pickup-locations": ne.value,
					"selected-option": e.selectedOption,
					"user-has-searched": te.value,
					onSelectDeliveryOption: i[1] ||= (e) => l("selectDeliveryOption", e),
					onSelectPickupOption: i[2] ||= (e) => l("selectPickupOption", e)
				}, null, 8, [
					"active-tab",
					"delivery-options",
					"has-delivery-data",
					"has-pickup-data",
					"initial-selection",
					"is-loading",
					"pickup-locations",
					"selected-option",
					"user-has-searched"
				])
			]),
			_: 1
		}, 8, ["title"]));
	}
}), yp = Ts.properties.groups.items.properties.hsCode.maxLength, bp = 6, xp = [10], Sp = [8, 10], Cp = [
	6,
	8,
	10
], wp = [
	6,
	8,
	10
], Tp = [6, 8], Ep = [k.DPD, k.BPOST], Dp = (e, t) => !Ep.includes(e) && zr.countryCode.isUnitedStatesOfAmerica(t) ? { allowed: xp } : Wd(e) ? {
	min: 6,
	max: yp
} : Rd(e) ? { allowed: Sp } : Md(e) ? { allowed: Tp } : kd(e) ? { allowed: wp } : { allowed: Cp }, Op = (e) => !("barcode" in e), kp = (e) => "barcode" in e, Ap = (e) => e.shipping?.recipient ?? e.packages?.find((e) => e.shipment?.recipient)?.shipment?.recipient, jp = {
	[Os.PACKAGE]: 1e3,
	[Os.PALLET]: 5e4,
	[Os.DIGITAL_STAMP]: 10,
	[Os.MAILBOX]: 50,
	[Os.SMALL_PACKAGE]: 125,
	[Os.ENVELOPE]: 250
}, Mp = (e) => e in jp, Np = (e) => Mp(e) ? jp[e] : jp[Os.PACKAGE], Pp = [
	T.UnitedKingdom,
	T.Norway,
	T.Switzerland
], Fp = (e, t, n) => Wd(t) ? {
	required: !1,
	visible: !0
} : (Ld(t) || Fd(t)) && Pp.includes(e) && n ? {
	required: !0,
	visible: !0
} : {
	required: !1,
	visible: !1
}, Ip = (e, t, n) => Fp(e, t, n), Lp = (e, t, n) => Fp(e, t, n), Rp = (e, t, n) => zd(e, t) || jd(e, n), zp = (e, t) => zr.countryCode.isBelgium(e) && wd(t) ? !1 : !Dd(t), Bp = (e) => {
	let { hasDeliveryOptions: t, countryParam: n, carrier: r, packageType: i } = e, a = Fd(r), o = Id(r), s = Vd(r), c = zr.countryCode.isIreland(n), l = Td(i);
	return !(!t || s || a && c || o && l);
}, Vp = (e) => Ld(e), Hp = (e) => Wd(e), Up = (e) => {
	if (e.direction === As.INBOUND || Dd(e.packageType)) return !1;
	let t = Ld(e.carrier) || Fd(e.carrier), n = zr.countryCode.isIreland(e.countryCode);
	return t && n ? !0 : !Xe.includes(e.countryCode);
}, Wp = (e) => [
	Tl.CommercialGoods,
	Tl.CommercialSample,
	Tl.ReturnedGoods
].includes(e), Gp = (e, t) => {
	let n = [Tl.Documents, Tl.Gift];
	return !((zr.countryCode.isUnitedStatesOfAmerica(e) || zr.countryCode.isPuertoRico(e)) && n.includes(t));
}, Kp = (e) => e.status === Ds.OPEN && !e.assignedUserId, qp = (e) => e.status === Ds.OPEN, Jp = (e) => e.status === Ds.OPEN, Yp = (e) => e.status !== Ds.CANCELED, Xp = (e) => !!e.packages?.some((e) => e.lines?.length && e.shipment?.label && e.shipment.direction !== As.INBOUND), Zp = (e) => !!e.lines?.length && e.status !== Ds.RETURNING && e.status !== Ds.CANCELED, Qp = (e) => e.status === Ds.OPEN && !!e.assignedUserId, $p = (e) => e.status === Ds.OPEN && !!e.assignedUserId, em = (e, t) => e.every((e) => {
	if (!t) return !0;
	let n = e.packageType, r = wd(n) || Td(n);
	return kd(e.carrier) && r;
}), tm = (e) => !xd(e.status) && !bd(e.status), nm = {
	GRAM: "g",
	KILOGRAM: "kg"
}, rm = {
	[nm.GRAM]: 1,
	[nm.KILOGRAM]: 1e3
}, im = ({ value: e, unit: t }, n) => {
	let r = rm[t], i = rm[n];
	return !r || !i ? e : e * r / i;
}, am = {
	MILLIMETER: "mm",
	CENTIMETER: "cm",
	DECIMETER: "dm",
	METER: "m",
	KILOMETER: "km"
}, om = {
	[am.MILLIMETER]: 1,
	[am.CENTIMETER]: 10,
	[am.DECIMETER]: 100,
	[am.METER]: 1e3,
	[am.KILOMETER]: 1e6
}, sm = {
	[am.MILLIMETER]: "unit.millimeter.short",
	[am.CENTIMETER]: "unit.centimeter.short",
	[am.DECIMETER]: "unit.decimeter.short",
	[am.METER]: "unit.meter.short",
	[am.KILOMETER]: "unit.kilometer.short",
	[nm.GRAM]: "unit.gram.short",
	[nm.KILOGRAM]: "unit.kilogram.short"
}, cm = (e) => sm[e], lm = ({ value: e, unit: t }, n) => {
	let r = om[t], i = om[n];
	return !r || !i ? e : e * r / i;
}, um = (e) => {
	let t = e.packages ?? [], n = t.filter((e) => e.shipment).length, r = t.filter((e) => e.shipment && Ol(e.shipment.label)).length;
	return {
		isPartiallyProcessed: e.status === Ds.PROCESSING && n > 0 && r > 0 && r < n,
		processedCount: r,
		totalCount: n
	};
}, dm = { class: "flex flex-col w-full" }, fm = { class: "border border-gray-200 flex items-center justify-between p-4 rounded-lg w-full" }, pm = { class: "flex items-center" }, mm = {
	key: 0,
	class: "flex flex-col mt-3"
}, hm = {
	key: 2,
	class: "text-gray-900 text-sm"
}, gm = /* @__PURE__ */ l({
	__name: "AdjustedDeliveryCard",
	props: {
		carrier: {},
		selectedOption: {},
		countryCode: {}
	},
	emits: ["editAdjustedDelivery", "removeAdjustedDelivery"],
	setup(e, { emit: o }) {
		let s = e, l = o, { t: u } = Fe(), { postponedDeliveryDateMessage: d, postponedNormalMessage: p } = af(), { isPudo: m } = sf(), h = t(() => p(s.selectedOption)), g = t(() => d(s.carrier, s.selectedOption)), _ = t(() => Yd(s.carrier) && lu(su(s.selectedOption?.deliveryType))), ee = t(() => h.value || g.value || _.value), te = t(() => s.selectedOption?.deliveryType === $e.Pickup || s.selectedOption?.deliveryType === $e.PickupExpress ? "shipping.adjustedDelivery.deliverToPickupLocation" : "shipping.adjustedDelivery.deliverAtDifferentTime");
		return (t, o) => (f(), i("div", dm, [a("div", fm, [e.selectedOption ? (f(), n(df, {
			key: 0,
			"country-code": e.countryCode,
			option: e.selectedOption,
			title: te.value
		}, null, 8, [
			"country-code",
			"option",
			"title"
		])) : r("", !0), a("div", pm, [c(y(se), null, {
			default: x(() => [c(y(oe), {
				title: y(u)("edit", 1),
				"with-tooltip": "",
				onClick: o[0] ||= (e) => l("editAdjustedDelivery")
			}, {
				default: x(() => [c(y(be), { class: "text-primary" }, {
					default: x(() => [c(y(ge))]),
					_: 1
				})]),
				_: 1
			}, 8, ["title"]), c(y(oe), {
				title: y(u)("delete", 1),
				"with-tooltip": "",
				onClick: o[1] ||= (e) => l("removeAdjustedDelivery")
			}, {
				default: x(() => [c(y(be), { class: "text-red" }, {
					default: x(() => [c(y(Ne))]),
					_: 1
				})]),
				_: 1
			}, 8, ["title"])]),
			_: 1
		})])]), ee.value ? (f(), i("div", mm, [
			h.value && y(m)(e.countryCode) ? (f(), n(y(Te), {
				key: 0,
				id: "postponed-delivery-date-message",
				variant: "warning"
			}, {
				default: x(() => [a("p", null, v(y(u)(`${h.value}`)), 1)]),
				_: 1
			})) : r("", !0),
			_.value ? (f(), n(y(Te), {
				key: 1,
				id: "poste-italiane-pickup-dimensions-warning",
				variant: "warning"
			}, {
				default: x(() => [a("p", null, v(y(u)("shipping.adjustedDelivery.notification.posteItaliane.dimensions")), 1)]),
				_: 1
			})) : r("", !0),
			g.value ? (f(), i("p", hm, v(y(u)(`${g.value}`)), 1)) : r("", !0)
		])) : r("", !0)]));
	}
}), _m = { class: "flex flex-col" }, vm = ["title"], ym = { key: 0 }, bm = ["title"], xm = ["title"], Sm = {
	key: 0,
	class: "truncate"
}, Cm = {
	key: 1,
	class: "truncate"
}, wm = {
	key: 2,
	class: "truncate"
}, Tm = {
	key: 3,
	class: "truncate"
}, Em = /* @__PURE__ */ l({
	__name: "Address",
	props: {
		address: {},
		contact: {},
		showFullCountryName: { type: Boolean }
	},
	setup(e) {
		let n = e, { t: o } = Fe(), c = t(() => n.contact && El(n.contact) ? n.contact : null), l = t(() => n.contact && Dl(n.contact) ? n.contact : null), u = t(() => [
			n.address?.street,
			n.address?.houseNumber,
			n.address?.houseNumberSuffix
		].filter(Boolean).join(" ")), d = t(() => [
			n.address?.city,
			n.address?.region,
			n.address?.state
		].filter(Boolean).join(", ")), p = t(() => [n.address?.postalCode, d.value].filter(Boolean).join(" ")), m = t(() => n.showFullCountryName ? o(`location.countries.${n.address?.countryCode}`) : n.address?.countryCode), h = t(() => n.address ? [
			u.value,
			n.address.additionalInformation,
			p.value,
			m.value
		].filter(Boolean).join(", ") : ""), g = t(() => {
			if (c.value) return [c.value.company, c.value.attention].filter(Boolean).join(" ");
		});
		return (t, n) => (f(), i("div", _m, [
			c.value ? (f(), i("p", {
				key: 0,
				class: "truncate",
				title: g.value
			}, [s(v(c.value.company) + " ", 1), c.value.attention ? (f(), i("span", ym, v(c.value.attention), 1)) : r("", !0)], 8, vm)) : r("", !0),
			l.value ? (f(), i("p", {
				key: 1,
				class: "truncate",
				title: l.value.name
			}, v(l.value.name), 9, bm)) : r("", !0),
			a("p", {
				class: "inline-flex flex-col",
				title: h.value
			}, [
				u.value ? (f(), i("span", Sm, v(u.value), 1)) : r("", !0),
				e.address?.additionalInformation ? (f(), i("span", Cm, v(e.address.additionalInformation), 1)) : r("", !0),
				p.value ? (f(), i("span", wm, v(p.value), 1)) : r("", !0),
				e.address?.countryCode ? (f(), i("span", Tm, v(m.value), 1)) : r("", !0)
			], 8, xm)
		]));
	}
}), Dm = { class: "flex items-center max-w-full gap-x-1" }, Om = { class: "text-gray-900 truncate" }, km = /* @__PURE__ */ l({
	__name: "EcommercePlatform",
	props: {
		ecommercePlatform: {},
		name: {}
	},
	setup(e) {
		return (t, n) => (f(), i("div", Dm, [c(y(he), {
			name: e.ecommercePlatform,
			size: y(We).Medium
		}, null, 8, ["name", "size"]), a("div", Om, v(e.name), 1)]));
	}
}), Am = { class: "flex items-center max-w-full gap-x-1" }, jm = { class: "text-gray-900 truncate" }, Mm = /* @__PURE__ */ l({
	__name: "MyParcelShopExternalReference",
	setup(e) {
		let { t } = Fe();
		return (e, n) => (f(), i("div", Am, [c(y(we), { "data-test": "external-reference-myparcel-shop" }), a("div", jm, v(y(t)("webshop.myParcelShop")), 1)]));
	}
}), Nm = /* @__PURE__ */ l({
	__name: "Price",
	props: { price: {} },
	setup(e) {
		let n = e, r = t(() => Si.currency.format(Si.currency.fromMoney(n.price), { currency: n.price?.currency }));
		return (e, t) => (f(), i("span", null, v(r.value), 1));
	}
}), Pm = /* @__PURE__ */ l({
	__name: "Barcode",
	props: {
		barcode: {},
		trackTraceLink: { default: void 0 }
	},
	setup(t) {
		let { t: a } = Fe();
		return (o, l) => (f(), i(e, null, [c(y(pe), {
			class: "p-0!",
			"copy-confirmation": y(a)("orders.table.row.barcodeCopied"),
			"copy-content": t.barcode
		}, {
			default: x(() => [s(v(t.barcode), 1)]),
			_: 1
		}, 8, ["copy-confirmation", "copy-content"]), t.trackTraceLink ? (f(), n(y(_e), {
			key: 0,
			class: "text-primary",
			href: t.trackTraceLink,
			target: "_blank"
		}, {
			default: x(() => [s(v(y(a)("trackTracePanel.details.viewOnCarrierWebsite")) + " ", 1), c(y(Ue), null, {
				default: x(() => [c(y(Pf))]),
				_: 1
			})]),
			_: 1
		}, 8, ["href"])) : r("", !0)], 64));
	}
}), Fm = { class: "border-b border-gray-400 py-2 last:border-b-0" }, Im = /* @__PURE__ */ l({
	__name: "TrackTraceDetail",
	props: {
		title: {},
		detail: {}
	},
	setup(e) {
		return (t, n) => (f(), i("div", Fm, [a("strong", null, v(e.title), 1), g(t.$slots, "default", {}, () => [a("p", null, v(e.detail), 1)])]));
	}
}), Lm = /* @__PURE__ */ l({
	__name: "BarcodeDetails",
	props: {
		package: {},
		trackTrace: {}
	},
	setup(a) {
		let o = a, { t: s } = Fe(), l = t(() => Ol(o.package.shipment?.label) ? o.package.shipment?.label : void 0);
		return (t, o) => (f(), i(e, null, [l.value ? (f(), n(Im, {
			key: 0,
			title: y(s)("barcode")
		}, {
			default: x(() => [c(Pm, {
				barcode: l.value.barcode,
				"track-trace-link": a.trackTrace?.link_tracktrace
			}, null, 8, ["barcode", "track-trace-link"])]),
			_: 1
		}, 8, ["title"])) : r("", !0), a.trackTrace?.partner_tracktraces.length ? (f(), n(Im, {
			key: 1,
			title: y(s)("trackTracePanel.details.partnerBarcode")
		}, {
			default: x(() => [(f(!0), i(e, null, h(a.trackTrace.partner_tracktraces, (e) => (f(), i("div", {
				key: e.barcode,
				class: "border-b border-b-gray-400 last:border-b-0 py-2 first:pt-0 last:pb-0"
			}, [c(Pm, {
				barcode: e.barcode,
				"track-trace-link": e.uri
			}, null, 8, ["barcode", "track-trace-link"])]))), 128))]),
			_: 1
		}, 8, ["title"])) : r("", !0)], 64));
	}
}), Rm = { key: 0 }, zm = { key: 1 }, Bm = { key: 2 }, Vm = { key: 1 }, Hm = /* @__PURE__ */ l({
	__name: "DeliveryDetails",
	props: { package: {} },
	setup(a) {
		let o = a, { t: s } = Fe(), c = t(() => o.package?.shipment?.delivery?.type ? [Es.MORNING_DELIVERY, Es.EVENING_DELIVERY].includes(o.package.shipment.delivery.type) : !1), l = t(() => o.package?.shipment?.pickup || c.value || o.package?.shipment?.options?.saturdayDelivery);
		return (t, u) => l.value || a.package.shipment?.dropOff?.date ? (f(), n(Im, {
			key: 0,
			title: y(s)("shipping.adjustedDelivery.title")
		}, {
			default: x(() => [l.value ? (f(), i(e, { key: 0 }, [
				a.package.shipment?.pickup ? (f(), i("p", Rm, v(y(s)("trackTracePanel.details.pickupAtPostalPoint", { locationName: a.package.shipment.pickup.location.name })), 1)) : r("", !0),
				c.value ? (f(), i("p", zm, v(o.package.shipment.delivery.type), 1)) : r("", !0),
				a.package.shipment?.options?.saturdayDelivery ? (f(), i("p", Bm, v(y(s)("shipping.shipmentOption.saturdayDelivery")), 1)) : r("", !0)
			], 64)) : r("", !0), a.package.shipment?.dropOff?.date ? (f(), i("p", Vm, v(y(s)("trackTracePanel.details.deliverOnDate", { date: a.package.shipment.dropOff.date })), 1)) : r("", !0)]),
			_: 1
		}, 8, ["title"])) : r("", !0);
	}
}), Um = { key: 0 }, Wm = { key: 1 }, Gm = /* @__PURE__ */ l({
	__name: "InsuranceDetails",
	props: { package: {} },
	setup(e) {
		let r = e, { t: a } = Fe(), o = t(() => {
			if (r.package.shipment?.options?.insurance !== void 0) return r.package.shipment.options.insurance.amount;
		});
		return (e, t) => (f(), n(Im, { title: y(a)("shipping.shipmentOption.insurance") }, {
			default: x(() => [o.value ? (f(), i("p", Um, [c(Nm, { price: o.value }, null, 8, ["price"])])) : (f(), i("p", Wm, v(y(a)("trackTracePanel.details.notInsured")), 1))]),
			_: 1
		}, 8, ["title"]));
	}
}), Km = { key: 0 }, qm = { key: 1 }, Jm = { key: 2 }, Ym = { key: 3 }, Xm = { key: 0 }, Zm = { key: 1 }, Qm = { key: 2 }, $m = { key: 3 }, eh = /* @__PURE__ */ l({
	__name: "PhysicalDetails",
	props: {
		package: {},
		carrierPhysicalProperties: {}
	},
	setup(n) {
		let r = n, { t: a } = Fe(), o = (e) => `${e.value} ${a(cm(e.unit))}`, s = (e) => {
			let t = e?.weight;
			if (!t) return;
			let n = im(t, nm.GRAM);
			if (n >= 1e3) {
				let e = im(t, nm.KILOGRAM);
				return o({
					value: Math.round(e),
					unit: nm.KILOGRAM
				});
			}
			return o({
				value: n,
				unit: nm.GRAM
			});
		}, l = (e) => {
			let t = e;
			if (!(!t || !t.length || !t.width || !t.height)) return [
				Math.round(lm(t.length, am.CENTIMETER)),
				Math.round(lm(t.width, am.CENTIMETER)),
				Math.round(lm(t.height, am.CENTIMETER))
			].join(" x ").concat(" ", a("unit.centimeter.short"));
		}, u = t(() => s(r.package.physicalProperties)), d = t(() => s(r.carrierPhysicalProperties)), p = t(() => l(r.package.physicalProperties)), m = t(() => l(r.carrierPhysicalProperties));
		return (t, n) => (f(), i(e, null, [c(Im, { title: y(a)("shipping.dimensions.weight") }, {
			default: x(() => [u.value ? (f(), i("p", Km, v(y(a)("trackTracePanel.details.dimensions.user")) + " " + v(u.value), 1)) : (f(), i("p", qm, v(y(a)("trackTracePanel.details.dimensions.user")) + " " + v(y(a)("trackTracePanel.details.noWeightSpecified")), 1)), d.value ? (f(), i("p", Jm, v(y(a)("trackTracePanel.details.dimensions.carrier")) + " " + v(d.value), 1)) : (f(), i("p", Ym, v(y(a)("trackTracePanel.details.dimensions.carrier")) + " " + v(y(a)("trackTracePanel.details.noWeightSpecified")), 1))]),
			_: 1
		}, 8, ["title"]), c(Im, { title: y(a)("trackTracePanel.details.dimensions.title") }, {
			default: x(() => [p.value ? (f(), i("p", Xm, v(y(a)("trackTracePanel.details.dimensions.user")) + " " + v(p.value), 1)) : (f(), i("p", Zm, v(y(a)("trackTracePanel.details.dimensions.user")) + " " + v(y(a)("trackTracePanel.details.dimensions.notSpecified")), 1)), m.value ? (f(), i("p", Qm, v(y(a)("trackTracePanel.details.dimensions.carrier")) + " " + v(m.value), 1)) : (f(), i("p", $m, v(y(a)("trackTracePanel.details.dimensions.carrier")) + " " + v(y(a)("trackTracePanel.details.dimensions.notSpecified")), 1))]),
			_: 1
		}, 8, ["title"])], 64));
	}
}), th = { class: "flex flex-col" }, nh = { class: "flex flex-row gap-2" }, rh = { class: "basis-1/3" }, ih = { class: "basis-2/3" }, ah = { key: 0 }, oh = { key: 1 }, sh = { class: "flex flex-row gap-2" }, ch = { class: "basis-1/3" }, lh = { class: "basis-2/3" }, uh = { key: 1 }, dh = /* @__PURE__ */ l({
	__name: "RecipientDetails",
	props: {
		address: {},
		contact: {}
	},
	setup(t) {
		let { t: n } = Fe();
		return (r, o) => (f(), i(e, null, [c(Im, { title: y(n)("location.address.address") }, {
			default: x(() => [c(Em, {
				address: t.address,
				contact: t.contact,
				"show-full-country-name": ""
			}, null, 8, ["address", "contact"])]),
			_: 1
		}, 8, ["title"]), c(Im, { title: y(n)("trackTracePanel.details.contact") }, {
			default: x(() => [a("dl", th, [a("div", nh, [a("dt", rh, v(y(n)("trackTracePanel.details.phone")), 1), a("dd", ih, [t.contact.phoneNumber ? (f(), i("span", ah, v(t.contact.phoneNumber), 1)) : (f(), i("span", oh, v(y(n)("trackTracePanel.details.noPhoneNumber")), 1))])]), a("div", sh, [a("dt", ch, v(y(n)("trackTracePanel.details.email", t.contact.emailAddresses?.length)), 1), a("div", lh, [t.contact.emailAddresses?.length ? (f(!0), i(e, { key: 0 }, h(t.contact.emailAddresses, (e) => (f(), i("dd", { key: e }, v(e), 1))), 128)) : (f(), i("div", uh, v(y(n)("trackTracePanel.details.noEmailAddress")), 1))])])])]),
			_: 1
		}, 8, ["title"])], 64));
	}
}), I = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18,
	Spring: 19,
	ViaTim: 20,
	DhlFreight: 21
}, L = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	Spring: "spring",
	SPRING: "SPRING",
	ViaTim: "viatim",
	VIA_TIM: "VIA_TIM",
	DhlFreight: "dhlfreight",
	DHL_FREIGHT: "DHL_FREIGHT"
};
I.Dhl, I.Instabox, I.PostNl, L.PostNl, I.Bpost, L.Bpost, I.CheapCargo, L.CheapCargo, I.Dpd, L.Dpd, I.Instabox, L.Instabox, I.Dhl, L.Dhl, I.Bol, L.Bol, I.Ups, L.Ups, I.DhlForYou, L.DhlForYou, I.DhlParcelConnect, L.DhlParcelConnect, I.DhlEuroPlus, L.DhlEuroPlus, I.UpsStandard, L.UpsStandard, I.UpsExpressSaver, L.UpsExpressSaver, I.Gls, L.Gls, I.Brt, L.Brt, I.Trunkrs, L.Trunkrs, I.InPost, L.InPost, I.PosteItaliane, L.PosteItaliane, I.Spring, L.Spring, I.ViaTim, L.ViaTim, I.DhlFreight, L.DhlFreight, I.PostNl, L.POSTNL, I.Bpost, L.BPOST, I.CheapCargo, L.CHEAP_CARGO, I.Dpd, L.DPD, I.Instabox, L.INSTABOX, I.Dhl, L.DHL, I.Bol, L.BOL, I.Ups, L.UPS, I.DhlForYou, L.DHL_FOR_YOU, I.DhlParcelConnect, L.DHL_PARCEL_CONNECT, I.DhlEuroPlus, L.DHL_EUROPLUS, I.UpsStandard, L.UPS_STANDARD, I.UpsExpressSaver, L.UPS_EXPRESS_SAVER, I.Gls, L.GLS, I.Brt, L.BRT, I.Trunkrs, L.TRUNKRS, I.InPost, L.INPOST, I.PosteItaliane, L.POSTE_ITALIANE, I.Spring, L.SPRING, I.ViaTim, L.VIA_TIM, I.DhlFreight, L.DHL_FREIGHT, L.POSTNL, I.PostNl, L.BPOST, I.Bpost, L.CHEAP_CARGO, I.CheapCargo, L.DPD, I.Dpd, L.INSTABOX, I.Instabox, L.DHL, I.Dhl, L.BOL, I.Bol, L.UPS, I.Ups, L.DHL_FOR_YOU, I.DhlForYou, L.DHL_PARCEL_CONNECT, I.DhlParcelConnect, L.DHL_EUROPLUS, I.DhlEuroPlus, L.UPS_STANDARD, I.UpsStandard, L.UPS_EXPRESS_SAVER, I.UpsExpressSaver, L.GLS, I.Gls, L.BRT, I.Brt, L.TRUNKRS, I.Trunkrs, L.INPOST, I.InPost, L.POSTE_ITALIANE, I.PosteItaliane, L.SPRING, I.Spring, L.VIA_TIM, I.ViaTim, L.DHL_FREIGHT, I.DhlFreight, L.PostNl, I.PostNl, L.POSTNL, I.PostNl, L.Bpost, I.Bpost, L.BPOST, I.Bpost, L.CheapCargo, I.CheapCargo, L.CHEAP_CARGO, I.CheapCargo, L.Dpd, I.Dpd, L.DPD, I.Dpd, L.Instabox, I.Instabox, L.Dhl, I.Dhl, L.BolCom, I.Bol, L.Bol, I.Bol, L.BOL, I.Bol, L.Ups, I.Ups, L.DhlForYou, I.DhlForYou, L.DHL_FOR_YOU, I.DhlForYou, L.DhlParcelConnect, I.DhlParcelConnect, L.DHL_PARCEL_CONNECT, I.DhlParcelConnect, L.DhlEuroPlus, I.DhlEuroPlus, L.DHL_EUROPLUS, I.DhlEuroPlus, L.UpsStandard, I.UpsStandard, L.UPS_STANDARD, I.UpsStandard, L.UpsExpressSaver, I.UpsExpressSaver, L.UPS_EXPRESS_SAVER, I.UpsExpressSaver, L.Gls, I.Gls, L.GLS, I.Gls, L.Brt, I.Brt, L.BRT, I.Brt, L.Trunkrs, I.Trunkrs, L.TRUNKRS, I.Trunkrs, L.InPost, I.InPost, L.INPOST, I.InPost, L.PosteItaliane, I.PosteItaliane, L.POSTE_ITALIANE, I.PosteItaliane, L.Spring, I.Spring, L.SPRING, I.Spring, L.ViaTim, I.ViaTim, L.VIA_TIM, I.ViaTim, L.DhlFreight, I.DhlFreight, L.DHL_FREIGHT, I.DhlFreight, I.PostNl, I.Bpost, I.CheapCargo, I.Dpd, I.Instabox, I.Dhl, I.Bol, I.Ups, I.DhlForYou, I.DhlParcelConnect, I.DhlEuroPlus, I.UpsStandard, I.UpsExpressSaver, I.Gls, I.Brt, I.Trunkrs, I.InPost, I.PosteItaliane, I.Spring, I.ViaTim, I.DhlFreight;
var R = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
};
R.Austria, R.Belgium, R.Bulgaria, R.Croatia, R.Cyprus, R.CzechRepublic, R.Denmark, R.Estonia, R.Finland, R.France, R.Germany, R.Greece, R.Hungary, R.Ireland, R.Italy, R.Latvia, R.Lithuania, R.Luxembourg, R.Malta, R.Netherlands, R.Poland, R.Portugal, R.Romania, R.Slovakia, R.Slovenia, R.Spain, R.Sweden, Object.values(R), R.Angola, R.AntiguaAndBarbuda, R.Aruba, R.Bahamas, R.Belize, R.Benin, R.Bermuda, R.BonaireSintEustatiusAndSaba, R.Botswana, R.BurkinaFaso, R.Burundi, R.Cameroon, R.CanaryIslands, R.CentralAfricanRepublic, R.Comoros, R.CongoBrazzaville, R.CongoKinshasa, R.CoteDIvoire, R.Curacao, R.Djibouti, R.Dominica, R.DutchAntilles, R.EquatorialGuinea, R.Eritrea, R.Fiji, R.Gabon, R.Gambia, R.Ghana, R.Grenada, R.Guyana, R.HongKong, R.Kiribati, R.KoreaPeoplesDemocraticRepublic, R.Macao, R.Malawi, R.Mali, R.Mauritania, R.Nauru, R.Qatar, R.Rwanda, R.SaintKittsAndNevis, R.SaoTomeAndPrincipe, R.Seychelles, R.SierraLeone, R.SintMaarten, R.Suriname, R.SyrianArabRepublic, R.TimorLeste, R.Togo, R.Tonga, R.Tuvalu, R.Uganda, R.UnitedArabEmirates, R.Vanuatu, R.Yemen, R.Zimbabwe, R.Austria, R.Belgium, R.Bulgaria, R.Croatia, R.CzechRepublic, R.Estonia, R.Finland, R.France, R.Germany, R.Greece, R.Hungary, R.Ireland, R.Italy, R.Latvia, R.Lithuania, R.Luxembourg, R.Malta, R.Netherlands, R.Portugal, R.Romania, R.Slovakia, R.Slovenia, R.Spain, R.UnitedKingdom, R.Denmark, R.Germany, R.Sweden;
var fh = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, ph = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, mh = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
};
fh.EarlyMorning, ph.EarlyMorning, fh.Morning, ph.Morning, fh.Standard, ph.Standard, fh.Evening, ph.Evening, fh.Pickup, ph.Pickup, fh.PickupExpress, ph.PickupExpress, fh.SameDayDelivery, ph.SameDayDelivery, fh.Express, ph.Express, ph.EarlyMorning, fh.EarlyMorning, ph.Morning, fh.Morning, ph.Standard, fh.Standard, ph.Evening, fh.Evening, ph.Pickup, fh.Pickup, ph.PickupExpress, fh.PickupExpress, ph.SameDayDelivery, fh.SameDayDelivery, ph.Express, fh.Express, fh.EarlyMorning, mh.EarlyMorning, fh.Morning, mh.Morning, fh.Standard, mh.Standard, fh.Evening, mh.Evening, fh.Pickup, mh.Pickup, fh.PickupExpress, mh.PickupExpress, fh.SameDayDelivery, mh.SameDayDelivery, fh.Express, mh.Express, mh.EarlyMorning, ph.EarlyMorning, mh.Morning, ph.Morning, mh.Standard, ph.Standard, mh.Evening, ph.Evening, mh.Pickup, ph.Pickup, mh.PickupExpress, ph.PickupExpress, mh.SameDayDelivery, ph.SameDayDelivery, mh.Express, ph.Express, fh.EarlyMorning, fh.Morning, fh.Standard, fh.Evening, fh.Pickup, fh.PickupExpress, fh.SameDayDelivery, fh.Express, { Vasco: 1 }.Vasco, { Vasco: "vasco" }.Vasco;
var hh = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, gh = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
};
gh.Sunday, hh.Sunday, gh.Monday, hh.Monday, gh.Tuesday, hh.Tuesday, gh.Wednesday, hh.Wednesday, gh.Thursday, hh.Thursday, gh.Friday, hh.Friday, gh.Saturday, hh.Saturday, hh.Sunday, gh.Sunday, hh.Monday, gh.Monday, hh.Tuesday, gh.Tuesday, hh.Wednesday, gh.Wednesday, hh.Thursday, gh.Thursday, hh.Friday, gh.Friday, hh.Saturday, gh.Saturday;
var _h = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
};
_h.Bytes, _h.Kilobytes, _h.Megabytes, _h.Gigabytes, _h.Terabytes;
var vh = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, yh = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
};
vh.Bol, yh.Bol, vh.Exact, yh.Exact, vh.Amazon, yh.Amazon, vh.Wix, yh.Wix, vh.ExactDe, yh.ExactDe, vh.Etsy, yh.Etsy, yh.Bol, vh.Bol, yh.Exact, vh.Exact, yh.Amazon, vh.Amazon, yh.Wix, vh.Wix, yh.ExactDe, vh.ExactDe, yh.Etsy, vh.Etsy;
var bh = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, xh = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
};
bh.Unpaid, xh.Unpaid, bh.Due, xh.Due, bh.DuePrepayment, xh.DuePrepayment, bh.Reminder1, xh.Reminder1, bh.Reminder2, xh.Reminder2, bh.Dun, xh.Dun, bh.Collection, xh.Collection, bh.Instalments, xh.Instalments, bh.PaymentArrangement, xh.PaymentArrangement, bh.Dispute, xh.Dispute, bh.LegalProcedure, xh.LegalProcedure, bh.Insolvency, xh.Insolvency, bh.WriteOff, xh.WriteOff, bh.Pending, xh.Pending, bh.Cancelled, xh.Cancelled, bh.Paid, xh.Paid, bh.PaidOnline, xh.PaidOnline, bh.PaidAutomatic, xh.PaidAutomatic, bh.PaidCredit, xh.PaidCredit, bh.PaidZeroItems, xh.PaidZeroItems, bh.InvoiceWith0InvoiceItemsPaidZeroBalance, xh.PaidZeroBalance, bh.Due, bh.Reminder1, bh.Reminder2, bh.Dun, bh.Collection, bh.Instalments, bh.PaymentArrangement, bh.Dispute, bh.Paid, bh.PaidOnline, bh.PaidAutomatic, bh.PaidCredit, bh.PaidZeroItems;
var Sh = {
	Gram: "g",
	Kilogram: "kg"
};
Sh.Gram, Sh.Kilogram;
var Ch = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
};
Ch.Millimeter, Ch.Centimeter, Ch.Meter;
var wh = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, Th = {
	Delivered: "delivered",
	Dispatching: "dispatching",
	Distributing: "distributing",
	PickingAndPacking: "pickingAndPacking",
	Sorting: "sorting",
	Untraceable: "untraceable"
}, Eh = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnRouteHandedToCarrier: 3,
	EnRouteSorting: 4,
	EnRouteDistribution: 5,
	EnRouteCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedLetter: 12,
	InactiveCredited: 13,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnRouteHandedToCarrier: 32,
	InactiveEnRouteSorting: 33,
	InactiveEnRouteDistribution: 34,
	InactiveEnRouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38
};
Eh.PendingConcept, Eh.PendingRegistered, Eh.EnRouteHandedToCarrier, Eh.EnRouteSorting, Eh.EnRouteDistribution, Eh.EnRouteCustoms, Eh.DeliveredReadyForPickup, Eh.DeliveredAtRecipient, Eh.DeliveredPackagePickedUp;
var Dh = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, Oh = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
};
Oh.Light, Dh.Light, Oh.Start, Dh.Start, Oh.Plus, Dh.Plus, Oh.Premium, Dh.Premium, Oh.Max, Dh.Max, Dh.Light, Oh.Light, Dh.Start, Oh.Start, Dh.Plus, Oh.Plus, Dh.Premium, Oh.Premium, Dh.Max, Oh.Max;
var kh = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, Ah = {
	Start: Dh.Start,
	Plus: Dh.Plus,
	Premium: Dh.Premium,
	Max: Dh.Max
};
kh.Start, Ah.Start, kh.Plus, Ah.Plus, kh.Premium, Ah.Premium, kh.Max, Ah.Max, Ah.Start, kh.Start, Ah.Plus, kh.Plus, Ah.Premium, kh.Premium, Ah.Max, kh.Max;
var jh = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, Mh = {
	Start: Dh.Start,
	Plus: Dh.Plus,
	Premium: Dh.Premium,
	Max: Dh.Max
};
jh.Start, Mh.Start, jh.Plus, Mh.Plus, jh.Premium, Mh.Premium, jh.Max, Mh.Max, Mh.Start, jh.Start, Mh.Plus, jh.Plus, Mh.Premium, jh.Premium, Mh.Max, jh.Max;
var Nh = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, Ph = {
	Light: Dh.Light,
	Start: Dh.Start,
	Plus: Dh.Plus,
	Premium: Dh.Premium,
	Max: Dh.Max
};
Nh.Light, Ph.Light, Nh.Start, Ph.Start, Nh.Plus, Ph.Plus, Nh.Premium, Ph.Premium, Nh.Max, Ph.Max, Ph.Light, Nh.Light, Ph.Start, Nh.Start, Ph.Plus, Nh.Plus, Ph.Premium, Nh.Premium, Ph.Max, Nh.Max;
var Fh = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, Ih = {
	Start: Dh.Start,
	Plus: Dh.Plus,
	Premium: Dh.Premium,
	Max: Dh.Max
};
Fh.Start, Ih.Start, Fh.Plus, Ih.Plus, Fh.Premium, Ih.Premium, Fh.Max, Ih.Max, Ih.Start, Fh.Start, Ih.Plus, Fh.Plus, Ih.Premium, Fh.Premium, Ih.Max, Fh.Max;
var Lh = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, Rh = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, zh = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
};
Lh.MyParcel, Rh.MyParcel, Lh.Flespakket, Rh.Flespakket, Lh.SendMyParcel, Rh.SendMyParcel, Lh.MyParcelIt, Rh.MyParcelIt, Lh.DeliverDutch, Rh.DeliverDutch, Lh.PostNlPlugin, Rh.PostNlPlugin, Lh.MyParcel, zh.MyParcelNl, Lh.Flespakket, zh.MyParcelNl, Lh.SendMyParcel, zh.MyParcelBe, Lh.MyParcelIt, zh.MyParcelIt, Lh.DeliverDutch, zh.DeliverDutch, Lh.PostNlPlugin, zh.PostNlPlugin, zh.MyParcelNl, Lh.MyParcel, zh.MyParcelBe, Lh.SendMyParcel, zh.MyParcelIt, Lh.MyParcelIt, zh.MyParcelNl, wh.HomeCountry, R.Netherlands, wh.Eu, wh.Row, R.Belgium, zh.MyParcelBe, wh.HomeCountry, R.Belgium, R.Netherlands, wh.Eu, wh.Row, zh.MyParcelBe, wh.HomeCountry, R.Belgium, wh.Eu, wh.Row, zh.MyParcelNl, wh.HomeCountry, R.Netherlands, wh.Eu, wh.Row, zh.MyParcelNl, wh.HomeCountry, R.Netherlands, R.Belgium, R.Luxembourg, I.Bpost, I.PostNl, I.DhlForYou, I.DhlParcelConnect, I.DhlEuroPlus, I.Ups, I.UpsStandard, I.UpsExpressSaver;
var Bh = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, Vh = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
};
Bh.Package, Vh.Package, Bh.Mailbox, Vh.Mailbox, Bh.Letter, Vh.Letter, Bh.DigitalStamp, Vh.DigitalStamp, Bh.Pallet, Vh.Pallet, Bh.PackageSmall, Vh.PackageSmall, Bh.Envelope, Vh.Envelope, Vh.Package, Bh.Package, Vh.Mailbox, Bh.Mailbox, Vh.Letter, Bh.Letter, Vh.DigitalStamp, Bh.DigitalStamp, Vh.Pallet, Bh.Pallet, Vh.PackageSmall, Bh.PackageSmall, Vh.Envelope, Bh.Envelope;
var Hh = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
};
Bh.Package, Hh.PACKAGE, Bh.Mailbox, Hh.MAILBOX, Bh.Letter, Hh.UNFRANKED, Bh.DigitalStamp, Hh.DIGITAL_STAMP, Bh.Pallet, Hh.PALLET, Bh.PackageSmall, Hh.SMALL_PACKAGE, Bh.Envelope, Hh.ENVELOPE, Hh.PACKAGE, Bh.Package, Hh.MAILBOX, Bh.Mailbox, Hh.UNFRANKED, Bh.Letter, Hh.DIGITAL_STAMP, Bh.DigitalStamp, Hh.PALLET, Bh.Pallet, Hh.SMALL_PACKAGE, Bh.PackageSmall, Hh.ENVELOPE, Bh.Envelope, Bh.Package, Bh.Mailbox, Bh.Letter, Bh.DigitalStamp, Bh.Pallet, Bh.PackageSmall, Bh.Envelope;
var Uh = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
};
Uh.PendingConcept, Uh.PendingRegistered, Uh.EnrouteHandedToCarrier, Uh.EnrouteSorting, Uh.EnrouteDistribution, Uh.DeliveredAtCustoms, Uh.DeliveredAtRecipient, Uh.DeliveredPackagePickedUp, Uh.DeliveredReturnShipmentPackagePickedUp, Uh.DeliveredAtAgreedLocation, Uh.PrintedLetter, Uh.PrintedDigitalStamp, Uh.InactiveConcept, Uh.InactiveRegistered, Uh.InactiveEnrouteHandedToCarrier, Uh.InactiveEnrouteSorting, Uh.InactiveEnrouteDistribution, Uh.InactiveEnrouteCustoms, Uh.InactiveDeliveredAtRecipient, Uh.InactiveDeliveredReadyForPickup, Uh.InactiveDeliveredPackagePickedUp, Eh.PendingConcept, Eh.PendingRegistered, Eh.EnRouteHandedToCarrier, Eh.EnRouteSorting, Eh.EnRouteDistribution, Eh.EnRouteCustoms, Eh.DeliveredAtRecipient, Eh.DeliveredReadyForPickup, Eh.DeliveredPackagePickedUp, Eh.DeliveredReturnShipmentReadyForPickup, Eh.DeliveredReturnShipmentPackagePickedUp, Eh.PrintedLetter, Eh.InactiveCredited, Eh.PrintedDigitalStamp, Eh.Expired, Eh.Cancelled, Eh.InactiveConcept, Eh.InactiveRegistered, Eh.InactiveEnRouteHandedToCarrier, Eh.InactiveEnRouteSorting, Eh.InactiveEnRouteDistribution, Eh.InactiveEnRouteCustoms, Eh.InactiveDeliveredAtRecipient, Eh.InactiveDeliveredReadyForPickup, Eh.InactiveDeliveredPackagePickedUp, Th.Dispatching, Eh.PendingConcept, Eh.PendingRegistered, Eh.EnRouteHandedToCarrier, Eh.Cancelled, Th.Sorting, Eh.EnRouteSorting, Th.Distributing, Eh.EnRouteDistribution, Eh.EnRouteCustoms, Eh.DeliveredReadyForPickup, Eh.DeliveredReturnShipmentPackagePickedUp, Th.PickingAndPacking, Th.Delivered, Eh.DeliveredAtRecipient, Eh.DeliveredPackagePickedUp, Eh.DeliveredReturnShipmentReadyForPickup, Th.Untraceable, Eh.PrintedLetter, Eh.PrintedDigitalStamp;
function Wh(e) {
	return e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
}
var Gh = /\p{Lu}?\p{Ll}+|[0-9]+|\p{Lu}+(?!\p{Ll})|\p{Emoji_Presentation}|\p{Extended_Pictographic}|\p{L}+/gu;
function Kh(e) {
	return Array.from(e.match(Gh) ?? []);
}
function qh(e) {
	let t = Kh(e);
	if (t.length === 0) return "";
	let [n, ...r] = t;
	return `${n.toLowerCase()}${r.map((e) => Wh(e)).join("")}`;
}
var Jh = (e, t) => {
	let n = e(t);
	return typeof n == "string" ? n.length > 0 : !!n && typeof n == "object" && Object.keys(n).length > 0;
}, Yh = (e, t, n) => {
	let r = n ? qh(n) : void 0, i = qh(t), a = `shipping.shipmentOption.${i}`, o;
	return r && Jh(e, `shipping.shipmentOption.exceptions.${r}.${i}`) && (a = `shipping.shipmentOption.exceptions.${r}.${i}`), Jh(e, `shipmentOption.${i}.note`) && (o = `shipmentOption.${i}.note`), r && Jh(e, `shipmentOption.exceptions.${r}.${i}.note`) && (o = `shipmentOption.exceptions.${r}.${i}.note`), {
		label: a,
		note: o ? { keypath: o } : void 0
	};
};
Object.freeze({ status: "aborted" });
function z(e, t, n) {
	function r(n, r) {
		var i;
		Object.defineProperty(n, "_zod", {
			value: n._zod ?? {},
			enumerable: !1
		}), (i = n._zod).traits ?? (i.traits = /* @__PURE__ */ new Set()), n._zod.traits.add(e), t(n, r);
		for (let e in o.prototype) e in n || Object.defineProperty(n, e, { value: o.prototype[e].bind(n) });
		n._zod.constr = o, n._zod.def = r;
	}
	let i = n?.Parent ?? Object;
	class a extends i {}
	Object.defineProperty(a, "name", { value: e });
	function o(e) {
		var t;
		let i = n?.Parent ? new a() : this;
		r(i, e), (t = i._zod).deferred ?? (t.deferred = []);
		for (let e of i._zod.deferred) e();
		return i;
	}
	return Object.defineProperty(o, "init", { value: r }), Object.defineProperty(o, Symbol.hasInstance, { value: (t) => n?.Parent && t instanceof n.Parent ? !0 : t?._zod?.traits?.has(e) }), Object.defineProperty(o, "name", { value: e }), o;
}
var Xh = class extends Error {
	constructor() {
		super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
	}
}, Zh = class extends Error {
	constructor(e) {
		super(`Encountered unidirectional transform during encode: ${e}`), this.name = "ZodEncodeError";
	}
}, Qh = {};
function $h(e) {
	return e && Object.assign(Qh, e), Qh;
}
function eg(e) {
	let t = Object.values(e).filter((e) => typeof e == "number");
	return Object.entries(e).filter(([e, n]) => t.indexOf(+e) === -1).map(([e, t]) => t);
}
function tg(e, t) {
	return typeof t == "bigint" ? t.toString() : t;
}
function ng(e) {
	return { get value() {
		{
			let t = e();
			return Object.defineProperty(this, "value", { value: t }), t;
		}
	} };
}
function rg(e) {
	return e == null;
}
function ig(e) {
	let t = +!!e.startsWith("^"), n = e.endsWith("$") ? e.length - 1 : e.length;
	return e.slice(t, n);
}
function ag(e, t) {
	let n = (e.toString().split(".")[1] || "").length, r = t.toString(), i = (r.split(".")[1] || "").length;
	if (i === 0 && /\d?e-\d?/.test(r)) {
		let e = r.match(/\d?e-(\d?)/);
		e?.[1] && (i = Number.parseInt(e[1]));
	}
	let a = n > i ? n : i;
	return Number.parseInt(e.toFixed(a).replace(".", "")) % Number.parseInt(t.toFixed(a).replace(".", "")) / 10 ** a;
}
var og = Symbol("evaluating");
function sg(e, t, n) {
	let r;
	Object.defineProperty(e, t, {
		get() {
			if (r !== og) return r === void 0 && (r = og, r = n()), r;
		},
		set(n) {
			Object.defineProperty(e, t, { value: n });
		},
		configurable: !0
	});
}
function cg(e) {
	return Object.create(Object.getPrototypeOf(e), Object.getOwnPropertyDescriptors(e));
}
function lg(e, t, n) {
	Object.defineProperty(e, t, {
		value: n,
		writable: !0,
		enumerable: !0,
		configurable: !0
	});
}
function ug(...e) {
	let t = {};
	for (let n of e) {
		let e = Object.getOwnPropertyDescriptors(n);
		Object.assign(t, e);
	}
	return Object.defineProperties({}, t);
}
function dg(e) {
	return JSON.stringify(e);
}
var fg = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {};
function pg(e) {
	return typeof e == "object" && !!e && !Array.isArray(e);
}
var mg = ng(() => {
	if (typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare")) return !1;
	try {
		return Function(""), !0;
	} catch {
		return !1;
	}
});
function hg(e) {
	if (pg(e) === !1) return !1;
	let t = e.constructor;
	if (t === void 0) return !0;
	let n = t.prototype;
	return pg(n) !== !1 && Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") !== !1;
}
function gg(e) {
	return hg(e) ? { ...e } : e;
}
var _g = /* @__PURE__ */ new Set([
	"string",
	"number",
	"symbol"
]);
function vg(e) {
	return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function yg(e, t, n) {
	let r = new e._zod.constr(t ?? e._zod.def);
	return (!t || n?.parent) && (r._zod.parent = e), r;
}
function B(e) {
	let t = e;
	if (!t) return {};
	if (typeof t == "string") return { error: () => t };
	if (t?.message !== void 0) {
		if (t?.error !== void 0) throw Error("Cannot specify both `message` and `error` params");
		t.error = t.message;
	}
	return delete t.message, typeof t.error == "string" ? {
		...t,
		error: () => t.error
	} : t;
}
function bg(e) {
	return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
var xg = {
	safeint: [-(2 ** 53 - 1), 2 ** 53 - 1],
	int32: [-2147483648, 2147483647],
	uint32: [0, 4294967295],
	float32: [-34028234663852886e22, 34028234663852886e22],
	float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function Sg(e, t) {
	let n = e._zod.def;
	return yg(e, ug(e._zod.def, {
		get shape() {
			let e = {};
			for (let r in t) {
				if (!(r in n.shape)) throw Error(`Unrecognized key: "${r}"`);
				t[r] && (e[r] = n.shape[r]);
			}
			return lg(this, "shape", e), e;
		},
		checks: []
	}));
}
function Cg(e, t) {
	let n = e._zod.def;
	return yg(e, ug(e._zod.def, {
		get shape() {
			let r = { ...e._zod.def.shape };
			for (let e in t) {
				if (!(e in n.shape)) throw Error(`Unrecognized key: "${e}"`);
				t[e] && delete r[e];
			}
			return lg(this, "shape", r), r;
		},
		checks: []
	}));
}
function wg(e, t) {
	if (!hg(t)) throw Error("Invalid input to extend: expected a plain object");
	let n = e._zod.def.checks;
	if (n && n.length > 0) throw Error("Object schemas containing refinements cannot be extended. Use `.safeExtend()` instead.");
	return yg(e, ug(e._zod.def, {
		get shape() {
			let n = {
				...e._zod.def.shape,
				...t
			};
			return lg(this, "shape", n), n;
		},
		checks: []
	}));
}
function Tg(e, t) {
	if (!hg(t)) throw Error("Invalid input to safeExtend: expected a plain object");
	return yg(e, {
		...e._zod.def,
		get shape() {
			let n = {
				...e._zod.def.shape,
				...t
			};
			return lg(this, "shape", n), n;
		},
		checks: e._zod.def.checks
	});
}
function Eg(e, t) {
	return yg(e, ug(e._zod.def, {
		get shape() {
			let n = {
				...e._zod.def.shape,
				...t._zod.def.shape
			};
			return lg(this, "shape", n), n;
		},
		get catchall() {
			return t._zod.def.catchall;
		},
		checks: []
	}));
}
function Dg(e, t, n) {
	return yg(t, ug(t._zod.def, {
		get shape() {
			let r = t._zod.def.shape, i = { ...r };
			if (n) for (let t in n) {
				if (!(t in r)) throw Error(`Unrecognized key: "${t}"`);
				n[t] && (i[t] = e ? new e({
					type: "optional",
					innerType: r[t]
				}) : r[t]);
			}
			else for (let t in r) i[t] = e ? new e({
				type: "optional",
				innerType: r[t]
			}) : r[t];
			return lg(this, "shape", i), i;
		},
		checks: []
	}));
}
function Og(e, t, n) {
	return yg(t, ug(t._zod.def, {
		get shape() {
			let r = t._zod.def.shape, i = { ...r };
			if (n) for (let t in n) {
				if (!(t in i)) throw Error(`Unrecognized key: "${t}"`);
				n[t] && (i[t] = new e({
					type: "nonoptional",
					innerType: r[t]
				}));
			}
			else for (let t in r) i[t] = new e({
				type: "nonoptional",
				innerType: r[t]
			});
			return lg(this, "shape", i), i;
		},
		checks: []
	}));
}
function kg(e, t = 0) {
	if (e.aborted === !0) return !0;
	for (let n = t; n < e.issues.length; n++) if (e.issues[n]?.continue !== !0) return !0;
	return !1;
}
function Ag(e, t) {
	return t.map((t) => {
		var n;
		return (n = t).path ?? (n.path = []), t.path.unshift(e), t;
	});
}
function jg(e) {
	return typeof e == "string" ? e : e?.message;
}
function Mg(e, t, n) {
	let r = {
		...e,
		path: e.path ?? []
	};
	return e.message || (r.message = jg(e.inst?._zod.def?.error?.(e)) ?? jg(t?.error?.(e)) ?? jg(n.customError?.(e)) ?? jg(n.localeError?.(e)) ?? "Invalid input"), delete r.inst, delete r.continue, t?.reportInput || delete r.input, r;
}
function Ng(e) {
	return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function Pg(...e) {
	let [t, n, r] = e;
	return typeof t == "string" ? {
		message: t,
		code: "custom",
		input: n,
		inst: r
	} : { ...t };
}
var Fg = (e, t) => {
	e.name = "$ZodError", Object.defineProperty(e, "_zod", {
		value: e._zod,
		enumerable: !1
	}), Object.defineProperty(e, "issues", {
		value: t,
		enumerable: !1
	}), e.message = JSON.stringify(t, tg, 2), Object.defineProperty(e, "toString", {
		value: () => e.message,
		enumerable: !1
	});
}, Ig = z("$ZodError", Fg), Lg = z("$ZodError", Fg, { Parent: Error });
function Rg(e, t = (e) => e.message) {
	let n = {}, r = [];
	for (let i of e.issues) i.path.length > 0 ? (n[i.path[0]] = n[i.path[0]] || [], n[i.path[0]].push(t(i))) : r.push(t(i));
	return {
		formErrors: r,
		fieldErrors: n
	};
}
function zg(e, t) {
	let n = t || function(e) {
		return e.message;
	}, r = { _errors: [] }, i = (e) => {
		for (let t of e.issues) if (t.code === "invalid_union" && t.errors.length) t.errors.map((e) => i({ issues: e }));
		else if (t.code === "invalid_key") i({ issues: t.issues });
		else if (t.code === "invalid_element") i({ issues: t.issues });
		else if (t.path.length === 0) r._errors.push(n(t));
		else {
			let e = r, i = 0;
			for (; i < t.path.length;) {
				let r = t.path[i];
				i === t.path.length - 1 ? (e[r] = e[r] || { _errors: [] }, e[r]._errors.push(n(t))) : e[r] = e[r] || { _errors: [] }, e = e[r], i++;
			}
		}
	};
	return i(e), r;
}
var Bg = (e) => (t, n, r, i) => {
	let a = r ? Object.assign(r, { async: !1 }) : { async: !1 }, o = t._zod.run({
		value: n,
		issues: []
	}, a);
	if (o instanceof Promise) throw new Xh();
	if (o.issues.length) {
		let t = new ((i?.Err) ?? e)(o.issues.map((e) => Mg(e, a, $h())));
		throw fg(t, i?.callee), t;
	}
	return o.value;
}, Vg = (e) => async (t, n, r, i) => {
	let a = r ? Object.assign(r, { async: !0 }) : { async: !0 }, o = t._zod.run({
		value: n,
		issues: []
	}, a);
	if (o instanceof Promise && (o = await o), o.issues.length) {
		let t = new ((i?.Err) ?? e)(o.issues.map((e) => Mg(e, a, $h())));
		throw fg(t, i?.callee), t;
	}
	return o.value;
}, Hg = (e) => (t, n, r) => {
	let i = r ? {
		...r,
		async: !1
	} : { async: !1 }, a = t._zod.run({
		value: n,
		issues: []
	}, i);
	if (a instanceof Promise) throw new Xh();
	return a.issues.length ? {
		success: !1,
		error: new (e ?? Ig)(a.issues.map((e) => Mg(e, i, $h())))
	} : {
		success: !0,
		data: a.value
	};
}, Ug = /* @__PURE__*/ Hg(Lg), Wg = (e) => async (t, n, r) => {
	let i = r ? Object.assign(r, { async: !0 }) : { async: !0 }, a = t._zod.run({
		value: n,
		issues: []
	}, i);
	return a instanceof Promise && (a = await a), a.issues.length ? {
		success: !1,
		error: new e(a.issues.map((e) => Mg(e, i, $h())))
	} : {
		success: !0,
		data: a.value
	};
}, Gg = /* @__PURE__*/ Wg(Lg), Kg = (e) => (t, n, r) => {
	let i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
	return Bg(e)(t, n, i);
}, qg = (e) => (t, n, r) => Bg(e)(t, n, r), Jg = (e) => async (t, n, r) => {
	let i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
	return Vg(e)(t, n, i);
}, Yg = (e) => async (t, n, r) => Vg(e)(t, n, r), Xg = (e) => (t, n, r) => {
	let i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
	return Hg(e)(t, n, i);
}, Zg = (e) => (t, n, r) => Hg(e)(t, n, r), Qg = (e) => async (t, n, r) => {
	let i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
	return Wg(e)(t, n, i);
}, $g = (e) => async (t, n, r) => Wg(e)(t, n, r), e_ = /^[cC][^\s-]{8,}$/, t_ = /^[0-9a-z]+$/, n_ = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, r_ = /^[0-9a-vA-V]{20}$/, i_ = /^[A-Za-z0-9]{27}$/, a_ = /^[a-zA-Z0-9_-]{21}$/, o_ = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, s_ = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, c_ = (e) => e ? RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, l_ = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, u_ = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function d_() {
	return new RegExp(u_, "u");
}
var f_ = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, p_ = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})$/, m_ = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, h_ = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, g_ = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, __ = /^[A-Za-z0-9_-]*$/, v_ = /^(?=.{1,253}\.?$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[-0-9a-zA-Z]{0,61}[0-9a-zA-Z])?)*\.?$/, y_ = /^\+(?:[0-9]){6,14}[0-9]$/, b_ = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", x_ = /*@__PURE__*/ RegExp(`^${b_}$`);
function S_(e) {
	let t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
	return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function C_(e) {
	return RegExp(`^${S_(e)}$`);
}
function w_(e) {
	let t = S_({ precision: e.precision }), n = ["Z"];
	e.local && n.push(""), e.offset && n.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
	let r = `${t}(?:${n.join("|")})`;
	return RegExp(`^${b_}T(?:${r})$`);
}
var T_ = (e) => {
	let t = e ? `[\\s\\S]{${e?.minimum ?? 0},${e?.maximum ?? ""}}` : "[\\s\\S]*";
	return RegExp(`^${t}$`);
}, E_ = /^\d+n?$/, D_ = /^\d+$/, O_ = /^-?\d+(?:\.\d+)?/i, k_ = /true|false/i, A_ = /null/i, j_ = /^[^A-Z]*$/, M_ = /^[^a-z]*$/, N_ = /*@__PURE__*/ z("$ZodCheck", (e, t) => {
	var n;
	e._zod ??= {}, e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), P_ = {
	number: "number",
	bigint: "bigint",
	object: "date"
}, F_ = /*@__PURE__*/ z("$ZodCheckLessThan", (e, t) => {
	N_.init(e, t);
	let n = P_[typeof t.value];
	e._zod.onattach.push((e) => {
		let n = e._zod.bag, r = (t.inclusive ? n.maximum : n.exclusiveMaximum) ?? Infinity;
		t.value < r && (t.inclusive ? n.maximum = t.value : n.exclusiveMaximum = t.value);
	}), e._zod.check = (r) => {
		(t.inclusive ? r.value <= t.value : r.value < t.value) || r.issues.push({
			origin: n,
			code: "too_big",
			maximum: t.value,
			input: r.value,
			inclusive: t.inclusive,
			inst: e,
			continue: !t.abort
		});
	};
}), I_ = /*@__PURE__*/ z("$ZodCheckGreaterThan", (e, t) => {
	N_.init(e, t);
	let n = P_[typeof t.value];
	e._zod.onattach.push((e) => {
		let n = e._zod.bag, r = (t.inclusive ? n.minimum : n.exclusiveMinimum) ?? -Infinity;
		t.value > r && (t.inclusive ? n.minimum = t.value : n.exclusiveMinimum = t.value);
	}), e._zod.check = (r) => {
		(t.inclusive ? r.value >= t.value : r.value > t.value) || r.issues.push({
			origin: n,
			code: "too_small",
			minimum: t.value,
			input: r.value,
			inclusive: t.inclusive,
			inst: e,
			continue: !t.abort
		});
	};
}), L_ = /*@__PURE__*/ z("$ZodCheckMultipleOf", (e, t) => {
	N_.init(e, t), e._zod.onattach.push((e) => {
		var n;
		(n = e._zod.bag).multipleOf ?? (n.multipleOf = t.value);
	}), e._zod.check = (n) => {
		if (typeof n.value != typeof t.value) throw Error("Cannot mix number and bigint in multiple_of check.");
		(typeof n.value == "bigint" ? n.value % t.value === BigInt(0) : ag(n.value, t.value) === 0) || n.issues.push({
			origin: typeof n.value,
			code: "not_multiple_of",
			divisor: t.value,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), R_ = /*@__PURE__*/ z("$ZodCheckNumberFormat", (e, t) => {
	N_.init(e, t), t.format = t.format || "float64";
	let n = t.format?.includes("int"), r = n ? "int" : "number", [i, a] = xg[t.format];
	e._zod.onattach.push((e) => {
		let r = e._zod.bag;
		r.format = t.format, r.minimum = i, r.maximum = a, n && (r.pattern = D_);
	}), e._zod.check = (o) => {
		let s = o.value;
		if (n) {
			if (!Number.isInteger(s)) {
				o.issues.push({
					expected: r,
					format: t.format,
					code: "invalid_type",
					continue: !1,
					input: s,
					inst: e
				});
				return;
			}
			if (!Number.isSafeInteger(s)) {
				s > 0 ? o.issues.push({
					input: s,
					code: "too_big",
					maximum: 2 ** 53 - 1,
					note: "Integers must be within the safe integer range.",
					inst: e,
					origin: r,
					continue: !t.abort
				}) : o.issues.push({
					input: s,
					code: "too_small",
					minimum: -(2 ** 53 - 1),
					note: "Integers must be within the safe integer range.",
					inst: e,
					origin: r,
					continue: !t.abort
				});
				return;
			}
		}
		s < i && o.issues.push({
			origin: "number",
			input: s,
			code: "too_small",
			minimum: i,
			inclusive: !0,
			inst: e,
			continue: !t.abort
		}), s > a && o.issues.push({
			origin: "number",
			input: s,
			code: "too_big",
			maximum: a,
			inst: e
		});
	};
}), z_ = /*@__PURE__*/ z("$ZodCheckMaxLength", (e, t) => {
	var n;
	N_.init(e, t), (n = e._zod.def).when ?? (n.when = (e) => {
		let t = e.value;
		return !rg(t) && t.length !== void 0;
	}), e._zod.onattach.push((e) => {
		let n = e._zod.bag.maximum ?? Infinity;
		t.maximum < n && (e._zod.bag.maximum = t.maximum);
	}), e._zod.check = (n) => {
		let r = n.value;
		if (r.length <= t.maximum) return;
		let i = Ng(r);
		n.issues.push({
			origin: i,
			code: "too_big",
			maximum: t.maximum,
			inclusive: !0,
			input: r,
			inst: e,
			continue: !t.abort
		});
	};
}), B_ = /*@__PURE__*/ z("$ZodCheckMinLength", (e, t) => {
	var n;
	N_.init(e, t), (n = e._zod.def).when ?? (n.when = (e) => {
		let t = e.value;
		return !rg(t) && t.length !== void 0;
	}), e._zod.onattach.push((e) => {
		let n = e._zod.bag.minimum ?? -Infinity;
		t.minimum > n && (e._zod.bag.minimum = t.minimum);
	}), e._zod.check = (n) => {
		let r = n.value;
		if (r.length >= t.minimum) return;
		let i = Ng(r);
		n.issues.push({
			origin: i,
			code: "too_small",
			minimum: t.minimum,
			inclusive: !0,
			input: r,
			inst: e,
			continue: !t.abort
		});
	};
}), V_ = /*@__PURE__*/ z("$ZodCheckLengthEquals", (e, t) => {
	var n;
	N_.init(e, t), (n = e._zod.def).when ?? (n.when = (e) => {
		let t = e.value;
		return !rg(t) && t.length !== void 0;
	}), e._zod.onattach.push((e) => {
		let n = e._zod.bag;
		n.minimum = t.length, n.maximum = t.length, n.length = t.length;
	}), e._zod.check = (n) => {
		let r = n.value, i = r.length;
		if (i === t.length) return;
		let a = Ng(r), o = i > t.length;
		n.issues.push({
			origin: a,
			...o ? {
				code: "too_big",
				maximum: t.length
			} : {
				code: "too_small",
				minimum: t.length
			},
			inclusive: !0,
			exact: !0,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), H_ = /*@__PURE__*/ z("$ZodCheckStringFormat", (e, t) => {
	var n, r;
	N_.init(e, t), e._zod.onattach.push((e) => {
		let n = e._zod.bag;
		n.format = t.format, t.pattern && (n.patterns ??= /* @__PURE__ */ new Set(), n.patterns.add(t.pattern));
	}), t.pattern ? (n = e._zod).check ?? (n.check = (n) => {
		t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: t.format,
			input: n.value,
			...t.pattern ? { pattern: t.pattern.toString() } : {},
			inst: e,
			continue: !t.abort
		});
	}) : (r = e._zod).check ?? (r.check = () => {});
}), U_ = /*@__PURE__*/ z("$ZodCheckRegex", (e, t) => {
	H_.init(e, t), e._zod.check = (n) => {
		t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: "regex",
			input: n.value,
			pattern: t.pattern.toString(),
			inst: e,
			continue: !t.abort
		});
	};
}), W_ = /*@__PURE__*/ z("$ZodCheckLowerCase", (e, t) => {
	t.pattern ??= j_, H_.init(e, t);
}), G_ = /*@__PURE__*/ z("$ZodCheckUpperCase", (e, t) => {
	t.pattern ??= M_, H_.init(e, t);
}), K_ = /*@__PURE__*/ z("$ZodCheckIncludes", (e, t) => {
	N_.init(e, t);
	let n = vg(t.includes), r = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${n}` : n);
	t.pattern = r, e._zod.onattach.push((e) => {
		let t = e._zod.bag;
		t.patterns ??= /* @__PURE__ */ new Set(), t.patterns.add(r);
	}), e._zod.check = (n) => {
		n.value.includes(t.includes, t.position) || n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: "includes",
			includes: t.includes,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), q_ = /*@__PURE__*/ z("$ZodCheckStartsWith", (e, t) => {
	N_.init(e, t);
	let n = RegExp(`^${vg(t.prefix)}.*`);
	t.pattern ??= n, e._zod.onattach.push((e) => {
		let t = e._zod.bag;
		t.patterns ??= /* @__PURE__ */ new Set(), t.patterns.add(n);
	}), e._zod.check = (n) => {
		n.value.startsWith(t.prefix) || n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: "starts_with",
			prefix: t.prefix,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), J_ = /*@__PURE__*/ z("$ZodCheckEndsWith", (e, t) => {
	N_.init(e, t);
	let n = RegExp(`.*${vg(t.suffix)}$`);
	t.pattern ??= n, e._zod.onattach.push((e) => {
		let t = e._zod.bag;
		t.patterns ??= /* @__PURE__ */ new Set(), t.patterns.add(n);
	}), e._zod.check = (n) => {
		n.value.endsWith(t.suffix) || n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: "ends_with",
			suffix: t.suffix,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), Y_ = /*@__PURE__*/ z("$ZodCheckOverwrite", (e, t) => {
	N_.init(e, t), e._zod.check = (e) => {
		e.value = t.tx(e.value);
	};
}), X_ = class {
	constructor(e = []) {
		this.content = [], this.indent = 0, this && (this.args = e);
	}
	indented(e) {
		this.indent += 1, e(this), --this.indent;
	}
	write(e) {
		if (typeof e == "function") {
			e(this, { execution: "sync" }), e(this, { execution: "async" });
			return;
		}
		let t = e.split("\n").filter((e) => e), n = Math.min(...t.map((e) => e.length - e.trimStart().length)), r = t.map((e) => e.slice(n)).map((e) => " ".repeat(this.indent * 2) + e);
		for (let e of r) this.content.push(e);
	}
	compile() {
		let e = Function, t = this?.args, n = [...(this?.content ?? [""]).map((e) => `  ${e}`)];
		return new e(...t, n.join("\n"));
	}
}, Z_ = {
	major: 4,
	minor: 1,
	patch: 5
}, Q_ = /*@__PURE__*/ z("$ZodType", (e, t) => {
	var n;
	e ??= {}, e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = Z_;
	let r = [...e._zod.def.checks ?? []];
	e._zod.traits.has("$ZodCheck") && r.unshift(e);
	for (let t of r) for (let n of t._zod.onattach) n(e);
	if (r.length === 0) (n = e._zod).deferred ?? (n.deferred = []), e._zod.deferred?.push(() => {
		e._zod.run = e._zod.parse;
	});
	else {
		let t = (e, t, n) => {
			let r = kg(e), i;
			for (let a of t) {
				if (a._zod.def.when) {
					if (!a._zod.def.when(e)) continue;
				} else if (r) continue;
				let t = e.issues.length, o = a._zod.check(e);
				if (o instanceof Promise && n?.async === !1) throw new Xh();
				if (i || o instanceof Promise) i = (i ?? Promise.resolve()).then(async () => {
					await o, e.issues.length !== t && (r ||= kg(e, t));
				});
				else {
					if (e.issues.length === t) continue;
					r ||= kg(e, t);
				}
			}
			return i ? i.then(() => e) : e;
		}, n = (n, i, a) => {
			if (kg(n)) return n.aborted = !0, n;
			let o = t(i, r, a);
			if (o instanceof Promise) {
				if (a.async === !1) throw new Xh();
				return o.then((t) => e._zod.parse(t, a));
			}
			return e._zod.parse(o, a);
		};
		e._zod.run = (i, a) => {
			if (a.skipChecks) return e._zod.parse(i, a);
			if (a.direction === "backward") {
				let t = e._zod.parse({
					value: i.value,
					issues: []
				}, {
					...a,
					skipChecks: !0
				});
				return t instanceof Promise ? t.then((e) => n(e, i, a)) : n(t, i, a);
			}
			let o = e._zod.parse(i, a);
			if (o instanceof Promise) {
				if (a.async === !1) throw new Xh();
				return o.then((e) => t(e, r, a));
			}
			return t(o, r, a);
		};
	}
	e["~standard"] = {
		validate: (t) => {
			try {
				let n = Ug(e, t);
				return n.success ? { value: n.data } : { issues: n.error?.issues };
			} catch {
				return Gg(e, t).then((e) => e.success ? { value: e.data } : { issues: e.error?.issues });
			}
		},
		vendor: "zod",
		version: 1
	};
}), $_ = /*@__PURE__*/ z("$ZodString", (e, t) => {
	Q_.init(e, t), e._zod.pattern = [...e?._zod.bag?.patterns ?? []].pop() ?? T_(e._zod.bag), e._zod.parse = (n, r) => {
		if (t.coerce) try {
			n.value = String(n.value);
		} catch {}
		return typeof n.value == "string" || n.issues.push({
			expected: "string",
			code: "invalid_type",
			input: n.value,
			inst: e
		}), n;
	};
}), ev = /*@__PURE__*/ z("$ZodStringFormat", (e, t) => {
	H_.init(e, t), $_.init(e, t);
}), tv = /*@__PURE__*/ z("$ZodGUID", (e, t) => {
	t.pattern ??= s_, ev.init(e, t);
}), nv = /*@__PURE__*/ z("$ZodUUID", (e, t) => {
	if (t.version) {
		let e = {
			v1: 1,
			v2: 2,
			v3: 3,
			v4: 4,
			v5: 5,
			v6: 6,
			v7: 7,
			v8: 8
		}[t.version];
		if (e === void 0) throw Error(`Invalid UUID version: "${t.version}"`);
		t.pattern ??= c_(e);
	} else t.pattern ??= c_();
	ev.init(e, t);
}), rv = /*@__PURE__*/ z("$ZodEmail", (e, t) => {
	t.pattern ??= l_, ev.init(e, t);
}), iv = /*@__PURE__*/ z("$ZodURL", (e, t) => {
	ev.init(e, t), e._zod.check = (n) => {
		try {
			let r = n.value.trim(), i = new URL(r);
			t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(i.hostname) || n.issues.push({
				code: "invalid_format",
				format: "url",
				note: "Invalid hostname",
				pattern: v_.source,
				input: n.value,
				inst: e,
				continue: !t.abort
			})), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(i.protocol.endsWith(":") ? i.protocol.slice(0, -1) : i.protocol) || n.issues.push({
				code: "invalid_format",
				format: "url",
				note: "Invalid protocol",
				pattern: t.protocol.source,
				input: n.value,
				inst: e,
				continue: !t.abort
			})), n.value = t.normalize ? i.href : r;
			return;
		} catch {
			n.issues.push({
				code: "invalid_format",
				format: "url",
				input: n.value,
				inst: e,
				continue: !t.abort
			});
		}
	};
}), av = /*@__PURE__*/ z("$ZodEmoji", (e, t) => {
	t.pattern ??= d_(), ev.init(e, t);
}), ov = /*@__PURE__*/ z("$ZodNanoID", (e, t) => {
	t.pattern ??= a_, ev.init(e, t);
}), sv = /*@__PURE__*/ z("$ZodCUID", (e, t) => {
	t.pattern ??= e_, ev.init(e, t);
}), cv = /*@__PURE__*/ z("$ZodCUID2", (e, t) => {
	t.pattern ??= t_, ev.init(e, t);
}), lv = /*@__PURE__*/ z("$ZodULID", (e, t) => {
	t.pattern ??= n_, ev.init(e, t);
}), uv = /*@__PURE__*/ z("$ZodXID", (e, t) => {
	t.pattern ??= r_, ev.init(e, t);
}), dv = /*@__PURE__*/ z("$ZodKSUID", (e, t) => {
	t.pattern ??= i_, ev.init(e, t);
}), fv = /*@__PURE__*/ z("$ZodISODateTime", (e, t) => {
	t.pattern ??= w_(t), ev.init(e, t);
}), pv = /*@__PURE__*/ z("$ZodISODate", (e, t) => {
	t.pattern ??= x_, ev.init(e, t);
}), mv = /*@__PURE__*/ z("$ZodISOTime", (e, t) => {
	t.pattern ??= C_(t), ev.init(e, t);
}), hv = /*@__PURE__*/ z("$ZodISODuration", (e, t) => {
	t.pattern ??= o_, ev.init(e, t);
}), gv = /*@__PURE__*/ z("$ZodIPv4", (e, t) => {
	t.pattern ??= f_, ev.init(e, t), e._zod.onattach.push((e) => {
		let t = e._zod.bag;
		t.format = "ipv4";
	});
}), _v = /*@__PURE__*/ z("$ZodIPv6", (e, t) => {
	t.pattern ??= p_, ev.init(e, t), e._zod.onattach.push((e) => {
		let t = e._zod.bag;
		t.format = "ipv6";
	}), e._zod.check = (n) => {
		try {
			new URL(`http://[${n.value}]`);
		} catch {
			n.issues.push({
				code: "invalid_format",
				format: "ipv6",
				input: n.value,
				inst: e,
				continue: !t.abort
			});
		}
	};
}), vv = /*@__PURE__*/ z("$ZodCIDRv4", (e, t) => {
	t.pattern ??= m_, ev.init(e, t);
}), yv = /*@__PURE__*/ z("$ZodCIDRv6", (e, t) => {
	t.pattern ??= h_, ev.init(e, t), e._zod.check = (n) => {
		let [r, i] = n.value.split("/");
		try {
			if (!i) throw Error();
			let e = Number(i);
			if (`${e}` !== i || e < 0 || e > 128) throw Error();
			new URL(`http://[${r}]`);
		} catch {
			n.issues.push({
				code: "invalid_format",
				format: "cidrv6",
				input: n.value,
				inst: e,
				continue: !t.abort
			});
		}
	};
});
function bv(e) {
	if (e === "") return !0;
	if (e.length % 4 != 0) return !1;
	try {
		return atob(e), !0;
	} catch {
		return !1;
	}
}
var xv = /*@__PURE__*/ z("$ZodBase64", (e, t) => {
	t.pattern ??= g_, ev.init(e, t), e._zod.onattach.push((e) => {
		e._zod.bag.contentEncoding = "base64";
	}), e._zod.check = (n) => {
		bv(n.value) || n.issues.push({
			code: "invalid_format",
			format: "base64",
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
});
function Sv(e) {
	if (!__.test(e)) return !1;
	let t = e.replace(/[-_]/g, (e) => e === "-" ? "+" : "/");
	return bv(t.padEnd(Math.ceil(t.length / 4) * 4, "="));
}
var Cv = /*@__PURE__*/ z("$ZodBase64URL", (e, t) => {
	t.pattern ??= __, ev.init(e, t), e._zod.onattach.push((e) => {
		e._zod.bag.contentEncoding = "base64url";
	}), e._zod.check = (n) => {
		Sv(n.value) || n.issues.push({
			code: "invalid_format",
			format: "base64url",
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), wv = /*@__PURE__*/ z("$ZodE164", (e, t) => {
	t.pattern ??= y_, ev.init(e, t);
});
function Tv(e, t = null) {
	try {
		let n = e.split(".");
		if (n.length !== 3) return !1;
		let [r] = n;
		if (!r) return !1;
		let i = JSON.parse(atob(r));
		return !("typ" in i && i?.typ !== "JWT" || !i.alg || t && (!("alg" in i) || i.alg !== t));
	} catch {
		return !1;
	}
}
var Ev = /*@__PURE__*/ z("$ZodJWT", (e, t) => {
	ev.init(e, t), e._zod.check = (n) => {
		Tv(n.value, t.alg) || n.issues.push({
			code: "invalid_format",
			format: "jwt",
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), Dv = /*@__PURE__*/ z("$ZodNumber", (e, t) => {
	Q_.init(e, t), e._zod.pattern = e._zod.bag.pattern ?? O_, e._zod.parse = (n, r) => {
		if (t.coerce) try {
			n.value = Number(n.value);
		} catch {}
		let i = n.value;
		if (typeof i == "number" && !Number.isNaN(i) && Number.isFinite(i)) return n;
		let a = typeof i == "number" ? Number.isNaN(i) ? "NaN" : Number.isFinite(i) ? void 0 : "Infinity" : void 0;
		return n.issues.push({
			expected: "number",
			code: "invalid_type",
			input: i,
			inst: e,
			...a ? { received: a } : {}
		}), n;
	};
}), Ov = /*@__PURE__*/ z("$ZodNumber", (e, t) => {
	R_.init(e, t), Dv.init(e, t);
}), kv = /*@__PURE__*/ z("$ZodBoolean", (e, t) => {
	Q_.init(e, t), e._zod.pattern = k_, e._zod.parse = (n, r) => {
		if (t.coerce) try {
			n.value = !!n.value;
		} catch {}
		let i = n.value;
		return typeof i == "boolean" || n.issues.push({
			expected: "boolean",
			code: "invalid_type",
			input: i,
			inst: e
		}), n;
	};
}), Av = /*@__PURE__*/ z("$ZodBigInt", (e, t) => {
	Q_.init(e, t), e._zod.pattern = E_, e._zod.parse = (n, r) => {
		if (t.coerce) try {
			n.value = BigInt(n.value);
		} catch {}
		return typeof n.value == "bigint" || n.issues.push({
			expected: "bigint",
			code: "invalid_type",
			input: n.value,
			inst: e
		}), n;
	};
}), jv = /*@__PURE__*/ z("$ZodNull", (e, t) => {
	Q_.init(e, t), e._zod.pattern = A_, e._zod.values = /* @__PURE__ */ new Set([null]), e._zod.parse = (t, n) => {
		let r = t.value;
		return r === null || t.issues.push({
			expected: "null",
			code: "invalid_type",
			input: r,
			inst: e
		}), t;
	};
}), Mv = /*@__PURE__*/ z("$ZodUnknown", (e, t) => {
	Q_.init(e, t), e._zod.parse = (e) => e;
}), Nv = /*@__PURE__*/ z("$ZodNever", (e, t) => {
	Q_.init(e, t), e._zod.parse = (t, n) => (t.issues.push({
		expected: "never",
		code: "invalid_type",
		input: t.value,
		inst: e
	}), t);
}), Pv = /*@__PURE__*/ z("$ZodVoid", (e, t) => {
	Q_.init(e, t), e._zod.parse = (t, n) => {
		let r = t.value;
		return r === void 0 || t.issues.push({
			expected: "void",
			code: "invalid_type",
			input: r,
			inst: e
		}), t;
	};
});
function Fv(e, t, n) {
	e.issues.length && t.issues.push(...Ag(n, e.issues)), t.value[n] = e.value;
}
var Iv = /*@__PURE__*/ z("$ZodArray", (e, t) => {
	Q_.init(e, t), e._zod.parse = (n, r) => {
		let i = n.value;
		if (!Array.isArray(i)) return n.issues.push({
			expected: "array",
			code: "invalid_type",
			input: i,
			inst: e
		}), n;
		n.value = Array(i.length);
		let a = [];
		for (let e = 0; e < i.length; e++) {
			let o = i[e], s = t.element._zod.run({
				value: o,
				issues: []
			}, r);
			s instanceof Promise ? a.push(s.then((t) => Fv(t, n, e))) : Fv(s, n, e);
		}
		return a.length ? Promise.all(a).then(() => n) : n;
	};
});
function Lv(e, t, n, r) {
	e.issues.length && t.issues.push(...Ag(n, e.issues)), e.value === void 0 ? n in r && (t.value[n] = void 0) : t.value[n] = e.value;
}
function Rv(e) {
	let t = Object.keys(e.shape);
	for (let n of t) if (!e.shape[n]._zod.traits.has("$ZodType")) throw Error(`Invalid element at key "${n}": expected a Zod schema`);
	let n = bg(e.shape);
	return {
		...e,
		keys: t,
		keySet: new Set(t),
		numKeys: t.length,
		optionalKeys: new Set(n)
	};
}
function zv(e, t, n, r, i, a) {
	let o = [], s = i.keySet, c = i.catchall._zod, l = c.def.type;
	for (let i of Object.keys(t)) {
		if (s.has(i)) continue;
		if (l === "never") {
			o.push(i);
			continue;
		}
		let a = c.run({
			value: t[i],
			issues: []
		}, r);
		a instanceof Promise ? e.push(a.then((e) => Lv(e, n, i, t))) : Lv(a, n, i, t);
	}
	return o.length && n.issues.push({
		code: "unrecognized_keys",
		keys: o,
		input: t,
		inst: a
	}), e.length ? Promise.all(e).then(() => n) : n;
}
var Bv = /*@__PURE__*/ z("$ZodObject", (e, t) => {
	Q_.init(e, t);
	let n = ng(() => Rv(t));
	sg(e._zod, "propValues", () => {
		let e = t.shape, n = {};
		for (let t in e) {
			let r = e[t]._zod;
			if (r.values) {
				n[t] ?? (n[t] = /* @__PURE__ */ new Set());
				for (let e of r.values) n[t].add(e);
			}
		}
		return n;
	});
	let r = pg, i = t.catchall, a;
	e._zod.parse = (t, o) => {
		a ??= n.value;
		let s = t.value;
		if (!r(s)) return t.issues.push({
			expected: "object",
			code: "invalid_type",
			input: s,
			inst: e
		}), t;
		t.value = {};
		let c = [], l = a.shape;
		for (let e of a.keys) {
			let n = l[e]._zod.run({
				value: s[e],
				issues: []
			}, o);
			n instanceof Promise ? c.push(n.then((n) => Lv(n, t, e, s))) : Lv(n, t, e, s);
		}
		return i ? zv(c, s, t, o, n.value, e) : c.length ? Promise.all(c).then(() => t) : t;
	};
}), Vv = /*@__PURE__*/ z("$ZodObjectJIT", (e, t) => {
	Bv.init(e, t);
	let n = e._zod.parse, r = ng(() => Rv(t)), i = (e) => {
		let t = new X_([
			"shape",
			"payload",
			"ctx"
		]), n = r.value, i = (e) => {
			let t = dg(e);
			return `shape[${t}]._zod.run({ value: input[${t}], issues: [] }, ctx)`;
		};
		t.write("const input = payload.value;");
		let a = Object.create(null), o = 0;
		for (let e of n.keys) a[e] = `key_${o++}`;
		t.write("const newResult = {}");
		for (let e of n.keys) {
			let n = a[e], r = dg(e);
			t.write(`const ${n} = ${i(e)};`), t.write(`
        if (${n}.issues.length) {
          payload.issues = payload.issues.concat(${n}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${r}, ...iss.path] : [${r}]
          })));
        }
        
        if (${n}.value === undefined) {
          if (${r} in input) {
            newResult[${r}] = undefined;
          }
        } else {
          newResult[${r}] = ${n}.value;
        }
      `);
		}
		t.write("payload.value = newResult;"), t.write("return payload;");
		let s = t.compile();
		return (t, n) => s(e, t, n);
	}, a, o = pg, s = !Qh.jitless, c = s && mg.value, l = t.catchall, u;
	e._zod.parse = (d, f) => {
		u ??= r.value;
		let p = d.value;
		return o(p) ? s && c && f?.async === !1 && f.jitless !== !0 ? (a ||= i(t.shape), d = a(d, f), l ? zv([], p, d, f, u, e) : d) : n(d, f) : (d.issues.push({
			expected: "object",
			code: "invalid_type",
			input: p,
			inst: e
		}), d);
	};
});
function Hv(e, t, n, r) {
	for (let n of e) if (n.issues.length === 0) return t.value = n.value, t;
	let i = e.filter((e) => !kg(e));
	return i.length === 1 ? (t.value = i[0].value, i[0]) : (t.issues.push({
		code: "invalid_union",
		input: t.value,
		inst: n,
		errors: e.map((e) => e.issues.map((e) => Mg(e, r, $h())))
	}), t);
}
var Uv = /*@__PURE__*/ z("$ZodUnion", (e, t) => {
	Q_.init(e, t), sg(e._zod, "optin", () => t.options.some((e) => e._zod.optin === "optional") ? "optional" : void 0), sg(e._zod, "optout", () => t.options.some((e) => e._zod.optout === "optional") ? "optional" : void 0), sg(e._zod, "values", () => {
		if (t.options.every((e) => e._zod.values)) return new Set(t.options.flatMap((e) => Array.from(e._zod.values)));
	}), sg(e._zod, "pattern", () => {
		if (t.options.every((e) => e._zod.pattern)) {
			let e = t.options.map((e) => e._zod.pattern);
			return RegExp(`^(${e.map((e) => ig(e.source)).join("|")})$`);
		}
	});
	let n = t.options.length === 1, r = t.options[0]._zod.run;
	e._zod.parse = (i, a) => {
		if (n) return r(i, a);
		let o = !1, s = [];
		for (let e of t.options) {
			let t = e._zod.run({
				value: i.value,
				issues: []
			}, a);
			if (t instanceof Promise) s.push(t), o = !0;
			else {
				if (t.issues.length === 0) return t;
				s.push(t);
			}
		}
		return o ? Promise.all(s).then((t) => Hv(t, i, e, a)) : Hv(s, i, e, a);
	};
}), Wv = /*@__PURE__*/ z("$ZodIntersection", (e, t) => {
	Q_.init(e, t), e._zod.parse = (e, n) => {
		let r = e.value, i = t.left._zod.run({
			value: r,
			issues: []
		}, n), a = t.right._zod.run({
			value: r,
			issues: []
		}, n);
		return i instanceof Promise || a instanceof Promise ? Promise.all([i, a]).then(([t, n]) => Kv(e, t, n)) : Kv(e, i, a);
	};
});
function Gv(e, t) {
	if (e === t || e instanceof Date && t instanceof Date && +e == +t) return {
		valid: !0,
		data: e
	};
	if (hg(e) && hg(t)) {
		let n = Object.keys(t), r = Object.keys(e).filter((e) => n.indexOf(e) !== -1), i = {
			...e,
			...t
		};
		for (let n of r) {
			let r = Gv(e[n], t[n]);
			if (!r.valid) return {
				valid: !1,
				mergeErrorPath: [n, ...r.mergeErrorPath]
			};
			i[n] = r.data;
		}
		return {
			valid: !0,
			data: i
		};
	}
	if (Array.isArray(e) && Array.isArray(t)) {
		if (e.length !== t.length) return {
			valid: !1,
			mergeErrorPath: []
		};
		let n = [];
		for (let r = 0; r < e.length; r++) {
			let i = e[r], a = t[r], o = Gv(i, a);
			if (!o.valid) return {
				valid: !1,
				mergeErrorPath: [r, ...o.mergeErrorPath]
			};
			n.push(o.data);
		}
		return {
			valid: !0,
			data: n
		};
	}
	return {
		valid: !1,
		mergeErrorPath: []
	};
}
function Kv(e, t, n) {
	if (t.issues.length && e.issues.push(...t.issues), n.issues.length && e.issues.push(...n.issues), kg(e)) return e;
	let r = Gv(t.value, n.value);
	if (!r.valid) throw Error(`Unmergable intersection. Error path: ${JSON.stringify(r.mergeErrorPath)}`);
	return e.value = r.data, e;
}
var qv = /*@__PURE__*/ z("$ZodRecord", (e, t) => {
	Q_.init(e, t), e._zod.parse = (n, r) => {
		let i = n.value;
		if (!hg(i)) return n.issues.push({
			expected: "record",
			code: "invalid_type",
			input: i,
			inst: e
		}), n;
		let a = [];
		if (t.keyType._zod.values) {
			let o = t.keyType._zod.values;
			n.value = {};
			for (let e of o) if (typeof e == "string" || typeof e == "number" || typeof e == "symbol") {
				let o = t.valueType._zod.run({
					value: i[e],
					issues: []
				}, r);
				o instanceof Promise ? a.push(o.then((t) => {
					t.issues.length && n.issues.push(...Ag(e, t.issues)), n.value[e] = t.value;
				})) : (o.issues.length && n.issues.push(...Ag(e, o.issues)), n.value[e] = o.value);
			}
			let s;
			for (let e in i) o.has(e) || (s ??= [], s.push(e));
			s && s.length > 0 && n.issues.push({
				code: "unrecognized_keys",
				input: i,
				inst: e,
				keys: s
			});
		} else {
			n.value = {};
			for (let o of Reflect.ownKeys(i)) {
				if (o === "__proto__") continue;
				let s = t.keyType._zod.run({
					value: o,
					issues: []
				}, r);
				if (s instanceof Promise) throw Error("Async schemas not supported in object keys currently");
				if (s.issues.length) {
					n.issues.push({
						code: "invalid_key",
						origin: "record",
						issues: s.issues.map((e) => Mg(e, r, $h())),
						input: o,
						path: [o],
						inst: e
					}), n.value[s.value] = s.value;
					continue;
				}
				let c = t.valueType._zod.run({
					value: i[o],
					issues: []
				}, r);
				c instanceof Promise ? a.push(c.then((e) => {
					e.issues.length && n.issues.push(...Ag(o, e.issues)), n.value[s.value] = e.value;
				})) : (c.issues.length && n.issues.push(...Ag(o, c.issues)), n.value[s.value] = c.value);
			}
		}
		return a.length ? Promise.all(a).then(() => n) : n;
	};
}), Jv = /*@__PURE__*/ z("$ZodEnum", (e, t) => {
	Q_.init(e, t);
	let n = eg(t.entries), r = new Set(n);
	e._zod.values = r, e._zod.pattern = RegExp(`^(${n.filter((e) => _g.has(typeof e)).map((e) => typeof e == "string" ? vg(e) : e.toString()).join("|")})$`), e._zod.parse = (t, i) => {
		let a = t.value;
		return r.has(a) || t.issues.push({
			code: "invalid_value",
			values: n,
			input: a,
			inst: e
		}), t;
	};
}), Yv = /*@__PURE__*/ z("$ZodLiteral", (e, t) => {
	if (Q_.init(e, t), t.values.length === 0) throw Error("Cannot create literal schema with no valid values");
	e._zod.values = new Set(t.values), e._zod.pattern = RegExp(`^(${t.values.map((e) => typeof e == "string" ? vg(e) : e ? vg(e.toString()) : String(e)).join("|")})$`), e._zod.parse = (n, r) => {
		let i = n.value;
		return e._zod.values.has(i) || n.issues.push({
			code: "invalid_value",
			values: t.values,
			input: i,
			inst: e
		}), n;
	};
}), Xv = /*@__PURE__*/ z("$ZodTransform", (e, t) => {
	Q_.init(e, t), e._zod.parse = (n, r) => {
		if (r.direction === "backward") throw new Zh(e.constructor.name);
		let i = t.transform(n.value, n);
		if (r.async) return (i instanceof Promise ? i : Promise.resolve(i)).then((e) => (n.value = e, n));
		if (i instanceof Promise) throw new Xh();
		return n.value = i, n;
	};
});
function Zv(e, t) {
	return e.issues.length && t === void 0 ? {
		issues: [],
		value: void 0
	} : e;
}
var Qv = /*@__PURE__*/ z("$ZodOptional", (e, t) => {
	Q_.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", sg(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), sg(e._zod, "pattern", () => {
		let e = t.innerType._zod.pattern;
		return e ? RegExp(`^(${ig(e.source)})?$`) : void 0;
	}), e._zod.parse = (e, n) => {
		if (t.innerType._zod.optin === "optional") {
			let r = t.innerType._zod.run(e, n);
			return r instanceof Promise ? r.then((t) => Zv(t, e.value)) : Zv(r, e.value);
		}
		return e.value === void 0 ? e : t.innerType._zod.run(e, n);
	};
}), $v = /*@__PURE__*/ z("$ZodNullable", (e, t) => {
	Q_.init(e, t), sg(e._zod, "optin", () => t.innerType._zod.optin), sg(e._zod, "optout", () => t.innerType._zod.optout), sg(e._zod, "pattern", () => {
		let e = t.innerType._zod.pattern;
		return e ? RegExp(`^(${ig(e.source)}|null)$`) : void 0;
	}), sg(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (e, n) => e.value === null ? e : t.innerType._zod.run(e, n);
}), ey = /*@__PURE__*/ z("$ZodDefault", (e, t) => {
	Q_.init(e, t), e._zod.optin = "optional", sg(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (e, n) => {
		if (n.direction === "backward") return t.innerType._zod.run(e, n);
		if (e.value === void 0) return e.value = t.defaultValue, e;
		let r = t.innerType._zod.run(e, n);
		return r instanceof Promise ? r.then((e) => ty(e, t)) : ty(r, t);
	};
});
function ty(e, t) {
	return e.value === void 0 && (e.value = t.defaultValue), e;
}
var ny = /*@__PURE__*/ z("$ZodPrefault", (e, t) => {
	Q_.init(e, t), e._zod.optin = "optional", sg(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (e, n) => (n.direction === "backward" || e.value === void 0 && (e.value = t.defaultValue), t.innerType._zod.run(e, n));
}), ry = /*@__PURE__*/ z("$ZodNonOptional", (e, t) => {
	Q_.init(e, t), sg(e._zod, "values", () => {
		let e = t.innerType._zod.values;
		return e ? new Set([...e].filter((e) => e !== void 0)) : void 0;
	}), e._zod.parse = (n, r) => {
		let i = t.innerType._zod.run(n, r);
		return i instanceof Promise ? i.then((t) => iy(t, e)) : iy(i, e);
	};
});
function iy(e, t) {
	return !e.issues.length && e.value === void 0 && e.issues.push({
		code: "invalid_type",
		expected: "nonoptional",
		input: e.value,
		inst: t
	}), e;
}
var ay = /*@__PURE__*/ z("$ZodCatch", (e, t) => {
	Q_.init(e, t), sg(e._zod, "optin", () => t.innerType._zod.optin), sg(e._zod, "optout", () => t.innerType._zod.optout), sg(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (e, n) => {
		if (n.direction === "backward") return t.innerType._zod.run(e, n);
		let r = t.innerType._zod.run(e, n);
		return r instanceof Promise ? r.then((r) => (e.value = r.value, r.issues.length && (e.value = t.catchValue({
			...e,
			error: { issues: r.issues.map((e) => Mg(e, n, $h())) },
			input: e.value
		}), e.issues = []), e)) : (e.value = r.value, r.issues.length && (e.value = t.catchValue({
			...e,
			error: { issues: r.issues.map((e) => Mg(e, n, $h())) },
			input: e.value
		}), e.issues = []), e);
	};
}), oy = /*@__PURE__*/ z("$ZodPipe", (e, t) => {
	Q_.init(e, t), sg(e._zod, "values", () => t.in._zod.values), sg(e._zod, "optin", () => t.in._zod.optin), sg(e._zod, "optout", () => t.out._zod.optout), sg(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (e, n) => {
		if (n.direction === "backward") {
			let r = t.out._zod.run(e, n);
			return r instanceof Promise ? r.then((e) => sy(e, t.in, n)) : sy(r, t.in, n);
		}
		let r = t.in._zod.run(e, n);
		return r instanceof Promise ? r.then((e) => sy(e, t.out, n)) : sy(r, t.out, n);
	};
});
function sy(e, t, n) {
	return e.issues.length ? (e.aborted = !0, e) : t._zod.run({
		value: e.value,
		issues: e.issues
	}, n);
}
var cy = /*@__PURE__*/ z("$ZodReadonly", (e, t) => {
	Q_.init(e, t), sg(e._zod, "propValues", () => t.innerType._zod.propValues), sg(e._zod, "values", () => t.innerType._zod.values), sg(e._zod, "optin", () => t.innerType._zod.optin), sg(e._zod, "optout", () => t.innerType._zod.optout), e._zod.parse = (e, n) => {
		if (n.direction === "backward") return t.innerType._zod.run(e, n);
		let r = t.innerType._zod.run(e, n);
		return r instanceof Promise ? r.then(ly) : ly(r);
	};
});
function ly(e) {
	return e.value = Object.freeze(e.value), e;
}
var uy = /*@__PURE__*/ z("$ZodCustom", (e, t) => {
	N_.init(e, t), Q_.init(e, t), e._zod.parse = (e, t) => e, e._zod.check = (n) => {
		let r = n.value, i = t.fn(r);
		if (i instanceof Promise) return i.then((t) => dy(t, n, r, e));
		dy(i, n, r, e);
	};
});
function dy(e, t, n, r) {
	if (!e) {
		let e = {
			code: "custom",
			input: n,
			inst: r,
			path: [...r._zod.def.path ?? []],
			continue: !r._zod.def.abort
		};
		r._zod.def.params && (e.params = r._zod.def.params), t.issues.push(Pg(e));
	}
}
var fy = class {
	constructor() {
		this._map = /* @__PURE__ */ new Map(), this._idmap = /* @__PURE__ */ new Map();
	}
	add(e, ...t) {
		let n = t[0];
		if (this._map.set(e, n), n && typeof n == "object" && "id" in n) {
			if (this._idmap.has(n.id)) throw Error(`ID ${n.id} already exists in the registry`);
			this._idmap.set(n.id, e);
		}
		return this;
	}
	clear() {
		return this._map = /* @__PURE__ */ new Map(), this._idmap = /* @__PURE__ */ new Map(), this;
	}
	remove(e) {
		let t = this._map.get(e);
		return t && typeof t == "object" && "id" in t && this._idmap.delete(t.id), this._map.delete(e), this;
	}
	get(e) {
		let t = e._zod.parent;
		if (t) {
			let n = { ...this.get(t) ?? {} };
			delete n.id;
			let r = {
				...n,
				...this._map.get(e)
			};
			return Object.keys(r).length ? r : void 0;
		}
		return this._map.get(e);
	}
	has(e) {
		return this._map.has(e);
	}
};
function py() {
	return new fy();
}
var V = /*@__PURE__*/ py();
function my(e, t) {
	return new e({
		type: "string",
		...B(t)
	});
}
function hy(e, t) {
	return new e({
		type: "string",
		format: "email",
		check: "string_format",
		abort: !1,
		...B(t)
	});
}
function gy(e, t) {
	return new e({
		type: "string",
		format: "guid",
		check: "string_format",
		abort: !1,
		...B(t)
	});
}
function _y(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		...B(t)
	});
}
function vy(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		version: "v4",
		...B(t)
	});
}
function yy(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		version: "v6",
		...B(t)
	});
}
function by(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		version: "v7",
		...B(t)
	});
}
function xy(e, t) {
	return new e({
		type: "string",
		format: "url",
		check: "string_format",
		abort: !1,
		...B(t)
	});
}
function Sy(e, t) {
	return new e({
		type: "string",
		format: "emoji",
		check: "string_format",
		abort: !1,
		...B(t)
	});
}
function Cy(e, t) {
	return new e({
		type: "string",
		format: "nanoid",
		check: "string_format",
		abort: !1,
		...B(t)
	});
}
function wy(e, t) {
	return new e({
		type: "string",
		format: "cuid",
		check: "string_format",
		abort: !1,
		...B(t)
	});
}
function Ty(e, t) {
	return new e({
		type: "string",
		format: "cuid2",
		check: "string_format",
		abort: !1,
		...B(t)
	});
}
function Ey(e, t) {
	return new e({
		type: "string",
		format: "ulid",
		check: "string_format",
		abort: !1,
		...B(t)
	});
}
function Dy(e, t) {
	return new e({
		type: "string",
		format: "xid",
		check: "string_format",
		abort: !1,
		...B(t)
	});
}
function Oy(e, t) {
	return new e({
		type: "string",
		format: "ksuid",
		check: "string_format",
		abort: !1,
		...B(t)
	});
}
function ky(e, t) {
	return new e({
		type: "string",
		format: "ipv4",
		check: "string_format",
		abort: !1,
		...B(t)
	});
}
function Ay(e, t) {
	return new e({
		type: "string",
		format: "ipv6",
		check: "string_format",
		abort: !1,
		...B(t)
	});
}
function jy(e, t) {
	return new e({
		type: "string",
		format: "cidrv4",
		check: "string_format",
		abort: !1,
		...B(t)
	});
}
function My(e, t) {
	return new e({
		type: "string",
		format: "cidrv6",
		check: "string_format",
		abort: !1,
		...B(t)
	});
}
function Ny(e, t) {
	return new e({
		type: "string",
		format: "base64",
		check: "string_format",
		abort: !1,
		...B(t)
	});
}
function Py(e, t) {
	return new e({
		type: "string",
		format: "base64url",
		check: "string_format",
		abort: !1,
		...B(t)
	});
}
function Fy(e, t) {
	return new e({
		type: "string",
		format: "e164",
		check: "string_format",
		abort: !1,
		...B(t)
	});
}
function Iy(e, t) {
	return new e({
		type: "string",
		format: "jwt",
		check: "string_format",
		abort: !1,
		...B(t)
	});
}
function Ly(e, t) {
	return new e({
		type: "string",
		format: "datetime",
		check: "string_format",
		offset: !1,
		local: !1,
		precision: null,
		...B(t)
	});
}
function Ry(e, t) {
	return new e({
		type: "string",
		format: "date",
		check: "string_format",
		...B(t)
	});
}
function zy(e, t) {
	return new e({
		type: "string",
		format: "time",
		check: "string_format",
		precision: null,
		...B(t)
	});
}
function By(e, t) {
	return new e({
		type: "string",
		format: "duration",
		check: "string_format",
		...B(t)
	});
}
function Vy(e, t) {
	return new e({
		type: "number",
		checks: [],
		...B(t)
	});
}
function Hy(e, t) {
	return new e({
		type: "number",
		check: "number_format",
		abort: !1,
		format: "safeint",
		...B(t)
	});
}
function Uy(e, t) {
	return new e({
		type: "boolean",
		...B(t)
	});
}
function Wy(e, t) {
	return new e({
		type: "bigint",
		coerce: !0,
		...B(t)
	});
}
function Gy(e, t) {
	return new e({
		type: "null",
		...B(t)
	});
}
function Ky(e) {
	return new e({ type: "unknown" });
}
function qy(e, t) {
	return new e({
		type: "never",
		...B(t)
	});
}
function Jy(e, t) {
	return new e({
		type: "void",
		...B(t)
	});
}
function Yy(e, t) {
	return new F_({
		check: "less_than",
		...B(t),
		value: e,
		inclusive: !1
	});
}
function Xy(e, t) {
	return new F_({
		check: "less_than",
		...B(t),
		value: e,
		inclusive: !0
	});
}
function Zy(e, t) {
	return new I_({
		check: "greater_than",
		...B(t),
		value: e,
		inclusive: !1
	});
}
function Qy(e, t) {
	return new I_({
		check: "greater_than",
		...B(t),
		value: e,
		inclusive: !0
	});
}
function $y(e, t) {
	return new L_({
		check: "multiple_of",
		...B(t),
		value: e
	});
}
function eb(e, t) {
	return new z_({
		check: "max_length",
		...B(t),
		maximum: e
	});
}
function tb(e, t) {
	return new B_({
		check: "min_length",
		...B(t),
		minimum: e
	});
}
function nb(e, t) {
	return new V_({
		check: "length_equals",
		...B(t),
		length: e
	});
}
function rb(e, t) {
	return new U_({
		check: "string_format",
		format: "regex",
		...B(t),
		pattern: e
	});
}
function ib(e) {
	return new W_({
		check: "string_format",
		format: "lowercase",
		...B(e)
	});
}
function ab(e) {
	return new G_({
		check: "string_format",
		format: "uppercase",
		...B(e)
	});
}
function ob(e, t) {
	return new K_({
		check: "string_format",
		format: "includes",
		...B(t),
		includes: e
	});
}
function sb(e, t) {
	return new q_({
		check: "string_format",
		format: "starts_with",
		...B(t),
		prefix: e
	});
}
function cb(e, t) {
	return new J_({
		check: "string_format",
		format: "ends_with",
		...B(t),
		suffix: e
	});
}
function lb(e) {
	return new Y_({
		check: "overwrite",
		tx: e
	});
}
function ub(e) {
	return lb((t) => t.normalize(e));
}
function db() {
	return lb((e) => e.trim());
}
function fb() {
	return lb((e) => e.toLowerCase());
}
function pb() {
	return lb((e) => e.toUpperCase());
}
function mb(e, t, n) {
	return new e({
		type: "array",
		element: t,
		...B(n)
	});
}
function hb(e, t, n) {
	return new e({
		type: "custom",
		check: "custom",
		fn: t,
		...B(n)
	});
}
function gb(e) {
	let t = _b((n) => (n.addIssue = (e) => {
		if (typeof e == "string") n.issues.push(Pg(e, n.value, t._zod.def));
		else {
			let r = e;
			r.fatal && (r.continue = !1), r.code ??= "custom", r.input ??= n.value, r.inst ??= t, r.continue ??= !t._zod.def.abort, n.issues.push(Pg(r));
		}
	}, e(n.value, n)));
	return t;
}
function _b(e, t) {
	let n = new N_({
		check: "custom",
		...B(t)
	});
	return n._zod.check = e, n;
}
var vb = /*@__PURE__*/ z("ZodISODateTime", (e, t) => {
	fv.init(e, t), Ub.init(e, t);
});
function yb(e) {
	return Ly(vb, e);
}
var bb = /*@__PURE__*/ z("ZodISODate", (e, t) => {
	pv.init(e, t), Ub.init(e, t);
});
function xb(e) {
	return Ry(bb, e);
}
var Sb = /*@__PURE__*/ z("ZodISOTime", (e, t) => {
	mv.init(e, t), Ub.init(e, t);
});
function Cb(e) {
	return zy(Sb, e);
}
var wb = /*@__PURE__*/ z("ZodISODuration", (e, t) => {
	hv.init(e, t), Ub.init(e, t);
});
function Tb(e) {
	return By(wb, e);
}
var Eb = (e, t) => {
	Ig.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
		format: { value: (t) => zg(e, t) },
		flatten: { value: (t) => Rg(e, t) },
		addIssue: { value: (t) => {
			e.issues.push(t), e.message = JSON.stringify(e.issues, tg, 2);
		} },
		addIssues: { value: (t) => {
			e.issues.push(...t), e.message = JSON.stringify(e.issues, tg, 2);
		} },
		isEmpty: { get() {
			return e.issues.length === 0;
		} }
	});
};
z("ZodError", Eb);
var Db = z("ZodError", Eb, { Parent: Error }), Ob = /* @__PURE__ */ Bg(Db), kb = /* @__PURE__ */ Vg(Db), Ab = /* @__PURE__ */ Hg(Db), jb = /* @__PURE__ */ Wg(Db), Mb = /* @__PURE__ */ Kg(Db), Nb = /* @__PURE__ */ qg(Db), Pb = /* @__PURE__ */ Jg(Db), Fb = /* @__PURE__ */ Yg(Db), Ib = /* @__PURE__ */ Xg(Db), Lb = /* @__PURE__ */ Zg(Db), Rb = /* @__PURE__ */ Qg(Db), zb = /* @__PURE__ */ $g(Db), Bb = /*@__PURE__*/ z("ZodType", (e, t) => (Q_.init(e, t), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.check = (...n) => e.clone({
	...t,
	checks: [...t.checks ?? [], ...n.map((e) => typeof e == "function" ? { _zod: {
		check: e,
		def: { check: "custom" },
		onattach: []
	} } : e)]
}), e.clone = (t, n) => yg(e, t, n), e.brand = () => e, e.register = ((t, n) => (t.add(e, n), e)), e.parse = (t, n) => Ob(e, t, n, { callee: e.parse }), e.safeParse = (t, n) => Ab(e, t, n), e.parseAsync = async (t, n) => kb(e, t, n, { callee: e.parseAsync }), e.safeParseAsync = async (t, n) => jb(e, t, n), e.spa = e.safeParseAsync, e.encode = (t, n) => Mb(e, t, n), e.decode = (t, n) => Nb(e, t, n), e.encodeAsync = async (t, n) => Pb(e, t, n), e.decodeAsync = async (t, n) => Fb(e, t, n), e.safeEncode = (t, n) => Ib(e, t, n), e.safeDecode = (t, n) => Lb(e, t, n), e.safeEncodeAsync = async (t, n) => Rb(e, t, n), e.safeDecodeAsync = async (t, n) => zb(e, t, n), e.refine = (t, n) => e.check(Yx(t, n)), e.superRefine = (t) => e.check(Xx(t)), e.overwrite = (t) => e.check(lb(t)), e.optional = () => Nx(e), e.nullable = () => Fx(e), e.nullish = () => Nx(Fx(e)), e.nonoptional = (t) => Vx(e, t), e.array = () => J(e), e.or = (t) => X([e, t]), e.and = (t) => Ex(e, t), e.transform = (t) => Gx(e, jx(t)), e.default = (t) => Lx(e, t), e.prefault = (t) => zx(e, t), e.catch = (t) => Ux(e, t), e.pipe = (t) => Gx(e, t), e.readonly = () => qx(e), e.describe = (t) => {
	let n = e.clone();
	return V.add(n, { description: t }), n;
}, Object.defineProperty(e, "description", {
	get() {
		return V.get(e)?.description;
	},
	configurable: !0
}), e.meta = (...t) => {
	if (t.length === 0) return V.get(e);
	let n = e.clone();
	return V.add(n, t[0]), n;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e)), Vb = /*@__PURE__*/ z("_ZodString", (e, t) => {
	$_.init(e, t), Bb.init(e, t);
	let n = e._zod.bag;
	e.format = n.format ?? null, e.minLength = n.minimum ?? null, e.maxLength = n.maximum ?? null, e.regex = (...t) => e.check(rb(...t)), e.includes = (...t) => e.check(ob(...t)), e.startsWith = (...t) => e.check(sb(...t)), e.endsWith = (...t) => e.check(cb(...t)), e.min = (...t) => e.check(tb(...t)), e.max = (...t) => e.check(eb(...t)), e.length = (...t) => e.check(nb(...t)), e.nonempty = (...t) => e.check(tb(1, ...t)), e.lowercase = (t) => e.check(ib(t)), e.uppercase = (t) => e.check(ab(t)), e.trim = () => e.check(db()), e.normalize = (...t) => e.check(ub(...t)), e.toLowerCase = () => e.check(fb()), e.toUpperCase = () => e.check(pb());
}), Hb = /*@__PURE__*/ z("ZodString", (e, t) => {
	$_.init(e, t), Vb.init(e, t), e.email = (t) => e.check(hy(Wb, t)), e.url = (t) => e.check(xy(Yb, t)), e.jwt = (t) => e.check(Iy(dx, t)), e.emoji = (t) => e.check(Sy(Zb, t)), e.guid = (t) => e.check(gy(Kb, t)), e.uuid = (t) => e.check(_y(qb, t)), e.uuidv4 = (t) => e.check(vy(qb, t)), e.uuidv6 = (t) => e.check(yy(qb, t)), e.uuidv7 = (t) => e.check(by(qb, t)), e.nanoid = (t) => e.check(Cy(Qb, t)), e.guid = (t) => e.check(gy(Kb, t)), e.cuid = (t) => e.check(wy($b, t)), e.cuid2 = (t) => e.check(Ty(ex, t)), e.ulid = (t) => e.check(Ey(tx, t)), e.base64 = (t) => e.check(Ny(cx, t)), e.base64url = (t) => e.check(Py(lx, t)), e.xid = (t) => e.check(Dy(nx, t)), e.ksuid = (t) => e.check(Oy(rx, t)), e.ipv4 = (t) => e.check(ky(ix, t)), e.ipv6 = (t) => e.check(Ay(ax, t)), e.cidrv4 = (t) => e.check(jy(ox, t)), e.cidrv6 = (t) => e.check(My(sx, t)), e.e164 = (t) => e.check(Fy(ux, t)), e.datetime = (t) => e.check(yb(t)), e.date = (t) => e.check(xb(t)), e.time = (t) => e.check(Cb(t)), e.duration = (t) => e.check(Tb(t));
});
function H(e) {
	return my(Hb, e);
}
var Ub = /*@__PURE__*/ z("ZodStringFormat", (e, t) => {
	ev.init(e, t), Vb.init(e, t);
}), Wb = /*@__PURE__*/ z("ZodEmail", (e, t) => {
	rv.init(e, t), Ub.init(e, t);
});
function Gb(e) {
	return hy(Wb, e);
}
var Kb = /*@__PURE__*/ z("ZodGUID", (e, t) => {
	tv.init(e, t), Ub.init(e, t);
}), qb = /*@__PURE__*/ z("ZodUUID", (e, t) => {
	nv.init(e, t), Ub.init(e, t);
});
function Jb(e) {
	return _y(qb, e);
}
var Yb = /*@__PURE__*/ z("ZodURL", (e, t) => {
	iv.init(e, t), Ub.init(e, t);
});
function Xb(e) {
	return xy(Yb, e);
}
var Zb = /*@__PURE__*/ z("ZodEmoji", (e, t) => {
	av.init(e, t), Ub.init(e, t);
}), Qb = /*@__PURE__*/ z("ZodNanoID", (e, t) => {
	ov.init(e, t), Ub.init(e, t);
}), $b = /*@__PURE__*/ z("ZodCUID", (e, t) => {
	sv.init(e, t), Ub.init(e, t);
}), ex = /*@__PURE__*/ z("ZodCUID2", (e, t) => {
	cv.init(e, t), Ub.init(e, t);
}), tx = /*@__PURE__*/ z("ZodULID", (e, t) => {
	lv.init(e, t), Ub.init(e, t);
}), nx = /*@__PURE__*/ z("ZodXID", (e, t) => {
	uv.init(e, t), Ub.init(e, t);
}), rx = /*@__PURE__*/ z("ZodKSUID", (e, t) => {
	dv.init(e, t), Ub.init(e, t);
}), ix = /*@__PURE__*/ z("ZodIPv4", (e, t) => {
	gv.init(e, t), Ub.init(e, t);
}), ax = /*@__PURE__*/ z("ZodIPv6", (e, t) => {
	_v.init(e, t), Ub.init(e, t);
}), ox = /*@__PURE__*/ z("ZodCIDRv4", (e, t) => {
	vv.init(e, t), Ub.init(e, t);
}), sx = /*@__PURE__*/ z("ZodCIDRv6", (e, t) => {
	yv.init(e, t), Ub.init(e, t);
}), cx = /*@__PURE__*/ z("ZodBase64", (e, t) => {
	xv.init(e, t), Ub.init(e, t);
}), lx = /*@__PURE__*/ z("ZodBase64URL", (e, t) => {
	Cv.init(e, t), Ub.init(e, t);
}), ux = /*@__PURE__*/ z("ZodE164", (e, t) => {
	wv.init(e, t), Ub.init(e, t);
}), dx = /*@__PURE__*/ z("ZodJWT", (e, t) => {
	Ev.init(e, t), Ub.init(e, t);
}), fx = /*@__PURE__*/ z("ZodNumber", (e, t) => {
	Dv.init(e, t), Bb.init(e, t), e.gt = (t, n) => e.check(Zy(t, n)), e.gte = (t, n) => e.check(Qy(t, n)), e.min = (t, n) => e.check(Qy(t, n)), e.lt = (t, n) => e.check(Yy(t, n)), e.lte = (t, n) => e.check(Xy(t, n)), e.max = (t, n) => e.check(Xy(t, n)), e.int = (t) => e.check(W(t)), e.safe = (t) => e.check(W(t)), e.positive = (t) => e.check(Zy(0, t)), e.nonnegative = (t) => e.check(Qy(0, t)), e.negative = (t) => e.check(Yy(0, t)), e.nonpositive = (t) => e.check(Xy(0, t)), e.multipleOf = (t, n) => e.check($y(t, n)), e.step = (t, n) => e.check($y(t, n)), e.finite = () => e;
	let n = e._zod.bag;
	e.minValue = Math.max(n.minimum ?? -Infinity, n.exclusiveMinimum ?? -Infinity) ?? null, e.maxValue = Math.min(n.maximum ?? Infinity, n.exclusiveMaximum ?? Infinity) ?? null, e.isInt = (n.format ?? "").includes("int") || Number.isSafeInteger(n.multipleOf ?? .5), e.isFinite = !0, e.format = n.format ?? null;
});
function U(e) {
	return Vy(fx, e);
}
var px = /*@__PURE__*/ z("ZodNumberFormat", (e, t) => {
	Ov.init(e, t), fx.init(e, t);
});
function W(e) {
	return Hy(px, e);
}
var mx = /*@__PURE__*/ z("ZodBoolean", (e, t) => {
	kv.init(e, t), Bb.init(e, t);
});
function G(e) {
	return Uy(mx, e);
}
var hx = /*@__PURE__*/ z("ZodBigInt", (e, t) => {
	Av.init(e, t), Bb.init(e, t), e.gte = (t, n) => e.check(Qy(t, n)), e.min = (t, n) => e.check(Qy(t, n)), e.gt = (t, n) => e.check(Zy(t, n)), e.gte = (t, n) => e.check(Qy(t, n)), e.min = (t, n) => e.check(Qy(t, n)), e.lt = (t, n) => e.check(Yy(t, n)), e.lte = (t, n) => e.check(Xy(t, n)), e.max = (t, n) => e.check(Xy(t, n)), e.positive = (t) => e.check(Zy(BigInt(0), t)), e.negative = (t) => e.check(Yy(BigInt(0), t)), e.nonpositive = (t) => e.check(Xy(BigInt(0), t)), e.nonnegative = (t) => e.check(Qy(BigInt(0), t)), e.multipleOf = (t, n) => e.check($y(t, n));
	let n = e._zod.bag;
	e.minValue = n.minimum ?? null, e.maxValue = n.maximum ?? null, e.format = n.format ?? null;
}), gx = /*@__PURE__*/ z("ZodNull", (e, t) => {
	jv.init(e, t), Bb.init(e, t);
});
function _x(e) {
	return Gy(gx, e);
}
var vx = /*@__PURE__*/ z("ZodUnknown", (e, t) => {
	Mv.init(e, t), Bb.init(e, t);
});
function K() {
	return Ky(vx);
}
var yx = /*@__PURE__*/ z("ZodNever", (e, t) => {
	Nv.init(e, t), Bb.init(e, t);
});
function q(e) {
	return qy(yx, e);
}
var bx = /*@__PURE__*/ z("ZodVoid", (e, t) => {
	Pv.init(e, t), Bb.init(e, t);
});
function xx(e) {
	return Jy(bx, e);
}
var Sx = /*@__PURE__*/ z("ZodArray", (e, t) => {
	Iv.init(e, t), Bb.init(e, t), e.element = t.element, e.min = (t, n) => e.check(tb(t, n)), e.nonempty = (t) => e.check(tb(1, t)), e.max = (t, n) => e.check(eb(t, n)), e.length = (t, n) => e.check(nb(t, n)), e.unwrap = () => e.element;
});
function J(e, t) {
	return mb(Sx, e, t);
}
var Cx = /*@__PURE__*/ z("ZodObject", (e, t) => {
	Vv.init(e, t), Bb.init(e, t), sg(e, "shape", () => t.shape), e.keyof = () => Q(Object.keys(e._zod.def.shape)), e.catchall = (t) => e.clone({
		...e._zod.def,
		catchall: t
	}), e.passthrough = () => e.clone({
		...e._zod.def,
		catchall: K()
	}), e.loose = () => e.clone({
		...e._zod.def,
		catchall: K()
	}), e.strict = () => e.clone({
		...e._zod.def,
		catchall: q()
	}), e.strip = () => e.clone({
		...e._zod.def,
		catchall: void 0
	}), e.extend = (t) => wg(e, t), e.safeExtend = (t) => Tg(e, t), e.merge = (t) => Eg(e, t), e.pick = (t) => Sg(e, t), e.omit = (t) => Cg(e, t), e.partial = (...t) => Dg(Mx, e, t[0]), e.required = (...t) => Og(Bx, e, t[0]);
});
function Y(e, t) {
	return new Cx({
		type: "object",
		get shape() {
			return lg(this, "shape", e ? cg(e) : {}), this.shape;
		},
		...B(t)
	});
}
var wx = /*@__PURE__*/ z("ZodUnion", (e, t) => {
	Uv.init(e, t), Bb.init(e, t), e.options = t.options;
});
function X(e, t) {
	return new wx({
		type: "union",
		options: e,
		...B(t)
	});
}
var Tx = /*@__PURE__*/ z("ZodIntersection", (e, t) => {
	Wv.init(e, t), Bb.init(e, t);
});
function Ex(e, t) {
	return new Tx({
		type: "intersection",
		left: e,
		right: t
	});
}
var Dx = /*@__PURE__*/ z("ZodRecord", (e, t) => {
	qv.init(e, t), Bb.init(e, t), e.keyType = t.keyType, e.valueType = t.valueType;
});
function Z(e, t, n) {
	return new Dx({
		type: "record",
		keyType: e,
		valueType: t,
		...B(n)
	});
}
var Ox = /*@__PURE__*/ z("ZodEnum", (e, t) => {
	Jv.init(e, t), Bb.init(e, t), e.enum = t.entries, e.options = Object.values(t.entries);
	let n = new Set(Object.keys(t.entries));
	e.extract = (e, r) => {
		let i = {};
		for (let r of e) if (n.has(r)) i[r] = t.entries[r];
		else throw Error(`Key ${r} not found in enum`);
		return new Ox({
			...t,
			checks: [],
			...B(r),
			entries: i
		});
	}, e.exclude = (e, r) => {
		let i = { ...t.entries };
		for (let t of e) if (n.has(t)) delete i[t];
		else throw Error(`Key ${t} not found in enum`);
		return new Ox({
			...t,
			checks: [],
			...B(r),
			entries: i
		});
	};
});
function Q(e, t) {
	return new Ox({
		type: "enum",
		entries: Array.isArray(e) ? Object.fromEntries(e.map((e) => [e, e])) : e,
		...B(t)
	});
}
var kx = /*@__PURE__*/ z("ZodLiteral", (e, t) => {
	Yv.init(e, t), Bb.init(e, t), e.values = new Set(t.values), Object.defineProperty(e, "value", { get() {
		if (t.values.length > 1) throw Error("This schema contains multiple valid literal values. Use `.values` instead.");
		return t.values[0];
	} });
});
function $(e, t) {
	return new kx({
		type: "literal",
		values: Array.isArray(e) ? e : [e],
		...B(t)
	});
}
var Ax = /*@__PURE__*/ z("ZodTransform", (e, t) => {
	Xv.init(e, t), Bb.init(e, t), e._zod.parse = (n, r) => {
		if (r.direction === "backward") throw new Zh(e.constructor.name);
		n.addIssue = (r) => {
			if (typeof r == "string") n.issues.push(Pg(r, n.value, t));
			else {
				let t = r;
				t.fatal && (t.continue = !1), t.code ??= "custom", t.input ??= n.value, t.inst ??= e, n.issues.push(Pg(t));
			}
		};
		let i = t.transform(n.value, n);
		return i instanceof Promise ? i.then((e) => (n.value = e, n)) : (n.value = i, n);
	};
});
function jx(e) {
	return new Ax({
		type: "transform",
		transform: e
	});
}
var Mx = /*@__PURE__*/ z("ZodOptional", (e, t) => {
	Qv.init(e, t), Bb.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Nx(e) {
	return new Mx({
		type: "optional",
		innerType: e
	});
}
var Px = /*@__PURE__*/ z("ZodNullable", (e, t) => {
	$v.init(e, t), Bb.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Fx(e) {
	return new Px({
		type: "nullable",
		innerType: e
	});
}
var Ix = /*@__PURE__*/ z("ZodDefault", (e, t) => {
	ey.init(e, t), Bb.init(e, t), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function Lx(e, t) {
	return new Ix({
		type: "default",
		innerType: e,
		get defaultValue() {
			return typeof t == "function" ? t() : gg(t);
		}
	});
}
var Rx = /*@__PURE__*/ z("ZodPrefault", (e, t) => {
	ny.init(e, t), Bb.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function zx(e, t) {
	return new Rx({
		type: "prefault",
		innerType: e,
		get defaultValue() {
			return typeof t == "function" ? t() : gg(t);
		}
	});
}
var Bx = /*@__PURE__*/ z("ZodNonOptional", (e, t) => {
	ry.init(e, t), Bb.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Vx(e, t) {
	return new Bx({
		type: "nonoptional",
		innerType: e,
		...B(t)
	});
}
var Hx = /*@__PURE__*/ z("ZodCatch", (e, t) => {
	ay.init(e, t), Bb.init(e, t), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function Ux(e, t) {
	return new Hx({
		type: "catch",
		innerType: e,
		catchValue: typeof t == "function" ? t : () => t
	});
}
var Wx = /*@__PURE__*/ z("ZodPipe", (e, t) => {
	oy.init(e, t), Bb.init(e, t), e.in = t.in, e.out = t.out;
});
function Gx(e, t) {
	return new Wx({
		type: "pipe",
		in: e,
		out: t
	});
}
var Kx = /*@__PURE__*/ z("ZodReadonly", (e, t) => {
	cy.init(e, t), Bb.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function qx(e) {
	return new Kx({
		type: "readonly",
		innerType: e
	});
}
var Jx = /*@__PURE__*/ z("ZodCustom", (e, t) => {
	uy.init(e, t), Bb.init(e, t);
});
function Yx(e, t = {}) {
	return hb(Jx, e, t);
}
function Xx(e) {
	return gb(e);
}
function Zx(e) {
	return Wy(hx, e);
}
var Qx = { bodySerializer: (e) => JSON.stringify(e, (e, t) => typeof t == "bigint" ? t.toString() : t) };
Object.entries({
	$body_: "body",
	$headers_: "headers",
	$path_: "path",
	$query_: "query"
});
var $x = ({ onRequest: e, onSseError: t, onSseEvent: n, responseTransformer: r, responseValidator: i, sseDefaultRetryDelay: a, sseMaxRetryAttempts: o, sseMaxRetryDelay: s, sseSleepFn: c, url: l, ...u }) => {
	let d, f = c ?? ((e) => new Promise((t) => setTimeout(t, e)));
	return { stream: async function* () {
		let c = a ?? 3e3, p = 0, m = u.signal ?? new AbortController().signal;
		for (; !m.aborted;) {
			p++;
			let a = u.headers instanceof Headers ? u.headers : new Headers(u.headers);
			d !== void 0 && a.set("Last-Event-ID", d);
			try {
				let t = {
					redirect: "follow",
					...u,
					body: u.serializedBody,
					headers: a,
					signal: m
				}, o = new Request(l, t);
				e && (o = await e(l, t));
				let s = await (u.fetch ?? globalThis.fetch)(o);
				if (!s.ok) throw Error(`SSE failed: ${s.status} ${s.statusText}`);
				if (!s.body) throw Error("No body in SSE response");
				let f = s.body.pipeThrough(new TextDecoderStream()).getReader(), p = "", h = () => {
					try {
						f.cancel();
					} catch {}
				};
				m.addEventListener("abort", h);
				try {
					for (;;) {
						let { done: e, value: t } = await f.read();
						if (e) break;
						p += t, p = p.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
						let a = p.split("\n\n");
						p = a.pop() ?? "";
						for (let e of a) {
							let t = e.split("\n"), a = [], o;
							for (let e of t) if (e.startsWith("data:")) a.push(e.replace(/^data:\s*/, ""));
							else if (e.startsWith("event:")) o = e.replace(/^event:\s*/, "");
							else if (e.startsWith("id:")) d = e.replace(/^id:\s*/, "");
							else if (e.startsWith("retry:")) {
								let t = Number.parseInt(e.replace(/^retry:\s*/, ""), 10);
								Number.isNaN(t) || (c = t);
							}
							let s, l = !1;
							if (a.length) {
								let e = a.join("\n");
								try {
									s = JSON.parse(e), l = !0;
								} catch {
									s = e;
								}
							}
							l && (i && await i(s), r && (s = await r(s))), n?.({
								data: s,
								event: o,
								id: d,
								retry: c
							}), a.length && (yield s);
						}
					}
				} finally {
					m.removeEventListener("abort", h), f.releaseLock();
				}
				break;
			} catch (e) {
				if (t?.(e), o !== void 0 && p >= o) break;
				let n = Math.min(c * 2 ** (p - 1), s ?? 3e4);
				await f(n);
			}
		}
	}() };
}, eS = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, tS = (e) => {
	switch (e) {
		case "form": return ",";
		case "pipeDelimited": return "|";
		case "spaceDelimited": return "%20";
		default: return ",";
	}
}, nS = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, rS = ({ allowReserved: e, explode: t, name: n, style: r, value: i }) => {
	if (!t) {
		let t = (e ? i : i.map((e) => encodeURIComponent(e))).join(tS(r));
		switch (r) {
			case "label": return `.${t}`;
			case "matrix": return `;${n}=${t}`;
			case "simple": return t;
			default: return `${n}=${t}`;
		}
	}
	let a = eS(r), o = i.map((t) => r === "label" || r === "simple" ? e ? t : encodeURIComponent(t) : iS({
		allowReserved: e,
		name: n,
		value: t
	})).join(a);
	return r === "label" || r === "matrix" ? a + o : o;
}, iS = ({ allowReserved: e, name: t, value: n }) => {
	if (n == null) return "";
	if (typeof n == "object") throw Error("Deeply-nested arrays/objects aren’t supported. Provide your own `querySerializer()` to handle these.");
	return `${t}=${e ? n : encodeURIComponent(n)}`;
}, aS = ({ allowReserved: e, explode: t, name: n, style: r, value: i, valueOnly: a }) => {
	if (i instanceof Date) return a ? i.toISOString() : `${n}=${i.toISOString()}`;
	if (r !== "deepObject" && !t) {
		let t = [];
		Object.entries(i).forEach(([n, r]) => {
			t = [
				...t,
				n,
				e ? r : encodeURIComponent(r)
			];
		});
		let a = t.join(",");
		switch (r) {
			case "form": return `${n}=${a}`;
			case "label": return `.${a}`;
			case "matrix": return `;${n}=${a}`;
			default: return a;
		}
	}
	let o = nS(r), s = Object.entries(i).map(([t, i]) => iS({
		allowReserved: e,
		name: r === "deepObject" ? `${n}[${t}]` : t,
		value: i
	})).join(o);
	return r === "label" || r === "matrix" ? o + s : s;
}, oS = /\{[^{}]+\}/g, sS = ({ path: e, url: t }) => {
	let n = t, r = t.match(oS);
	if (r) for (let t of r) {
		let r = !1, i = t.substring(1, t.length - 1), a = "simple";
		i.endsWith("*") && (r = !0, i = i.substring(0, i.length - 1)), i.startsWith(".") ? (i = i.substring(1), a = "label") : i.startsWith(";") && (i = i.substring(1), a = "matrix");
		let o = e[i];
		if (o == null) continue;
		if (Array.isArray(o)) {
			n = n.replace(t, rS({
				explode: r,
				name: i,
				style: a,
				value: o
			}));
			continue;
		}
		if (typeof o == "object") {
			n = n.replace(t, aS({
				explode: r,
				name: i,
				style: a,
				value: o,
				valueOnly: !0
			}));
			continue;
		}
		if (a === "matrix") {
			n = n.replace(t, `;${iS({
				name: i,
				value: o
			})}`);
			continue;
		}
		let s = encodeURIComponent(a === "label" ? `.${o}` : o);
		n = n.replace(t, s);
	}
	return n;
}, cS = ({ baseUrl: e, path: t, query: n, querySerializer: r, url: i }) => {
	let a = i.startsWith("/") ? i : `/${i}`, o = (e ?? "") + a;
	t && (o = sS({
		path: t,
		url: o
	}));
	let s = n ? r(n) : "";
	return s.startsWith("?") && (s = s.substring(1)), s && (o += `?${s}`), o;
};
function lS(e) {
	let t = e.body !== void 0;
	if (t && e.bodySerializer) return "serializedBody" in e ? e.serializedBody !== void 0 && e.serializedBody !== "" ? e.serializedBody : null : e.body === "" ? null : e.body;
	if (t) return e.body;
}
var uS = async (e, t) => {
	let n = typeof t == "function" ? await t(e) : t;
	if (n) return e.scheme === "bearer" ? `Bearer ${n}` : e.scheme === "basic" ? `Basic ${btoa(n)}` : n;
}, dS = ({ parameters: e = {}, ...t } = {}) => (n) => {
	let r = [];
	if (n && typeof n == "object") for (let i in n) {
		let a = n[i];
		if (a == null) continue;
		let o = e[i] || t;
		if (Array.isArray(a)) {
			let e = rS({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "form",
				value: a,
				...o.array
			});
			e && r.push(e);
		} else if (typeof a == "object") {
			let e = aS({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "deepObject",
				value: a,
				...o.object
			});
			e && r.push(e);
		} else {
			let e = iS({
				allowReserved: o.allowReserved,
				name: i,
				value: a
			});
			e && r.push(e);
		}
	}
	return r.join("&");
}, fS = (e) => {
	if (!e) return "stream";
	let t = e.split(";")[0]?.trim();
	if (t) {
		if (t.startsWith("application/json") || t.endsWith("+json")) return "json";
		if (t === "multipart/form-data") return "formData";
		if ([
			"application/",
			"audio/",
			"image/",
			"video/"
		].some((e) => t.startsWith(e))) return "blob";
		if (t.startsWith("text/")) return "text";
	}
}, pS = (e, t) => t ? !!(e.headers.has(t) || e.query?.[t] || e.headers.get("Cookie")?.includes(`${t}=`)) : !1, mS = async ({ security: e, ...t }) => {
	for (let n of e) {
		if (pS(t, n.name)) continue;
		let e = await uS(n, t.auth);
		if (!e) continue;
		let r = n.name ?? "Authorization";
		switch (n.in) {
			case "query":
				t.query ||= {}, t.query[r] = e;
				break;
			case "cookie":
				t.headers.append("Cookie", `${r}=${e}`);
				break;
			default: t.headers.set(r, e);
		}
	}
}, hS = (e) => cS({
	baseUrl: e.baseUrl,
	path: e.path,
	query: e.query,
	querySerializer: typeof e.querySerializer == "function" ? e.querySerializer : dS(e.querySerializer),
	url: e.url
}), gS = (e, t) => {
	let n = {
		...e,
		...t
	};
	return n.baseUrl?.endsWith("/") && (n.baseUrl = n.baseUrl.substring(0, n.baseUrl.length - 1)), n.headers = vS(e.headers, t.headers), n;
}, _S = (e) => {
	let t = [];
	return e.forEach((e, n) => {
		t.push([n, e]);
	}), t;
}, vS = (...e) => {
	let t = new Headers();
	for (let n of e) {
		if (!n) continue;
		let e = n instanceof Headers ? _S(n) : Object.entries(n);
		for (let [n, r] of e) if (r === null) t.delete(n);
		else if (Array.isArray(r)) for (let e of r) t.append(n, e);
		else r !== void 0 && t.set(n, typeof r == "object" ? JSON.stringify(r) : r);
	}
	return t;
}, yS = class {
	fns = [];
	clear() {
		this.fns = [];
	}
	eject(e) {
		let t = this.getInterceptorIndex(e);
		this.fns[t] && (this.fns[t] = null);
	}
	exists(e) {
		let t = this.getInterceptorIndex(e);
		return !!this.fns[t];
	}
	getInterceptorIndex(e) {
		return typeof e == "number" ? this.fns[e] ? e : -1 : this.fns.indexOf(e);
	}
	update(e, t) {
		let n = this.getInterceptorIndex(e);
		return this.fns[n] ? (this.fns[n] = t, e) : !1;
	}
	use(e) {
		return this.fns.push(e), this.fns.length - 1;
	}
}, bS = () => ({
	error: new yS(),
	request: new yS(),
	response: new yS()
}), xS = dS({
	allowReserved: !1,
	array: {
		explode: !0,
		style: "form"
	},
	object: {
		explode: !0,
		style: "deepObject"
	}
}), SS = { "Content-Type": "application/json" }, CS = (e = {}) => ({
	...Qx,
	headers: SS,
	parseAs: "auto",
	querySerializer: xS,
	...e
});
((e = {}) => {
	let t = gS(CS(), e), n = () => ({ ...t }), r = (e) => (t = gS(t, e), n()), i = bS(), a = async (e) => {
		let n = {
			...t,
			...e,
			fetch: e.fetch ?? t.fetch ?? globalThis.fetch,
			headers: vS(t.headers, e.headers),
			serializedBody: void 0
		};
		return n.security && await mS({
			...n,
			security: n.security
		}), n.requestValidator && await n.requestValidator(n), n.body !== void 0 && n.bodySerializer && (n.serializedBody = n.bodySerializer(n.body)), (n.body === void 0 || n.serializedBody === "") && n.headers.delete("Content-Type"), {
			opts: n,
			url: hS(n)
		};
	}, o = async (e) => {
		let { opts: t, url: n } = await a(e), r = {
			redirect: "follow",
			...t,
			body: lS(t)
		}, o = new Request(n, r);
		for (let e of i.request.fns) e && (o = await e(o, t));
		let s = t.fetch, c;
		try {
			c = await s(o);
		} catch (e) {
			let n = e;
			for (let r of i.error.fns) r && (n = await r(e, void 0, o, t));
			if (n ||= {}, t.throwOnError) throw n;
			return t.responseStyle === "data" ? void 0 : {
				error: n,
				request: o,
				response: void 0
			};
		}
		for (let e of i.response.fns) e && (c = await e(c, o, t));
		let l = {
			request: o,
			response: c
		};
		if (c.ok) {
			let e = (t.parseAs === "auto" ? fS(c.headers.get("Content-Type")) : t.parseAs) ?? "json";
			if (c.status === 204 || c.headers.get("Content-Length") === "0") {
				let n;
				switch (e) {
					case "arrayBuffer":
					case "blob":
					case "text":
						n = await c[e]();
						break;
					case "formData":
						n = new FormData();
						break;
					case "stream":
						n = c.body;
						break;
					default: n = {};
				}
				return t.responseStyle === "data" ? n : {
					data: n,
					...l
				};
			}
			let n;
			switch (e) {
				case "arrayBuffer":
				case "blob":
				case "formData":
				case "text":
					n = await c[e]();
					break;
				case "json": {
					let e = await c.text();
					n = e ? JSON.parse(e) : {};
					break;
				}
				case "stream": return t.responseStyle === "data" ? c.body : {
					data: c.body,
					...l
				};
			}
			return e === "json" && (t.responseValidator && await t.responseValidator(n), t.responseTransformer && (n = await t.responseTransformer(n))), t.responseStyle === "data" ? n : {
				data: n,
				...l
			};
		}
		let u = await c.text(), d;
		try {
			d = JSON.parse(u);
		} catch {}
		let f = d ?? u, p = f;
		for (let e of i.error.fns) e && (p = await e(f, c, o, t));
		if (p ||= {}, t.throwOnError) throw p;
		return t.responseStyle === "data" ? void 0 : {
			error: p,
			...l
		};
	}, s = (e) => (t) => o({
		...t,
		method: e
	}), c = (e) => async (t) => {
		let { opts: n, url: r } = await a(t);
		return $x({
			...n,
			body: n.body,
			headers: n.headers,
			method: e,
			onRequest: async (e, t) => {
				let r = new Request(e, t);
				for (let e of i.request.fns) e && (r = await e(r, n));
				return r;
			},
			serializedBody: lS(n),
			url: r
		});
	};
	return {
		buildUrl: (e) => hS({
			...t,
			...e
		}),
		connect: s("CONNECT"),
		delete: s("DELETE"),
		get: s("GET"),
		getConfig: n,
		head: s("HEAD"),
		interceptors: i,
		options: s("OPTIONS"),
		patch: s("PATCH"),
		post: s("POST"),
		put: s("PUT"),
		request: o,
		setConfig: r,
		sse: {
			connect: c("CONNECT"),
			delete: c("DELETE"),
			get: c("GET"),
			head: c("HEAD"),
			options: c("OPTIONS"),
			patch: c("PATCH"),
			post: c("POST"),
			put: c("PUT"),
			trace: c("TRACE")
		},
		trace: s("TRACE")
	};
})(CS({
	baseUrl: "https://api.myparcel.nl/",
	throwOnError: !0
}));
var wS = W().gte(400).lte(499).register(V, { description: "The request contains bad syntax or cannot be fulfilled" }), TS = X([X([
	$(3e3),
	$(3001),
	$(3002),
	$(3003),
	$(3004),
	$(3005),
	$(3006),
	$(3007)
]).register(V, { description: "Authentication and Authorization related error codes" }), W()]), ES = Y({
	status: wS.optional(),
	code: TS.optional(),
	title: H().optional(),
	message: H().optional()
}), DS = Y({
	message: H(),
	request_id: H().register(V, { description: "Internal request ID, useful for debugging purposes." }),
	status_code: wS,
	errors: X([J(ES), Z(H(), ES)])
}), OS = $(404).register(V, { description: "Did not find the requested target resource." });
DS.and(Y({
	status_code: OS.optional(),
	errors: J(Y({
		status: OS.optional(),
		code: W().optional()
	})).optional()
}));
var kS = Zx().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).register(V, { description: "Unique ID of a Shipment." }), AS = W().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), jS = W().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), MS = X([
	$(1),
	$(2),
	$(3),
	$(4),
	$(5),
	$(6),
	$(7),
	$(8)
]), NS = H().length(2).regex(/^[A-Za-z]{2}$/), PS = X([Q([""]), K()]).nullable(), FS = X([K(), Q([""])]).nullable(), IS = Y({
	account_id: AS.optional(),
	person: H().optional(),
	first_name: H().optional(),
	last_name: H().optional(),
	company: H().nullish(),
	street: H().optional(),
	street_additional_info: H().nullish(),
	number: H().nullish(),
	number_suffix: H().nullish(),
	postal_code: H().optional(),
	city: H().optional(),
	state: H().optional(),
	cc: NS,
	region: H().max(35).nullish(),
	area: H().optional(),
	phone: H().nullish(),
	email: X([K(), Q([""])]).nullish(),
	billing_email: PS.optional(),
	secondary_emails: J(FS).nullish(),
	box_number: H().max(8).nullish(),
	eori_number: H().optional(),
	vat_number: H().optional(),
	invalid: G().optional()
}), LS = IS.and(Y({
	person: K().optional(),
	first_name: H().max(50).optional(),
	last_name: H().max(50).optional(),
	company: K().optional(),
	street: K().optional(),
	street_additional_info: K().optional(),
	number: K().optional(),
	number_suffix: K().optional(),
	postal_code: K().optional(),
	city: K().optional(),
	state: K().optional(),
	area: K().optional(),
	phone: K().optional()
})), RS = X([
	$(1),
	$(2),
	$(3),
	$(4),
	$(5),
	$(6),
	$(7),
	$(8),
	$(9),
	$(10),
	$(11),
	$(12),
	$(13),
	$(14),
	$(15),
	$(16),
	$(17),
	$(18),
	$(19),
	$(98),
	$(99),
	$(100),
	$(101),
	$(30),
	$(31),
	$(32),
	$(33),
	$(34),
	$(35),
	$(36),
	$(37),
	$(38)
]), zS = Y({ insurance: Y({
	currency: Q(["EUR"]),
	amount: W().gte(0)
}).optional() }).and(Y({ insurance: Y({ amount: K().optional() }).optional() })), BS = X([$(0), $(1)]), VS = Y({
	currency: Q(["", "EUR"]).register(V, { description: "The currency as uppercase 3-letter ISO 4217 code." }),
	amount: X([W().gte(0), H().regex(/\d*/)])
}).register(V, { description: "Money amount with currency" }), HS = Y({
	age_check: BS.optional(),
	cash_on_delivery: VS.optional(),
	collect: BS.optional(),
	cooled_delivery: BS.optional(),
	drop_off_at_postal_point: BS.optional(),
	extra_assurance: BS.optional(),
	fresh_food: BS.optional(),
	frozen: BS.optional(),
	hide_sender: BS.optional(),
	large_format: BS.optional(),
	no_tracking: BS.optional(),
	only_recipient: BS.optional(),
	priority_delivery: BS.optional(),
	receipt_code: BS.optional(),
	return: BS.optional(),
	same_day_delivery: BS.optional(),
	saturday_delivery: BS.optional(),
	signature: BS.optional(),
	tracked: BS.optional()
}), US = X([
	$(1),
	$(2),
	$(3),
	$(4),
	$(5),
	$(6),
	$(7)
]).register(V, { description: "Package Type." }), WS = Y({ package_type: US.optional() }), GS = Y({ delivery_type: X([
	$(1),
	$(2),
	$(3),
	$(4),
	$(5),
	$(6),
	$(7),
	$(8)
]).nullish() }), KS = Y({ delivery_date: H().regex(/([0-9]{4})-([0-9]{2})-([0-9]{2}) ([0-9]{2}):([0-9]{2}):([0-9]{2})/).nullish() }), qS = Y({ label_description: H().max(45).nullish() }), JS = zS.and(HS).and(WS).and(GS).and(KS).and(qS), YS = Y({
	save_recipient_address: BS.optional(),
	delivery_notification: BS.optional(),
	delivery_notification_email: J(Gb()).optional(),
	disable_auto_detect_pickup: BS.optional(),
	printer_identifier: H().optional(),
	tracktrace: Y({
		bcc: BS.optional(),
		bcc_email: PS.optional(),
		carrier_email_basic_notification: BS.optional(),
		delivery_notification: BS.optional(),
		delivery_notification_email: J(H()).optional(),
		disable_auto_detect_pickup: BS.optional(),
		email_on_handed_to_courier: BS.optional(),
		from_address_company: H().optional(),
		from_address_email: X([K(), Q([""])]).optional(),
		printer_identifier: H().optional(),
		save_recipient_address: BS.optional(),
		send_track_trace_emails: BS.optional()
	}).optional()
}).nullable(), XS = Q([
	"retail",
	"locker",
	"post_office"
]).register(V, { description: "Pickup / drop-off location type." }), ZS = X([
	$(0),
	$(1),
	$(2),
	$(4),
	$(8),
	$(16)
]), QS = Y({
	location_code: H().optional(),
	location_name: H().optional(),
	street: H().optional(),
	number: H().optional(),
	number_suffix: H().nullish(),
	postal_code: H().optional(),
	city: H().optional(),
	cc: H().length(2).regex(/^[A-Z]{2}/).optional(),
	location_type: X([XS, ZS]).optional(),
	retail_network_id: H().optional()
}).nullable(), $S = X([
	$(1),
	$(2),
	$(3),
	$(4),
	$(5)
]), eC = Y({
	description: H().max(50),
	amount: W().gte(1).lte(99999),
	weight: W().gte(0).lte(999999999),
	item_value: VS,
	classification: H(),
	country: X([K(), Q([""])]).optional()
}), tC = Y({
	contents: $S,
	invoice: H().max(150).nullish(),
	eori_number: H().nullish(),
	vat_number: H().nullish(),
	vat_number_uk: H().nullish(),
	voec_number: H().nullish(),
	weight: W().gte(0).lte(999999999),
	items: J(eC).min(1).max(100)
}), nC = W().gte(0).lte(999999999), rC = W().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), iC = W().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), aC = W().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), oC = W().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), sC = nC, cC = rC.nullable(), lC = iC.nullable(), uC = aC.nullable(), dC = oC.nullable(), fC = Y({
	weight: nC.optional(),
	height: rC.nullish(),
	width: iC.nullish(),
	length: aC.nullish(),
	volume: oC.nullish(),
	carrier_weight: X([sC, H().regex(/^\d+$/)]).nullish(),
	carrier_height: cC.nullish(),
	carrier_width: lC.nullish(),
	carrier_length: uC.nullish(),
	carrier_volume: dC.nullish()
}).nullable(), pC = X([W(), H().max(255).regex(/^[^=\?]*$/)]).nullable(), mC = Q([
	"pending",
	"unpaid",
	"paid"
]).nullable(), hC = QS, gC = Y({
	currency: Q(["", "EUR"]).register(V, { description: "The currency as uppercase 3-letter ISO 4217 code." }),
	amount: X([W().gte(0), H().regex(/\d*/)]).nullable()
}).register(V, { description: "Money amount with currency, where the amount may be null. The amount is null when the requester lacks permission to read price amounts (Permissions::BILLING_READ_PRICE_AMOUNTS)." }), _C = Q([
	"Facebook",
	"Flespakket.nl",
	"Amazon",
	"Bol.com",
	"MyParcel.nl",
	"Wix",
	"Ecwid",
	"Exact Online DE",
	"Exact Online NL",
	"Etsy"
]), vC = Zx().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }), yC = Q([
	"pending",
	"unpaid",
	"paid"
]).nullable(), bC = X([
	$(1),
	$(2),
	$(3),
	$(4),
	$(5),
	$(6),
	$(7),
	$(8),
	$(9),
	$(10),
	$(11),
	$(12),
	$(13),
	$(14),
	$(15),
	$(16),
	$(17),
	$(18),
	$(19),
	$(20),
	$(21)
]).register(V, { description: "This enumeration represents the Carriers. The value is the Carrier id." }), xC = X([
	$(1),
	$(2),
	$(3),
	$(4),
	$(5),
	$(6)
]), SC = H().max(255), CC = H().max(255).nullable(), wC = kS.nullable(), TC = AS, EC = jS, DC = MS, OC = LS, kC = IS, AC = RS, jC = JS.and(K()), MC = YS, NC = QS, PC = tC.nullable(), FC = fC, IC = pC, LC = mC, RC = hC, zC = BS, BC = gC, VC = H().max(255), HC = X([K(), Q(["Wereld"])]), UC = _C.nullable(), WC = vC.nullable(), GC = yC, KC = bC, qC = xC, JC = SC.nullable(), YC = CC, XC = H().max(255), ZC = H().max(255), QC = X([H().regex(/\d+/), W()]), $C = H().max(255), ew = H().max(255), tw = H().max(255), nw = H().regex(/^[A-Z][A-Z]$/), rw = H().max(255), iw = H().max(8).nullable(), aw = Y({
	id: W().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).optional(),
	gender: H().max(3).nullish(),
	first_name: H().max(255).nullish(),
	last_name: H().max(255).nullable(),
	email: X([Q([""]), K()]).nullable(),
	phone: H().max(100).nullable(),
	company: H().max(255).nullable(),
	street: XC,
	street_additional_info: ZC.optional(),
	number: QC,
	number_suffix: $C.optional(),
	postal_code: ew,
	city: tw,
	cc: nw,
	region: rw.optional(),
	box_number: iw.optional()
}), ow = aw.nullable(), sw = kS.nullable(), cw = H().max(255).nullable(), lw = cw, uw = G().default(!1), dw = G().default(!1), fw = W().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).nullable(), pw = Q(["", "EUR"]), mw = pw.nullable(), hw = Zx().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).nullable(), gw = X([K(), Q([""])]).nullable(), _w = J(Y({
	uri: X([Q([""]), K()]),
	barcode: H()
})), vw = _w, yw = H().nullable(), bw = Jb().max(36).nullable(), xw = W().nullable(), Sw = H().nullable(), Cw = Z(H(), K()).nullable(), ww = H().nullable(), Tw = Y({
	quantity: xw.optional(),
	order_line_identifier: Sw.optional(),
	order_line: Cw.optional(),
	picklist_identifier: ww.optional(),
	order_identifier: H().nullish()
}).nullable(), Ew = J(Tw).nullable(), Dw = H().regex(/\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2]\d|3[0-1]) ([0-1]\d|2[0-4]):[0-5]\d(:([0-5]\d|60)(.\d+)?)?/).register(V, { description: "Represents a date in ISO 8601 format and a time in ISO 8601 format, separated\nby a space, so:\n\n```\nYYYY-MM-DD hh:mm:ss.u\n```\n\nWhere:\n  - `YYYY` represents a four-digit year, `0000` through `9999`\n  - `MM` represents a zero-padded month of the year, `01` through `12`\n  - `DD` represents a zero-padded day of that month, `01` through `31`\nand:\n  - `hh` represents a zero-padded hour, `00` through `24`\n  - `mm` represents a zero-padded minute, `00` through `59`\n  - `ss` (optional) represents a zero-padded second, `00` through `60`\n    (where `60` is only used to denote an added leap second)\n  - `.u` (optional) represents a fraction of a second, `.0` through `.999999+`\n" }), Ow = Dw, kw = Ow, Aw = Dw, jw = Aw, Mw = Zx().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }), Nw = Mw.nullable(), Pw = Nw, Fw = Mw.nullable(), Iw = Fw, Lw = Y({
	id: Zx().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).register(V, { description: "Unique ID of a Shipment." }),
	parent_id: kS.nullable(),
	account_id: AS,
	shop_id: jS,
	shipment_type: MS,
	recipient: LS,
	sender: IS,
	status: RS,
	options: JS.and(K()),
	general_settings: YS,
	pickup: QS,
	customs_declaration: tC.nullable(),
	physical_properties: fC,
	reference_identifier: pC,
	transaction_status: mC,
	drop_off_point: hC,
	hidden: BS,
	price: gC,
	barcode: H().max(255),
	region: X([K(), Q(["Wereld"])]),
	external_provider: _C.nullable(),
	external_provider_id: vC.nullable(),
	payment_status: yC,
	carrier_id: bC,
	platform_id: xC,
	origin: SC.nullable(),
	user_agent: CC,
	secondary_shipments: J(Y({
		id: kS,
		parent_id: wC,
		account_id: TC,
		shop_id: EC,
		shipment_type: DC,
		recipient: OC,
		sender: kC,
		status: AC,
		options: jC,
		general_settings: MC,
		pickup: NC,
		customs_declaration: PC,
		physical_properties: FC,
		reference_identifier: IC,
		transaction_status: LC,
		drop_off_point: RC,
		hidden: zC,
		price: BC,
		barcode: VC,
		region: HC,
		external_provider: UC,
		external_provider_id: WC,
		payment_status: GC,
		carrier_id: KC,
		platform_id: qC,
		origin: JC,
		user_agent: YC,
		secondary_shipments: J(K()).max(0).nullish(),
		collection_contact: ow,
		multi_collo_main_shipment_id: sw,
		external_identifier: lw,
		delayed: uw,
		delivered: dw,
		amount: fw.optional(),
		currency: mw.optional(),
		contract_id: hw,
		link_consumer_portal: gw.optional(),
		partner_tracktraces: vw.optional(),
		pickup_request_number: yw.optional(),
		order_shipment_identifier: bw.optional(),
		shipped_items: Ew.optional(),
		created: kw,
		modified: jw,
		created_by: Pw,
		modified_by: Iw
	})),
	collection_contact: aw.nullable(),
	multi_collo_main_shipment_id: kS.nullable(),
	external_identifier: cw,
	delayed: G().default(!1),
	delivered: G().default(!1),
	amount: W().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).nullish(),
	currency: pw.nullish(),
	contract_id: Zx().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).nullable(),
	link_consumer_portal: X([K(), Q([""])]).nullish(),
	partner_tracktraces: _w.optional(),
	pickup_request_number: H().nullish(),
	order_shipment_identifier: Jb().max(36).nullish(),
	shipped_items: J(Tw).nullish(),
	created: Ow,
	modified: Aw,
	created_by: Nw,
	modified_by: Fw
}), Rw = Y({ data: Y({ shipments: J(Lw).register(V, { description: "A list of Shipment Resources." }) }) });
X([H(), K()]);
var zw = Y({ url: Xb() }), Bw = Y({ data: X([
	Y({ pdf: zw }),
	Y({ pdfs: zw }),
	Y({ csvs: zw }),
	Y({ zpl: zw }),
	Y({ zpls: zw })
]) }), Vw = J(Y({
	shipment_id: kS,
	price: VS,
	price_after_vat: VS
}));
Y({ data: Y({ shipments: Y({
	unpaid_shipments: Vw,
	blocked_shipments: Vw
}) }) });
var Hw = Y({
	amount: W().nullable(),
	currency: Q(["", "EUR"]).register(V, { description: "The currency as uppercase 3-letter ISO 4217 code." })
}).register(V, { description: "Price amount in a specific currency" });
Y({ data: Y({ payment_instructions: J(Y({
	id: H(),
	hash: H(),
	type: W(),
	notification_hash: H(),
	original_notification_hash: H(),
	paid: X([$(0), $(1)]),
	price: Hw,
	payment_url: Xb().nullable(),
	invoices: Y({
		id: W(),
		number: H(),
		status: W()
	})
})) }) });
var Uw = $(400).register(V, { description: "The server will not process the request due to a client error." });
DS.and(Y({
	status_code: Uw.optional(),
	errors: J(Y({
		status: Uw.optional(),
		code: W().optional()
	})).optional()
})), Y({
	type: H().register(V, { description: "URI reference identifying the problem type. Derived from the wrapping UserException constant name (e.g. `urn:problem:invalid-shipments`) or, when no matching constant exists, a status-based fallback URN.\n" }),
	title: H().register(V, { description: "A short, human-readable summary of the problem type." }),
	status: W().register(V, { description: "The HTTP status code for this occurrence." }),
	detail: H().register(V, { description: "A human-readable explanation specific to this occurrence." }),
	instance: H().register(V, { description: "URI reference identifying the specific occurrence. The request path for the top-level object; the RFC 6901 JSON Pointer of the failing field for each `errors[]` entry.\n" }).optional(),
	request_id: H().register(V, { description: "Per-request correlation identifier. Mirrors the value of the `X-Request-Id` response header and the legacy envelope's `request_id` field. Allowed as an RFC 9457 §3.2 extension member so consumers don't have to read both header and body for tracing.\n" }).optional(),
	errors: J(Y({
		type: H(),
		title: H(),
		detail: H(),
		instance: H().optional()
	})).register(V, { description: "Sub-problem list. Each entry is itself an RFC 9457 problem-detail object describing one failing field. The sub-error `type`/`title` narrow past the wrapping problem when the underlying validator code maps to its own UserException constant (e.g. `urn:problem:invalid-address`, `urn:problem:invalid-physical-properties`).\n" }).optional()
}).register(V, { description: "RFC 9457 problem-detail object returned when the caller lists `application/problem+json` in the Accept header. Top-level fields are strictly the five defined in RFC 9457 §3.1; the `errors` array is an extension populated when the underlying exception carried per-field validator errors.\n" });
var Ww = X([
	$(0),
	$(1),
	$(2),
	$(3)
]), Gw = Y({
	date: Dw,
	timezone: H(),
	timezone_type: Ww
}), Kw = Q([
	"morning",
	"standard",
	"evening",
	"same_day",
	"express",
	"early_morning"
]), qw = Q([
	"package",
	"mailbox",
	"unfranked",
	"digital_stamp",
	"pallet",
	"small_package",
	"envelope"
]).register(V, { description: "Package Type." }), Jw = Y({
	type: Q(["start", "end"]),
	date_time: Gw
});
Y({ data: Y({ deliveries: J(Y({
	date: Gw,
	possibilities: J(Y({
		type: Kw.nullable(),
		package_type: qw,
		delivery_time_frames: J(Jw),
		shipment_options: J(Y({
			name: H(),
			schema: Y({
				type: Q(["boolean"]),
				enum: J(G())
			})
		})),
		price: Hw.optional(),
		identifier: H().optional(),
		transporter: H().optional(),
		label_type: H().optional()
	}))
})) }) });
var Yw = xb().regex(/\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2]\d|3[0-1])/).register(V, { description: "Represents a date in ISO 8601 format:\n\n```\nYYYY-MM-DD\n```\n\nWhere:\n  - `YYYY` represents a four-digit year, `0000` through `9999`\n  - `MM` represents a zero-padded month of the year, `01` through `12`\n  - `DD` represents a zero-padded day of that month, `01` through `31`\n" }), Xw = Cb().regex(/([0-1]\d|2[0-4]):[0-5]\d(:([0-5]\d|60)(.\d+)?)?/).register(V, { description: "Represents a time in ISO 8601 format:\n\n```\nhh:mm:ss.u\n```\n\nWhere:\n  - `hh` represents a zero-padded hour, `00` through `24`\n  - `mm` represents a zero-padded minute, `00` through `59`\n  - `ss` (optional) represents a zero-padded second, `00` through `60`\n    (where `60` is only used to denote an added leap second)\n  - `.u` (optional) represents a fraction of a second, `.0` through `.999999+`\n" }), Zw = Y({
	date: Yw,
	time: J(Y({
		start: Xw,
		end: Xw,
		price: Hw,
		price_comment: H(),
		comment: H(),
		type: W(),
		collect_date: Gw.optional(),
		identifier: H().optional(),
		transporter: H().optional(),
		label_type: H().optional()
	}))
}), Qw = X([
	$(1),
	$(2),
	$(3),
	$(4),
	$(6),
	$(7),
	$(8)
]), $w = Y({
	start: Xw.nullish(),
	type: Qw.optional(),
	price: Hw.optional()
}), eT = J(H()).register(V, { description: "Opening hours.\nEach opening consist out of open- and close time formatted as a single string separated by ' - '. e.g. \"13:00 - 20:00\"\n" }), tT = Y({
	monday: eT,
	tuesday: eT,
	wednesday: eT,
	thursday: eT,
	friday: eT,
	saturday: eT,
	sunday: eT
}), nT = X([U().gte(-90).lte(90), H().regex(/^[-+]?(90|[0-8]?\d)(\.\d+)?$/)]), rT = X([U().gte(-180).lte(180), H().regex(/^[-+]?(180|(0?\d{0,2}|1[0-7]\d)(\.\d+)?)$/)]), iT = Y({
	date: Yw.nullish(),
	time: J($w).optional(),
	location: H().optional(),
	street: H().optional(),
	number: H().optional(),
	number_suffix: H().nullish(),
	postal_code: H().optional(),
	city: H().optional(),
	cc: H().optional(),
	start_time: Xw.nullish(),
	price: W().optional(),
	price_comment: Q(["retail", "retailexpress"]).optional(),
	comment: H().optional(),
	phone_number: H().optional(),
	opening_hours: tT.optional(),
	distance: H().optional(),
	latitude: nT.optional(),
	longitude: rT.optional(),
	location_code: H().optional(),
	retail_network_id: H().nullish(),
	holiday: Y({
		from: H().nullish(),
		to: H().nullish()
	}).optional()
}), aT = W().gte(500).lte(599).register(V, { description: "The server failed to fulfill an apparently valid request" }), oT = Y({
	status: X([wS, aT]).optional(),
	code: TS,
	title: H().optional(),
	message: H()
});
Y({
	data: Y({
		delivery: J(Zw),
		pickup: J(iT),
		message: H().optional()
	}),
	errors: J(X([oT, Y({
		code: W(),
		message: H(),
		human: H().optional()
	})])).optional()
});
var sT = $(406).register(V, { description: "The target resource doesn't have an acceptable representation for the user agent." });
DS.and(Y({
	status_code: sT.optional(),
	errors: J(Y({
		status: sT.optional(),
		code: W().optional()
	})).optional()
})), Y({ data: Y({ download_url: Y({ link: Xb() }).register(V, { description: "DownloadUrl Object Definition" }) }) });
var cT = J(X([X([
	$(0),
	$(1),
	$(2),
	$(3),
	$(4),
	$(5),
	$(6)
]), X([
	$(1),
	$(2),
	$(3),
	$(4),
	$(5),
	$(6),
	$(7)
])])).nullable(), lT = Y({
	monday: U().nullish(),
	tuesday: U().nullish(),
	wednesday: U().nullish(),
	thursday: U().nullish(),
	friday: U().nullish(),
	saturday: U().nullish(),
	sunday: U().nullish()
}), uT = J(Y({
	start: Gw.nullable(),
	end: Gw.nullable()
})), dT = Y({
	monday: uT.optional(),
	tuesday: uT.optional(),
	wednesday: uT.optional(),
	thursday: uT.optional(),
	friday: uT.optional(),
	saturday: uT.optional(),
	sunday: uT.optional()
}).nullable();
Y({ data: Y({ drop_off_points: J(Y({
	location_code: H().optional(),
	location_name: H().nullish(),
	cc: H().optional(),
	state: H().nullish(),
	city: H().optional(),
	postal_code: H().optional(),
	street: H().optional(),
	number: X([H(), W()]).nullish(),
	number_suffix: H().nullish(),
	phone: H().nullish(),
	reference: H().nullish(),
	longitude: rT.nullish(),
	latitude: nT.nullish(),
	available_days: cT.optional(),
	cut_off_time: H().nullish(),
	carrier_id: bC.optional(),
	distance: U().nullish(),
	occupancy: lT.nullish(),
	occupancy_today: U().nullish(),
	default_drop_off_point: G().nullish(),
	type: XS.nullish(),
	opening_hours: dT.optional()
})) }) });
var fT = $(415).register(V, { description: "Content is in a format not supported by this method on the target resource." });
DS.and(Y({
	status_code: fT.optional(),
	errors: J(Y({
		status: fT.optional(),
		code: $(3100).optional()
	})).optional()
}));
var pT = $(401).register(V, { description: "The request lacks valid authentication credentials for the target resource." });
DS.and(Y({
	status_code: pT.optional(),
	errors: J(Y({
		status: pT.optional(),
		code: W().optional()
	})).optional()
}));
var mT = Y({
	cc: H(),
	city: H(),
	street: H(),
	postal_code: H(),
	number: H(),
	number_suffix: H().nullish()
}), hT = J(Y({
	delivery_type_id: W(),
	delivery_type_name: H(),
	price: W(),
	moment: Y({ start: Gw.nullish() })
})), gT = Y({
	start: Gw.nullable(),
	end: Gw.nullable()
}), _T = Y({
	monday: J(gT),
	tuesday: J(gT),
	wednesday: J(gT),
	thursday: J(gT),
	friday: J(gT),
	saturday: J(gT),
	sunday: J(gT)
});
Y({ data: Y({ pickup_locations: J(Y({
	address: mT,
	possibilities: hT,
	location: Y({
		location_name: H(),
		retail_network_id: H().nullable(),
		distance: H(),
		latitude: H(),
		longitude: H(),
		location_code: H(),
		phone_number: H().nullable(),
		type: XS.nullable(),
		opening_hours: _T
	})
})) }) }), Y({ data: Y({
	shipments: J(Lw).register(V, { description: "A list of Shipment Resources." }),
	pdf: Y({ url: H().regex(/^\/pdfs\/.*/) }).optional(),
	zpl: Y({ url: H().regex(/^\/zpls\/.*/) }).optional()
}) }), Y({ data: Y({ ids: J(Y({
	id: kS,
	reference_identifier: pC
})).register(V, { description: "A list of Shipment IDs." }) }) });
var vT = J(Y({
	id: kS,
	reference_identifier: pC
})).register(V, { description: "A list of Shipment IDs." });
Y({ data: X([Y({
	ids: vT,
	pdf: Y({ url: H().regex(/^\/pdfs\/.*/) })
}), Y({
	ids: vT,
	zpl: Y({ url: H().regex(/^\/zpls\/.*/) })
})]) });
var yT = Y({
	status: aT.optional(),
	code: W().optional(),
	title: H().optional(),
	message: H().optional()
});
Y({
	message: H().register(V, { description: "A human-readable description of the error." }).optional(),
	request_id: H().register(V, { description: "Internal request ID, useful for debugging purposes." }).optional(),
	status_code: aT.optional(),
	errors: J(yT).optional()
}), Y({ data: Y({
	shipments: J(Lw).register(V, { description: "A list of Shipment Resources." }),
	results: W().register(V, { description: "The number of results." })
}) });
var bT = Y({
	uri: Xb(),
	barcode: H()
}), xT = Y({
	name: H(),
	cc: H().nullable(),
	city: H().nullable(),
	postal_code: H().nullable(),
	street: H().nullable(),
	number: H().nullable(),
	number_suffix: H().nullable(),
	longitude: U().nullable(),
	latitude: U().nullable()
}), ST = Q([
	"registered",
	"handed_to_carrier",
	"sorting",
	"distribution",
	"delivered"
]).nullable(), CT = J(Y({
	code: H(),
	status: RS.nullable(),
	main: ST,
	description: H(),
	time: Dw,
	delayed: G(),
	location: xT
})), wT = Q(["estimated", "expected"]).nullable(), TT = Y({
	start: Gw.nullable(),
	end: Gw.nullable()
}).nullable(), ET = X([H(), Y({
	content: H(),
	content_type: H()
})]).nullable();
Y({ data: Y({ tracktraces: J(Y({
	shipment_id: kS,
	carrier: bC,
	code: H(),
	description: H(),
	time: Dw,
	link_consumer_portal: Xb().nullable(),
	link_tracktrace: Xb().nullable(),
	partner_tracktraces: J(bT),
	recipient: LS,
	sender: IS,
	options: JS,
	pickup: QS,
	delayed: G(),
	location: xT,
	status: Y({
		current: RS,
		main: ST,
		final: G()
	}),
	history: CT,
	delivery_moment_type: wT.optional(),
	delivery_moment: TT.optional(),
	signature: ET.optional(),
	returnable: G().optional()
}).register(V, { description: "A Track & Trace resource." })).register(V, { description: "A list of Track & Trace Resources." }) }) });
var DT = Q([
	"BPOST",
	"BRT",
	"CHEAP_CARGO",
	"DHL_EUROPLUS",
	"DHL_FOR_YOU",
	"DHL_FREIGHT",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"GLS",
	"INPOST",
	"POSTE_ITALIANE",
	"POSTNL",
	"SPRING",
	"TRUNKRS",
	"UPS_EXPRESS_SAVER",
	"UPS_STANDARD",
	"VIA_TIM"
]).register(V, { description: "Carrier string definition for capabilities endpoints (v2)" }), OT = Y({
	id: W().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).register(V, { description: "The contract ID." }),
	type: Q(["MAIN", "CUSTOM"]).register(V, { description: "The type of contract." })
}).register(V, { description: "Contract definition for capabilities endpoints (v2)" }), kT = Q([
	"PACKAGE",
	"MAILBOX",
	"UNFRANKED",
	"DIGITAL_STAMP",
	"PALLET",
	"SMALL_PACKAGE",
	"ENVELOPE"
]).register(V, { description: "Package Type." }), AT = Y({
	isSelectedByDefault: G(),
	isRequired: G()
}), jT = Y({
	additionalInsurance: AT.optional(),
	deliverAtPostalPoint: AT.optional(),
	freshFood: AT.optional(),
	frozen: AT.optional(),
	hideSender: AT.optional(),
	noTracking: AT.optional(),
	oversizedPackage: AT.optional(),
	priorityDelivery: AT.optional(),
	printReturnLabelAtDropOff: AT.optional(),
	recipientOnlyDelivery: AT.optional(),
	requiresAgeVerification: AT.optional(),
	requiresCashOnDelivery: AT.optional(),
	requiresReceiptCode: AT.optional(),
	requiresSignature: AT.optional(),
	returnOnFirstFailedDelivery: AT.optional(),
	sameDayDelivery: AT.optional(),
	saturdayDelivery: AT.optional(),
	scheduledCollection: AT.optional(),
	tracked: AT.optional()
}), MT = AT.and(Y({
	requires: J(H()).register(V, { description: "camelCase shipment option keys that are required" }),
	excludes: J(H()).register(V, { description: "camelCase shipment option keys that are excluded" })
})), NT = Y({
	insuredAmount: Y({
		default: VS,
		min: VS,
		max: VS
	}).register(V, { description: "Deprecated. Use the flat default/min/max properties on the insurance option directly. Will be removed in a future release.\n" }).optional(),
	default: VS.optional(),
	min: VS.optional(),
	max: VS.optional()
}), PT = MT.and(NT), FT = jT.and(Y({
	additionalInsurance: MT.optional(),
	deliverAtPostalPoint: MT.optional(),
	freshFood: MT.optional(),
	frozen: MT.optional(),
	hideSender: MT.optional(),
	insurance: PT.optional(),
	noTracking: MT.optional(),
	oversizedPackage: MT.optional(),
	priorityDelivery: MT.optional(),
	printReturnLabelAtDropOff: MT.optional(),
	recipientOnlyDelivery: MT.optional(),
	requiresAgeVerification: MT.optional(),
	requiresCashOnDelivery: MT.optional(),
	requiresReceiptCode: MT.optional(),
	requiresSignature: MT.optional(),
	returnOnFirstFailedDelivery: MT.optional(),
	sameDayDelivery: MT.optional(),
	saturdayDelivery: MT.optional(),
	scheduledCollection: MT.optional(),
	tracked: MT.optional()
})), IT = Y({
	value: U().register(V, { description: "The numeric value" }),
	unit: Q([
		"g",
		"kg",
		"cm",
		"mm",
		"mm3",
		"cm3",
		"dm3",
		"m3"
	]).register(V, { description: "The unit of measurement in SI units" })
}), LT = Y({
	min: IT,
	max: IT,
	calculation: H()
}), RT = Y({
	weight: LT.optional(),
	width: LT.optional(),
	length: LT.optional(),
	height: LT.optional(),
	girth: LT.optional(),
	volumetricWeight: LT.optional(),
	volume: LT.optional(),
	lengthWidthHeightSum: LT.optional()
}), zT = Q([
	"MORNING_DELIVERY",
	"STANDARD_DELIVERY",
	"EVENING_DELIVERY",
	"PICKUP_DELIVERY",
	"SAME_DAY_DELIVERY",
	"EXPRESS_DELIVERY",
	"EARLY_MORNING_DELIVERY"
]), BT = Q(["B2B", "B2C"]), VT = Y({ max: W() });
Y({ results: J(Y({
	carrier: DT,
	contract: OT.optional(),
	packageTypes: J(kT),
	options: FT,
	physicalProperties: RT,
	deliveryTypes: J(zT),
	transactionTypes: J(BT),
	collo: VT
}).register(V, { description: "A V2 Capability response item for a given Shipment configuration." })).register(V, { description: "A list of V2 Capabilities for a given Shipment configuration." }) });
var HT = X([
	$(1),
	$(2),
	$(3),
	$(4),
	$(9),
	$(10),
	$(11),
	$(12),
	$(13),
	$(14),
	$(15),
	$(16),
	$(17),
	$(18),
	$(19),
	$(20),
	$(21)
]).register(V, { description: "Carrier ID definition for capabilities endpoints (v1)" }), UT = Y({
	id: W().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).register(V, { description: "The contract ID." }),
	type: Q(["main", "custom"]).register(V, { description: "The type of contract." })
}).register(V, { description: "Contract definition for capabilities endpoints (v1)" }), WT = Y({
	is_selected_by_default: G(),
	is_required: G()
}), GT = Y({
	age_check: WT.optional(),
	cash_on_delivery: WT.optional(),
	collect: WT.optional(),
	drop_off_at_postal_point: WT.optional(),
	extra_assurance: WT.optional(),
	fresh_food: WT.optional(),
	frozen: WT.optional(),
	hide_sender: WT.optional(),
	large_format: WT.optional(),
	no_tracking: WT.optional(),
	only_recipient: WT.optional(),
	printerless_return: WT.optional(),
	priority_delivery: WT.optional(),
	receipt_code: WT.optional(),
	return: WT.optional(),
	same_day_delivery: WT.optional(),
	saturday_delivery: WT.optional(),
	signature: WT.optional(),
	tracked: WT.optional()
}), KT = WT.and(Y({
	requires: J(H()).register(V, { description: "snake_case shipment option keys that are required" }),
	excludes: J(H()).register(V, { description: "snake_case shipment option keys that are excluded" })
})), qT = Y({
	insured_amount: Y({
		default: VS,
		min: VS,
		max: VS
	}).register(V, { description: "Deprecated. Use the flat default/min/max properties on the insurance option directly. Will be removed in a future release.\n" }).optional(),
	default: VS.optional(),
	min: VS.optional(),
	max: VS.optional()
}), JT = KT.and(qT), YT = GT.and(Y({
	age_check: KT.optional(),
	cash_on_delivery: KT.optional(),
	collect: KT.optional(),
	drop_off_at_postal_point: KT.optional(),
	extra_assurance: KT.optional(),
	fresh_food: KT.optional(),
	frozen: KT.optional(),
	hide_sender: KT.optional(),
	insurance: JT.optional(),
	large_format: KT.optional(),
	no_tracking: KT.optional(),
	only_recipient: KT.optional(),
	printerless_return: KT.optional(),
	priority_delivery: KT.optional(),
	receipt_code: KT.optional(),
	return: KT.optional(),
	same_day_delivery: KT.optional(),
	saturday_delivery: KT.optional(),
	signature: KT.optional(),
	tracked: KT.optional()
})), XT = Y({
	weight: LT.optional(),
	width: LT.optional(),
	length: LT.optional(),
	height: LT.optional(),
	girth: LT.optional(),
	volumetric_weight: LT.optional(),
	volume: LT.optional(),
	length_width_height_sum: LT.optional()
});
Y({ data: Y({ capabilities: J(Y({
	carrier_id: HT,
	contract: UT.optional(),
	package_types: J(US),
	options: YT,
	physical_properties: XT,
	delivery_types: J(Qw),
	transaction_types: J(BT),
	collo: VT
}).register(V, { description: "A V1 Capability response item for a given Shipment configuration." })).register(V, { description: "A list of V1 Capabilities for a given Shipment configuration." }) }) });
var ZT = AT.and(Y({})), QT = ZT.and(NT), $T = jT.and(Y({
	additionalInsurance: ZT.optional(),
	deliverAtPostalPoint: ZT.optional(),
	hideSender: ZT.optional(),
	insurance: QT.optional(),
	noTracking: ZT.optional(),
	oversizedPackage: ZT.optional(),
	priorityDelivery: ZT.optional(),
	printReturnLabelAtDropOff: ZT.optional(),
	recipientOnlyDelivery: ZT.optional(),
	requiresAgeVerification: ZT.optional(),
	requiresCashOnDelivery: ZT.optional(),
	requiresReceiptCode: ZT.optional(),
	requiresSignature: ZT.optional(),
	returnOnFirstFailedDelivery: ZT.optional(),
	sameDayDelivery: ZT.optional(),
	saturdayDelivery: ZT.optional(),
	scheduledCollection: ZT.optional(),
	tracked: ZT.optional()
}));
Y({ items: J(Y({
	carrier: DT,
	packageTypes: J(kT),
	options: $T,
	deliveryTypes: J(zT),
	transactionTypes: J(BT),
	collo: VT
}).register(V, { description: "A V2 Capability response item for a given Shipment configuration." })).register(V, { description: "A superset of V2 Capabilities for the contracts within a user's account." }) });
var eE = WT.and(Y({})), tE = eE.and(qT), nE = GT.and(Y({
	age_check: eE.optional(),
	cash_on_delivery: eE.optional(),
	collect: eE.optional(),
	drop_off_at_postal_point: eE.optional(),
	extra_assurance: eE.optional(),
	hide_sender: eE.optional(),
	insurance: tE.optional(),
	large_format: eE.optional(),
	no_tracking: eE.optional(),
	only_recipient: eE.optional(),
	printerless_return: eE.optional(),
	priority_delivery: eE.optional(),
	receipt_code: eE.optional(),
	return: eE.optional(),
	same_day_delivery: eE.optional(),
	saturday_delivery: eE.optional(),
	signature: eE.optional(),
	tracked: eE.optional()
}));
Y({ data: Y({ contract_definitions: J(Y({
	carrier_id: HT,
	package_types: J(US),
	options: nE,
	delivery_types: J(Qw),
	transaction_types: J(BT),
	collo: VT
}).register(V, { description: "A V1 Capability contract definitions response item for a given Shipment configuration." })).register(V, { description: "A superset of V1 Capabilities for the contracts within a user's account." }) }) });
var rE = Y({
	id: W().register(V, { description: "The id of the contract." }),
	type: Q(["MAIN", "CUSTOM"]).register(V, { description: "The type of contract." })
}).register(V, { description: "The contract object." }), iE = Q([
	"EXPRESS",
	"FULFILMENT",
	"LABEL_PACKAGE",
	"MULTI_COLLO",
	"RETURN",
	"RETURN_ERS",
	"RETURN_SPECIAL",
	"STANDARD"
]), aE = Y({
	name: H(),
	key: H(),
	price: gC,
	vat: gC,
	priceWithVat: gC
}).register(V, { description: "A V2 Price object." }), oE = Y({
	base: aE,
	charges: J(aE),
	discounts: J(aE),
	options: J(aE),
	other: J(aE),
	total: aE
}).register(V, { description: "The V2 price composition object, containing the base, options, charges, discounts and total prices." }), sE = Y({
	carrier: DT,
	contract: rE.optional(),
	packageType: kT,
	deliveryType: zT.optional(),
	shipmentType: iE,
	priceComposition: oE
}).register(V, { description: "A V2 Rate response item for a given Shipment configuration." }), cE = Y({
	id: W().register(V, { description: "The id of the contract." }),
	type: Q(["main", "custom"]).register(V, { description: "The type of contract." })
}).register(V, { description: "The contract object." }), lE = X([
	$(1),
	$(2),
	$(3),
	$(4),
	$(5),
	$(6),
	$(7)
]), uE = Y({
	name: H(),
	key: H(),
	price: gC,
	vat: gC,
	price_with_vat: gC
}).register(V, { description: "A V1 Price object." }), dE = Y({
	base: uE,
	charges: J(uE),
	discounts: J(uE),
	options: J(uE),
	other: J(uE),
	total: uE
}).register(V, { description: "The price composition object, containing the base, options, charges, discounts and total prices." });
Y({ data: Y({ rates: J(Y({
	carrier_id: HT,
	contract: cE.optional(),
	package_type: US,
	delivery_type: Qw.optional(),
	shipment_type: lE,
	price_composition: dE
}).register(V, { description: "A V1 Rate response item for a given Shipment configuration." })).register(V, { description: "A list of V1 Rates for a given Shipment configuration." }) }) }), Y({ results: J(Y({
	id: W(),
	shopId: W(),
	packageType: Q([
		"DIGITAL_STAMP",
		"ENVELOPE",
		"UNFRANKED",
		"MAILBOX",
		"PACKAGE",
		"PALLET",
		"SMALL_PACKAGE"
	]).nullable(),
	countryCode: H().length(2).regex(/^[A-Z]{2}$/).nullable(),
	shipmentDirection: Q(["OUTBOUND", "INBOUND"]),
	fallback: G()
}).register(V, { description: "A Notification Group response item" })) });
var fE = Q([
	"LABEL_DOWNLOAD",
	"FIRST_SCAN",
	"RETURN"
]).register(V, { description: "The notification template type." });
Y({ results: J(Y({
	id: W(),
	notificationGroupId: W(),
	type: fE,
	subject: H(),
	body: H(),
	active: G()
}).register(V, { description: "A Notification Template response item" })) }), Y({ data: Y({ webhook_subscriptions: J(Y({
	id: W(),
	account_id: W(),
	shop_id: W(),
	hook: H(),
	url: H(),
	payload: H().nullish()
}).register(V, { description: "A Webhook Subscription response item" })) }) }), Y({ data: Y({ webhook_subscriptions: J(Y({
	id: W(),
	account_id: W(),
	shop_id: W(),
	hook: H(),
	url: H()
}).register(V, { description: "A Webhook Subscription response item" })) }) }), Y({ data: Y({ ids: J(Y({ id: W() })).register(V, { description: "A list of created webhook subscription IDs." }) }) });
var pE = H().min(6).max(32).regex(/^[a-zA-Z0-9\-\s]+$/), mE = Q([
	"1",
	"2",
	"3",
	"4",
	"5",
	"6",
	"7",
	"8",
	"9",
	"10",
	"11",
	"12",
	"13",
	"14",
	"15",
	"16",
	"17",
	"18",
	"19",
	"20",
	"21"
]).register(V, { description: "This enumeration represents the Carriers. The value is the Carrier id." }), hE = X([mE, Q([
	"postnl",
	"bpost",
	"cheapcargo",
	"dpd",
	"instabox",
	"dhl",
	"bol.com",
	"ups",
	"dhlforyou",
	"dhlparcelconnect",
	"dhleuroplus",
	"upsstandard",
	"upsexpresssaver",
	"gls",
	"brt",
	"trunkrs",
	"inpost",
	"posteitaliane",
	"spring",
	"viatim",
	"dhlfreight"
]).register(V, { description: "This enumeration represents the Carriers. The value is the Carrier id." })]).nullable(), gE = xb().regex(/\d{4}-\d{2}-\d{2}/).nullable(), _E = H().length(2).regex(/^[A-Za-z]{2}$/).register(V, { description: "ISO 3166-1 alpha-2 country code" }), vE = Xw.nullable(), yE = X([
	G(),
	W().gte(0).lte(1),
	X([K(), K()]),
	Q([
		"0",
		"1",
		"false",
		"true"
	])
]), bE = X([
	$(!1),
	$(!0),
	$(0),
	$(1),
	$("0"),
	$("1"),
	$("false"),
	$("true"),
	$("off"),
	$("on"),
	$("no"),
	$("yes"),
	$("")
]).nullable(), xE = Yw.nullable(), SE = Xw.nullable(), CE = H().nullable(), wE = H().regex(/^([0-6](;[0-6])*)?$/).nullable(), TE = X([Q([
	"1",
	"2",
	"3",
	"4",
	"6",
	"7",
	"8"
]), K()]), EE = Q(["A4", "A6"]).register(V, { description: "The size of a paper as specified in ISO216." }), DE = nT.nullable(), OE = rT.nullable(), kE = Q(["ASC", "DESC"]).register(V, { description: "Specify whether the results should be sorted in ascending or descending order." }), AE = X([
	US,
	J(US),
	H().regex(/^[1-7](;[1-7]){0,5}$/)
]), jE = W().gte(1).lte(1e3).register(V, { description: "Request a specific page of the results, used for paginated results." }), ME = X([Q([
	"myparcel",
	"flespakket",
	"belgie",
	"delivery_dutch",
	"postnl_customer",
	"italy"
]), Q([
	"1",
	"2",
	"3",
	"4",
	"5",
	"6"
])]).nullable(), NE = X([X([
	$(1),
	$(2),
	$(3),
	$(4)
]).register(V, { description: "The position of the label on the paper." }), H().regex(/^[0-4](;[1-4]){0,3}$/)]), PE = H().min(2).max(12).regex(/^[a-zA-Z0-9\-\s]{2,12}$/).nullable(), FE = X([Zx().gte(BigInt(1)).lte(BigInt(0x8000000000000000)), H().regex(/^;*[1-9][0-9]{0,18}(;([1-9][0-9]{0,18}|[a-zA-Z]+)?)*$/)]), IE = X([
	MS,
	J(MS),
	H().regex(/^[1-8](;[1-8]){0,7}$/)
]), LE = W().gte(1).lte(2147483647), RE = X([
	LE,
	J(LE),
	H().regex(/^[1-9][0-9]{0,9}(;[1-9][0-9]{0,9})*$/)
]), zE = W().gte(0).lte(1e4).register(V, { description: "Specify the number of resources returned per page, used for paginated results." }), BE = Q([
	"amount",
	"created",
	"created_by",
	"currency",
	"drop_off_point",
	"hidden",
	"id",
	"mark_delivered",
	"modified",
	"modified_by",
	"order_shipment_identifier",
	"parent_id",
	"recipient",
	"reference_identifier",
	"sender",
	"shipment_type",
	"shop_id",
	"status",
	"transaction_status"
]), VE = X([
	RS,
	J(RS),
	H().regex(/^(1|2|3|4|5|6|7|8|9|10|11|12|13|14|15|16|17|18|19|30|31|32|33|34|35|36|37|38|39|40|41|42|98|99|100|101)(;(1|2|3|4|5|6|7|8|9|10|11|12|13|14|15|16|17|18|19|30|31|32|33|34|35|36|37|38|39|40|41|42|98|99|100|101))*$/)
]), HE = H().regex(/^(?:;*(delivery_moment|returnable|signature)(?=;|$)(?!.*;\1(?:;|$)))+;*$/), UE = J(X([Gb(), H().max(0)])).max(4), WE = Y({
	cc: H().length(2),
	postal_code: H(),
	city: H(),
	street: H(),
	street_additional_info: H().nullish(),
	number: H().optional(),
	number_suffix: H().optional(),
	box_number: H().max(8).optional(),
	region: H().max(35).optional(),
	person: H(),
	company: H().optional(),
	phone: H().optional(),
	email: X([Gb(), H().max(0)]).nullish()
}), GE = Y({
	postal_code: H().optional(),
	location_name: H().optional(),
	city: H().optional(),
	street: H().optional(),
	number: H().optional(),
	number_suffix: H().nullish(),
	box_number: H().max(8).optional(),
	region: H().max(35).optional(),
	state: H().max(2).optional(),
	cc: H().length(2).regex(/^[A-Z]{2}/).optional(),
	location_code: H().optional(),
	location_type: X([ZS, XS]).optional(),
	retail_network_id: H().optional()
}).nullable(), KE = Y({ data: Y({
	user_agent: H().max(255).optional(),
	shipments: J(Y({
		account_id: W().optional(),
		shop_id: W().optional(),
		contract_id: W().optional(),
		reference_identifier: X([W(), H().max(255).regex(/^[^=\?]*$/)]).optional(),
		recipient: Y({
			cc: H().length(2),
			region: H().max(35).optional(),
			state: H().max(2).optional(),
			postal_code: H().max(10),
			city: H().min(1).max(35),
			street: H().min(1).max(40).regex(/\D+/),
			street_additional_info: H().max(50).optional(),
			number: H().max(8).optional(),
			number_suffix: H().max(6).optional(),
			box_number: H().max(8).optional(),
			area: H().max(35).optional(),
			person: H().min(1).max(50),
			company: H().max(50).optional(),
			email: X([Gb(), H().max(0)]).optional(),
			secondary_emails: UE.optional(),
			phone: H().max(25).optional(),
			eori_number: H().nullish(),
			vat_number: H().nullish()
		}),
		sender: WE.optional(),
		recipients: J(U()).min(1).optional(),
		physical_properties: Y({
			weight: W().gte(0).lte(999999999),
			height: W().optional(),
			width: W().optional(),
			length: W().optional(),
			volume: W().optional()
		}).optional(),
		options: JS.and(K()),
		customs_declaration: tC.optional(),
		carrier: bC,
		pickup: GE.optional(),
		drop_off_point: Y({
			postal_code: H(),
			location_name: H(),
			city: H(),
			street: H(),
			number: H(),
			number_suffix: H().optional(),
			box_number: H().optional(),
			region: H().optional(),
			state: H().optional(),
			cc: H().optional(),
			location_code: H(),
			retail_network_id: H().optional()
		}).nullish(),
		note: H().optional(),
		status: X([
			$(1),
			$(2),
			$(3),
			$(4),
			$(5),
			$(6),
			$(7),
			$(8)
		]).optional(),
		delivered: $(0).optional(),
		general_settings: Y({
			save_recipient_address: X([$(0), $(1)]).optional(),
			delivery_notification: X([$(0), $(1)]).optional(),
			delivery_notification_email: J(H()).optional(),
			disable_auto_detect_pickup: X([$(0), $(1)]).optional(),
			printer_identifier: H().optional()
		}).optional(),
		secondary_shipments: J(Y({
			account_id: W().optional(),
			shop_id: W().optional(),
			reference_identifier: X([W(), H().max(255).regex(/^[^=\?]*$/)]).optional(),
			recipient: Y({
				cc: H().length(2).optional(),
				region: H().max(35).optional(),
				state: H().max(2).optional(),
				postal_code: H().max(10).optional(),
				city: H().min(1).max(35).optional(),
				street: H().min(1).max(40).optional(),
				street_additional_info: H().max(50).optional(),
				number: H().max(8).optional(),
				number_suffix: H().max(6).optional(),
				box_number: H().max(8).optional(),
				area: H().max(35).optional(),
				person: H().min(1).max(50).optional(),
				company: H().max(50).optional(),
				email: X([Gb(), H().max(0)]).optional(),
				secondary_emails: UE.optional(),
				phone: H().max(25).optional(),
				eori_number: H().nullish(),
				vat_number: H().nullish()
			}).optional(),
			recipients: J(U()).min(1).optional(),
			physical_properties: Y({
				weight: W().gte(0).lte(999999999),
				height: W().optional(),
				width: W().optional(),
				length: W().optional(),
				volume: W().optional()
			}).optional(),
			options: JS.optional(),
			customs_declaration: tC.optional(),
			carrier: bC.optional(),
			pickup: GE.optional(),
			drop_off_point: Y({
				postal_code: H(),
				location_name: H(),
				city: H(),
				street: H(),
				number: H(),
				number_suffix: H().optional(),
				box_number: H().optional(),
				region: H().optional(),
				state: H().optional(),
				cc: H().optional(),
				location_code: H(),
				retail_network_id: H().optional()
			}).nullish(),
			note: H().optional(),
			status: X([
				$(1),
				$(2),
				$(3),
				$(4),
				$(5),
				$(6),
				$(7),
				$(8)
			]).optional(),
			delivered: $(0).optional(),
			general_settings: Y({ save_recipient_address: X([$(0), $(1)]).optional() }).optional(),
			hidden: X([$(0), $(1)]).optional(),
			shipped_items: J(Y({
				order_line_identifier: H(),
				quantity: W().gte(1)
			})).min(0).optional()
		})).min(1).optional(),
		collection_contact: Y({
			cc: H().length(2),
			city: H().min(1).max(255),
			company: H(),
			email: Gb(),
			first_name: H().optional(),
			gender: Q(["mr", "mrs"]).optional(),
			last_name: H(),
			number: X([H().min(1), W()]),
			number_suffix: H().nullish(),
			phone: H().min(8),
			postal_code: H().min(1),
			street: H().min(1),
			street_additional_info: H().nullish()
		}).optional(),
		hidden: X([$(0), $(1)]).optional(),
		shipped_items: J(Y({
			order_line_identifier: H(),
			quantity: W().gte(1)
		})).min(0).optional()
	})).min(1).max(100)
}) });
Y({ data: Y({
	user_agent: H().max(255).optional(),
	shipments: J(Y({
		account_id: W().optional(),
		shop_id: W().optional(),
		reference_identifier: X([W(), H().max(255).regex(/^[^=\?]*$/)]).optional(),
		recipient: Y({
			cc: H().length(2),
			region: H().max(35).optional(),
			state: H().max(2).optional(),
			postal_code: H().max(10).optional(),
			city: H().min(1).max(35),
			street: H().min(1).max(40).regex(/\D+/),
			street_additional_info: H().max(50).optional(),
			number: H().max(8).optional(),
			number_suffix: H().max(6).optional(),
			box_number: H().max(8).optional(),
			area: H().max(35).optional(),
			person: H().min(1).max(50),
			company: H().max(50).optional(),
			email: X([Gb(), H().max(0)]).optional(),
			secondary_emails: UE.optional(),
			phone: H().max(25).optional()
		}),
		sender: WE.optional(),
		recipients: J(U()).min(1).optional(),
		physical_properties: Y({
			weight: W().gte(0).lte(999999999),
			height: W().optional(),
			width: W().optional(),
			length: W().optional(),
			volume: W().optional()
		}).optional(),
		options: JS.and(K()),
		customs_declaration: tC.optional(),
		carrier: bC,
		pickup: GE.optional(),
		"multi-colli": Y({ amount: W() }).nullish(),
		note: H().optional(),
		status: X([
			$(1),
			$(2),
			$(3),
			$(4),
			$(5),
			$(6),
			$(7),
			$(8)
		]).optional(),
		delivered: $(0).optional(),
		general_settings: Y({
			save_recipient_address: X([$(0), $(1)]).optional(),
			delivery_notification: X([$(0), $(1)]).optional(),
			delivery_notification_email: J(H()).optional(),
			disable_auto_detect_pickup: X([$(0), $(1)]).optional(),
			printer_identifier: H().optional()
		}).optional(),
		hidden: X([$(0), $(1)]).optional()
	})).min(1).max(100)
}) });
var qE = Y({ package_type: X([
	$(1),
	$(2),
	$(6)
]).optional() });
$(1).register(V, { description: "Regular package." }), $(2).register(V, { description: "Shipment that fits through a mailbox slot." }), $(6);
var JE = Y({
	age_check: BS.optional(),
	cooled_delivery: BS.optional(),
	drop_off_at_postal_point: BS.optional(),
	extra_assurance: BS.optional(),
	hide_sender: BS.optional(),
	large_format: BS.optional(),
	only_recipient: BS.optional(),
	receipt_code: BS.optional(),
	return: BS.optional(),
	same_day_delivery: BS.optional(),
	saturday_delivery: BS.optional(),
	signature: BS.optional()
}), YE = Y({ options: qE.and(zS).and(JE).and(qS).and(Y({
	contribution: VS.and(Y({ amount: K().optional() })).optional(),
	printerless_return: BS.optional()
})).optional() }), XE = X([
	$(1),
	$(2),
	$(4),
	$(9),
	$(10),
	$(11),
	$(14),
	$(15),
	$(17),
	$(18)
]);
Y({ data: Y({ return_shipments: J(YE.and(Y({
	account_id: W().optional(),
	shop_id: W().optional(),
	contract_id: W().optional(),
	parent: W(),
	reference_identifier: X([W(), H().max(255).regex(/^[^=\?]*$/)]).optional(),
	carrier: XE,
	email: H(),
	name: H(),
	sender: Y({
		cc: H().length(2),
		postal_code: H().optional(),
		city: H(),
		street: H(),
		street_additional_info: H().optional(),
		number: H().optional(),
		number_suffix: H().optional(),
		box_number: H().max(8).optional(),
		region: H().max(35).optional(),
		person: H(),
		company: H().optional(),
		email: X([Gb(), H().max(0)]).nullish(),
		phone: H().optional()
	}).optional(),
	physical_properties: Y({
		weight: W().gte(0).lte(999999999).optional(),
		height: W().optional(),
		width: W().optional(),
		length: W().optional(),
		volume: W().optional()
	}).optional(),
	customs_declaration: tC.optional(),
	general_settings: Y({ save_recipient_address: X([$(0), $(1)]).optional() }).optional()
}))).min(1).optional() }) }), Y({ data: Y({ return_shipments: J(YE.and(Y({
	account_id: W().optional(),
	shop_id: W().optional(),
	carrier: XE,
	email: H().optional(),
	name: H().optional(),
	cc: H().optional(),
	sender: Y({
		cc: H().length(2),
		postal_code: H().optional(),
		city: H(),
		street: H(),
		street_additional_info: H().optional(),
		number: H().optional(),
		number_suffix: H().optional(),
		box_number: H().max(8).optional(),
		region: H().max(35).optional(),
		person: H(),
		company: H().optional(),
		email: X([Gb(), H().max(0)]).nullish(),
		phone: H().optional()
	}).optional(),
	physical_properties: Y({
		weight: W().gte(0).lte(999999999).optional(),
		height: W().optional(),
		width: W().optional(),
		length: W().optional(),
		volume: W().optional()
	}).optional(),
	customs_declaration: tC.optional(),
	general_settings: Y({ save_recipient_address: X([$(0), $(1)]).optional() }).optional()
}))).min(1).optional() }) });
var ZE = Y({ data: Y({ shipments: J(Y({
	id: W(),
	account_id: W().optional(),
	shop_id: W().optional(),
	contract_id: W().optional(),
	reference_identifier: X([W(), H().max(255).regex(/^[^=\?]*$/)]).optional(),
	carrier: bC,
	status: W().optional(),
	delivered: X([$(0), $(1)]).optional(),
	recipient: Y({
		cc: H().length(2),
		region: H().max(32).optional(),
		state: H().max(2).optional(),
		postal_code: H().max(10).optional(),
		city: H().max(35),
		street: H().max(40),
		street_additional_info: H().max(50).optional(),
		number: H().max(8).nullish(),
		number_suffix: H().max(6).nullish(),
		box_number: H().max(8).optional(),
		person: H().max(50),
		company: H().max(50).optional(),
		email: X([Gb(), H().max(0)]).optional(),
		secondary_emails: UE.optional(),
		phone: H().max(25).optional(),
		eori_number: H().nullish(),
		vat_number: H().nullish()
	}),
	sender: WE.optional(),
	options: JS.and(K()),
	customs_declaration: tC.optional(),
	physical_properties: Y({
		weight: W().gte(0).lte(999999999),
		height: W().optional(),
		width: W().optional(),
		length: W().optional(),
		volume: W().optional()
	}).optional(),
	pickup: GE.optional(),
	drop_off_point: Y({
		postal_code: H(),
		location_name: H(),
		city: H(),
		street: H(),
		number: H(),
		number_suffix: H().optional(),
		box_number: H().optional(),
		region: H().optional(),
		state: H().optional(),
		cc: H().optional(),
		location_code: H(),
		retail_network_id: H().optional()
	}).nullish(),
	note: H().optional(),
	general_settings: Y({
		save_recipient_address: X([$(0), $(1)]).optional(),
		delivery_notification: X([$(0), $(1)]).optional(),
		delivery_notification_email: J(H()).optional(),
		disable_auto_detect_pickup: X([$(0), $(1)]).optional(),
		printer_identifier: H().optional()
	}).optional(),
	multi_collo_main_shipment_id: W().nullish(),
	secondary_shipments: J(Y({
		id: W().optional(),
		account_id: W().optional(),
		shop_id: W().optional(),
		reference_identifier: X([W(), H().max(255).regex(/^[^=\?]*$/)]).optional(),
		recipient: Y({
			cc: H().length(2).optional(),
			region: H().max(35).optional(),
			state: H().max(2).optional(),
			postal_code: H().max(10).optional(),
			city: H().min(1).max(35).optional(),
			street: H().min(1).max(40).optional(),
			street_additional_info: H().max(50).optional(),
			number: H().max(8).nullish(),
			number_suffix: H().max(6).nullish(),
			box_number: H().max(8).optional(),
			area: H().max(35).optional(),
			person: H().min(1).max(50).optional(),
			company: H().max(50).optional(),
			email: X([Gb(), H().max(0)]).optional(),
			secondary_emails: UE.optional(),
			phone: H().max(25).optional(),
			eori_number: H().nullish(),
			vat_number: H().nullish()
		}).optional(),
		recipients: J(U()).min(1).optional(),
		physical_properties: Y({
			weight: W().gte(0).lte(999999999),
			height: W().optional(),
			width: W().optional(),
			length: W().optional(),
			volume: W().optional()
		}).optional(),
		options: JS.optional(),
		customs_declaration: tC.optional(),
		carrier: bC.optional(),
		pickup: GE.optional(),
		drop_off_point: Y({
			postal_code: H(),
			location_name: H(),
			city: H(),
			street: H(),
			number: H(),
			number_suffix: H().optional(),
			box_number: H().optional(),
			region: H().optional(),
			state: H().optional(),
			cc: H().optional(),
			location_code: H(),
			retail_network_id: H().optional()
		}).nullish(),
		note: H().optional(),
		status: X([
			$(1),
			$(2),
			$(3),
			$(4),
			$(5),
			$(6),
			$(7),
			$(8)
		]).optional(),
		delivered: X([$(0), $(1)]).optional(),
		general_settings: Y({ save_recipient_address: X([$(0), $(1)]).optional() }).optional(),
		multi_collo_main_shipment_id: W().nullish(),
		hidden: X([$(0), $(1)]).optional(),
		shipped_items: J(Y({
			order_line_identifier: H(),
			quantity: W().gte(1)
		})).min(0).optional()
	})).min(1).optional(),
	collection_contact: Y({
		cc: H().length(2),
		city: H().min(1).max(255),
		company: H().nullish(),
		email: Gb().optional(),
		first_name: H().optional(),
		gender: Q(["mr", "mrs"]).optional(),
		last_name: H().optional(),
		number: X([H().min(1), W()]),
		number_suffix: H().nullish(),
		phone: H().min(8),
		postal_code: H().min(1),
		street: H().min(1),
		street_additional_info: H().nullish()
	}).optional(),
	hidden: X([$(0), $(1)]).optional(),
	shipped_items: J(Y({
		order_line_identifier: H(),
		quantity: W().gte(1)
	})).min(0).optional()
})).min(1).max(100).optional() }) });
Y({ data: Y({ shipments: J(Y({
	id: W(),
	account_id: W().optional(),
	shop_id: W().optional(),
	reference_identifier: X([W(), H().max(255).regex(/^[^=\?]*$/)]).optional(),
	carrier: bC,
	status: W().optional(),
	delivered: X([$(0), $(1)]).optional(),
	recipient: Y({
		cc: H().length(2),
		region: H().max(32).optional(),
		state: H().max(2).optional(),
		postal_code: H().max(10).optional(),
		city: H().max(35),
		street: H().max(40),
		street_additional_info: H().max(50).optional(),
		number: H().max(8).nullish(),
		number_suffix: H().max(6).nullish(),
		box_number: H().max(8).optional(),
		person: H().max(50),
		company: H().max(50).optional(),
		email: X([Gb(), H().max(0)]).optional(),
		secondary_emails: UE.optional(),
		phone: H().max(25).optional()
	}),
	sender: WE.optional(),
	options: JS.and(K()),
	customs_declaration: tC.optional(),
	physical_properties: Y({
		weight: W().gte(0).lte(999999999),
		height: W().optional(),
		width: W().optional(),
		length: W().optional(),
		volume: W().optional()
	}).optional(),
	pickup: GE.optional(),
	note: H().optional(),
	general_settings: Y({
		save_recipient_address: X([$(0), $(1)]).optional(),
		delivery_notification: X([$(0), $(1)]).optional(),
		delivery_notification_email: J(H()).optional(),
		disable_auto_detect_pickup: X([$(0), $(1)]).optional(),
		printer_identifier: H().optional()
	}).optional(),
	hidden: X([$(0), $(1)]).optional()
})).min(1).max(100).optional() }) });
var QE = Y({ data: Y({ shipments: J(Y({
	id: W(),
	hidden: X([$(0), $(1)]).optional(),
	status: RS.optional(),
	delivered: X([$(0), $(1)]).optional()
})).min(1).max(100) }) }), $E = Q([
	"RETAIL",
	"LOCKER",
	"POST_OFFICE"
]).register(V, { description: "Pickup / drop-off location type used for capability and rates filtering." }), eD = Y({
	shopId: W().register(V, { description: "The ID of the shop for which the capabilities are requested." }).optional(),
	contractId: W().register(V, { description: "The ID of the contract for which the capabilities are requested." }).optional(),
	recipient: Y({
		countryCode: H().length(2).regex(/^[A-Z]{2}$/).register(V, { description: "Alpha-2 Country code of the recipient." }),
		postalCode: H().min(1).max(15).register(V, { description: "Postal code of the recipient." }).optional(),
		isBusiness: G().register(V, { description: "Whether this is a business address." }).optional()
	}).register(V, { description: "Recipient data." }),
	sender: Y({
		countryCode: H().length(2).regex(/^[A-Z]{2}$/).register(V, { description: "Alpha-2 Country code of the sender." }).optional(),
		postalCode: H().min(1).max(15).register(V, { description: "Postal code of the sender." }).optional(),
		isBusiness: G().register(V, { description: "Whether this is a business address." }).optional()
	}).register(V, { description: "Sender data." }).optional(),
	carrier: DT.optional(),
	packageType: kT.optional(),
	physicalProperties: Y({
		height: Y({
			value: W().gte(0).lte(1e4).register(V, { description: "The height value" }),
			unit: Q(["cm", "mm"]).register(V, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(V, { description: "The height of the package" }).optional(),
		width: Y({
			value: W().gte(0).lte(1e4).register(V, { description: "The width value" }),
			unit: Q(["cm", "mm"]).register(V, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(V, { description: "The width of the package" }).optional(),
		length: Y({
			value: W().gte(0).lte(1e4).register(V, { description: "The length value" }),
			unit: Q(["cm", "mm"]).register(V, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(V, { description: "The length of the package" }).optional(),
		weight: Y({
			value: W().gte(0).register(V, { description: "The weight value" }),
			unit: Q(["g", "kg"]).register(V, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(V, { description: "The weight of the package" }).optional()
	}).register(V, { description: "Physical properties of the package." }).optional(),
	options: Y({
		additionalInsurance: Z(H(), q()).register(V, { description: "Additional insurance option" }).optional(),
		deliverAtPostalPoint: Z(H(), q()).register(V, { description: "Deliver at postal point option" }).optional(),
		freshFood: Z(H(), q()).register(V, { description: "Fresh food delivery option" }).optional(),
		frozen: Z(H(), q()).register(V, { description: "Frozen delivery option" }).optional(),
		hideSender: Z(H(), q()).register(V, { description: "Hide sender option" }).optional(),
		insurance: X([Z(H(), q()), VS]).optional(),
		noTracking: Z(H(), q()).register(V, { description: "Ship without track and trace option" }).optional(),
		oversizedPackage: Z(H(), q()).register(V, { description: "Oversized package option" }).optional(),
		printReturnLabelAtDropOff: Z(H(), q()).register(V, { description: "Print return label at drop off package option" }).optional(),
		priorityDelivery: Z(H(), q()).register(V, { description: "Priority delivery package option" }).optional(),
		recipientOnlyDelivery: Z(H(), q()).register(V, { description: "Recipient only delivery option" }).optional(),
		returnOnFirstFailedDelivery: Z(H(), q()).register(V, { description: "Return on first failed delivery option" }).optional(),
		requiresAgeVerification: Z(H(), q()).register(V, { description: "Requires age verification option" }).optional(),
		requiresCashOnDelivery: Z(H(), q()).register(V, { description: "Cash on delivery option" }).optional(),
		requiresReceiptCode: Z(H(), q()).register(V, { description: "Requires receipt code option" }).optional(),
		requiresSignature: Z(H(), q()).register(V, { description: "Requires signature option" }).optional(),
		sameDayDelivery: Z(H(), q()).register(V, { description: "Same day delivery option" }).optional(),
		saturdayDelivery: Z(H(), q()).register(V, { description: "Saturday delivery option" }).optional(),
		scheduledCollection: Z(H(), q()).register(V, { description: "Scheduled collection option" }).optional()
	}).register(V, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	deliveryType: Q([
		"EVENING_DELIVERY",
		"EXPRESS_DELIVERY",
		"EARLY_MORNING_DELIVERY",
		"MORNING_DELIVERY",
		"PICKUP_DELIVERY",
		"SAME_DAY_DELIVERY",
		"STANDARD_DELIVERY"
	]).optional(),
	direction: Q(["INBOUND", "OUTBOUND"]).register(V, { description: "The shipment direction for which the capabilities are requested." }).optional(),
	pickup: Y({ location: Y({ type: $E.optional() }).register(V, { description: "Pickup location details." }).optional() }).register(V, { description: "Pickup location criteria for filtering capabilities." }).optional()
});
Y({ data: Y({ capabilities: J(Y({
	shop_id: W().register(V, { description: "The ID of the shop for which the capabilities are requested." }).optional(),
	contract_id: W().register(V, { description: "The ID of the contract for which the capabilities are requested." }).optional(),
	recipient: Y({
		cc: H().length(2).regex(/^[A-Z]{2}$/).register(V, { description: "Alpha-2 Country code of the recipient." }),
		postal_code: H().min(1).max(15).register(V, { description: "Postal code of the recipient." }).optional(),
		is_business: G().register(V, { description: "Whether this is a business address." }).optional()
	}).register(V, { description: "Recipient data." }),
	sender: Y({
		cc: H().length(2).regex(/^[A-Z]{2}$/).register(V, { description: "Alpha-2 Country code of the sender." }).optional(),
		postal_code: H().min(1).max(15).register(V, { description: "Postal code of the sender." }).optional(),
		is_business: G().register(V, { description: "Whether this is a business address." }).optional()
	}).register(V, { description: "Sender data." }).optional(),
	carrier_id: HT.optional(),
	package_type: X([
		$(1),
		$(2),
		$(3),
		$(4),
		$(5),
		$(6),
		$(7)
	]).optional(),
	physical_properties: Y({
		height: Y({
			value: W().gte(0).lte(1e4).register(V, { description: "The height value" }),
			unit: Q(["cm", "mm"]).register(V, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(V, { description: "The height of the package" }).optional(),
		width: Y({
			value: W().gte(0).lte(1e4).register(V, { description: "The width value" }),
			unit: Q(["cm", "mm"]).register(V, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(V, { description: "The width of the package" }).optional(),
		length: Y({
			value: W().gte(0).lte(1e4).register(V, { description: "The length value" }),
			unit: Q(["cm", "mm"]).register(V, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(V, { description: "The length of the package" }).optional(),
		weight: Y({
			value: W().gte(0).register(V, { description: "The weight value" }),
			unit: Q(["g", "kg"]).register(V, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(V, { description: "The weight of the package" }).optional()
	}).register(V, { description: "Physical properties of the package." }).optional(),
	options: Y({
		age_check: Z(H(), q()).register(V, { description: "Requires age verification option" }).optional(),
		cash_on_delivery: Z(H(), q()).register(V, { description: "Cash on delivery option" }).optional(),
		collect: Z(H(), q()).register(V, { description: "Scheduled collection option" }).optional(),
		drop_off_at_postal_point: Z(H(), q()).register(V, { description: "Deliver at postal point option" }).optional(),
		extra_assurance: Z(H(), q()).register(V, { description: "Additional insurance option" }).optional(),
		fresh_food: Z(H(), q()).register(V, { description: "Fresh food delivery option" }).optional(),
		frozen: Z(H(), q()).register(V, { description: "Frozen delivery option" }).optional(),
		hide_sender: Z(H(), q()).register(V, { description: "Hide sender option" }).optional(),
		large_format: Z(H(), q()).register(V, { description: "Oversized package option" }).optional(),
		no_tracking: Z(H(), q()).register(V, { description: "Ship without track and trace option" }).optional(),
		only_recipient: Z(H(), q()).register(V, { description: "Recipient only delivery option" }).optional(),
		priority_delivery: Z(H(), q()).register(V, { description: "Priority delivery option" }).optional(),
		printerless_return: Z(H(), q()).register(V, { description: "Printerless return delivery option" }).optional(),
		receipt_code: Z(H(), q()).register(V, { description: "Requires receipt code option" }).optional(),
		return: Z(H(), q()).register(V, { description: "Return on first failed delivery option" }).optional(),
		same_day_delivery: Z(H(), q()).register(V, { description: "Same day delivery option" }).optional(),
		saturday_delivery: Z(H(), q()).register(V, { description: "Saturday delivery option" }).optional(),
		signature: Z(H(), q()).register(V, { description: "Requires signature option" }).optional(),
		tracked: Z(H(), q()).register(V, { description: "DEPRECATED: replaced by no_tracking (its inverse)." }).optional(),
		insurance: X([Z(H(), q()), VS]).optional()
	}).register(V, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	delivery_type: X([
		$(1),
		$(2),
		$(3),
		$(4),
		$(5),
		$(6),
		$(7),
		$(8)
	]).optional(),
	shipment_type: X([
		$(1),
		$(2),
		$(3),
		$(4),
		$(5),
		$(6),
		$(7),
		$(8)
	]).optional(),
	direction: Q(["INBOUND", "OUTBOUND"]).register(V, { description: "The shipment direction for which the capabilities are requested." }).optional(),
	pickup: Y({ location_type: XS.optional() }).register(V, { description: "Pickup location criteria for filtering capabilities." }).optional()
})) }) });
var tD = Y({ carrier: Q([
	"BRT",
	"DHL_EUROPLUS",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"DHL_FOR_YOU",
	"INPOST",
	"POSTNL"
]).optional() });
Y({ data: Y({ carrier_id: X([
	$(1),
	$(4),
	$(9),
	$(10),
	$(11),
	$(15),
	$(17)
]).optional() }).optional() });
var nD = Y({
	address: Y({
		city: H().min(1).max(100).register(V, { description: "The city of the address." }).optional(),
		countryCode: H().length(2).regex(/[A-Z]{2}/).register(V, { description: "The country code (ISO 3166-1 alpha-2) of the address." }),
		street: H().min(1).max(100).register(V, { description: "The street of the address." }).optional(),
		additionalInformation: H().min(1).max(100).register(V, { description: "Additional information about the address." }).optional(),
		boxNumber: H().min(1).max(20).register(V, { description: "The box number of the address. Only applicable for `countryCode`=`BE`." }).optional(),
		houseNumber: H().min(1).max(25).register(V, { description: "The house number of the address." }).optional(),
		houseNumberSuffix: H().min(1).max(25).register(V, { description: "The house number suffix of the address." }).optional(),
		postalCode: H().min(1).max(15).register(V, { description: "The postal code of the address." }).optional(),
		region: H().min(1).max(100).register(V, { description: "The region of the address." }).optional(),
		state: H().min(1).max(100).register(V, { description: "The state of the address." }).optional()
	}),
	location: Y({
		name: H().min(1).max(200).register(V, { description: "The name of the pickup location." }),
		code: H().min(1).max(64).register(V, { description: "The location code of the pickup location." }).optional(),
		type: $E.optional()
	}),
	retailNetworkId: Q(["PNPNL-01", "PNPBE-01"]).register(V, { description: "PostNL Retail network ID." }).optional()
}).register(V, { description: "Pickup location data." }), rD = Y({
	shopId: W().register(V, { description: "The ID of the shop for which the rates are requested." }).optional(),
	contractId: W().register(V, { description: "The ID of the contract for which the rates are requested." }).optional(),
	recipient: Y({
		countryCode: H().length(2).regex(/^[A-Z]{2}$/).register(V, { description: "Alpha-2 Country code of the recipient." }),
		postalCode: H().min(1).max(15).register(V, { description: "Postal code of the recipient." }).optional(),
		isBusiness: G().register(V, { description: "Whether this is a business address." }).optional()
	}).register(V, { description: "Recipient data." }),
	sender: Y({
		countryCode: H().length(2).regex(/^[A-Z]{2}$/).register(V, { description: "Alpha-2 Country code of the sender." }).optional(),
		postalCode: H().min(1).max(15).register(V, { description: "Postal code of the sender." }).optional(),
		isBusiness: G().register(V, { description: "Whether this is a business address." }).optional()
	}).register(V, { description: "Sender data." }).optional(),
	pickup: nD.optional(),
	carrier: DT,
	packageType: kT,
	physicalProperties: Y({
		height: Y({
			value: U().gte(0).register(V, { description: "The height value" }),
			unit: Q(["cm", "mm"]).register(V, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(V, { description: "The height of the package" }).optional(),
		width: Y({
			value: U().gte(0).register(V, { description: "The width value" }),
			unit: Q(["cm", "mm"]).register(V, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(V, { description: "The width of the package" }).optional(),
		length: Y({
			value: U().gte(0).register(V, { description: "The length value" }),
			unit: Q(["cm", "mm"]).register(V, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(V, { description: "The length of the package" }).optional(),
		weight: Y({
			value: U().gte(0).register(V, { description: "The weight value" }),
			unit: Q(["g", "kg"]).register(V, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(V, { description: "The weight of the package" }).optional()
	}).register(V, { description: "Physical properties of the package." }).optional(),
	options: Y({
		additionalInsurance: Z(H(), q()).register(V, { description: "Additional insurance option" }).optional(),
		deliverAtPostalPoint: Z(H(), q()).register(V, { description: "Deliver at postal point option" }).optional(),
		freshFood: Z(H(), q()).register(V, { description: "Fresh food option" }).optional(),
		frozen: Z(H(), q()).register(V, { description: "Frozen option" }).optional(),
		hideSender: Z(H(), q()).register(V, { description: "Hide sender option" }).optional(),
		insurance: X([Y({ insuredAmount: VS }).register(V, { description: "Deprecated. Use options.insurance.{amount, currency} directly. Will be removed in a future release." }), VS]).optional(),
		noTracking: Z(H(), q()).register(V, { description: "Ship without track and trace option" }).optional(),
		oversizedPackage: Z(H(), q()).register(V, { description: "Oversized package option" }).optional(),
		priorityDelivery: Z(H(), q()).register(V, { description: "Priority delivery package option" }).optional(),
		recipientOnlyDelivery: Z(H(), q()).register(V, { description: "Recipient only delivery option" }).optional(),
		returnOnFirstFailedDelivery: Z(H(), q()).register(V, { description: "Return on first failed delivery option" }).optional(),
		requiresAgeVerification: Z(H(), q()).register(V, { description: "Requires age verification option" }).optional(),
		requiresCashOnDelivery: Y({ dueAmount: VS }).register(V, { description: "Cash on delivery option" }).optional(),
		requiresReceiptCode: Z(H(), q()).register(V, { description: "Requires receipt code option" }).optional(),
		requiresSignature: Z(H(), q()).register(V, { description: "Requires signature option" }).optional(),
		sameDayDelivery: Z(H(), q()).register(V, { description: "Same day delivery option" }).optional(),
		saturdayDelivery: Z(H(), q()).register(V, { description: "Saturday delivery option" }).optional(),
		scheduledCollection: Z(H(), q()).register(V, { description: "Scheduled collection option" }).optional()
	}).register(V, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	deliveryType: Q([
		"EARLY_MORNING_DELIVERY",
		"EVENING_DELIVERY",
		"EXPRESS_DELIVERY",
		"MORNING_DELIVERY",
		"PICKUP_DELIVERY",
		"SAME_DAY_DELIVERY",
		"STANDARD_DELIVERY"
	]).optional(),
	direction: Q(["INBOUND", "OUTBOUND"]).register(V, { description: "The shipment direction for which the rates are requested." }).optional(),
	collo: W().gte(1).register(V, { description: "The number of collo for which the rates are requested." }).optional()
});
Y({ data: Y({ rates: J(Y({
	shop_id: W().register(V, { description: "The ID of the shop for which the rates are requested." }).optional(),
	contract_id: W().register(V, { description: "The ID of the contract for which the rates are requested." }).optional(),
	recipient: Y({
		cc: H().length(2).regex(/^[A-Z]{2}$/).register(V, { description: "Alpha-2 Country code of the recipient." }),
		postal_code: H().min(1).max(15).register(V, { description: "Postal code of the recipient." }).optional(),
		is_business: G().register(V, { description: "Whether this is a business address." }).optional()
	}).register(V, { description: "Recipient data." }),
	sender: Y({
		cc: H().length(2).regex(/^[A-Z]{2}$/).register(V, { description: "Alpha-2 Country code of the sender." }).optional(),
		postal_code: H().min(1).max(15).register(V, { description: "Postal code of the sender." }).optional(),
		is_business: G().register(V, { description: "Whether this is a business address." }).optional()
	}).register(V, { description: "Sender data." }).optional(),
	pickup: QS.optional(),
	carrier_id: HT,
	package_type: US,
	physical_properties: Y({
		height: Y({
			value: U().gte(0).register(V, { description: "The height value" }),
			unit: Q(["cm", "mm"]).register(V, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(V, { description: "The height of the package" }).optional(),
		width: Y({
			value: U().gte(0).register(V, { description: "The width value" }),
			unit: Q(["cm", "mm"]).register(V, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(V, { description: "The width of the package" }).optional(),
		length: Y({
			value: U().gte(0).register(V, { description: "The length value" }),
			unit: Q(["cm", "mm"]).register(V, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(V, { description: "The length of the package" }).optional(),
		weight: Y({
			value: U().gte(0).register(V, { description: "The weight value" }),
			unit: Q(["g", "kg"]).register(V, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(V, { description: "The weight of the package" }).optional()
	}).register(V, { description: "Physical properties of the package." }).optional(),
	options: Y({
		age_check: Z(H(), q()).register(V, { description: "Requires age verification option" }).optional(),
		cash_on_delivery: Y({ due_amount: VS }).register(V, { description: "Cash on delivery option" }).optional(),
		collect: Z(H(), q()).register(V, { description: "Scheduled collection option" }).optional(),
		cooled_delivery: Z(H(), q()).register(V, { description: "Cooled delivery option" }).optional(),
		drop_off_at_postal_point: Z(H(), q()).register(V, { description: "Deliver at postal point option" }).optional(),
		extra_assurance: Z(H(), q()).register(V, { description: "Additional insurance option" }).optional(),
		hide_sender: Z(H(), q()).register(V, { description: "Hide sender option" }).optional(),
		large_format: Z(H(), q()).register(V, { description: "Oversized package option" }).optional(),
		no_tracking: Z(H(), q()).register(V, { description: "Ship without track and trace option" }).optional(),
		only_recipient: Z(H(), q()).register(V, { description: "Recipient only delivery option" }).optional(),
		priority_delivery: Z(H(), q()).register(V, { description: "Priority delivery option" }).optional(),
		receipt_code: Z(H(), q()).register(V, { description: "Requires receipt code option" }).optional(),
		return: Z(H(), q()).register(V, { description: "Return on first failed delivery option" }).optional(),
		same_day_delivery: Z(H(), q()).register(V, { description: "Same day delivery option" }).optional(),
		saturday_delivery: Z(H(), q()).register(V, { description: "Saturday delivery option" }).optional(),
		signature: Z(H(), q()).register(V, { description: "Requires signature option" }).optional(),
		tracked: Z(H(), q()).register(V, { description: "DEPRECATED: replaced by no_tracking (its inverse)." }).optional(),
		insurance: X([Y({ insured_amount: VS }).register(V, { description: "Deprecated. Use options.insurance.{amount, currency} directly. Will be removed in a future release." }), VS]).optional()
	}).register(V, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	delivery_type: X([
		$(1),
		$(2),
		$(3),
		$(4),
		$(5),
		$(6),
		$(7),
		$(8)
	]).optional(),
	shipment_type: X([
		$(1),
		$(2),
		$(3),
		$(4),
		$(5),
		$(6),
		$(7),
		$(8)
	]).optional(),
	direction: Q(["INBOUND", "OUTBOUND"]).register(V, { description: "The shipment direction for which the rates are requested." }).optional(),
	collo: W().gte(1).register(V, { description: "The number of collo for which the rates are requested." }).optional()
})).min(1) }) });
var iD = X([Y({
	shopId: W(),
	packageType: Q([
		"DIGITAL_STAMP",
		"ENVELOPE",
		"UNFRANKED",
		"MAILBOX",
		"PACKAGE",
		"PALLET",
		"SMALL_PACKAGE"
	]),
	countryCode: H().length(2).regex(/^[A-Z]{2}$/).register(V, { description: "ISO 3166-1 alpha-2 country code" }),
	shipmentDirection: Q(["OUTBOUND"])
}), Y({
	shopId: W(),
	packageType: _x().optional(),
	countryCode: H().length(2).regex(/^[A-Z]{2}$/).register(V, { description: "ISO 3166-1 alpha-2 country code" }).optional(),
	shipmentDirection: Q(["INBOUND"])
})]), aD = Y({
	body: H().min(1),
	subject: H().min(1).max(255)
}), oD = Y({ data: Y({ webhook_subscriptions: J(Y({
	account_id: W().optional(),
	shop_id: W().optional(),
	hook: H(),
	url: H(),
	payload: H().nullish()
})).min(1).optional() }) });
Y({ data: Y({ webhook_subscriptions: J(Y({
	account_id: W().optional(),
	shop_id: W().optional(),
	hook: H(),
	url: H()
})).min(1).optional() }) }), H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }), H().nullable(), H().nullable(), xb().register(V, { description: "When set, only resources created after this date will be returned. Inclusive." }), yE.nullable(), W().gte(-1).lte(14).nullable(), W().gte(0).nullable(), W().gte(0).lte(14).nullable(), G().register(V, { description: "Use this parameter to only show Shipments that need to be dropped off today." }), yE.nullable(), H().nullable(), G(), X([EE, H().regex(/^[Aa][46]$/)]), G(), W().nullable(), G(), H().nullable(), yE.nullable(), H().nullable(), X([kE, H().regex(/^([Aa][Ss][Cc]|[Dd][Ee][Ss][Cc])$/)]), H().nullable(), H().nullable(), H().register(V, { description: "Filter by `reference_identifier`, an optional arbitrary identifier to identify the Shipment." }), H().register(V, { description: "The region, department, state or province of the address." }), Q(["asc", "desc"]).register(V, { description: "Sort order. Defaults to `desc`." }), H().nullable(), W().register(V, { description: "The ID of the notification group." }), H().register(V, { description: "One or more notification group IDs. Separate multiple IDs using `;`." }), W().register(V, { description: "The ID of the notification template." }), H().register(V, { description: "Filter by webhook event type." });
var sD = KE, cD = ZE, lD = QE, uD = eD, dD = tD, fD = rD, pD = iD, mD = aD, hD = oD;
Y({
	body: q().optional(),
	path: q().optional(),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	title: H().optional(),
	status: H()
}).register(V, { description: "Status is OK" }), Y({
	body: q().optional(),
	path: q().optional(),
	query: Y({
		cc: H().nullish(),
		postal_code: PE.optional(),
		number: H().nullish(),
		city: H().nullish(),
		street: H().nullish(),
		platform: ME.optional(),
		shop_id: RE.optional(),
		carrier: hE.optional(),
		delivery_date: xE.optional(),
		delivery_time: SE.optional(),
		cutoff_time: vE.optional(),
		dropoff_days: wE.optional(),
		monday_delivery: yE.nullish(),
		dropoff_delay: W().gte(0).lte(14).nullish(),
		deliverydays_window: W().gte(-1).lte(14).nullish(),
		exclude_delivery_type: TE.optional(),
		exclude_parcel_lockers: yE.nullish(),
		latitude: DE.optional(),
		longitude: OE.optional()
	}).optional()
}), Y({
	body: q().optional(),
	path: q().optional(),
	query: Y({
		postal_code: PE.optional(),
		number: H().nullish(),
		distance: W().gte(0).nullish(),
		cc: H().nullish(),
		limit: W().nullish(),
		carrier_id: mE.optional(),
		shop_id: RE.optional(),
		reference: H().nullish(),
		location_name: H().nullish(),
		external_identifier: H().nullish(),
		city: H().nullish(),
		cut_off_time: vE.optional(),
		min_cut_off_time: vE.optional(),
		max_cut_off_time: vE.optional(),
		latitude: DE.optional(),
		longitude: OE.optional(),
		exclude_parcel_lockers: yE.nullish()
	}).optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	body: q().optional(),
	path: q().optional(),
	query: Y({
		cc: H().nullish(),
		postal_code: PE.optional(),
		number: H().nullish(),
		city: H().nullish(),
		street: H().nullish(),
		platform: ME.optional(),
		shop_id: RE.optional(),
		carrier: hE.optional(),
		delivery_date: xE.optional(),
		delivery_time: SE.optional(),
		cutoff_time: vE.optional(),
		dropoff_days: wE.optional(),
		monday_delivery: yE.nullish(),
		dropoff_delay: W().gte(0).lte(14).nullish(),
		deliverydays_window: W().gte(-1).lte(14).nullish(),
		exclude_delivery_type: TE.optional(),
		exclude_parcel_lockers: yE.nullish(),
		latitude: DE.optional(),
		longitude: OE.optional()
	}).optional()
}), Y({
	body: q().optional(),
	path: q().optional(),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	body: q().optional(),
	path: q().optional(),
	query: Y({
		barcode: pE.optional(),
		carrier_id: mE.optional(),
		created: xb().register(V, { description: "When set, only resources created after this date will be returned. Inclusive." }).optional(),
		delayed: yE.nullish(),
		delivered: bE.optional(),
		dropoff_today: G().register(V, { description: "Use this parameter to only show Shipments that need to be dropped off today." }).optional(),
		filter_hidden_shops: G().optional(),
		hidden: bE.optional(),
		link_consumer_portal: G().optional(),
		order: X([kE, H().regex(/^([Aa][Ss][Cc]|[Dd][Ee][Ss][Cc])$/)]).optional(),
		package_type: AE.optional(),
		page: jE.optional(),
		q: H().nullish(),
		reference_identifier: H().register(V, { description: "Filter by `reference_identifier`, an optional arbitrary identifier to identify the Shipment." }).optional(),
		region: H().register(V, { description: "The region, department, state or province of the address." }).optional(),
		shipment_type: IE.optional(),
		shop_id: RE.optional(),
		size: zE.optional(),
		sort: BE.optional(),
		status: VE.optional(),
		transaction_status: mC.optional()
	}).optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	body: lD,
	path: q().optional(),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), xx().register(V, { description: "Shipment patch was successful." }), Y({
	body: sD,
	path: q().optional(),
	query: Y({
		format: X([EE, H().regex(/^[Aa][46]$/)]).optional(),
		positions: NE.optional(),
		collect_date: gE.optional(),
		delivery_options_identifier: CE.optional()
	}).optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	body: cD,
	path: q().optional(),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), X([Rw, xx().register(V, { description: "Shipment update was successful." })]), Y({
	body: q().optional(),
	path: Y({ ids: FE }),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), xx().register(V, { description: "Shipment deletion was successful." }), Y({
	body: q().optional(),
	path: Y({ ids: FE }),
	query: Y({ link_consumer_portal: G().optional() }).optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	body: uD,
	path: q().optional(),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	body: dD,
	path: q().optional(),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	body: fD,
	path: q().optional(),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), X([sE, xx().register(V, { description: "This response is given when the request is successful and the response is empty." })]), Y({
	body: q().optional(),
	path: Y({ ids: FE }),
	query: Y({
		format: X([EE, H().regex(/^[Aa][46]$/)]).optional(),
		positions: NE.optional(),
		collect_date: gE.optional(),
		delivery_options_identifier: CE.optional()
	}).optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), X([xx().register(V, { description: "Direct Printing Response" }), Bw]), Y({
	body: q().optional(),
	path: q().optional(),
	query: Y({
		barcode: pE.optional(),
		country_code: _E.optional(),
		external_identifier: pE.optional(),
		extra_info: HE.optional(),
		postal_code: PE.optional(),
		sort: Q(["asc", "desc"]).register(V, { description: "Sort order. Defaults to `desc`." }).optional()
	}).optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	body: q().optional(),
	path: Y({ ids: FE }),
	query: Y({
		sort: Q(["asc", "desc"]).register(V, { description: "Sort order. Defaults to `desc`." }).optional(),
		extra_info: HE.optional()
	}).optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	body: q().optional(),
	path: q().optional(),
	query: Y({ shopId: RE.optional() }).optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	body: pD,
	path: q().optional(),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	body: q().optional(),
	path: Y({ ids: H().register(V, { description: "One or more notification group IDs. Separate multiple IDs using `;`." }) }),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), xx().register(V, { description: "Notification group deletion was successful." }), Y({
	body: q().optional(),
	path: Y({ notification_group_id: W().register(V, { description: "The ID of the notification group." }) }),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	body: mD,
	path: Y({
		notification_group_id: W().register(V, { description: "The ID of the notification group." }),
		notification_template_id: W().register(V, { description: "The ID of the notification template." })
	}),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), xx().register(V, { description: "Notification template update was successful." }), Y({
	body: q().optional(),
	path: Y({ notification_group_id: W().register(V, { description: "The ID of the notification group." }) }),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), xx().register(V, { description: "Disabling notification templates was successful." }), Y({
	body: q().optional(),
	path: Y({ notification_group_id: W().register(V, { description: "The ID of the notification group." }) }),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), xx().register(V, { description: "Enabling notification templates was successful." }), Y({
	body: q().optional(),
	path: Y({
		notification_group_id: W().register(V, { description: "The ID of the notification group." }),
		notification_template_id: W().register(V, { description: "The ID of the notification template." })
	}),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), xx().register(V, { description: "Disabling notification template was successful." }), Y({
	body: q().optional(),
	path: Y({
		notification_group_id: W().register(V, { description: "The ID of the notification group." }),
		notification_template_id: W().register(V, { description: "The ID of the notification template." })
	}),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), xx().register(V, { description: "Enabling notification template was successful." }), Y({
	body: q().optional(),
	path: Y({
		notification_group_id: W().register(V, { description: "The ID of the notification group." }),
		notification_template_id: W().register(V, { description: "The ID of the notification template." })
	}),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), xx().register(V, { description: "Test notification was successfully send." }), Y({
	body: q().optional(),
	path: q().optional(),
	query: Y({ hook: H().register(V, { description: "Filter by webhook event type." }).optional() }).optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	body: hD,
	path: q().optional(),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	body: q().optional(),
	path: Y({ ids: FE }),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), xx().register(V, { description: "Webhook subscription deletion was successful." }), Y({
	body: q().optional(),
	path: Y({ ids: FE }),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var gD = W().gte(400).lte(499).register(V, { description: "The request contains bad syntax or cannot be fulfilled" }), _D = X([X([
	$(3e3),
	$(3001),
	$(3002),
	$(3003),
	$(3004),
	$(3005),
	$(3006),
	$(3007)
]).register(V, { description: "Authentication and Authorization related error codes" }), W()]), vD = Y({
	status: gD.optional(),
	code: _D.optional(),
	title: H().optional(),
	message: H().optional()
}), yD = Y({
	message: H(),
	request_id: H().register(V, { description: "Internal request ID, useful for debugging purposes." }),
	status_code: gD,
	errors: X([J(vD), Z(H(), vD)])
}), bD = $(404).register(V, { description: "Did not find the requested target resource." });
yD.and(Y({
	status_code: bD.optional(),
	errors: J(Y({
		status: bD.optional(),
		code: W().optional()
	})).optional()
}));
var xD = Zx().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).register(V, { description: "Unique ID of a Shipment." }), SD = W().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), CD = W().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), wD = X([
	$(1),
	$(2),
	$(3),
	$(4),
	$(5),
	$(6),
	$(7),
	$(8)
]), TD = H(), ED = X([X([Q([""]), H()]), K()]).nullable(), DD = X([K(), X([Q([""]), H()])]).nullable(), OD = Y({
	account_id: SD.optional(),
	person: H().optional(),
	first_name: H().optional(),
	last_name: H().optional(),
	company: H().nullish(),
	street: H().optional(),
	street_additional_info: H().nullish(),
	number: H().nullish(),
	number_suffix: H().nullish(),
	postal_code: H().optional(),
	city: H().optional(),
	state: H().optional(),
	cc: TD,
	region: H().nullish(),
	area: H().optional(),
	phone: H().nullish(),
	email: X([K(), X([Q([""]), H()])]).nullish(),
	billing_email: ED.optional(),
	secondary_emails: J(DD).nullish(),
	box_number: H().nullish(),
	eori_number: H().optional(),
	vat_number: H().optional(),
	invalid: G().optional()
}), kD = OD.and(Y({
	person: K().optional(),
	first_name: H().optional(),
	last_name: H().optional(),
	company: K().optional(),
	street: K().optional(),
	street_additional_info: K().optional(),
	number: K().optional(),
	number_suffix: K().optional(),
	postal_code: K().optional(),
	city: K().optional(),
	state: K().optional(),
	area: K().optional(),
	phone: K().optional()
})), AD = X([
	$(1),
	$(2),
	$(3),
	$(4),
	$(5),
	$(6),
	$(7),
	$(8),
	$(9),
	$(10),
	$(11),
	$(12),
	$(13),
	$(14),
	$(15),
	$(16),
	$(17),
	$(18),
	$(19),
	$(98),
	$(99),
	$(100),
	$(101),
	$(30),
	$(31),
	$(32),
	$(33),
	$(34),
	$(35),
	$(36),
	$(37),
	$(38)
]), jD = Y({ insurance: Y({
	currency: X([Q(["EUR"]), H()]),
	amount: W().gte(0)
}).optional() }).and(Y({ insurance: Y({ amount: K().optional() }).optional() })), MD = X([$(0), $(1)]), ND = Y({
	currency: X([Q(["", "EUR"]), H()]).register(V, { description: "The currency as uppercase 3-letter ISO 4217 code." }),
	amount: X([W().gte(0), H()])
}).register(V, { description: "Money amount with currency" }), PD = Y({
	age_check: MD.optional(),
	cash_on_delivery: ND.optional(),
	collect: MD.optional(),
	cooled_delivery: MD.optional(),
	drop_off_at_postal_point: MD.optional(),
	extra_assurance: MD.optional(),
	fresh_food: MD.optional(),
	frozen: MD.optional(),
	hide_sender: MD.optional(),
	large_format: MD.optional(),
	no_tracking: MD.optional(),
	only_recipient: MD.optional(),
	priority_delivery: MD.optional(),
	receipt_code: MD.optional(),
	return: MD.optional(),
	same_day_delivery: MD.optional(),
	saturday_delivery: MD.optional(),
	signature: MD.optional(),
	tracked: MD.optional()
}), FD = X([
	$(1),
	$(2),
	$(3),
	$(4),
	$(5),
	$(6),
	$(7)
]).register(V, { description: "Package Type." }), ID = Y({ package_type: FD.optional() }), LD = Y({ delivery_type: X([
	$(1),
	$(2),
	$(3),
	$(4),
	$(5),
	$(6),
	$(7),
	$(8)
]).nullish() }), RD = Y({ delivery_date: H().nullish() }), zD = Y({ label_description: H().nullish() }), BD = jD.and(PD).and(ID).and(LD).and(RD).and(zD), VD = Y({
	save_recipient_address: MD.optional(),
	delivery_notification: MD.optional(),
	delivery_notification_email: J(Gb()).optional(),
	disable_auto_detect_pickup: MD.optional(),
	printer_identifier: H().optional(),
	tracktrace: Y({
		bcc: MD.optional(),
		bcc_email: ED.optional(),
		carrier_email_basic_notification: MD.optional(),
		delivery_notification: MD.optional(),
		delivery_notification_email: J(H()).optional(),
		disable_auto_detect_pickup: MD.optional(),
		email_on_handed_to_courier: MD.optional(),
		from_address_company: H().optional(),
		from_address_email: X([K(), X([Q([""]), H()])]).optional(),
		printer_identifier: H().optional(),
		save_recipient_address: MD.optional(),
		send_track_trace_emails: MD.optional()
	}).optional()
}).nullable(), HD = X([Q([
	"retail",
	"locker",
	"post_office"
]), H()]).register(V, { description: "Pickup / drop-off location type." }), UD = X([
	$(0),
	$(1),
	$(2),
	$(4),
	$(8),
	$(16)
]), WD = Y({
	location_code: H().optional(),
	location_name: H().optional(),
	street: H().optional(),
	number: H().optional(),
	number_suffix: H().nullish(),
	postal_code: H().optional(),
	city: H().optional(),
	cc: H().optional(),
	location_type: X([HD, UD]).optional(),
	retail_network_id: H().optional()
}).nullable(), GD = X([
	$(1),
	$(2),
	$(3),
	$(4),
	$(5)
]), KD = Y({
	description: H(),
	amount: W().gte(1).lte(99999),
	weight: W().gte(0).lte(999999999),
	item_value: ND,
	classification: H(),
	country: X([K(), X([Q([""]), H()])]).optional()
}), qD = Y({
	contents: GD,
	invoice: H().nullish(),
	eori_number: H().nullish(),
	vat_number: H().nullish(),
	vat_number_uk: H().nullish(),
	voec_number: H().nullish(),
	weight: W().gte(0).lte(999999999),
	items: J(KD)
}), JD = W().gte(0).lte(999999999), YD = W().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), XD = W().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), ZD = W().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), QD = W().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), $D = JD, eO = YD.nullable(), tO = XD.nullable(), nO = ZD.nullable(), rO = QD.nullable(), iO = Y({
	weight: JD.optional(),
	height: YD.nullish(),
	width: XD.nullish(),
	length: ZD.nullish(),
	volume: QD.nullish(),
	carrier_weight: X([$D, H()]).nullish(),
	carrier_height: eO.nullish(),
	carrier_width: tO.nullish(),
	carrier_length: nO.nullish(),
	carrier_volume: rO.nullish()
}).nullable(), aO = X([W(), H()]).nullable(), oO = X([Q([
	"pending",
	"unpaid",
	"paid"
]), H()]).nullable(), sO = WD, cO = Y({
	currency: X([Q(["", "EUR"]), H()]).register(V, { description: "The currency as uppercase 3-letter ISO 4217 code." }),
	amount: X([W().gte(0), H()]).nullable()
}).register(V, { description: "Money amount with currency, where the amount may be null. The amount is null when the requester lacks permission to read price amounts (Permissions::BILLING_READ_PRICE_AMOUNTS)." }), lO = X([Q([
	"Facebook",
	"Flespakket.nl",
	"Amazon",
	"Bol.com",
	"MyParcel.nl",
	"Wix",
	"Ecwid",
	"Exact Online DE",
	"Exact Online NL",
	"Etsy"
]), H()]), uO = Zx().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }), dO = X([Q([
	"pending",
	"unpaid",
	"paid"
]), H()]).nullable(), fO = X([
	$(1),
	$(2),
	$(3),
	$(4),
	$(5),
	$(6),
	$(7),
	$(8),
	$(9),
	$(10),
	$(11),
	$(12),
	$(13),
	$(14),
	$(15),
	$(16),
	$(17),
	$(18),
	$(19),
	$(20),
	$(21)
]).register(V, { description: "This enumeration represents the Carriers. The value is the Carrier id." }), pO = X([
	$(1),
	$(2),
	$(3),
	$(4),
	$(5),
	$(6)
]), mO = H(), hO = H().nullable(), gO = xD.nullable(), _O = SD, vO = CD, yO = wD, bO = kD, xO = OD, SO = AD, CO = BD.and(K()), wO = VD, TO = WD, EO = qD.nullable(), DO = iO, OO = aO, kO = oO, AO = sO, jO = MD, MO = cO, NO = H(), PO = X([K(), X([Q(["Wereld"]), H()])]), FO = lO.nullable(), IO = uO.nullable(), LO = dO, RO = fO, zO = pO, BO = mO.nullable(), VO = hO, HO = H(), UO = H(), WO = X([H(), W()]), GO = H(), KO = H(), qO = H(), JO = H(), YO = H(), XO = H().nullable(), ZO = Y({
	id: W().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).optional(),
	gender: H().nullish(),
	first_name: H().nullish(),
	last_name: H().nullable(),
	email: X([X([Q([""]), H()]), K()]).nullable(),
	phone: H().nullable(),
	company: H().nullable(),
	street: HO,
	street_additional_info: UO.optional(),
	number: WO,
	number_suffix: GO.optional(),
	postal_code: KO,
	city: qO,
	cc: JO,
	region: YO.optional(),
	box_number: XO.optional()
}), QO = ZO.nullable(), $O = xD.nullable(), ek = H().nullable(), tk = ek, nk = G().default(!1), rk = G().default(!1), ik = W().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).nullable(), ak = X([Q(["", "EUR"]), H()]), ok = ak.nullable(), sk = Zx().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).nullable(), ck = X([K(), X([Q([""]), H()])]).nullable(), lk = J(Y({
	uri: X([X([Q([""]), H()]), K()]),
	barcode: H()
})), uk = lk, dk = H().nullable(), fk = Jb().max(36).nullable(), pk = W().nullable(), mk = H().nullable(), hk = Z(H(), K()).nullable(), gk = H().nullable(), _k = Y({
	quantity: pk.optional(),
	order_line_identifier: mk.optional(),
	order_line: hk.optional(),
	picklist_identifier: gk.optional(),
	order_identifier: H().nullish()
}).nullable(), vk = J(_k).nullable(), yk = H().register(V, { description: "Represents a date in ISO 8601 format and a time in ISO 8601 format, separated\nby a space, so:\n\n```\nYYYY-MM-DD hh:mm:ss.u\n```\n\nWhere:\n  - `YYYY` represents a four-digit year, `0000` through `9999`\n  - `MM` represents a zero-padded month of the year, `01` through `12`\n  - `DD` represents a zero-padded day of that month, `01` through `31`\nand:\n  - `hh` represents a zero-padded hour, `00` through `24`\n  - `mm` represents a zero-padded minute, `00` through `59`\n  - `ss` (optional) represents a zero-padded second, `00` through `60`\n    (where `60` is only used to denote an added leap second)\n  - `.u` (optional) represents a fraction of a second, `.0` through `.999999+`\n" }), bk = yk, xk = bk, Sk = yk, Ck = Sk, wk = Zx().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }), Tk = wk.nullable(), Ek = Tk, Dk = wk.nullable(), Ok = Dk, kk = Y({
	id: Zx().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).register(V, { description: "Unique ID of a Shipment." }),
	parent_id: xD.nullable(),
	account_id: SD,
	shop_id: CD,
	shipment_type: wD,
	recipient: kD,
	sender: OD,
	status: AD,
	options: BD.and(K()),
	general_settings: VD,
	pickup: WD,
	customs_declaration: qD.nullable(),
	physical_properties: iO,
	reference_identifier: aO,
	transaction_status: oO,
	drop_off_point: sO,
	hidden: MD,
	price: cO,
	barcode: H(),
	region: X([K(), X([Q(["Wereld"]), H()])]),
	external_provider: lO.nullable(),
	external_provider_id: uO.nullable(),
	payment_status: dO,
	carrier_id: fO,
	platform_id: pO,
	origin: mO.nullable(),
	user_agent: hO,
	secondary_shipments: J(Y({
		id: xD,
		parent_id: gO,
		account_id: _O,
		shop_id: vO,
		shipment_type: yO,
		recipient: bO,
		sender: xO,
		status: SO,
		options: CO,
		general_settings: wO,
		pickup: TO,
		customs_declaration: EO,
		physical_properties: DO,
		reference_identifier: OO,
		transaction_status: kO,
		drop_off_point: AO,
		hidden: jO,
		price: MO,
		barcode: NO,
		region: PO,
		external_provider: FO,
		external_provider_id: IO,
		payment_status: LO,
		carrier_id: RO,
		platform_id: zO,
		origin: BO,
		user_agent: VO,
		secondary_shipments: J(K()).max(0).nullish(),
		collection_contact: QO,
		multi_collo_main_shipment_id: $O,
		external_identifier: tk,
		delayed: nk,
		delivered: rk,
		amount: ik.optional(),
		currency: ok.optional(),
		contract_id: sk,
		link_consumer_portal: ck.optional(),
		partner_tracktraces: uk.optional(),
		pickup_request_number: dk.optional(),
		order_shipment_identifier: fk.optional(),
		shipped_items: vk.optional(),
		created: xk,
		modified: Ck,
		created_by: Ek,
		modified_by: Ok
	})),
	collection_contact: ZO.nullable(),
	multi_collo_main_shipment_id: xD.nullable(),
	external_identifier: ek,
	delayed: G().default(!1),
	delivered: G().default(!1),
	amount: W().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).nullish(),
	currency: ak.nullish(),
	contract_id: Zx().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).nullable(),
	link_consumer_portal: X([K(), X([Q([""]), H()])]).nullish(),
	partner_tracktraces: lk.optional(),
	pickup_request_number: H().nullish(),
	order_shipment_identifier: Jb().max(36).nullish(),
	shipped_items: J(_k).nullish(),
	created: bk,
	modified: Sk,
	created_by: Tk,
	modified_by: Dk
}), Ak = Y({ data: Y({ shipments: J(kk).register(V, { description: "A list of Shipment Resources." }) }) });
X([H(), K()]);
var jk = Y({ url: Xb() }), Mk = Y({ data: X([
	Y({ pdf: jk }),
	Y({ pdfs: jk }),
	Y({ csvs: jk }),
	Y({ zpl: jk }),
	Y({ zpls: jk })
]) }), Nk = J(Y({
	shipment_id: xD,
	price: ND,
	price_after_vat: ND
}));
Y({ data: Y({ shipments: Y({
	unpaid_shipments: Nk,
	blocked_shipments: Nk
}) }) });
var Pk = Y({
	amount: W().nullable(),
	currency: X([Q(["", "EUR"]), H()]).register(V, { description: "The currency as uppercase 3-letter ISO 4217 code." })
}).register(V, { description: "Price amount in a specific currency" });
Y({ data: Y({ payment_instructions: J(Y({
	id: H(),
	hash: H(),
	type: W(),
	notification_hash: H(),
	original_notification_hash: H(),
	paid: X([$(0), $(1)]),
	price: Pk,
	payment_url: Xb().nullable(),
	invoices: Y({
		id: W(),
		number: H(),
		status: W()
	})
})) }) });
var Fk = $(400).register(V, { description: "The server will not process the request due to a client error." });
yD.and(Y({
	status_code: Fk.optional(),
	errors: J(Y({
		status: Fk.optional(),
		code: W().optional()
	})).optional()
})), Y({
	type: H().register(V, { description: "URI reference identifying the problem type. Derived from the wrapping UserException constant name (e.g. `urn:problem:invalid-shipments`) or, when no matching constant exists, a status-based fallback URN.\n" }),
	title: H().register(V, { description: "A short, human-readable summary of the problem type." }),
	status: W().register(V, { description: "The HTTP status code for this occurrence." }),
	detail: H().register(V, { description: "A human-readable explanation specific to this occurrence." }),
	instance: H().register(V, { description: "URI reference identifying the specific occurrence. The request path for the top-level object; the RFC 6901 JSON Pointer of the failing field for each `errors[]` entry.\n" }).optional(),
	request_id: H().register(V, { description: "Per-request correlation identifier. Mirrors the value of the `X-Request-Id` response header and the legacy envelope's `request_id` field. Allowed as an RFC 9457 §3.2 extension member so consumers don't have to read both header and body for tracing.\n" }).optional(),
	errors: J(Y({
		type: H(),
		title: H(),
		detail: H(),
		instance: H().optional()
	})).register(V, { description: "Sub-problem list. Each entry is itself an RFC 9457 problem-detail object describing one failing field. The sub-error `type`/`title` narrow past the wrapping problem when the underlying validator code maps to its own UserException constant (e.g. `urn:problem:invalid-address`, `urn:problem:invalid-physical-properties`).\n" }).optional()
}).register(V, { description: "RFC 9457 problem-detail object returned when the caller lists `application/problem+json` in the Accept header. Top-level fields are strictly the five defined in RFC 9457 §3.1; the `errors` array is an extension populated when the underlying exception carried per-field validator errors.\n" });
var Ik = X([
	$(0),
	$(1),
	$(2),
	$(3)
]), Lk = Y({
	date: yk,
	timezone: H(),
	timezone_type: Ik
}), Rk = X([Q([
	"morning",
	"standard",
	"evening",
	"same_day",
	"express",
	"early_morning"
]), H()]), zk = X([Q([
	"package",
	"mailbox",
	"unfranked",
	"digital_stamp",
	"pallet",
	"small_package",
	"envelope"
]), H()]).register(V, { description: "Package Type." }), Bk = Y({
	type: X([Q(["start", "end"]), H()]),
	date_time: Lk
});
Y({ data: Y({ deliveries: J(Y({
	date: Lk,
	possibilities: J(Y({
		type: Rk.nullable(),
		package_type: zk,
		delivery_time_frames: J(Bk),
		shipment_options: J(Y({
			name: H(),
			schema: Y({
				type: X([Q(["boolean"]), H()]),
				enum: J(G())
			})
		})),
		price: Pk.optional(),
		identifier: H().optional(),
		transporter: H().optional(),
		label_type: H().optional()
	}))
})) }) });
var Vk = xb().regex(/\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2]\d|3[0-1])/).register(V, { description: "Represents a date in ISO 8601 format:\n\n```\nYYYY-MM-DD\n```\n\nWhere:\n  - `YYYY` represents a four-digit year, `0000` through `9999`\n  - `MM` represents a zero-padded month of the year, `01` through `12`\n  - `DD` represents a zero-padded day of that month, `01` through `31`\n" }), Hk = Cb().regex(/([0-1]\d|2[0-4]):[0-5]\d(:([0-5]\d|60)(.\d+)?)?/).register(V, { description: "Represents a time in ISO 8601 format:\n\n```\nhh:mm:ss.u\n```\n\nWhere:\n  - `hh` represents a zero-padded hour, `00` through `24`\n  - `mm` represents a zero-padded minute, `00` through `59`\n  - `ss` (optional) represents a zero-padded second, `00` through `60`\n    (where `60` is only used to denote an added leap second)\n  - `.u` (optional) represents a fraction of a second, `.0` through `.999999+`\n" }), Uk = Y({
	date: Vk,
	time: J(Y({
		start: Hk,
		end: Hk,
		price: Pk,
		price_comment: H(),
		comment: H(),
		type: W(),
		collect_date: Lk.optional(),
		identifier: H().optional(),
		transporter: H().optional(),
		label_type: H().optional()
	}))
}), Wk = X([
	$(1),
	$(2),
	$(3),
	$(4),
	$(6),
	$(7),
	$(8)
]), Gk = Y({
	start: Hk.nullish(),
	type: Wk.optional(),
	price: Pk.optional()
}), Kk = J(H()).register(V, { description: "Opening hours.\nEach opening consist out of open- and close time formatted as a single string separated by ' - '. e.g. \"13:00 - 20:00\"\n" }), qk = Y({
	monday: Kk,
	tuesday: Kk,
	wednesday: Kk,
	thursday: Kk,
	friday: Kk,
	saturday: Kk,
	sunday: Kk
}), Jk = X([U().gte(-90).lte(90), H()]), Yk = X([U().gte(-180).lte(180), H()]), Xk = Y({
	date: Vk.nullish(),
	time: J(Gk).optional(),
	location: H().optional(),
	street: H().optional(),
	number: H().optional(),
	number_suffix: H().nullish(),
	postal_code: H().optional(),
	city: H().optional(),
	cc: H().optional(),
	start_time: Hk.nullish(),
	price: W().optional(),
	price_comment: X([Q(["retail", "retailexpress"]), H()]).optional(),
	comment: H().optional(),
	phone_number: H().optional(),
	opening_hours: qk.optional(),
	distance: H().optional(),
	latitude: Jk.optional(),
	longitude: Yk.optional(),
	location_code: H().optional(),
	retail_network_id: H().nullish(),
	holiday: Y({
		from: H().nullish(),
		to: H().nullish()
	}).optional()
}), Zk = W().gte(500).lte(599).register(V, { description: "The server failed to fulfill an apparently valid request" }), Qk = Y({
	status: X([gD, Zk]).optional(),
	code: _D,
	title: H().optional(),
	message: H()
});
Y({
	data: Y({
		delivery: J(Uk),
		pickup: J(Xk),
		message: H().optional()
	}),
	errors: J(X([Qk, Y({
		code: W(),
		message: H(),
		human: H().optional()
	})])).optional()
});
var $k = $(406).register(V, { description: "The target resource doesn't have an acceptable representation for the user agent." });
yD.and(Y({
	status_code: $k.optional(),
	errors: J(Y({
		status: $k.optional(),
		code: W().optional()
	})).optional()
})), Y({ data: Y({ download_url: Y({ link: Xb() }).register(V, { description: "DownloadUrl Object Definition" }) }) });
var eA = J(X([X([
	$(0),
	$(1),
	$(2),
	$(3),
	$(4),
	$(5),
	$(6)
]), X([
	$(1),
	$(2),
	$(3),
	$(4),
	$(5),
	$(6),
	$(7)
])])).nullable(), tA = Y({
	monday: U().nullish(),
	tuesday: U().nullish(),
	wednesday: U().nullish(),
	thursday: U().nullish(),
	friday: U().nullish(),
	saturday: U().nullish(),
	sunday: U().nullish()
}), nA = J(Y({
	start: Lk.nullable(),
	end: Lk.nullable()
})), rA = Y({
	monday: nA.optional(),
	tuesday: nA.optional(),
	wednesday: nA.optional(),
	thursday: nA.optional(),
	friday: nA.optional(),
	saturday: nA.optional(),
	sunday: nA.optional()
}).nullable();
Y({ data: Y({ drop_off_points: J(Y({
	location_code: H().optional(),
	location_name: H().nullish(),
	cc: H().optional(),
	state: H().nullish(),
	city: H().optional(),
	postal_code: H().optional(),
	street: H().optional(),
	number: X([H(), W()]).nullish(),
	number_suffix: H().nullish(),
	phone: H().nullish(),
	reference: H().nullish(),
	longitude: Yk.nullish(),
	latitude: Jk.nullish(),
	available_days: eA.optional(),
	cut_off_time: H().nullish(),
	carrier_id: fO.optional(),
	distance: U().nullish(),
	occupancy: tA.nullish(),
	occupancy_today: U().nullish(),
	default_drop_off_point: G().nullish(),
	type: HD.nullish(),
	opening_hours: rA.optional()
})) }) });
var iA = $(415).register(V, { description: "Content is in a format not supported by this method on the target resource." });
yD.and(Y({
	status_code: iA.optional(),
	errors: J(Y({
		status: iA.optional(),
		code: $(3100).optional()
	})).optional()
}));
var aA = $(401).register(V, { description: "The request lacks valid authentication credentials for the target resource." });
yD.and(Y({
	status_code: aA.optional(),
	errors: J(Y({
		status: aA.optional(),
		code: W().optional()
	})).optional()
}));
var oA = Y({
	cc: H(),
	city: H(),
	street: H(),
	postal_code: H(),
	number: H(),
	number_suffix: H().nullish()
}), sA = J(Y({
	delivery_type_id: W(),
	delivery_type_name: H(),
	price: W(),
	moment: Y({ start: Lk.nullish() })
})), cA = Y({
	start: Lk.nullable(),
	end: Lk.nullable()
}), lA = Y({
	monday: J(cA),
	tuesday: J(cA),
	wednesday: J(cA),
	thursday: J(cA),
	friday: J(cA),
	saturday: J(cA),
	sunday: J(cA)
});
Y({ data: Y({ pickup_locations: J(Y({
	address: oA,
	possibilities: sA,
	location: Y({
		location_name: H(),
		retail_network_id: H().nullable(),
		distance: H(),
		latitude: H(),
		longitude: H(),
		location_code: H(),
		phone_number: H().nullable(),
		type: HD.nullable(),
		opening_hours: lA
	})
})) }) }), Y({ data: Y({
	shipments: J(kk).register(V, { description: "A list of Shipment Resources." }),
	pdf: Y({ url: H() }).optional(),
	zpl: Y({ url: H() }).optional()
}) }), Y({ data: Y({ ids: J(Y({
	id: xD,
	reference_identifier: aO
})).register(V, { description: "A list of Shipment IDs." }) }) });
var uA = J(Y({
	id: xD,
	reference_identifier: aO
})).register(V, { description: "A list of Shipment IDs." });
Y({ data: X([Y({
	ids: uA,
	pdf: Y({ url: H() })
}), Y({
	ids: uA,
	zpl: Y({ url: H() })
})]) });
var dA = Y({
	status: Zk.optional(),
	code: W().optional(),
	title: H().optional(),
	message: H().optional()
});
Y({
	message: H().register(V, { description: "A human-readable description of the error." }).optional(),
	request_id: H().register(V, { description: "Internal request ID, useful for debugging purposes." }).optional(),
	status_code: Zk.optional(),
	errors: J(dA).optional()
}), Y({ data: Y({
	shipments: J(kk).register(V, { description: "A list of Shipment Resources." }),
	results: W().register(V, { description: "The number of results." })
}) });
var fA = Y({
	uri: Xb(),
	barcode: H()
}), pA = Y({
	name: H(),
	cc: H().nullable(),
	city: H().nullable(),
	postal_code: H().nullable(),
	street: H().nullable(),
	number: H().nullable(),
	number_suffix: H().nullable(),
	longitude: U().nullable(),
	latitude: U().nullable()
}), mA = X([Q([
	"registered",
	"handed_to_carrier",
	"sorting",
	"distribution",
	"delivered"
]), H()]).nullable(), hA = J(Y({
	code: H(),
	status: AD.nullable(),
	main: mA,
	description: H(),
	time: yk,
	delayed: G(),
	location: pA
})), gA = X([Q(["estimated", "expected"]), H()]).nullable(), _A = Y({
	start: Lk.nullable(),
	end: Lk.nullable()
}).nullable(), vA = X([H(), Y({
	content: H(),
	content_type: H()
})]).nullable();
Y({ data: Y({ tracktraces: J(Y({
	shipment_id: xD,
	carrier: fO,
	code: H(),
	description: H(),
	time: yk,
	link_consumer_portal: Xb().nullable(),
	link_tracktrace: Xb().nullable(),
	partner_tracktraces: J(fA),
	recipient: kD,
	sender: OD,
	options: BD,
	pickup: WD,
	delayed: G(),
	location: pA,
	status: Y({
		current: AD,
		main: mA,
		final: G()
	}),
	history: hA,
	delivery_moment_type: gA.optional(),
	delivery_moment: _A.optional(),
	signature: vA.optional(),
	returnable: G().optional()
}).register(V, { description: "A Track & Trace resource." })).register(V, { description: "A list of Track & Trace Resources." }) }) });
var yA = X([Q([
	"BPOST",
	"BRT",
	"CHEAP_CARGO",
	"DHL_EUROPLUS",
	"DHL_FOR_YOU",
	"DHL_FREIGHT",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"GLS",
	"INPOST",
	"POSTE_ITALIANE",
	"POSTNL",
	"SPRING",
	"TRUNKRS",
	"UPS_EXPRESS_SAVER",
	"UPS_STANDARD",
	"VIA_TIM"
]), H()]).register(V, { description: "Carrier string definition for capabilities endpoints (v2)" }), bA = Y({
	id: W().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).register(V, { description: "The contract ID." }),
	type: X([Q(["MAIN", "CUSTOM"]), H()]).register(V, { description: "The type of contract." })
}).register(V, { description: "Contract definition for capabilities endpoints (v2)" }), xA = X([Q([
	"PACKAGE",
	"MAILBOX",
	"UNFRANKED",
	"DIGITAL_STAMP",
	"PALLET",
	"SMALL_PACKAGE",
	"ENVELOPE"
]), H()]).register(V, { description: "Package Type." }), SA = Y({
	isSelectedByDefault: G(),
	isRequired: G()
}), CA = Y({
	additionalInsurance: SA.optional(),
	deliverAtPostalPoint: SA.optional(),
	freshFood: SA.optional(),
	frozen: SA.optional(),
	hideSender: SA.optional(),
	noTracking: SA.optional(),
	oversizedPackage: SA.optional(),
	priorityDelivery: SA.optional(),
	printReturnLabelAtDropOff: SA.optional(),
	recipientOnlyDelivery: SA.optional(),
	requiresAgeVerification: SA.optional(),
	requiresCashOnDelivery: SA.optional(),
	requiresReceiptCode: SA.optional(),
	requiresSignature: SA.optional(),
	returnOnFirstFailedDelivery: SA.optional(),
	sameDayDelivery: SA.optional(),
	saturdayDelivery: SA.optional(),
	scheduledCollection: SA.optional(),
	tracked: SA.optional()
}), wA = SA.and(Y({
	requires: J(H()).register(V, { description: "camelCase shipment option keys that are required" }),
	excludes: J(H()).register(V, { description: "camelCase shipment option keys that are excluded" })
})), TA = Y({
	insuredAmount: Y({
		default: ND,
		min: ND,
		max: ND
	}).register(V, { description: "Deprecated. Use the flat default/min/max properties on the insurance option directly. Will be removed in a future release.\n" }).optional(),
	default: ND.optional(),
	min: ND.optional(),
	max: ND.optional()
}), EA = wA.and(TA), DA = CA.and(Y({
	additionalInsurance: wA.optional(),
	deliverAtPostalPoint: wA.optional(),
	freshFood: wA.optional(),
	frozen: wA.optional(),
	hideSender: wA.optional(),
	insurance: EA.optional(),
	noTracking: wA.optional(),
	oversizedPackage: wA.optional(),
	priorityDelivery: wA.optional(),
	printReturnLabelAtDropOff: wA.optional(),
	recipientOnlyDelivery: wA.optional(),
	requiresAgeVerification: wA.optional(),
	requiresCashOnDelivery: wA.optional(),
	requiresReceiptCode: wA.optional(),
	requiresSignature: wA.optional(),
	returnOnFirstFailedDelivery: wA.optional(),
	sameDayDelivery: wA.optional(),
	saturdayDelivery: wA.optional(),
	scheduledCollection: wA.optional(),
	tracked: wA.optional()
})), OA = Y({
	value: U().register(V, { description: "The numeric value" }),
	unit: X([Q([
		"g",
		"kg",
		"cm",
		"mm",
		"mm3",
		"cm3",
		"dm3",
		"m3"
	]), H()]).register(V, { description: "The unit of measurement in SI units" })
}), kA = Y({
	min: OA,
	max: OA,
	calculation: H()
}), AA = Y({
	weight: kA.optional(),
	width: kA.optional(),
	length: kA.optional(),
	height: kA.optional(),
	girth: kA.optional(),
	volumetricWeight: kA.optional(),
	volume: kA.optional(),
	lengthWidthHeightSum: kA.optional()
}), jA = X([Q([
	"MORNING_DELIVERY",
	"STANDARD_DELIVERY",
	"EVENING_DELIVERY",
	"PICKUP_DELIVERY",
	"SAME_DAY_DELIVERY",
	"EXPRESS_DELIVERY",
	"EARLY_MORNING_DELIVERY"
]), H()]), MA = X([Q(["B2B", "B2C"]), H()]), NA = Y({ max: W() });
Y({ results: J(Y({
	carrier: yA,
	contract: bA.optional(),
	packageTypes: J(xA),
	options: DA,
	physicalProperties: AA,
	deliveryTypes: J(jA),
	transactionTypes: J(MA),
	collo: NA
}).register(V, { description: "A V2 Capability response item for a given Shipment configuration." })).register(V, { description: "A list of V2 Capabilities for a given Shipment configuration." }) });
var PA = X([
	$(1),
	$(2),
	$(3),
	$(4),
	$(9),
	$(10),
	$(11),
	$(12),
	$(13),
	$(14),
	$(15),
	$(16),
	$(17),
	$(18),
	$(19),
	$(20),
	$(21)
]).register(V, { description: "Carrier ID definition for capabilities endpoints (v1)" }), FA = Y({
	id: W().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).register(V, { description: "The contract ID." }),
	type: X([Q(["main", "custom"]), H()]).register(V, { description: "The type of contract." })
}).register(V, { description: "Contract definition for capabilities endpoints (v1)" }), IA = Y({
	is_selected_by_default: G(),
	is_required: G()
}), LA = Y({
	age_check: IA.optional(),
	cash_on_delivery: IA.optional(),
	collect: IA.optional(),
	drop_off_at_postal_point: IA.optional(),
	extra_assurance: IA.optional(),
	fresh_food: IA.optional(),
	frozen: IA.optional(),
	hide_sender: IA.optional(),
	large_format: IA.optional(),
	no_tracking: IA.optional(),
	only_recipient: IA.optional(),
	printerless_return: IA.optional(),
	priority_delivery: IA.optional(),
	receipt_code: IA.optional(),
	return: IA.optional(),
	same_day_delivery: IA.optional(),
	saturday_delivery: IA.optional(),
	signature: IA.optional(),
	tracked: IA.optional()
}), RA = IA.and(Y({
	requires: J(H()).register(V, { description: "snake_case shipment option keys that are required" }),
	excludes: J(H()).register(V, { description: "snake_case shipment option keys that are excluded" })
})), zA = Y({
	insured_amount: Y({
		default: ND,
		min: ND,
		max: ND
	}).register(V, { description: "Deprecated. Use the flat default/min/max properties on the insurance option directly. Will be removed in a future release.\n" }).optional(),
	default: ND.optional(),
	min: ND.optional(),
	max: ND.optional()
}), BA = RA.and(zA), VA = LA.and(Y({
	age_check: RA.optional(),
	cash_on_delivery: RA.optional(),
	collect: RA.optional(),
	drop_off_at_postal_point: RA.optional(),
	extra_assurance: RA.optional(),
	fresh_food: RA.optional(),
	frozen: RA.optional(),
	hide_sender: RA.optional(),
	insurance: BA.optional(),
	large_format: RA.optional(),
	no_tracking: RA.optional(),
	only_recipient: RA.optional(),
	printerless_return: RA.optional(),
	priority_delivery: RA.optional(),
	receipt_code: RA.optional(),
	return: RA.optional(),
	same_day_delivery: RA.optional(),
	saturday_delivery: RA.optional(),
	signature: RA.optional(),
	tracked: RA.optional()
})), HA = Y({
	weight: kA.optional(),
	width: kA.optional(),
	length: kA.optional(),
	height: kA.optional(),
	girth: kA.optional(),
	volumetric_weight: kA.optional(),
	volume: kA.optional(),
	length_width_height_sum: kA.optional()
});
Y({ data: Y({ capabilities: J(Y({
	carrier_id: PA,
	contract: FA.optional(),
	package_types: J(FD),
	options: VA,
	physical_properties: HA,
	delivery_types: J(Wk),
	transaction_types: J(MA),
	collo: NA
}).register(V, { description: "A V1 Capability response item for a given Shipment configuration." })).register(V, { description: "A list of V1 Capabilities for a given Shipment configuration." }) }) });
var UA = SA.and(Y({})), WA = UA.and(TA), GA = CA.and(Y({
	additionalInsurance: UA.optional(),
	deliverAtPostalPoint: UA.optional(),
	hideSender: UA.optional(),
	insurance: WA.optional(),
	noTracking: UA.optional(),
	oversizedPackage: UA.optional(),
	priorityDelivery: UA.optional(),
	printReturnLabelAtDropOff: UA.optional(),
	recipientOnlyDelivery: UA.optional(),
	requiresAgeVerification: UA.optional(),
	requiresCashOnDelivery: UA.optional(),
	requiresReceiptCode: UA.optional(),
	requiresSignature: UA.optional(),
	returnOnFirstFailedDelivery: UA.optional(),
	sameDayDelivery: UA.optional(),
	saturdayDelivery: UA.optional(),
	scheduledCollection: UA.optional(),
	tracked: UA.optional()
}));
Y({ items: J(Y({
	carrier: yA,
	packageTypes: J(xA),
	options: GA,
	deliveryTypes: J(jA),
	transactionTypes: J(MA),
	collo: NA
}).register(V, { description: "A V2 Capability response item for a given Shipment configuration." })).register(V, { description: "A superset of V2 Capabilities for the contracts within a user's account." }) });
var KA = IA.and(Y({})), qA = KA.and(zA), JA = LA.and(Y({
	age_check: KA.optional(),
	cash_on_delivery: KA.optional(),
	collect: KA.optional(),
	drop_off_at_postal_point: KA.optional(),
	extra_assurance: KA.optional(),
	hide_sender: KA.optional(),
	insurance: qA.optional(),
	large_format: KA.optional(),
	no_tracking: KA.optional(),
	only_recipient: KA.optional(),
	printerless_return: KA.optional(),
	priority_delivery: KA.optional(),
	receipt_code: KA.optional(),
	return: KA.optional(),
	same_day_delivery: KA.optional(),
	saturday_delivery: KA.optional(),
	signature: KA.optional(),
	tracked: KA.optional()
}));
Y({ data: Y({ contract_definitions: J(Y({
	carrier_id: PA,
	package_types: J(FD),
	options: JA,
	delivery_types: J(Wk),
	transaction_types: J(MA),
	collo: NA
}).register(V, { description: "A V1 Capability contract definitions response item for a given Shipment configuration." })).register(V, { description: "A superset of V1 Capabilities for the contracts within a user's account." }) }) });
var YA = Y({
	id: W().register(V, { description: "The id of the contract." }),
	type: X([Q(["MAIN", "CUSTOM"]), H()]).register(V, { description: "The type of contract." })
}).register(V, { description: "The contract object." }), XA = X([Q([
	"EXPRESS",
	"FULFILMENT",
	"LABEL_PACKAGE",
	"MULTI_COLLO",
	"RETURN",
	"RETURN_ERS",
	"RETURN_SPECIAL",
	"STANDARD"
]), H()]), ZA = Y({
	name: H(),
	key: H(),
	price: cO,
	vat: cO,
	priceWithVat: cO
}).register(V, { description: "A V2 Price object." }), QA = Y({
	base: ZA,
	charges: J(ZA),
	discounts: J(ZA),
	options: J(ZA),
	other: J(ZA),
	total: ZA
}).register(V, { description: "The V2 price composition object, containing the base, options, charges, discounts and total prices." }), $A = Y({
	carrier: yA,
	contract: YA.optional(),
	packageType: xA,
	deliveryType: jA.optional(),
	shipmentType: XA,
	priceComposition: QA
}).register(V, { description: "A V2 Rate response item for a given Shipment configuration." }), ej = Y({
	id: W().register(V, { description: "The id of the contract." }),
	type: X([Q(["main", "custom"]), H()]).register(V, { description: "The type of contract." })
}).register(V, { description: "The contract object." }), tj = X([
	$(1),
	$(2),
	$(3),
	$(4),
	$(5),
	$(6),
	$(7)
]), nj = Y({
	name: H(),
	key: H(),
	price: cO,
	vat: cO,
	price_with_vat: cO
}).register(V, { description: "A V1 Price object." }), rj = Y({
	base: nj,
	charges: J(nj),
	discounts: J(nj),
	options: J(nj),
	other: J(nj),
	total: nj
}).register(V, { description: "The price composition object, containing the base, options, charges, discounts and total prices." });
Y({ data: Y({ rates: J(Y({
	carrier_id: PA,
	contract: ej.optional(),
	package_type: FD,
	delivery_type: Wk.optional(),
	shipment_type: tj,
	price_composition: rj
}).register(V, { description: "A V1 Rate response item for a given Shipment configuration." })).register(V, { description: "A list of V1 Rates for a given Shipment configuration." }) }) }), Y({ results: J(Y({
	id: W(),
	shopId: W(),
	packageType: X([Q([
		"DIGITAL_STAMP",
		"ENVELOPE",
		"UNFRANKED",
		"MAILBOX",
		"PACKAGE",
		"PALLET",
		"SMALL_PACKAGE"
	]), H()]).nullable(),
	countryCode: H().nullable(),
	shipmentDirection: X([Q(["OUTBOUND", "INBOUND"]), H()]),
	fallback: G()
}).register(V, { description: "A Notification Group response item" })) });
var ij = X([Q([
	"LABEL_DOWNLOAD",
	"FIRST_SCAN",
	"RETURN"
]), H()]).register(V, { description: "The notification template type." });
Y({ results: J(Y({
	id: W(),
	notificationGroupId: W(),
	type: ij,
	subject: H(),
	body: H(),
	active: G()
}).register(V, { description: "A Notification Template response item" })) }), Y({ data: Y({ webhook_subscriptions: J(Y({
	id: W(),
	account_id: W(),
	shop_id: W(),
	hook: H(),
	url: H(),
	payload: H().nullish()
}).register(V, { description: "A Webhook Subscription response item" })) }) }), Y({ data: Y({ webhook_subscriptions: J(Y({
	id: W(),
	account_id: W(),
	shop_id: W(),
	hook: H(),
	url: H()
}).register(V, { description: "A Webhook Subscription response item" })) }) }), Y({ data: Y({ ids: J(Y({ id: W() })).register(V, { description: "A list of created webhook subscription IDs." }) }) });
var aj = H(), oj = X([Q([
	"1",
	"2",
	"3",
	"4",
	"5",
	"6",
	"7",
	"8",
	"9",
	"10",
	"11",
	"12",
	"13",
	"14",
	"15",
	"16",
	"17",
	"18",
	"19",
	"20",
	"21"
]), H()]).register(V, { description: "This enumeration represents the Carriers. The value is the Carrier id." }), sj = X([oj, X([Q([
	"postnl",
	"bpost",
	"cheapcargo",
	"dpd",
	"instabox",
	"dhl",
	"bol.com",
	"ups",
	"dhlforyou",
	"dhlparcelconnect",
	"dhleuroplus",
	"upsstandard",
	"upsexpresssaver",
	"gls",
	"brt",
	"trunkrs",
	"inpost",
	"posteitaliane",
	"spring",
	"viatim",
	"dhlfreight"
]), H()]).register(V, { description: "This enumeration represents the Carriers. The value is the Carrier id." })]).nullable(), cj = xb().regex(/\d{4}-\d{2}-\d{2}/).nullable(), lj = H().register(V, { description: "ISO 3166-1 alpha-2 country code" }), uj = Hk.nullable(), dj = X([
	G(),
	W().gte(0).lte(1),
	X([K(), K()]),
	X([Q([
		"0",
		"1",
		"false",
		"true"
	]), H()])
]), fj = X([
	$(!1),
	$(!0),
	$(0),
	$(1),
	$("0"),
	$("1"),
	$("false"),
	$("true"),
	$("off"),
	$("on"),
	$("no"),
	$("yes"),
	$("")
]).nullable(), pj = Vk.nullable(), mj = Hk.nullable(), hj = H().nullable(), gj = H().nullable(), _j = X([X([Q([
	"1",
	"2",
	"3",
	"4",
	"6",
	"7",
	"8"
]), H()]), K()]), vj = X([Q(["A4", "A6"]), H()]).register(V, { description: "The size of a paper as specified in ISO216." }), yj = Jk.nullable(), bj = Yk.nullable(), xj = X([Q(["ASC", "DESC"]), H()]).register(V, { description: "Specify whether the results should be sorted in ascending or descending order." }), Sj = X([
	FD,
	J(FD),
	H()
]), Cj = W().gte(1).lte(1e3).register(V, { description: "Request a specific page of the results, used for paginated results." }), wj = X([X([Q([
	"myparcel",
	"flespakket",
	"belgie",
	"delivery_dutch",
	"postnl_customer",
	"italy"
]), H()]), X([Q([
	"1",
	"2",
	"3",
	"4",
	"5",
	"6"
]), H()])]).nullable(), Tj = X([X([
	$(1),
	$(2),
	$(3),
	$(4)
]).register(V, { description: "The position of the label on the paper." }), H()]), Ej = H().nullable(), Dj = X([Zx().gte(BigInt(1)).lte(BigInt(0x8000000000000000)), H()]), Oj = X([
	wD,
	J(wD),
	H()
]), kj = W().gte(1).lte(2147483647), Aj = X([
	kj,
	J(kj),
	H()
]), jj = W().gte(0).lte(1e4).register(V, { description: "Specify the number of resources returned per page, used for paginated results." }), Mj = X([Q([
	"amount",
	"created",
	"created_by",
	"currency",
	"drop_off_point",
	"hidden",
	"id",
	"mark_delivered",
	"modified",
	"modified_by",
	"order_shipment_identifier",
	"parent_id",
	"recipient",
	"reference_identifier",
	"sender",
	"shipment_type",
	"shop_id",
	"status",
	"transaction_status"
]), H()]), Nj = X([
	AD,
	J(AD),
	H()
]), Pj = H(), Fj = J(X([Gb(), H()])), Ij = Y({
	cc: H(),
	postal_code: H(),
	city: H(),
	street: H(),
	street_additional_info: H().nullish(),
	number: H().optional(),
	number_suffix: H().optional(),
	box_number: H().optional(),
	region: H().optional(),
	person: H(),
	company: H().optional(),
	phone: H().optional(),
	email: X([Gb(), H()]).nullish()
}), Lj = Y({
	postal_code: H().optional(),
	location_name: H().optional(),
	city: H().optional(),
	street: H().optional(),
	number: H().optional(),
	number_suffix: H().nullish(),
	box_number: H().optional(),
	region: H().optional(),
	state: H().optional(),
	cc: H().optional(),
	location_code: H().optional(),
	location_type: X([UD, HD]).optional(),
	retail_network_id: H().optional()
}).nullable(), Rj = Y({ data: Y({
	user_agent: H().optional(),
	shipments: J(Y({
		account_id: W().optional(),
		shop_id: W().optional(),
		contract_id: W().optional(),
		reference_identifier: X([W(), H()]).optional(),
		recipient: Y({
			cc: H(),
			region: H().optional(),
			state: H().optional(),
			postal_code: H(),
			city: H(),
			street: H(),
			street_additional_info: H().optional(),
			number: H().optional(),
			number_suffix: H().optional(),
			box_number: H().optional(),
			area: H().optional(),
			person: H(),
			company: H().optional(),
			email: X([Gb(), H()]).optional(),
			secondary_emails: Fj.optional(),
			phone: H().optional(),
			eori_number: H().nullish(),
			vat_number: H().nullish()
		}),
		sender: Ij.optional(),
		recipients: J(U()).min(1).optional(),
		physical_properties: Y({
			weight: W().gte(0).lte(999999999),
			height: W().optional(),
			width: W().optional(),
			length: W().optional(),
			volume: W().optional()
		}).optional(),
		options: BD.and(K()),
		customs_declaration: qD.optional(),
		carrier: fO,
		pickup: Lj.optional(),
		drop_off_point: Y({
			postal_code: H(),
			location_name: H(),
			city: H(),
			street: H(),
			number: H(),
			number_suffix: H().optional(),
			box_number: H().optional(),
			region: H().optional(),
			state: H().optional(),
			cc: H().optional(),
			location_code: H(),
			retail_network_id: H().optional()
		}).nullish(),
		note: H().optional(),
		status: X([
			$(1),
			$(2),
			$(3),
			$(4),
			$(5),
			$(6),
			$(7),
			$(8)
		]).optional(),
		delivered: $(0).optional(),
		general_settings: Y({
			save_recipient_address: X([$(0), $(1)]).optional(),
			delivery_notification: X([$(0), $(1)]).optional(),
			delivery_notification_email: J(H()).optional(),
			disable_auto_detect_pickup: X([$(0), $(1)]).optional(),
			printer_identifier: H().optional()
		}).optional(),
		secondary_shipments: J(Y({
			account_id: W().optional(),
			shop_id: W().optional(),
			reference_identifier: X([W(), H()]).optional(),
			recipient: Y({
				cc: H().optional(),
				region: H().optional(),
				state: H().optional(),
				postal_code: H().optional(),
				city: H().optional(),
				street: H().optional(),
				street_additional_info: H().optional(),
				number: H().optional(),
				number_suffix: H().optional(),
				box_number: H().optional(),
				area: H().optional(),
				person: H().optional(),
				company: H().optional(),
				email: X([Gb(), H()]).optional(),
				secondary_emails: Fj.optional(),
				phone: H().optional(),
				eori_number: H().nullish(),
				vat_number: H().nullish()
			}).optional(),
			recipients: J(U()).min(1).optional(),
			physical_properties: Y({
				weight: W().gte(0).lte(999999999),
				height: W().optional(),
				width: W().optional(),
				length: W().optional(),
				volume: W().optional()
			}).optional(),
			options: BD.optional(),
			customs_declaration: qD.optional(),
			carrier: fO.optional(),
			pickup: Lj.optional(),
			drop_off_point: Y({
				postal_code: H(),
				location_name: H(),
				city: H(),
				street: H(),
				number: H(),
				number_suffix: H().optional(),
				box_number: H().optional(),
				region: H().optional(),
				state: H().optional(),
				cc: H().optional(),
				location_code: H(),
				retail_network_id: H().optional()
			}).nullish(),
			note: H().optional(),
			status: X([
				$(1),
				$(2),
				$(3),
				$(4),
				$(5),
				$(6),
				$(7),
				$(8)
			]).optional(),
			delivered: $(0).optional(),
			general_settings: Y({ save_recipient_address: X([$(0), $(1)]).optional() }).optional(),
			hidden: X([$(0), $(1)]).optional(),
			shipped_items: J(Y({
				order_line_identifier: H(),
				quantity: W().gte(1)
			})).min(0).optional()
		})).min(1).optional(),
		collection_contact: Y({
			cc: H(),
			city: H(),
			company: H(),
			email: Gb(),
			first_name: H().optional(),
			gender: X([Q(["mr", "mrs"]), H()]).optional(),
			last_name: H(),
			number: X([H(), W()]),
			number_suffix: H().nullish(),
			phone: H(),
			postal_code: H(),
			street: H(),
			street_additional_info: H().nullish()
		}).optional(),
		hidden: X([$(0), $(1)]).optional(),
		shipped_items: J(Y({
			order_line_identifier: H(),
			quantity: W().gte(1)
		})).min(0).optional()
	}))
}) });
Y({ data: Y({
	user_agent: H().optional(),
	shipments: J(Y({
		account_id: W().optional(),
		shop_id: W().optional(),
		reference_identifier: X([W(), H()]).optional(),
		recipient: Y({
			cc: H(),
			region: H().optional(),
			state: H().optional(),
			postal_code: H().optional(),
			city: H(),
			street: H(),
			street_additional_info: H().optional(),
			number: H().optional(),
			number_suffix: H().optional(),
			box_number: H().optional(),
			area: H().optional(),
			person: H(),
			company: H().optional(),
			email: X([Gb(), H()]).optional(),
			secondary_emails: Fj.optional(),
			phone: H().optional()
		}),
		sender: Ij.optional(),
		recipients: J(U()).min(1).optional(),
		physical_properties: Y({
			weight: W().gte(0).lte(999999999),
			height: W().optional(),
			width: W().optional(),
			length: W().optional(),
			volume: W().optional()
		}).optional(),
		options: BD.and(K()),
		customs_declaration: qD.optional(),
		carrier: fO,
		pickup: Lj.optional(),
		"multi-colli": Y({ amount: W() }).nullish(),
		note: H().optional(),
		status: X([
			$(1),
			$(2),
			$(3),
			$(4),
			$(5),
			$(6),
			$(7),
			$(8)
		]).optional(),
		delivered: $(0).optional(),
		general_settings: Y({
			save_recipient_address: X([$(0), $(1)]).optional(),
			delivery_notification: X([$(0), $(1)]).optional(),
			delivery_notification_email: J(H()).optional(),
			disable_auto_detect_pickup: X([$(0), $(1)]).optional(),
			printer_identifier: H().optional()
		}).optional(),
		hidden: X([$(0), $(1)]).optional()
	}))
}) });
var zj = Y({ package_type: X([
	$(1),
	$(2),
	$(6)
]).optional() });
$(1).register(V, { description: "Regular package." }), $(2).register(V, { description: "Shipment that fits through a mailbox slot." }), $(6);
var Bj = Y({
	age_check: MD.optional(),
	cooled_delivery: MD.optional(),
	drop_off_at_postal_point: MD.optional(),
	extra_assurance: MD.optional(),
	hide_sender: MD.optional(),
	large_format: MD.optional(),
	only_recipient: MD.optional(),
	receipt_code: MD.optional(),
	return: MD.optional(),
	same_day_delivery: MD.optional(),
	saturday_delivery: MD.optional(),
	signature: MD.optional()
}), Vj = Y({ options: zj.and(jD).and(Bj).and(zD).and(Y({
	contribution: ND.and(Y({ amount: K().optional() })).optional(),
	printerless_return: MD.optional()
})).optional() }), Hj = X([
	$(1),
	$(2),
	$(4),
	$(9),
	$(10),
	$(11),
	$(14),
	$(15),
	$(17),
	$(18)
]);
Y({ data: Y({ return_shipments: J(Vj.and(Y({
	account_id: W().optional(),
	shop_id: W().optional(),
	contract_id: W().optional(),
	parent: W(),
	reference_identifier: X([W(), H()]).optional(),
	carrier: Hj,
	email: H(),
	name: H(),
	sender: Y({
		cc: H(),
		postal_code: H().optional(),
		city: H(),
		street: H(),
		street_additional_info: H().optional(),
		number: H().optional(),
		number_suffix: H().optional(),
		box_number: H().optional(),
		region: H().optional(),
		person: H(),
		company: H().optional(),
		email: X([Gb(), H()]).nullish(),
		phone: H().optional()
	}).optional(),
	physical_properties: Y({
		weight: W().gte(0).lte(999999999).optional(),
		height: W().optional(),
		width: W().optional(),
		length: W().optional(),
		volume: W().optional()
	}).optional(),
	customs_declaration: qD.optional(),
	general_settings: Y({ save_recipient_address: X([$(0), $(1)]).optional() }).optional()
}))).optional() }) }), Y({ data: Y({ return_shipments: J(Vj.and(Y({
	account_id: W().optional(),
	shop_id: W().optional(),
	carrier: Hj,
	email: H().optional(),
	name: H().optional(),
	cc: H().optional(),
	sender: Y({
		cc: H(),
		postal_code: H().optional(),
		city: H(),
		street: H(),
		street_additional_info: H().optional(),
		number: H().optional(),
		number_suffix: H().optional(),
		box_number: H().optional(),
		region: H().optional(),
		person: H(),
		company: H().optional(),
		email: X([Gb(), H()]).nullish(),
		phone: H().optional()
	}).optional(),
	physical_properties: Y({
		weight: W().gte(0).lte(999999999).optional(),
		height: W().optional(),
		width: W().optional(),
		length: W().optional(),
		volume: W().optional()
	}).optional(),
	customs_declaration: qD.optional(),
	general_settings: Y({ save_recipient_address: X([$(0), $(1)]).optional() }).optional()
}))).optional() }) });
var Uj = Y({ data: Y({ shipments: J(Y({
	id: W(),
	account_id: W().optional(),
	shop_id: W().optional(),
	contract_id: W().optional(),
	reference_identifier: X([W(), H()]).optional(),
	carrier: fO,
	status: W().optional(),
	delivered: X([$(0), $(1)]).optional(),
	recipient: Y({
		cc: H(),
		region: H().optional(),
		state: H().optional(),
		postal_code: H().optional(),
		city: H(),
		street: H(),
		street_additional_info: H().optional(),
		number: H().nullish(),
		number_suffix: H().nullish(),
		box_number: H().optional(),
		person: H(),
		company: H().optional(),
		email: X([Gb(), H()]).optional(),
		secondary_emails: Fj.optional(),
		phone: H().optional(),
		eori_number: H().nullish(),
		vat_number: H().nullish()
	}),
	sender: Ij.optional(),
	options: BD.and(K()),
	customs_declaration: qD.optional(),
	physical_properties: Y({
		weight: W().gte(0).lte(999999999),
		height: W().optional(),
		width: W().optional(),
		length: W().optional(),
		volume: W().optional()
	}).optional(),
	pickup: Lj.optional(),
	drop_off_point: Y({
		postal_code: H(),
		location_name: H(),
		city: H(),
		street: H(),
		number: H(),
		number_suffix: H().optional(),
		box_number: H().optional(),
		region: H().optional(),
		state: H().optional(),
		cc: H().optional(),
		location_code: H(),
		retail_network_id: H().optional()
	}).nullish(),
	note: H().optional(),
	general_settings: Y({
		save_recipient_address: X([$(0), $(1)]).optional(),
		delivery_notification: X([$(0), $(1)]).optional(),
		delivery_notification_email: J(H()).optional(),
		disable_auto_detect_pickup: X([$(0), $(1)]).optional(),
		printer_identifier: H().optional()
	}).optional(),
	multi_collo_main_shipment_id: W().nullish(),
	secondary_shipments: J(Y({
		id: W().optional(),
		account_id: W().optional(),
		shop_id: W().optional(),
		reference_identifier: X([W(), H()]).optional(),
		recipient: Y({
			cc: H().optional(),
			region: H().optional(),
			state: H().optional(),
			postal_code: H().optional(),
			city: H().optional(),
			street: H().optional(),
			street_additional_info: H().optional(),
			number: H().nullish(),
			number_suffix: H().nullish(),
			box_number: H().optional(),
			area: H().optional(),
			person: H().optional(),
			company: H().optional(),
			email: X([Gb(), H()]).optional(),
			secondary_emails: Fj.optional(),
			phone: H().optional(),
			eori_number: H().nullish(),
			vat_number: H().nullish()
		}).optional(),
		recipients: J(U()).min(1).optional(),
		physical_properties: Y({
			weight: W().gte(0).lte(999999999),
			height: W().optional(),
			width: W().optional(),
			length: W().optional(),
			volume: W().optional()
		}).optional(),
		options: BD.optional(),
		customs_declaration: qD.optional(),
		carrier: fO.optional(),
		pickup: Lj.optional(),
		drop_off_point: Y({
			postal_code: H(),
			location_name: H(),
			city: H(),
			street: H(),
			number: H(),
			number_suffix: H().optional(),
			box_number: H().optional(),
			region: H().optional(),
			state: H().optional(),
			cc: H().optional(),
			location_code: H(),
			retail_network_id: H().optional()
		}).nullish(),
		note: H().optional(),
		status: X([
			$(1),
			$(2),
			$(3),
			$(4),
			$(5),
			$(6),
			$(7),
			$(8)
		]).optional(),
		delivered: X([$(0), $(1)]).optional(),
		general_settings: Y({ save_recipient_address: X([$(0), $(1)]).optional() }).optional(),
		multi_collo_main_shipment_id: W().nullish(),
		hidden: X([$(0), $(1)]).optional(),
		shipped_items: J(Y({
			order_line_identifier: H(),
			quantity: W().gte(1)
		})).min(0).optional()
	})).min(1).optional(),
	collection_contact: Y({
		cc: H(),
		city: H(),
		company: H().nullish(),
		email: Gb().optional(),
		first_name: H().optional(),
		gender: X([Q(["mr", "mrs"]), H()]).optional(),
		last_name: H().optional(),
		number: X([H(), W()]),
		number_suffix: H().nullish(),
		phone: H(),
		postal_code: H(),
		street: H(),
		street_additional_info: H().nullish()
	}).optional(),
	hidden: X([$(0), $(1)]).optional(),
	shipped_items: J(Y({
		order_line_identifier: H(),
		quantity: W().gte(1)
	})).min(0).optional()
})).optional() }) });
Y({ data: Y({ shipments: J(Y({
	id: W(),
	account_id: W().optional(),
	shop_id: W().optional(),
	reference_identifier: X([W(), H()]).optional(),
	carrier: fO,
	status: W().optional(),
	delivered: X([$(0), $(1)]).optional(),
	recipient: Y({
		cc: H(),
		region: H().optional(),
		state: H().optional(),
		postal_code: H().optional(),
		city: H(),
		street: H(),
		street_additional_info: H().optional(),
		number: H().nullish(),
		number_suffix: H().nullish(),
		box_number: H().optional(),
		person: H(),
		company: H().optional(),
		email: X([Gb(), H()]).optional(),
		secondary_emails: Fj.optional(),
		phone: H().optional()
	}),
	sender: Ij.optional(),
	options: BD.and(K()),
	customs_declaration: qD.optional(),
	physical_properties: Y({
		weight: W().gte(0).lte(999999999),
		height: W().optional(),
		width: W().optional(),
		length: W().optional(),
		volume: W().optional()
	}).optional(),
	pickup: Lj.optional(),
	note: H().optional(),
	general_settings: Y({
		save_recipient_address: X([$(0), $(1)]).optional(),
		delivery_notification: X([$(0), $(1)]).optional(),
		delivery_notification_email: J(H()).optional(),
		disable_auto_detect_pickup: X([$(0), $(1)]).optional(),
		printer_identifier: H().optional()
	}).optional(),
	hidden: X([$(0), $(1)]).optional()
})).optional() }) });
var Wj = Y({ data: Y({ shipments: J(Y({
	id: W(),
	hidden: X([$(0), $(1)]).optional(),
	status: AD.optional(),
	delivered: X([$(0), $(1)]).optional()
})) }) }), Gj = X([Q([
	"RETAIL",
	"LOCKER",
	"POST_OFFICE"
]), H()]).register(V, { description: "Pickup / drop-off location type used for capability and rates filtering." }), Kj = Y({
	shopId: W().register(V, { description: "The ID of the shop for which the capabilities are requested." }).optional(),
	contractId: W().register(V, { description: "The ID of the contract for which the capabilities are requested." }).optional(),
	recipient: Y({
		countryCode: H().register(V, { description: "Alpha-2 Country code of the recipient." }),
		postalCode: H().register(V, { description: "Postal code of the recipient." }).optional(),
		isBusiness: G().register(V, { description: "Whether this is a business address." }).optional()
	}).register(V, { description: "Recipient data." }),
	sender: Y({
		countryCode: H().register(V, { description: "Alpha-2 Country code of the sender." }).optional(),
		postalCode: H().register(V, { description: "Postal code of the sender." }).optional(),
		isBusiness: G().register(V, { description: "Whether this is a business address." }).optional()
	}).register(V, { description: "Sender data." }).optional(),
	carrier: yA.optional(),
	packageType: xA.optional(),
	physicalProperties: Y({
		height: Y({
			value: W().gte(0).lte(1e4).register(V, { description: "The height value" }),
			unit: X([Q(["cm", "mm"]), H()]).register(V, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(V, { description: "The height of the package" }).optional(),
		width: Y({
			value: W().gte(0).lte(1e4).register(V, { description: "The width value" }),
			unit: X([Q(["cm", "mm"]), H()]).register(V, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(V, { description: "The width of the package" }).optional(),
		length: Y({
			value: W().gte(0).lte(1e4).register(V, { description: "The length value" }),
			unit: X([Q(["cm", "mm"]), H()]).register(V, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(V, { description: "The length of the package" }).optional(),
		weight: Y({
			value: W().gte(0).register(V, { description: "The weight value" }),
			unit: X([Q(["g", "kg"]), H()]).register(V, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(V, { description: "The weight of the package" }).optional()
	}).register(V, { description: "Physical properties of the package." }).optional(),
	options: Y({
		additionalInsurance: Z(H(), q()).register(V, { description: "Additional insurance option" }).optional(),
		deliverAtPostalPoint: Z(H(), q()).register(V, { description: "Deliver at postal point option" }).optional(),
		freshFood: Z(H(), q()).register(V, { description: "Fresh food delivery option" }).optional(),
		frozen: Z(H(), q()).register(V, { description: "Frozen delivery option" }).optional(),
		hideSender: Z(H(), q()).register(V, { description: "Hide sender option" }).optional(),
		insurance: X([Z(H(), q()), ND]).optional(),
		noTracking: Z(H(), q()).register(V, { description: "Ship without track and trace option" }).optional(),
		oversizedPackage: Z(H(), q()).register(V, { description: "Oversized package option" }).optional(),
		printReturnLabelAtDropOff: Z(H(), q()).register(V, { description: "Print return label at drop off package option" }).optional(),
		priorityDelivery: Z(H(), q()).register(V, { description: "Priority delivery package option" }).optional(),
		recipientOnlyDelivery: Z(H(), q()).register(V, { description: "Recipient only delivery option" }).optional(),
		returnOnFirstFailedDelivery: Z(H(), q()).register(V, { description: "Return on first failed delivery option" }).optional(),
		requiresAgeVerification: Z(H(), q()).register(V, { description: "Requires age verification option" }).optional(),
		requiresCashOnDelivery: Z(H(), q()).register(V, { description: "Cash on delivery option" }).optional(),
		requiresReceiptCode: Z(H(), q()).register(V, { description: "Requires receipt code option" }).optional(),
		requiresSignature: Z(H(), q()).register(V, { description: "Requires signature option" }).optional(),
		sameDayDelivery: Z(H(), q()).register(V, { description: "Same day delivery option" }).optional(),
		saturdayDelivery: Z(H(), q()).register(V, { description: "Saturday delivery option" }).optional(),
		scheduledCollection: Z(H(), q()).register(V, { description: "Scheduled collection option" }).optional()
	}).register(V, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	deliveryType: X([Q([
		"EVENING_DELIVERY",
		"EXPRESS_DELIVERY",
		"EARLY_MORNING_DELIVERY",
		"MORNING_DELIVERY",
		"PICKUP_DELIVERY",
		"SAME_DAY_DELIVERY",
		"STANDARD_DELIVERY"
	]), H()]).optional(),
	direction: X([Q(["INBOUND", "OUTBOUND"]), H()]).register(V, { description: "The shipment direction for which the capabilities are requested." }).optional(),
	pickup: Y({ location: Y({ type: Gj.optional() }).register(V, { description: "Pickup location details." }).optional() }).register(V, { description: "Pickup location criteria for filtering capabilities." }).optional()
});
Y({ data: Y({ capabilities: J(Y({
	shop_id: W().register(V, { description: "The ID of the shop for which the capabilities are requested." }).optional(),
	contract_id: W().register(V, { description: "The ID of the contract for which the capabilities are requested." }).optional(),
	recipient: Y({
		cc: H().register(V, { description: "Alpha-2 Country code of the recipient." }),
		postal_code: H().register(V, { description: "Postal code of the recipient." }).optional(),
		is_business: G().register(V, { description: "Whether this is a business address." }).optional()
	}).register(V, { description: "Recipient data." }),
	sender: Y({
		cc: H().register(V, { description: "Alpha-2 Country code of the sender." }).optional(),
		postal_code: H().register(V, { description: "Postal code of the sender." }).optional(),
		is_business: G().register(V, { description: "Whether this is a business address." }).optional()
	}).register(V, { description: "Sender data." }).optional(),
	carrier_id: PA.optional(),
	package_type: X([
		$(1),
		$(2),
		$(3),
		$(4),
		$(5),
		$(6),
		$(7)
	]).optional(),
	physical_properties: Y({
		height: Y({
			value: W().gte(0).lte(1e4).register(V, { description: "The height value" }),
			unit: X([Q(["cm", "mm"]), H()]).register(V, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(V, { description: "The height of the package" }).optional(),
		width: Y({
			value: W().gte(0).lte(1e4).register(V, { description: "The width value" }),
			unit: X([Q(["cm", "mm"]), H()]).register(V, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(V, { description: "The width of the package" }).optional(),
		length: Y({
			value: W().gte(0).lte(1e4).register(V, { description: "The length value" }),
			unit: X([Q(["cm", "mm"]), H()]).register(V, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(V, { description: "The length of the package" }).optional(),
		weight: Y({
			value: W().gte(0).register(V, { description: "The weight value" }),
			unit: X([Q(["g", "kg"]), H()]).register(V, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(V, { description: "The weight of the package" }).optional()
	}).register(V, { description: "Physical properties of the package." }).optional(),
	options: Y({
		age_check: Z(H(), q()).register(V, { description: "Requires age verification option" }).optional(),
		cash_on_delivery: Z(H(), q()).register(V, { description: "Cash on delivery option" }).optional(),
		collect: Z(H(), q()).register(V, { description: "Scheduled collection option" }).optional(),
		drop_off_at_postal_point: Z(H(), q()).register(V, { description: "Deliver at postal point option" }).optional(),
		extra_assurance: Z(H(), q()).register(V, { description: "Additional insurance option" }).optional(),
		fresh_food: Z(H(), q()).register(V, { description: "Fresh food delivery option" }).optional(),
		frozen: Z(H(), q()).register(V, { description: "Frozen delivery option" }).optional(),
		hide_sender: Z(H(), q()).register(V, { description: "Hide sender option" }).optional(),
		large_format: Z(H(), q()).register(V, { description: "Oversized package option" }).optional(),
		no_tracking: Z(H(), q()).register(V, { description: "Ship without track and trace option" }).optional(),
		only_recipient: Z(H(), q()).register(V, { description: "Recipient only delivery option" }).optional(),
		priority_delivery: Z(H(), q()).register(V, { description: "Priority delivery option" }).optional(),
		printerless_return: Z(H(), q()).register(V, { description: "Printerless return delivery option" }).optional(),
		receipt_code: Z(H(), q()).register(V, { description: "Requires receipt code option" }).optional(),
		return: Z(H(), q()).register(V, { description: "Return on first failed delivery option" }).optional(),
		same_day_delivery: Z(H(), q()).register(V, { description: "Same day delivery option" }).optional(),
		saturday_delivery: Z(H(), q()).register(V, { description: "Saturday delivery option" }).optional(),
		signature: Z(H(), q()).register(V, { description: "Requires signature option" }).optional(),
		tracked: Z(H(), q()).register(V, { description: "DEPRECATED: replaced by no_tracking (its inverse)." }).optional(),
		insurance: X([Z(H(), q()), ND]).optional()
	}).register(V, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	delivery_type: X([
		$(1),
		$(2),
		$(3),
		$(4),
		$(5),
		$(6),
		$(7),
		$(8)
	]).optional(),
	shipment_type: X([
		$(1),
		$(2),
		$(3),
		$(4),
		$(5),
		$(6),
		$(7),
		$(8)
	]).optional(),
	direction: X([Q(["INBOUND", "OUTBOUND"]), H()]).register(V, { description: "The shipment direction for which the capabilities are requested." }).optional(),
	pickup: Y({ location_type: HD.optional() }).register(V, { description: "Pickup location criteria for filtering capabilities." }).optional()
})) }) });
var qj = Y({ carrier: X([Q([
	"BRT",
	"DHL_EUROPLUS",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"DHL_FOR_YOU",
	"INPOST",
	"POSTNL"
]), H()]).optional() });
Y({ data: Y({ carrier_id: X([
	$(1),
	$(4),
	$(9),
	$(10),
	$(11),
	$(15),
	$(17)
]).optional() }).optional() });
var Jj = Y({
	address: Y({
		city: H().register(V, { description: "The city of the address." }).optional(),
		countryCode: H().register(V, { description: "The country code (ISO 3166-1 alpha-2) of the address." }),
		street: H().register(V, { description: "The street of the address." }).optional(),
		additionalInformation: H().register(V, { description: "Additional information about the address." }).optional(),
		boxNumber: H().register(V, { description: "The box number of the address. Only applicable for `countryCode`=`BE`." }).optional(),
		houseNumber: H().register(V, { description: "The house number of the address." }).optional(),
		houseNumberSuffix: H().register(V, { description: "The house number suffix of the address." }).optional(),
		postalCode: H().register(V, { description: "The postal code of the address." }).optional(),
		region: H().register(V, { description: "The region of the address." }).optional(),
		state: H().register(V, { description: "The state of the address." }).optional()
	}),
	location: Y({
		name: H().register(V, { description: "The name of the pickup location." }),
		code: H().register(V, { description: "The location code of the pickup location." }).optional(),
		type: Gj.optional()
	}),
	retailNetworkId: X([Q(["PNPNL-01", "PNPBE-01"]), H()]).register(V, { description: "PostNL Retail network ID." }).optional()
}).register(V, { description: "Pickup location data." }), Yj = Y({
	shopId: W().register(V, { description: "The ID of the shop for which the rates are requested." }).optional(),
	contractId: W().register(V, { description: "The ID of the contract for which the rates are requested." }).optional(),
	recipient: Y({
		countryCode: H().register(V, { description: "Alpha-2 Country code of the recipient." }),
		postalCode: H().register(V, { description: "Postal code of the recipient." }).optional(),
		isBusiness: G().register(V, { description: "Whether this is a business address." }).optional()
	}).register(V, { description: "Recipient data." }),
	sender: Y({
		countryCode: H().register(V, { description: "Alpha-2 Country code of the sender." }).optional(),
		postalCode: H().register(V, { description: "Postal code of the sender." }).optional(),
		isBusiness: G().register(V, { description: "Whether this is a business address." }).optional()
	}).register(V, { description: "Sender data." }).optional(),
	pickup: Jj.optional(),
	carrier: yA,
	packageType: xA,
	physicalProperties: Y({
		height: Y({
			value: U().gte(0).register(V, { description: "The height value" }),
			unit: X([Q(["cm", "mm"]), H()]).register(V, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(V, { description: "The height of the package" }).optional(),
		width: Y({
			value: U().gte(0).register(V, { description: "The width value" }),
			unit: X([Q(["cm", "mm"]), H()]).register(V, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(V, { description: "The width of the package" }).optional(),
		length: Y({
			value: U().gte(0).register(V, { description: "The length value" }),
			unit: X([Q(["cm", "mm"]), H()]).register(V, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(V, { description: "The length of the package" }).optional(),
		weight: Y({
			value: U().gte(0).register(V, { description: "The weight value" }),
			unit: X([Q(["g", "kg"]), H()]).register(V, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(V, { description: "The weight of the package" }).optional()
	}).register(V, { description: "Physical properties of the package." }).optional(),
	options: Y({
		additionalInsurance: Z(H(), q()).register(V, { description: "Additional insurance option" }).optional(),
		deliverAtPostalPoint: Z(H(), q()).register(V, { description: "Deliver at postal point option" }).optional(),
		freshFood: Z(H(), q()).register(V, { description: "Fresh food option" }).optional(),
		frozen: Z(H(), q()).register(V, { description: "Frozen option" }).optional(),
		hideSender: Z(H(), q()).register(V, { description: "Hide sender option" }).optional(),
		insurance: X([Y({ insuredAmount: ND }).register(V, { description: "Deprecated. Use options.insurance.{amount, currency} directly. Will be removed in a future release." }), ND]).optional(),
		noTracking: Z(H(), q()).register(V, { description: "Ship without track and trace option" }).optional(),
		oversizedPackage: Z(H(), q()).register(V, { description: "Oversized package option" }).optional(),
		priorityDelivery: Z(H(), q()).register(V, { description: "Priority delivery package option" }).optional(),
		recipientOnlyDelivery: Z(H(), q()).register(V, { description: "Recipient only delivery option" }).optional(),
		returnOnFirstFailedDelivery: Z(H(), q()).register(V, { description: "Return on first failed delivery option" }).optional(),
		requiresAgeVerification: Z(H(), q()).register(V, { description: "Requires age verification option" }).optional(),
		requiresCashOnDelivery: Y({ dueAmount: ND }).register(V, { description: "Cash on delivery option" }).optional(),
		requiresReceiptCode: Z(H(), q()).register(V, { description: "Requires receipt code option" }).optional(),
		requiresSignature: Z(H(), q()).register(V, { description: "Requires signature option" }).optional(),
		sameDayDelivery: Z(H(), q()).register(V, { description: "Same day delivery option" }).optional(),
		saturdayDelivery: Z(H(), q()).register(V, { description: "Saturday delivery option" }).optional(),
		scheduledCollection: Z(H(), q()).register(V, { description: "Scheduled collection option" }).optional()
	}).register(V, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	deliveryType: X([Q([
		"EARLY_MORNING_DELIVERY",
		"EVENING_DELIVERY",
		"EXPRESS_DELIVERY",
		"MORNING_DELIVERY",
		"PICKUP_DELIVERY",
		"SAME_DAY_DELIVERY",
		"STANDARD_DELIVERY"
	]), H()]).optional(),
	direction: X([Q(["INBOUND", "OUTBOUND"]), H()]).register(V, { description: "The shipment direction for which the rates are requested." }).optional(),
	collo: W().gte(1).register(V, { description: "The number of collo for which the rates are requested." }).optional()
});
Y({ data: Y({ rates: J(Y({
	shop_id: W().register(V, { description: "The ID of the shop for which the rates are requested." }).optional(),
	contract_id: W().register(V, { description: "The ID of the contract for which the rates are requested." }).optional(),
	recipient: Y({
		cc: H().register(V, { description: "Alpha-2 Country code of the recipient." }),
		postal_code: H().register(V, { description: "Postal code of the recipient." }).optional(),
		is_business: G().register(V, { description: "Whether this is a business address." }).optional()
	}).register(V, { description: "Recipient data." }),
	sender: Y({
		cc: H().register(V, { description: "Alpha-2 Country code of the sender." }).optional(),
		postal_code: H().register(V, { description: "Postal code of the sender." }).optional(),
		is_business: G().register(V, { description: "Whether this is a business address." }).optional()
	}).register(V, { description: "Sender data." }).optional(),
	pickup: WD.optional(),
	carrier_id: PA,
	package_type: FD,
	physical_properties: Y({
		height: Y({
			value: U().gte(0).register(V, { description: "The height value" }),
			unit: X([Q(["cm", "mm"]), H()]).register(V, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(V, { description: "The height of the package" }).optional(),
		width: Y({
			value: U().gte(0).register(V, { description: "The width value" }),
			unit: X([Q(["cm", "mm"]), H()]).register(V, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(V, { description: "The width of the package" }).optional(),
		length: Y({
			value: U().gte(0).register(V, { description: "The length value" }),
			unit: X([Q(["cm", "mm"]), H()]).register(V, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(V, { description: "The length of the package" }).optional(),
		weight: Y({
			value: U().gte(0).register(V, { description: "The weight value" }),
			unit: X([Q(["g", "kg"]), H()]).register(V, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(V, { description: "The weight of the package" }).optional()
	}).register(V, { description: "Physical properties of the package." }).optional(),
	options: Y({
		age_check: Z(H(), q()).register(V, { description: "Requires age verification option" }).optional(),
		cash_on_delivery: Y({ due_amount: ND }).register(V, { description: "Cash on delivery option" }).optional(),
		collect: Z(H(), q()).register(V, { description: "Scheduled collection option" }).optional(),
		cooled_delivery: Z(H(), q()).register(V, { description: "Cooled delivery option" }).optional(),
		drop_off_at_postal_point: Z(H(), q()).register(V, { description: "Deliver at postal point option" }).optional(),
		extra_assurance: Z(H(), q()).register(V, { description: "Additional insurance option" }).optional(),
		hide_sender: Z(H(), q()).register(V, { description: "Hide sender option" }).optional(),
		large_format: Z(H(), q()).register(V, { description: "Oversized package option" }).optional(),
		no_tracking: Z(H(), q()).register(V, { description: "Ship without track and trace option" }).optional(),
		only_recipient: Z(H(), q()).register(V, { description: "Recipient only delivery option" }).optional(),
		priority_delivery: Z(H(), q()).register(V, { description: "Priority delivery option" }).optional(),
		receipt_code: Z(H(), q()).register(V, { description: "Requires receipt code option" }).optional(),
		return: Z(H(), q()).register(V, { description: "Return on first failed delivery option" }).optional(),
		same_day_delivery: Z(H(), q()).register(V, { description: "Same day delivery option" }).optional(),
		saturday_delivery: Z(H(), q()).register(V, { description: "Saturday delivery option" }).optional(),
		signature: Z(H(), q()).register(V, { description: "Requires signature option" }).optional(),
		tracked: Z(H(), q()).register(V, { description: "DEPRECATED: replaced by no_tracking (its inverse)." }).optional(),
		insurance: X([Y({ insured_amount: ND }).register(V, { description: "Deprecated. Use options.insurance.{amount, currency} directly. Will be removed in a future release." }), ND]).optional()
	}).register(V, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	delivery_type: X([
		$(1),
		$(2),
		$(3),
		$(4),
		$(5),
		$(6),
		$(7),
		$(8)
	]).optional(),
	shipment_type: X([
		$(1),
		$(2),
		$(3),
		$(4),
		$(5),
		$(6),
		$(7),
		$(8)
	]).optional(),
	direction: X([Q(["INBOUND", "OUTBOUND"]), H()]).register(V, { description: "The shipment direction for which the rates are requested." }).optional(),
	collo: W().gte(1).register(V, { description: "The number of collo for which the rates are requested." }).optional()
})) }) });
var Xj = X([Y({
	shopId: W(),
	packageType: X([Q([
		"DIGITAL_STAMP",
		"ENVELOPE",
		"UNFRANKED",
		"MAILBOX",
		"PACKAGE",
		"PALLET",
		"SMALL_PACKAGE"
	]), H()]),
	countryCode: H().register(V, { description: "ISO 3166-1 alpha-2 country code" }),
	shipmentDirection: X([Q(["OUTBOUND"]), H()])
}), Y({
	shopId: W(),
	packageType: _x().optional(),
	countryCode: H().register(V, { description: "ISO 3166-1 alpha-2 country code" }).optional(),
	shipmentDirection: X([Q(["INBOUND"]), H()])
})]), Zj = Y({
	body: H(),
	subject: H()
}), Qj = Y({ data: Y({ webhook_subscriptions: J(Y({
	account_id: W().optional(),
	shop_id: W().optional(),
	hook: H(),
	url: H(),
	payload: H().nullish()
})).optional() }) });
Y({ data: Y({ webhook_subscriptions: J(Y({
	account_id: W().optional(),
	shop_id: W().optional(),
	hook: H(),
	url: H()
})).optional() }) }), H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }), H().nullable(), H().nullable(), xb().register(V, { description: "When set, only resources created after this date will be returned. Inclusive." }), dj.nullable(), W().gte(-1).lte(14).nullable(), W().gte(0).nullable(), W().gte(0).lte(14).nullable(), G().register(V, { description: "Use this parameter to only show Shipments that need to be dropped off today." }), dj.nullable(), H().nullable(), G(), X([vj, H()]), G(), W().nullable(), G(), H().nullable(), dj.nullable(), H().nullable(), X([xj, H()]), H().nullable(), H().nullable(), H().register(V, { description: "Filter by `reference_identifier`, an optional arbitrary identifier to identify the Shipment." }), H().register(V, { description: "The region, department, state or province of the address." }), X([Q(["asc", "desc"]), H()]).register(V, { description: "Sort order. Defaults to `desc`." }), H().nullable(), W().register(V, { description: "The ID of the notification group." }), H().register(V, { description: "One or more notification group IDs. Separate multiple IDs using `;`." }), W().register(V, { description: "The ID of the notification template." }), H().register(V, { description: "Filter by webhook event type." });
var $j = Rj, eM = Uj, tM = Wj, nM = Kj, rM = qj, iM = Yj, aM = Xj, oM = Zj, sM = Qj;
Y({
	body: q().optional(),
	path: q().optional(),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	title: H().optional(),
	status: H()
}).register(V, { description: "Status is OK" }), Y({
	body: q().optional(),
	path: q().optional(),
	query: Y({
		cc: H().nullish(),
		postal_code: Ej.optional(),
		number: H().nullish(),
		city: H().nullish(),
		street: H().nullish(),
		platform: wj.optional(),
		shop_id: Aj.optional(),
		carrier: sj.optional(),
		delivery_date: pj.optional(),
		delivery_time: mj.optional(),
		cutoff_time: uj.optional(),
		dropoff_days: gj.optional(),
		monday_delivery: dj.nullish(),
		dropoff_delay: W().gte(0).lte(14).nullish(),
		deliverydays_window: W().gte(-1).lte(14).nullish(),
		exclude_delivery_type: _j.optional(),
		exclude_parcel_lockers: dj.nullish(),
		latitude: yj.optional(),
		longitude: bj.optional()
	}).optional()
}), Y({
	body: q().optional(),
	path: q().optional(),
	query: Y({
		postal_code: Ej.optional(),
		number: H().nullish(),
		distance: W().gte(0).nullish(),
		cc: H().nullish(),
		limit: W().nullish(),
		carrier_id: oj.optional(),
		shop_id: Aj.optional(),
		reference: H().nullish(),
		location_name: H().nullish(),
		external_identifier: H().nullish(),
		city: H().nullish(),
		cut_off_time: uj.optional(),
		min_cut_off_time: uj.optional(),
		max_cut_off_time: uj.optional(),
		latitude: yj.optional(),
		longitude: bj.optional(),
		exclude_parcel_lockers: dj.nullish()
	}).optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	body: q().optional(),
	path: q().optional(),
	query: Y({
		cc: H().nullish(),
		postal_code: Ej.optional(),
		number: H().nullish(),
		city: H().nullish(),
		street: H().nullish(),
		platform: wj.optional(),
		shop_id: Aj.optional(),
		carrier: sj.optional(),
		delivery_date: pj.optional(),
		delivery_time: mj.optional(),
		cutoff_time: uj.optional(),
		dropoff_days: gj.optional(),
		monday_delivery: dj.nullish(),
		dropoff_delay: W().gte(0).lte(14).nullish(),
		deliverydays_window: W().gte(-1).lte(14).nullish(),
		exclude_delivery_type: _j.optional(),
		exclude_parcel_lockers: dj.nullish(),
		latitude: yj.optional(),
		longitude: bj.optional()
	}).optional()
}), Y({
	body: q().optional(),
	path: q().optional(),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	body: q().optional(),
	path: q().optional(),
	query: Y({
		barcode: aj.optional(),
		carrier_id: oj.optional(),
		created: xb().register(V, { description: "When set, only resources created after this date will be returned. Inclusive." }).optional(),
		delayed: dj.nullish(),
		delivered: fj.optional(),
		dropoff_today: G().register(V, { description: "Use this parameter to only show Shipments that need to be dropped off today." }).optional(),
		filter_hidden_shops: G().optional(),
		hidden: fj.optional(),
		link_consumer_portal: G().optional(),
		order: X([xj, H()]).optional(),
		package_type: Sj.optional(),
		page: Cj.optional(),
		q: H().nullish(),
		reference_identifier: H().register(V, { description: "Filter by `reference_identifier`, an optional arbitrary identifier to identify the Shipment." }).optional(),
		region: H().register(V, { description: "The region, department, state or province of the address." }).optional(),
		shipment_type: Oj.optional(),
		shop_id: Aj.optional(),
		size: jj.optional(),
		sort: Mj.optional(),
		status: Nj.optional(),
		transaction_status: oO.optional()
	}).optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	body: tM,
	path: q().optional(),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), xx().register(V, { description: "Shipment patch was successful." }), Y({
	body: $j,
	path: q().optional(),
	query: Y({
		format: X([vj, H()]).optional(),
		positions: Tj.optional(),
		collect_date: cj.optional(),
		delivery_options_identifier: hj.optional()
	}).optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	body: eM,
	path: q().optional(),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), X([Ak, xx().register(V, { description: "Shipment update was successful." })]), Y({
	body: q().optional(),
	path: Y({ ids: Dj }),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), xx().register(V, { description: "Shipment deletion was successful." }), Y({
	body: q().optional(),
	path: Y({ ids: Dj }),
	query: Y({ link_consumer_portal: G().optional() }).optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	body: nM,
	path: q().optional(),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	body: rM,
	path: q().optional(),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	body: iM,
	path: q().optional(),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), X([$A, xx().register(V, { description: "This response is given when the request is successful and the response is empty." })]), Y({
	body: q().optional(),
	path: Y({ ids: Dj }),
	query: Y({
		format: X([vj, H()]).optional(),
		positions: Tj.optional(),
		collect_date: cj.optional(),
		delivery_options_identifier: hj.optional()
	}).optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), X([xx().register(V, { description: "Direct Printing Response" }), Mk]), Y({
	body: q().optional(),
	path: q().optional(),
	query: Y({
		barcode: aj.optional(),
		country_code: lj.optional(),
		external_identifier: aj.optional(),
		extra_info: Pj.optional(),
		postal_code: Ej.optional(),
		sort: X([Q(["asc", "desc"]), H()]).register(V, { description: "Sort order. Defaults to `desc`." }).optional()
	}).optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	body: q().optional(),
	path: Y({ ids: Dj }),
	query: Y({
		sort: X([Q(["asc", "desc"]), H()]).register(V, { description: "Sort order. Defaults to `desc`." }).optional(),
		extra_info: Pj.optional()
	}).optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	body: q().optional(),
	path: q().optional(),
	query: Y({ shopId: Aj.optional() }).optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	body: aM,
	path: q().optional(),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	body: q().optional(),
	path: Y({ ids: H().register(V, { description: "One or more notification group IDs. Separate multiple IDs using `;`." }) }),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), xx().register(V, { description: "Notification group deletion was successful." }), Y({
	body: q().optional(),
	path: Y({ notification_group_id: W().register(V, { description: "The ID of the notification group." }) }),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	body: oM,
	path: Y({
		notification_group_id: W().register(V, { description: "The ID of the notification group." }),
		notification_template_id: W().register(V, { description: "The ID of the notification template." })
	}),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), xx().register(V, { description: "Notification template update was successful." }), Y({
	body: q().optional(),
	path: Y({ notification_group_id: W().register(V, { description: "The ID of the notification group." }) }),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), xx().register(V, { description: "Disabling notification templates was successful." }), Y({
	body: q().optional(),
	path: Y({ notification_group_id: W().register(V, { description: "The ID of the notification group." }) }),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), xx().register(V, { description: "Enabling notification templates was successful." }), Y({
	body: q().optional(),
	path: Y({
		notification_group_id: W().register(V, { description: "The ID of the notification group." }),
		notification_template_id: W().register(V, { description: "The ID of the notification template." })
	}),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), xx().register(V, { description: "Disabling notification template was successful." }), Y({
	body: q().optional(),
	path: Y({
		notification_group_id: W().register(V, { description: "The ID of the notification group." }),
		notification_template_id: W().register(V, { description: "The ID of the notification template." })
	}),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), xx().register(V, { description: "Enabling notification template was successful." }), Y({
	body: q().optional(),
	path: Y({
		notification_group_id: W().register(V, { description: "The ID of the notification group." }),
		notification_template_id: W().register(V, { description: "The ID of the notification template." })
	}),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), xx().register(V, { description: "Test notification was successfully send." }), Y({
	body: q().optional(),
	path: q().optional(),
	query: Y({ hook: H().register(V, { description: "Filter by webhook event type." }).optional() }).optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	body: sM,
	path: q().optional(),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Y({
	body: q().optional(),
	path: Y({ ids: Dj }),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), xx().register(V, { description: "Webhook subscription deletion was successful." }), Y({
	body: q().optional(),
	path: Y({ ids: Dj }),
	query: q().optional(),
	headers: Y({ "User-Agent": H().register(V, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var cM = {
	STANDARD: 1,
	RETURN: 2,
	MULTI_COLLO: 3,
	LABEL_PACKAGE: 4,
	RETURN_ERS: 5,
	RETURN_SPECIAL: 6,
	EXPRESS: 7,
	FULFILMENT: 8
}, lM = {
	RETAIL: "retail",
	LOCKER: "locker",
	POST_OFFICE: "post_office"
}, uM = {
	BPOST: "BPOST",
	BRT: "BRT",
	CHEAP_CARGO: "CHEAP_CARGO",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DHL_FREIGHT: "DHL_FREIGHT",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DPD: "DPD",
	GLS: "GLS",
	INPOST: "INPOST",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	POSTNL: "POSTNL",
	SPRING: "SPRING",
	TRUNKRS: "TRUNKRS",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	UPS_STANDARD: "UPS_STANDARD",
	VIA_TIM: "VIA_TIM"
}, dM = {
	MORNING: "MORNING_DELIVERY",
	STANDARD: "STANDARD_DELIVERY",
	EVENING: "EVENING_DELIVERY",
	PICKUP: "PICKUP_DELIVERY",
	SAME_DAY: "SAME_DAY_DELIVERY",
	EXPRESS: "EXPRESS_DELIVERY",
	EARLY_MORNING: "EARLY_MORNING_DELIVERY"
}, fM = {
	RETAIL: "RETAIL",
	LOCKER: "LOCKER",
	POST_OFFICE: "POST_OFFICE"
};
lM.RETAIL, fM.RETAIL, lM.LOCKER, fM.LOCKER, lM.POST_OFFICE, fM.POST_OFFICE, fM.RETAIL, lM.RETAIL, fM.LOCKER, lM.LOCKER, fM.POST_OFFICE, lM.POST_OFFICE, new Set(Object.values(uM)), new Set(Object.values(dM)), cM.RETURN, cM.RETURN_ERS, ph.EarlyMorning, dM.EARLY_MORNING, ph.Morning, dM.MORNING, ph.Standard, dM.STANDARD, ph.Evening, dM.EVENING, ph.Pickup, dM.PICKUP, ph.PickupExpress, dM.PICKUP, ph.SameDayDelivery, dM.SAME_DAY, ph.Express, dM.EXPRESS, ks.PAID, ks.PENDING, ks.UNPAID;
//#endregion
//#region src/components/ShipmentTrackTraceSidePanel/components/ShipmentOptionDetails/ShipmentOptionDetails.vue?vue&type=script&setup=true&lang.ts
var pM = { key: 1 }, mM = /* @__PURE__ */ l({
	__name: "ShipmentOptionDetails",
	props: { package: {} },
	setup(r) {
		let a = r, { t: o, tm: s } = Fe(), c = [
			"insurance",
			"returnContributionFee",
			"customLabelText"
		], l = t(() => Object.keys(a.package.shipment?.options || {}).reduce((e, t) => (c.includes(t) || e.push(t), e), []));
		return (t, a) => (f(), n(Im, { title: y(o)("shipping.options") }, {
			default: x(() => [l.value.length ? (f(!0), i(e, { key: 0 }, h(l.value, (e) => (f(), i("div", { key: e }, v(y(o)(y(Yh)(y(s), e, r.package.shipment?.carrier).label)), 1))), 128)) : (f(), i("p", pM, v(y(o)("trackTracePanel.details.noShipmentOptions")), 1))]),
			_: 1
		}, 8, ["title"]));
	}
}), hM = ["alt", "src"], gM = { key: 1 }, _M = /* @__PURE__ */ l({
	__name: "SignatureDetails",
	props: { trackTrace: {} },
	setup(e) {
		let { t } = Fe();
		return (r, a) => (f(), n(Im, { title: y(t)("shipping.shipmentOption.requiresSignature") }, {
			default: x(() => [e.trackTrace.signature ? (f(), i("img", {
				key: 0,
				alt: y(t)("shipping.shipmentOption.requiresSignature"),
				src: `data:image/png;base64,${e.trackTrace.signature}`
			}, null, 8, hM)) : (f(), i("p", gM, v(y(t)("trackTracePanel.details.noSignature")), 1))]),
			_: 1
		}, 8, ["title"]));
	}
}), vM = { class: "flex flex-row gap-4 py-2 px-4 justify-between" }, yM = { class: "leading-5 text-center" }, bM = /* @__PURE__ */ l({
	__name: "TraceStatusBlocks",
	props: {
		packageStatus: {},
		disabled: { type: Boolean }
	},
	setup(r) {
		let o = r, { t: s } = Fe(), l = [
			"DISPATCHING",
			"SORTING",
			"DISTRIBUTING",
			"DELIVERED"
		], u = t(() => o.packageStatus.group === "DISPATCHING" && o.packageStatus.name === "READY_TO_SHIP"), p = (e) => o.disabled || u.value ? !1 : l.indexOf(o.packageStatus.group) >= l.indexOf(e), m = t(() => [
			{
				label: s("trackTracePanel.status.dispatching"),
				icon: Cf,
				active: p("DISPATCHING")
			},
			{
				label: s("trackTracePanel.status.sorting"),
				icon: Af,
				active: p("SORTING")
			},
			{
				label: s("trackTracePanel.status.distributing"),
				icon: Df,
				active: p("DISTRIBUTING")
			},
			{
				label: s("trackTracePanel.status.delivered"),
				icon: yf,
				active: p("DELIVERED")
			}
		]);
		return (t, r) => (f(), i("ul", vM, [(f(!0), i(e, null, h(m.value, (e) => (f(), i("li", {
			key: e.label,
			class: d(["text-xs flex flex-col items-center", {
				"text-gray-500": !e.active,
				"text-primary font-bold": e.active
			}])
		}, [c(y(Ue), { size: 24 }, {
			default: x(() => [(f(), n(_(e.icon)))]),
			_: 2
		}, 1024), a("p", yM, v(e.label), 1)], 2))), 128))]));
	}
}), xM = { class: "px-4 py-6 bg-white" }, SM = { class: "bg-gray-100 border-t border-gray-400 px-4 py-6 h-full" }, CM = { class: "flex flex-row justify-between items-center" }, wM = { class: "flex gap-2 items-center" }, TM = { class: "flex gap-2 items-center" }, EM = /* @__PURE__ */ l({
	__name: "ShipmentTrackTraceSidePanel",
	props: {
		package: {},
		trackTrace: { default: void 0 },
		returnReasons: { default: () => [] },
		withCaseCreate: { type: Boolean },
		withMarkAsDelivered: { type: Boolean },
		userAgent: { default: void 0 },
		origin: { default: void 0 },
		carrierPhysicalProperties: { default: void 0 },
		loading: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["createCase", "markAsDelivered"],
	setup(l, { expose: u, emit: d }) {
		let p = l, m = d, { t: g } = Fe(), { getFormattedTrackAndTrace: _ } = Ge(), ee = re("shipmentTrackTracePanel"), te = t(() => p.trackTrace ? _(p.trackTrace) : []), ne = t(() => p.package.shipment?.options?.customLabelText?.text), b = (e) => Ol(e) ? e.barcode : "", ie = () => m("createCase", b(p.package.shipment?.label));
		/* c8 ignore end */
		return u({
			openTrackTracePanel() {
				ee.value?.openSidePanel();
			},
			closeTrackTracePanel() {
				ee.value?.closeSidePanel();
			}
		}), (t, u) => (f(), n(y(ke), {
			ref: "shipmentTrackTracePanel",
			"aria-label": y(g)("trackTracePanel.title"),
			"body-class": "p-0 bg-gray-100",
			title: y(g)("trackTracePanel.title")
		}, o({
			default: x(() => [a("div", null, [
				c(bM, {
					class: "border-t border-b bg-white sticky top-0 z-20",
					disabled: !!l.package.shipment?.options?.noTracking,
					"package-status": l.package.status
				}, null, 8, ["disabled", "package-status"]),
				a("div", xM, [l.loading ? (f(), n(y(Ae), {
					key: 0,
					class: "flex justify-center",
					size: "small"
				})) : te.value.length ? te.value.length <= 3 ? (f(), n(y(Me), {
					key: 2,
					items: te.value
				}, null, 8, ["items"])) : (f(), n(y(Se), {
					key: 3,
					"close-text": y(g)("trackTracePanel.events.showLess"),
					"initial-height": 200,
					"open-text": y(g)("trackTracePanel.events.showMore")
				}, {
					default: x(() => [c(y(Me), { items: te.value }, null, 8, ["items"])]),
					_: 1
				}, 8, ["close-text", "open-text"])) : (f(), n(y(ce), {
					key: 1,
					variant: "warning"
				}, {
					default: x(() => [s(v(y(g)("trackTracePanel.events.noEvents")), 1)]),
					_: 1
				}))]),
				a("div", SM, [a("div", CM, [c(y(ye), {
					class: "m-0",
					level: "2"
				}, {
					default: x(() => [s(v(y(g)("trackTracePanel.details.title")), 1)]),
					_: 1
				}), l.withCaseCreate ? (f(), n(y(le), {
					key: 0,
					onClick: ie
				}, {
					default: x(() => [s(v(y(g)("trackTracePanel.createCase")), 1)]),
					_: 1
				})) : r("", !0)]), a("div", null, [
					c(Im, {
						detail: l.package.shipment?.id,
						title: y(g)("trackTracePanel.details.shipmentId")
					}, null, 8, ["detail", "title"]),
					l.userAgent ? (f(), n(Im, {
						key: 0,
						class: "max-w-md break-all",
						detail: l.userAgent,
						title: y(g)("trackTracePanel.details.userAgent")
					}, null, 8, ["detail", "title"])) : r("", !0),
					l.origin ? (f(), n(Im, {
						key: 1,
						detail: l.origin,
						title: y(g)("trackTracePanel.details.origin")
					}, null, 8, ["detail", "title"])) : r("", !0),
					c(Lm, {
						package: l.package,
						"track-trace": l.trackTrace
					}, null, 8, ["package", "track-trace"]),
					c(Im, { title: y(g)("trackTracePanel.details.createdDate") }, {
						default: x(() => [a("p", null, [c(y(me), { date: l.package.shipment?.createdAt }, null, 8, ["date"])])]),
						_: 1
					}, 8, ["title"]),
					c(Im, { title: y(g)("trackTracePanel.details.packageType") }, {
						default: x(() => [a("div", wM, [c(y(Ee), {
							class: "text-secondary",
							"package-type-id": l.package.shipment?.packageType
						}, null, 8, ["package-type-id"]), a("p", null, v(y(g)(`shipping.packageType.${y(rf)(l.package.shipment?.packageType ?? "")}`)), 1)])]),
						_: 1
					}, 8, ["title"]),
					c(Im, { title: y(g)("shipping.carrier") }, {
						default: x(() => [a("div", TM, [c(y(de), { carrier: l.package?.shipment?.carrier }, null, 8, ["carrier"]), a("p", null, v(y(g)(`shipping.carriers.${y(An)(l.package?.shipment?.carrier ?? "")}`)), 1)])]),
						_: 1
					}, 8, ["title"]),
					c(mM, { package: l.package }, null, 8, ["package"]),
					c(Gm, { package: l.package }, null, 8, ["package"]),
					ne.value ? (f(), n(Im, {
						key: 2,
						detail: ne.value,
						title: y(g)("trackTracePanel.details.labelDescription")
					}, null, 8, ["detail", "title"])) : r("", !0),
					l.package.shipment?.recipient.address && l.package.shipment.recipient.contact ? (f(), n(dh, {
						key: 3,
						address: l.package.shipment.recipient.address,
						contact: l.package.shipment.recipient.contact
					}, null, 8, ["address", "contact"])) : r("", !0),
					c(eh, {
						"carrier-physical-properties": l.carrierPhysicalProperties,
						package: l.package
					}, null, 8, ["carrier-physical-properties", "package"]),
					c(Hm, { package: l.package }, null, 8, ["package"]),
					l.trackTrace && l.package.shipment?.options?.requiresSignature ? (f(), n(_M, {
						key: 4,
						"track-trace": l.trackTrace
					}, null, 8, ["track-trace"])) : r("", !0),
					l.package.shipment?.direction === "INBOUND" && l.returnReasons.length ? (f(), n(Im, {
						key: 5,
						title: y(g)("trackTracePanel.details.returnReason")
					}, {
						default: x(() => [(f(!0), i(e, null, h(l.returnReasons, (e) => (f(), i("p", { key: e.name }, v(e.human), 1))), 128))]),
						_: 1
					}, 8, ["title"])) : r("", !0)
				])])
			])]),
			_: 2
		}, [l.withMarkAsDelivered ? {
			name: "subheader",
			fn: x(() => [c(y(le), {
				class: "flex items-center gap-2 text-black",
				variant: "gray",
				onClick: u[0] ||= (e) => m("markAsDelivered")
			}, {
				default: x(() => [c(y(Ue), { size: 24 }, {
					default: x(() => [c(y(Rf))]),
					_: 1
				}), a("span", null, v(y(g)("trackTracePanel.markAsDelivered")), 1)]),
				_: 1
			})]),
			key: "0"
		} : void 0]), 1032, ["aria-label", "title"]));
	}
}), DM = (e) => {
	let n = (n) => t(() => ee(e).filter((e) => tm(e) && n(e)));
	return {
		selectedOrdersToCreateShipmentFor: n(Jp),
		selectedOrdersToDownloadLabelsFor: n(Yp),
		selectedOrdersToPrintPackingSlipFor: n(Xp),
		selectedOrdersToPrintPicklistFor: n(Zp),
		selectedOrdersToCancel: n(qp),
		selectedOrdersToAssign: n(Kp),
		selectedOrdersToReassign: n(Qp),
		selectedOrdersToUnassign: n($p)
	};
};
//#endregion
export { Em as Address, gm as AdjustedDeliveryCard, vp as AdjustedDeliveryModal, Tp as BPOST_CLASSIFICATION_LENGTHS, Ep as CARRIERS_WITHOUT_SUPPORT_FOR_MAX_CLASSIFICATION_LENGTH, yp as CLASSIFICATION_MAX_LENGTH, Xd as CarrierIdToName, Qd as CarrierNameToId, Cp as DEFAULT_CLASSIFICATION_LENGTHS, Sp as DHL_CLASSIFICATION_LENGTHS, km as EcommercePlatform, am as LengthUnit, om as LengthUnitConversions, nm as MassUnit, rm as MassUnitConversions, Mm as MyParcelShopExternalReference, wp as POSTNL_CLASSIFICATION_LENGTHS, Nm as Price, EM as ShipmentTrackTraceSidePanel, bp as UPS_CLASSIFICATION_MIN_LENGTH, xp as USA_CLASSIFICATION_LENGTHS, Kp as allowedToAssignUser, qp as allowedToCancel, Jp as allowedToCreateShipment, Yp as allowedToDownloadLabel, Xp as allowedToPrintPackingSlip, Zp as allowedToPrintPickList, Qp as allowedToReassignUser, $p as allowedToUnassignUser, em as canChoosePaperSize, lm as convertLengthUnit, im as convertMassUnit, jp as defaultWeightsInGram, Dp as getAllowedGoodsCodeLength, Np as getDefaultWeight, Lp as getEoriFieldState, um as getOrderProcessingProgress, Ap as getOrderRecipient, cm as getUnitTranslationKey, Ip as getVatFieldState, Bd as isBol, Md as isBpost, Kd as isBrt, Nd as isCheapCargo, Gp as isContentsAllowedForCountry, Ld as isDhlEuroPlus, Id as isDhlForYou, Rd as isDhlNetwork, Fd as isDhlParcelConnect, zd as isDhlSmallPackage, Ed as isDigitalStamp, Pd as isDpd, Sd as isEnvelope, Gd as isGls, Jd as isInPost, kp as isLabelWithBarcode, Op as isLabelWithoutBarcode, Td as isMailbox, tm as isOrderActionable, Cd as isPackage, Od as isPallet, kd as isPostNl, jd as isPostNlAndNotRow, Ad as isPostNlAndRow, Yd as isPosteItaliane, Vp as isRequiredBusinessContact, Hp as isRequiredState, wd as isSmallPackage, qd as isTrunkrs, Dd as isUnfranked, Vd as isUps, Ud as isUpsExpressSaver, Wd as isUpsNetwork, Hd as isUpsStandard, $d as toCarrierId, Zd as toCarrierName, DM as useOrderBulkEligibility, Bp as withAdjustedDeliveryField, Up as withCustomsFields, Wp as withCustomsInvoiceField, Rp as withVolumeField, zp as withWeightField };
